export default {
  "account.pnl.profit_and_loss": "Profit and Loss",
  "account.pnl.get_link": "Get public link",
  "account.pnl.display_range": "Display range:",
  "account.pnl.source": "Sources:",
  "account.pnl.display_period": "Display period:",
  "account.pnl.margin": "Margin",
  "account.pnl.mam": "MAM",
  'margin.entry.team_name_is_required': '团队名称是必要的。',
  'margin.entry.email' : '邮箱',
  "leaderboard.top_25_traders_by_roe_entry": "ROE排名前25位交易者（登录制）",
  'margin.entry.leader_id': '队长ID',
  'entry.number_of_request': '"想参加您队伍的申请用户数',
  'margin.entry.maximum_member': '最大数',
  'entry.exception.msg.maximum_team_member': '您的队伍人数已达到上限！',
  'entry.exception.msg.team_has_maximum_member': '这个队伍人数已达到上限！',
  'entry.team_number': '报名的团队数',
  'entry.exception.msg.team_name_already_exists': '这团队名称已存在',
  'entry.exception.msg.user_already_entry' : '您已经在参加!',
  'entry.exception.msg.margin_balance_not_enough' : '保证金不够!',
  'entry.exception.msg.member_balance_not_enough' : '这个账号的用户的保证金不够!',
  'entry.msg.register_unsuccessfully' : '失败!',
  'entry.exception.msg.mam_user_join_request' : 'MAM使用者无法参加竞赛！',
  'entry.exception.msg.user_already_create_join_request' : '您已经发送参加请求了!',
  'message.response.request_invalid' : '请求无效',
  'margin.entry.contest_time':'活动期间',
  'margin.entry.contest_name':'活动名称',
  'margin.entry.entry_time':'报名',
  'entry.msg.create_team.success':'创造了团队!',
  'entry.msg.cancel.success':'取消了!',
  'margin.minimum_member':'最少团队人数',
  'margin.minimum_volume':'最低交易量',
  'margin.entry.contest':'交易大赛',
  'margin.entry.contest_start_at':'开始',
  'margin.entry.contest_end_at':'结束',
  'margin.entry.join_team_modal_title':'参加',
  'margin.entry.my_team_tab_title':'团队列表',
  'margin.entry.is_leader_span':'队长',
  'margin.entry.span_team_leader_email':'邮箱',
  'margin.entry.submitted_email_title':'邮箱',
  'margin.entry.team_id': '团队ID',
  'margin.entry.my_request_tab_title':'请求',
  'margin.entry.team_request_tab_title':'请求',
  'margin.entry.team_battle_create_modal_title':'创造团队',
  'margin.entry.team_name': '团队名称',
  'margin.entry.team_member_number': '团队人数',
  'margin.entry.entry_team_title_table':'参加团队列表',
  'margin.entry.description_title_table':'这份列表包含了所有参加的团队',
  'margin.entry.create_team_button':'创造新的团队',
  'margin.entry.team_entry_tab_title':'参加的团队',
  'margin.indicator': 'This indicator shows your position in the auto-deleverage queue. If all lights are lit, in the event of a liquidation, your position maybe reduced.',
  'register.entry': '参加',
  'entry.number_of_users': '参加人数',
  'participate.entry': '参加吗？',
  'participate.entry.note1': '报名期间或活动期间提取了保证金，则您的参赛资格将被取消',
  'participate.entry.note2': '如果您在报名期间交易的保证金低于要求的金额，则报名将被自动取消。 （如果添加保证金达到要求的金额，则可以重新进入竞赛。）',
  'participate.entry.note3': '-在比赛期间，如果可用余额低于最低保证金要求，也不会从报名中取消。',
  'participate.entry.note4': '如果您在报名期间持有仓位进入比赛时，则ROE将从该仓位在比赛期间完全平仓的那一刻开始计算。',
  'participate.entry.note5': '在比赛期间不进行交易的用户将被从竞赛中删除。',
  'mam.balance.search': 'Search by MasterId, Amount, Date and Reason',
  'mam.transfer_history': 'MAM Transfer History',
  'mam.transfer_history.nodata':'You have no history.',
  'mam.reason': 'Reason',
  'mam.reason.join': 'User created a request to join MAM fund.',
  'mam.reason.assign': 'User created a request to assign to MAM fund.',
  'mam.reason.revoke': 'User received a revoke amount.',
  'mam.reason.reject': 'MAM master rejected a join / an assign request.',
  'mam.reason.cancel': 'User canceled a join / an assign request.',
  'mam.reason.commission': 'MAM master receive commission fee.',
  'mam.reason.expired': 'User request is expired.',
  'mam.reason.closed': 'MAM fund is closed.',
  'mam.reason.created': 'User created a MAM fund.',
  'mam.enable.success': '成功启用',
  'mam.disable.success': '成功禁用',
  'mam.approve.success': 'Approve successfully!',
  'mam.approve.fail': 'Approve fail!',
  'mam.execute_im.success': 'Execute immediately successfully!',
  'mam.execute_im.fail': 'Execute immediately fail!',
  'mam.reject.success': 'Reject successfully!',
  'mam.reject.fail': 'Reject fail!',
  'mam.cancel.success': 'Cancel successfully!',
  'mam.cancel.fail': 'Cancel fail!',
  'mam.join.success': '您的请求已经通过了!',
  'mam.join.fail': 'Join fail!',
  'mam.balance.not_enough': 'Balance is not enough!',
  'mam.revoke.errors.max_amount': 'The revoke amount can be less than or equal to {amount}.',
  'mam.change.performance_fee_fail': 'Change performance fee fail!',
  'mam.change.next_performance_fee_error_max_value': 'Value of next performance fee must be smaller than {MAX_VALUE}.',
  'mam.change.performance_fee_error_max_value': 'Value of performance fee must be smaller than {MAX_VALUE}.',
  'mam.change.performance_fee_error_min_value': 'The minimum next performance fee must be greater than 0.',
  'mam.change.performance_fee_error_required': 'The next performance fee field is required.',
  'mam.create_account.initial_amount.error_min_value':'The initial amount must be greater than {min_amount} BTC.',
  'mam.create_account.performance_fee.error_min_value':'The performance fee must be greater than {min_amount} BTC.',

  'mam.confirm.reject': '拒绝吗？',
  'mam.confirm.approve': '您要批准吗？',
  'mam.confirm.execute_im': 'Do you want to execute immediately?',
  'mam.confirm.enable': '您要启用资金吗？',
  'mam.confirm.create_account': 'Do you want to create account?',
  'mam.confirm.close_account': 'Do you want to close account?',
  'mam.confirm.cancel': '您要取消吗？',
  'mam.msg.join_fund': '成功加入基金',
  'mam.msg.setting_commission': '成功设置佣金',
  'mam.msg.approve.success': '批准成功',
  'mam.msg.reject.success': '拒绝成功',
  "margin.animation": "Turn ON/OFF animation",
  'mam.msg.out.success': '成功退出',
  'mam.msg.cancel.success': '取消成功',
  'mam.msg.assigned.success': '指定成功',
  'mam.msg.revoked.success': '取消指定成功',
  'mam.msg.create_account.success': 'Create account successfully',
  'mam.msg.create_account.fail': 'Create account fail',
  'mam.type.assign': 'Assign',
  'mam.type.revoke': 'Revoke',
  'mam.type.join': '参加',
  'mam.status.submitted': '提交了',
  'mam.status.approved': '通过了',
  'mam.status.rejected': 'Rejected',
  'mam.status.canceled': '取消了',
  'mam.status.executed': 'Executed',
  'mam.status.failed': 'Failed',
  'mam.cancel': '取消',
  'mam.revoke_type.profit': 'Profit',
  'mam.revoke_type.partial': 'Partial',
  'mam.revoke_type.all': 'All',
  'mam.empty.commission': 'You have no commission history.',
  'mam.empty.follower': 'You have no follower.',
  'mam.unrealised_commission': '佣金未兌现',
  'mam.realised_commission': '佣金已兌现',
  'mam.request_history': '调阅历史纪录',
  'mam.date': '日期',
  'mam.detail': '详情',
  'mam.amount': '数量',
  'mam.account': '数量',
  'mam.fund_id': '帐户ID',
  'mam.max_drawdown': 'Max Drawdown',
  'mam.fund_capital': 'Fund Capital',
  'mam.fund_balance': 'Fund Balance',
  'mam.my_capital_share': 'My capital/share %',
  'mam.capital_share': 'Capital/share %',
  'mam.my_balance': 'My Balance',
  'mam.current_fee': 'Current Performance Fee',
  'mam.last_fee': 'Last Performance Fee',
  'mam.assign_revoke': 'Assign/Revoke',
  'mam.type': 'Type',
  'mam.submited_at': '提交',
  'mam.amonut': 'Amount',
  'mam.count': 'Count',
  'mam.pending': 'Pending',
  'mam.investments': '投资',
  'mam.status': '状态',
  'mam.assigned/revoke': '指定/撤销',
  'mam.assigned': '已指定',
  'mam.revoke': '已撤銷',
  'mam.balance': '馀额\r\n',
  'mam.currency': 'Currency',
  'mam.next_period': 'Next Period',
  'mam.since': '以来\r\n',
  'mam.win_rate': '赢率',
  'mam.performance_fee': '成功報酬',
  'mam.performance_fee_percent': 'Performance fee (%)',
  'mam.current_performance_fee': 'Current Performance Fee',
  'mam.next_performance_fee': 'Next performance fee',
  'mam.total_gain': 'Total Gain',
  'mam.this_month_pnl': '本月盈亏',
  'mam.unrealised_pnl': '未实现盈亏',
  'mam.last_month_pnl': '上个月盈亏',
  'mam.all_time_pnl': '所有时间损益',
  'mam.created_at': 'Created At',
  'i18n.lang': 'zh',
  'account.api.ip_access_res': 'IP访问限制：',
  'account.api.unrestricted': '不受限制（安全程度较低）',
  'account.api.not_recommended': '任何IP地址都可以使用此API密钥来访问您的帐户 (不建议这样做)',
  'account.api.restrict_access': '仅限制來自信任IP的访问（推荐使用）',
  'account.api.current_ip': 'Your current IP is 118.70.190.141. If entering multiple IPs, separate using commas.',
  'account.api.confirm': '确认',
  'account.api': 'API',
  'account.api.title_page': '创建API',
  'account.api.des_title_page': '您必须申請IP访问限制过滤器才能启用取款。',
  'account.api.key': 'API密钥',
  "account.api.edit_api": "Edit API",
  "account.api.update_success": "Update successful",
  "account.api.restriction": "API restrictions",
  "account.api.enable_reading": "Enable Reading",
  "account.api.enable_spot_trading": "Enable Spot Trading",
  "account.api.enable_future_trading": "Enable Future Trading",
  "account.api.enable_withdrawals": "Enable Withdrawals",
  'account.api.input_placeholder': '输入API密钥标签',
  'account.api.secret_key': '密钥',
  'account.api.scan_address': '扫描地址',
  'account.api.option': '选项',
  'account.api.permissions.read': '阅读信息',
  'account.api.permissions.withdrawal': '启用提款',
  'account.api.permissions.trading': '启用交易',
  'account.api_description': '创建API私钥可通过第三方站点或应用程序访问Demo上的市场和实时交易服务。',
  'account.api_view_documentation': '查看API文档',
  'account.api_create': '创建API',
  'account.api.copy': '复制',
  'account.api.edit': '编辑',
  'account.api.cancel': '取消',
  'account.api.save': '保存',
  'account.api.delete': '删除',
  'account.api.delete_api': '删除 API',
  'account.api.delete_api_message_withname': '您确定要永久删除API密钥 {name}',
  'account.api.delete_api_message_noname': '您确定要永久删除此API吗？?',
  'account.api.create_btn': '建立新密钥',
  'account.api.title': 'API 清单',
  'account.api.delete_all': '删除所有API',
  'account.api.save_success': '保存成功',
  'account.api.save_fail': '无法保存此API密钥',
  'account.api.delete_fail': '无法删除此API',
  'account.api.delete_success': '删除成功',
  'account.api.create_success': '成功创建新的API',
  'account.api.create_new_at_first': '\r\n开始使用API​​，请创建一个新密钥。',
  'kyc.id_number_unique': '护照/身份证号码已经获得。',
  'referral.level1': '1 等级',
  'referral.level2': '2 等级',
  'referral.level3': '3 等级',
  'referral.level4': '4 等级',
  'referral.level5': '5 等级',
  'referral.rate': 'Rate is',
  'referral.next_program': '如果您介绍{condition}个人或更多的朋友，此比例将增加到{rate}%',
  'refferal.text27': '报酬比率',
  'notifications.confirmation_reset_password.receiving_text': '因为账号的密码重新设定请求，接收到这封邮件。',
  'notifications.confirmation_reset_password.please_click': '请完成以下链接的密码变更。',
  'notifications.confirmation_reset_password.valid_24h': '上述链接24小时有效。',
  'notifications.confirmation_reset_password.please_confirm': '收到本邮件后，请在24小时内重新设置密码。',
  'notifications.deposit_withdraw_usd_alerts.hello': '您好',
  'window.suffix_title': '交易所',
  'about.about_us': '关于本公司',
  'about.advantage': '公司的优势',
  'about.coin': '支持丰富的代币',
  'about.coin_reason': 'BTC、ETH、LTC等',
  'about.device': '全设备对应',
  'about.device_reason': '可支持多种语言',
  'about.envi': '多语种对应',
  'about.envi_reason': 'Web、Android、iOS、移动网络',
  'about.liqui': '高い流動性',
  'about.liqui_reason': '通过各行业的丰富联系，实现高流动性',
  'about.perform': '高性能',
  'about.perform_reason': '可处理每秒140万个订单',
  'about.product': '有实际的产品',
  'about.product_reason': '{APP_NAME}平台已经在30多个交易所展开。支持所有设备多种语言，并提供无缝的用户延迟。',
  'about.resources': '同业界的交流',
  'about.resources_reason': '经济界、金融界、医学界等权威都全面支持我们的平台。',
  'about.safe': '安全・安定性',
  'about.safe_reason': '多层、多集群的系统构造的安全、稳定性',
  'about.team_strong': '强大团队',
  'about.team_strong_reason': '我们团队成员聚集了金融界和加密金融界的老前辈。事业开始上也有很多成功。',
  'about.tech': '高超的技术',
  'about.tech_reason': '我们的认证匹配引擎可以处理每秒140万个订单，是市场上最快的交易所之一。',
  'about.tit': 'Launched in 2018 {APP_NAME} is a  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, qttuis nostrud exercitation ullamco labor ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  'account.address_manager': '邮件地址管理',
  'account.address_manager_content': '通过使用邮件管理，可以在每个充值邮件中保存并写入备忘录。可选白名单功能仅允许提取白名单中注册的地址，有助于保护您的资金。',
  'account.bank': ':0',
  'account.btn_general': '一般',
  'account.btn_pending': '确认中',
  'account.btn_rejected': '不承认',
  'account.btn_unverified': '未承认',
  "account.btn_verify_now": "Verify Now",
  "account.btn_verify_change": "Change Verify",
  'account.btn_uver_bank': '未承认',
  'account.btn_verified': '已承认',
  'account.btn_verify_bank': '确认',
  'account.button_show': '再看看',
  'account.change': '更改',
  'account.daily_higher_limit': '上限',
  'account.daily_limit_withdraw': '二十四小时限制取款',
  'account.date': '日期',
  'account.email_desc': '如果禁用的话，您將不會接受到登录，提现，充值时的通知。',
  'account.device': '设备',
  'account.device_management': '设备管理',
  'account.devices_allowed': '这些终端现在被授权访问您的账户。',
  'account.disable': '无效',
  "account.cancel": "Cancel",
  'account.email_disable_confirm': '禁用接收通知吗？',
  'account.discount': '利用OGE支付手续费',
  'account.enable': '设定',
  'account.error_bank': '*用于取款和安全更改。',
  'account.google_auth': '谷歌认证系统',
  'account.lost_google_authenticator': '您忘记Google认证了吗？',
  'account.google_auth_content': '用于更改出款和安全。',
  'account.identity.choose_file': '选择文件',
  'account.identity.country': '国家/地区',
  'account.identity.errors.character_limit': '请输入英文数字:min～:max位数。',
  'account.identity.errors.exist': '身份证已经存在。',
  'account.identity.errors.format_number': '请输入不包含特殊文字的英文数字到9~12位。',
  'account.identity.errors.maxsize': '请把图像尺寸设为10MB以内。',
  'account.identity.errors.required': '必须输入此项。',
  'account.identity.errors.fullName.required': '必须输入姓名。',
  'account.identity.errors.passportID.required': '必须输入“护照/ID号码”。',
  'account.identity.errors.id_front.required': '身份证的正面/护照的封面是必须的。',
  'account.identity.errors.id_back.required': '必须输入“身份证背面/护照数据页面”。',
  'account.identity.errors.id_selfie.required': '必须输入“身份证和便笺一起的自拍”。',
  'account.identity.example': '样本',
  'account.identity.female': '女性',
  'account.identity.fullname': '名字',
  'account.identity.header_identity': '个人',
  'account.identity.header_verification': '本人确认文件',
  'account.identity.identityID': '有效的身份证证明',
  'account.identity.identity_back': '身份证背面/护照数据页面',
  'account.identity.identity_cover': '身份证的正面/护照的封面',
  'account.identity.identity_front': '身份证的正面',
  'account.identity.identity_image_back': '请确认照片以PNG、JPG、JPEG的形式，完全清晰可见。证书必须在有效期内。',
  'account.identity.identity_valid_card': '有效的身份证证明',
  'account.identity.image_identity': '如果没有护照的话，请上传驾驶证或国民身份证的正面照片。',
  'account.identity.image_passport': '图像必须以PNG、JPG、JPEG的形式提交。请让照片的题目看起来完全清晰。如果没有护照的话，请上传驾驶证或国民身份证的正面照片。',
  'account.identity.image_passport_data': '图像必须以PNG、JPG、JPEG的形式提交。请让照片的题目看起来完全清晰。请确认照片以PNG、JPG、JPEG的形式，完全清晰可见。身份证必须在有效期内。',
  'account.identity.male': '男性',
  'account.identity.passport': '护照/ID号码',
  'account.identity.selfie': '身份证和备忘录一起的自拍',
  'account.identity.sex': '性别',
  'account.identity.submit': '提交',
  'account.identity.success': '已创建。',
  'account.identity.update_success': '已更新。',
  'account.identity.sure_back': '请确认照片以PNG、JPG、JPEG的形式，完全清晰可见。证书必须在有效期内。',
  'account.identity.sure_front': '如果没有护照的话，请上传驾驶证或国民身份证的正面照片。',
  'account.identity.text_condition': '上传的图像必须清楚地显示面部和文章的信息。',
  'account.identity.text_date': '备忘录上的登录日期',
  'account.identity.text_face': '看得很清楚',
  'account.identity.text_image': '身份证看得很清楚',
  'account.identity.text_selfie': '请提供你带身份证表面的照片。请手持「本人确认文件」「Demo和写了今天的日期的纸」的状态，摄影为脸全体和文件全体纳入1个图像中。请确认清楚你的脸和所有护照的细节。',
  'account.identity.text_write': '写了 {APP_NAME} 的备忘录',
  'account.identity.verification_other': '此确认选项适用于所有非日本本土国家和地区的用户。当这个确认被处理时，你必须使用你的真实身份。你的个人信息会受到安全保护。政府发行的以下ID可以使用。',
  'account.identity.verification_other1': '<span>1.</span>护照',
  'account.identity.verification_other2': '<span>2.</span>驾驶证',
  'account.identity.verification_other3': '<span>3.政府发行证明书',
  'account.invalid_device': '您正在使用的设备错误或长期未使用的设备登录的。为了您的安全，已向您的电子邮件地址发送确认电子邮件。',
  'account.ip': 'IP',
  'account.ip_address': 'IP地址',
  'account.last_login': '最终登录',
  'account.last_login_time': '最终登录时间',
  'account.line': 'LINE',
  'account.line.desc': '启用账户接收登录、提现、充值时的通知',
  'account.location': '背景',
  'account.login': '登录密码',
  'account.lv': 'Lv',
  'account.modal.agreement_otp.view_secret_key': '显示密钥',
  'account.modal.agreement_otp.policy_content_text1': '1',
  "account.modal.agreement_otp.policy_content_text2": "1. Email Subject: Request stop Google Authenticator",
  'account.modal.agreement_otp.policy_content_text3': '2.本文',
  'account.modal.agreement_otp.policy_content_text4': '·本名',
  'account.modal.agreement_otp.policy_content_text5': '・你的电话号码',
  'account.modal.agreement_otp.policy_content_text6': '・{APP_NAME}中注册的电子邮件地址',
  'account.modal.agreement_otp.policy_content_text7': '3.附件',
  'account.modal.agreement_otp.policy_content_text8': '・身份证的正面',
  'account.modal.agreement_otp.policy_content_text9': '・身份证背面',
  'account.modal.agreement_otp.policy_content_text10': '・身份证和笔记一起自拍',
  'account.modal.agreement_otp.policy_content_text11': '请确认照片是否完整清晰。',
  'account.modal.agreement_otp.policy_content_text12': '请提供你带身份证正面的照片。',
  'account.modal.agreement_otp.policy_content_text13': "In the same picture, make a reference to {APP_NAME} and today’s date displayed.",
  'account.modal.agreement_otp.policy_content_text14': '请确认清楚你的脸和所有护照的细节。',
  'account.modal.agreement_otp.policy_content': '如果您忘记了恢复代码，无法解除Google Authenticator，请发送请求邮件至:<span class="primary-link">{contact_email}</span>。',
  'account.modal.agreement_otp.title': '如果忘了恢复代码',
  'account.modal.cancel_2fa.guide': '取消<p class=""font-18">双阶段认证（OTP）时，需要输入6位数字的Google认证号码</p><p class=""font-18">如果丢失手机或者安装了应用程序，请输入16位数字的恢复代码您也可以输入并禁用。</p>”',
  'account.modal.cancel_2fa.input_blank': '需要输入谷歌认证OTP代码',
  'account.modal.cancel_2fa.otp': 'OTP',
  'account.modal.cancel_2fa.otp_code': '认证号码',
  'account.modal.cancel_2fa.otp_policy': '如果忘了恢复代码',
  'account.modal.cancel_2fa.otp_restore': '恢复代码',
  'account.modal.cancel_2fa.stop_use_otp': '取消谷歌认证',
  'account.modal.cancel_2fa.success': 'OPT无效。',
  'account.modal.cancel_2fa.title': '谷歌认证无效。',
  'account.modal.confirm': '"<span class=""font-18"">确认</span>"',
  'account.modal.confirm_trusted_device': '删除选中的可靠设备？',
  'account.modal.confirm_registered_email':'You have registered by this email address but the confirmation link is expired. Do you want to resend the confirmation link to your email?',
  'account.modal.date_time_pick.text1': '日期范围:',
  'account.modal.date_time_pick.text2': '过去24小时',
  'account.modal.date_time_pick.text3': '前一天',
  'account.modal.date_time_pick.text4': '两个礼拜前',
  'account.modal.date_time_pick.text5': '过去一个月',
  'account.modal.date_time_pick.text6': '上个月',
  'account.modal.date_time_pick.text7': '过去三个月',
  'account.modal.date_time_pick.text8': '自定义（最大范围3个月）',
  'account.modal.date_time_pick.text9': '输出',
  'account.modal.date_time_pick.title': '手续费输出',
  'account.modal.lost_otp.guide': '要取消谷歌认证，必须输入恢复代码。',
  'account.modal.lost_otp.otp': 'OTP',
  'account.modal.lost_otp.otp_code': '认证号码',
  'account.modal.lost_otp.otp_policy': '如果忘了恢复代码',
  'account.modal.lost_otp.otp_restore': '恢复代码',
  'account.modal.lost_otp.stop_use_otp': '取消谷歌认证',
  'account.modal.lost_otp.title': '取消谷歌认证',
  'account.ni_bank': 'NI Bank账户',
  'account.no_commission_history': '没有手续费历史。',
  'account.no_referral_history': '没有介绍历史。',
  'account.no_latest_commission': '没有介绍记录。',
  'account.otp.authentication_failed': '认证失败',
  'account.otp.back': '上一步',
  'account.otp.backup_text1': '要重置谷歌认证，必须打开支持票，处理至少需要7天。',
  'account.otp.backup_text2': '请将这个钥匙保存在纸上。如果您使用此键丢失了电话，您可以恢复谷歌认证。',
  'account.otp.backup_title': '步骤3.备份保存恢复代码',
  'account.otp.enable_des': '谷歌认证启用',
  'account.otp.enable_step1': '1.应用下载',
  'account.otp.enable_step2': '2.扫描二维码',
  'account.otp.enable_step3': '3.恢复代码备份',
  'account.otp.enable_step4': '4.谷歌认证启用',
  'account.otp.enable_text1': '应用程序已安装。',
  'account.otp.enable_text2': '扫描了二维码',
  'account.otp.enable_text3': '已经写了16位数键',
  'account.otp.enable_title': '步骤4.Google认证启用',
  'account.otp.install_text': '请安装Google Authenticator应用程序。',
  "account.otp.sub-install_text": "Get the app",
  'account.otp.install_title': '步骤1.下载应用程序',
  'account.otp.next': '下一步',
  'account.otp.qr_text': '无法扫描二维码时，请手动输入此代码到应用程序中。',
  'account.otp.qt_title': '步骤2.扫描二维码',
  'account.otp.success': 'OTP有效。',
  'account.otp.txt_pass': '登录密码',
  'account.otp.should_enable_first': '必须启用谷歌认证。',
  'account.phone_number_in_use': '这个电话号码已经与{APP_NAME}账号绑定了。',
  'account.recent_activity': '最近的活动',
  'account.referral_code': '你的介绍代码：',
  "account.referral_des":"Invite Friends and Earn Crypto Together",
  "account.referral_content":"Earn {number}% commission on every trade across Spot and Futures",
  'account.referral_notification': '把朋友介绍给{APP_NAME}时得到最大:percent的手续费。共享此链接。',
  'account.referral_program': '介绍程序',
  'account.submit': '提交本人确认文件',
  'account.telegram': 'Telegram',
  'account.telegram.desc': '启用账户接收登录、提现、充值时的通知',
  'account.change_verify_kyc': '本人确认资料画面',
  'account.title_device': '当前允许这些设备访问您的帐户',
  'account.tooltip1': '如果开启此功能，您的账户只能在注册到白名单的出款地址上支付。',
  'account.tooltip2': '关闭此功能后，您的账户可向任何出款地址收款。',
  "account.turn_on_mode_whitelist": "Once this function is enabled, your account will only be able to withdraw to addresses on your whitelist.",
  "account.turn_off_mode_whitelist": "Once this function is disabled, your account will be able to withdraw to any withdrawal address.",
  'account.white_list': '白名单',
  'account.white_list_off': '白名单关闭',
  'account.white_list_on': '白名单开启',
  'account.withdrawal_address': '提现地址管理',
  'account.inactive': '您的账户无效。',
  'address.add_address': '提现地址管理',
  'address.add_success': '已创建。',
  'address.address': '邮箱地址',
  'address.all': '全部',
  'address.coin': '代币',
  'address.coin_name': '代币名',
  'address.confirm_remove_address': '确认删除吗？',
  'address.date': '日期',
  'address.delete': '删除',
  "address.deleted_success": "Withdrawal address is deleted",
  "address.deleted_sub_success": "Deleted withdrawal address",
  "address.deleted_success_message": "Deleted device",
  'address.errors.address_required': '必须输入邮箱地址。',
  'address.errors.blockchain_address': '提现地址无效。',
  'address.errors.coin_required': '必须输入代币。',
  'address.errors.exist_withdraw_address': '这个地址已经存在。',
  "address.errors.withdraw_address.invalide": "The withdraw address is invalid",
  'address.errors.label_required': '必须输入标签。',
  'address.errors.max_length': ':field是最大的:amount字符。',
  'address.errors.min_length': ':field在:amount字符以上。',
  'address.errors.tag_required': '必须输入收件人标签。',
  'address.label': '标签',
  'address.label_hint': '标签最多20个字符。',
  'address.memo': '笔记/标签/...',
  'address.none': '全部删除',
  'address.not_whitelisted': '非白名单',
  'address.only_dis': '只显示白名单的地址。',
  'address.remove_whitelist': '从白名单中删除',
  'address.select_coin': '选择代币',
  'address.submit': '提交',
  'address.tag': '标记',
  'address.tooltip1': '如果开启此功能，您的账户只能在注册到白名单的出款地址上支付。',
  'address.tooltip2': '关闭此功能后，您的账户可向任何出款地址收款。',
  'address.turn_off_mode_whitelist': '关闭此功能后，您可以向任何出款地址出款。确认关闭吗？',
  'address.turn_on_mode_whitelist': '开启此功能后，您只能向白名单注册的出款地址出款。确认开启吗？',
  'address.turn_on_whitelist': '请打开白名单功能。',
  'address.update_white_list': '请升级白名单功能',
  'address.updated_success': '已更新。',
  'address.white_list_off': '白名单关闭',
  'address.white_list_on': '白名单开启',
  'address.whitelisted': '白名单',
  'address.withdrawal_address': '提现地址管理',
  'address.table.empty_msg': '没有提现地址。',
  'admin.role': '权限',
  'admin.deposit_approved': '“充值完成:amountUSD:time{APP_NAME}”',
  'admin.deposit_rejected': '“充值失败:amountUSD:time数据不匹配。{APP_NAME}”',
  'admin.new_deposit': '新建充值:amountUSD:time{APP_NAME}”',
  'admin.new_withdrawal': '新增提现:amountUSD:time{APP_NAME}”',
  'admin.withdraw_approved': '提现完成:amountUSD :bankName bank :bankAccount:time{APP_NAME}”',
  'admin.withdraw_status_pending': '待定',
  'admin.withdraw_status_success': '成功',
  'approval_pending': '等待审核',
  'approval_pending.amount': '数量',
  'approval_pending.approval_request': '请求审核',
  'approval_pending.created_date': '创建日期',
  'approval_pending.currency': '货币',
  'approval_pending.detail': '详细',
  'approval_pending.title': '等待审核',
  'approval_pending.transaction_id': '交易ID',
  'approval_pending.user_name': '电子邮件地址',
  'approval_pending.view': '浏览',
  'approval_request': '请求审核',
  'approved_at': '审核时间',
  'approved_by': '审核者',
  'approved_order.amount': '数量',
  'approved_order.btn_detail': '详细',
  'approved_order.btn_search': '搜索',
  'approved_order.btn_view': '浏览',
  'approved_order.created_date': '创建日期',
  'approved_order.currency': '货币',
  'approved_order.heading_title': '已审核的交易',
  'approved_order.no': 'No',
  'approved_order.transaction_id': '交易ID',
  'approved_order.user_name': '电子邮件地址',
  'approved_order.withdraw_approval': '提现审核人',
  'approved_transaction': '已审核交易',
  'approved_transaction_page.approved_date': '审核日期',
  'approved_transaction_page.administrator_information': '管理员信息',
  'approved_transaction_page.withdrawal_currency': '提现货币',
  'approved_transaction_page.withdrawal_address': '提现地址',
  'approved_transaction_page.country': '国家',
  'approved_transaction_page.created_date': '创建日期',
  'approved_transaction_page.email': '电子邮件地址',
  'approved_transaction_page.header_title': '[详细]交易：:transaction_id',
  'approved_transaction_page.quantity': '数量',
  'approved_transaction_page.transaction_id': '交易ID',
  'approved_transaction_page.transaction_detail': '交易详情',
  'approved_transaction_page.customer_information': '顾客情报',
  'approved_transaction_page.transaction_hash': '交易哈希',
  'approved_transaction_page.remark': '<备考>',
  'approved_transactions': '已批审核交易',
  'auth.confirmation_email_subject': '[{APP_NAME}]{APP_NAME}帐户激活',
  'auth.email_confirm_success': '已确认邮件地址。',
  'auth.email_confirmation_code_invalid': '激活代码无效。',
  'auth.failed': '用户ID或密码未被正确输入。',
  'auth.failed_login': '用户ID或密码未被正确输入。',
  'auth.forgot_password': '您忘记登录密码了吗？',
  'auth.otp_code_invalid': '谷歌认证码无效。',
  'auth.otp_code_required': '必须输入谷歌认证码。',
  'auth.otp_not_used': '请等待下一个认证代码生成。',
  'auth.send_mail_failed': '无法发送邮件。请再试一次。',
  'auth.throttle': '登录次数太多了。:seconds秒后请再试一次。',
  'bank_setting.bank_setting': '银行设置',
  'bank_setting.bank_name': '银行名称',
  'bank_setting.bank_branch': '分店名称',
  'bank_setting.account_name': '账户名义',
  'bank_setting.account_no': '帐号',
  'bank_setting.edit': '编辑',
  'bank_setting.return': '返回',
  'bank_setting.save': '保存',
  'bank_setting.error.lose_bank_name': '必须输入账户名。',
  'bank_setting.error.lose_amount': '必须输入数量。',
  'bank_setting.error.lose_bank_branch': '必须输入分店名。',
  'bank_setting.error.lose_account_name': '必须输入账户名义。',
  'bank_setting.error.lose_account_no': '必须输入账户号码。',
  'bank_setting.update_success_msg': '已保存。',
  'base_deposit_withdraw_title_time': '日期',
  'base_deposit_withdraw_title_email': '电子邮件地址',
  'base_deposit_withdraw_title_transactionId': '交易ID',
  'base_deposit_withdraw_title_currency': '货币',
  'base_deposit_withdraw_title_amount': '数量/手续费',
  'base_deposit_withdraw_title_status': '状态',
  'change_password_form.confirm': '出于安全上的原因，变更安全方法后24小时禁止出款。',
  'change_password_form.confirm_new_password': '确认密码',
  'change_password_form.confirm_new_password_change': '确认密码',
  'change_password_form.error_confirm': '确认用密码不一致。',
  'change_password_form.error_duplicated_password': '新密码必须与以前的密码不同。',
  'change_password_form.error_message': '密码不会改变。',
  'common.datatable.data_empty.request_history': '您没有请求历史记录。',
  'common.datatable.data_empty.investment': 'You have no current investment.',
  'change_password_form.new_password': '新密码',
  'change_password_form.new_password_change': '新密码',
  'change_password_form.old_password': '现在的密码',
  'change_password_form.old_password_change': '现在的密码',
  'change_password_form.require_confirm': '必须输入新密码（确认）。',
  'change_password_form.require_new': '必须输入新密码。',
  'change_password_form.require_old': '必须输入当前密码。',
  'change_password_form.submit_button': '提交',
  "change_password_cancel": "Cancel",
  'change_password_form.submit_button_processing': '处理中',
  'change_password_form.successful_message': '密码已更改。',
  'change_password_form.title': '更改密码',
  'client_download.desktop': '桌面',
  'client_download.destop_content': '我们的桌面客户端已被调整为提供圆滑、高效的交易体验。',
  'client_download.more_way': '获取{APP_NAME}的其他方法',
  'client_download.provide_tool': '我们为您提供了一些随时随地交易所需的工具。',
  'client_download.sp_download': '智能应用',
  'client_download.track': '在任何地方都可以跟踪和管理交易。',
  'common.refresh': '更新',
  'common.reset': 'Reset',
  'common.geetest.fail': '请输入验证码。',
  "common.geetest.expired": "Capcha expired, please login again",
  'common.geetest.loading': '正在加载验证码。',
  'common.action.send': '发送',
  'common.action.cancel': '取消',
  'common.action.limit_close_position': '限价結算仓位',
  'common.action.market_close_position': '市价結算仓位',
  'common.action.no': '没有',
  'common.action.ok': 'OK',
  'common.action.yes': '是',
  'common.action.return': '返回',
  'common.action.save': '保存',
  'common.action.edit': '编辑',
  'common.action.enable': '有效',
  'common.action.disable': '无效',
  'common.announcements': '通知',
  'common.begin.trading': '现在马上开始交易！',
  'common.confirm': '确认',
  'common.create_account_amanpuri': '在Exchange创建帐号',
  'common.datatable.data_empty': '没有历史。',
  'common.datatable.empty_data': '没有数据。',
  'common.datatable.no_data': '没有数据。',
  'common.exchange.now': '马上交易',
  'common.error.required': '{field}必须输入。',
  'common.margin_exchange': '杠杆交易所',
  'common.margin_exchange.desc': '最大杠杆100倍。永续合约的交易。行业最先进的安全。欢迎来到比特币最先进的交易平台。',
  'common.margin_exchange.title': '订购无期限的高杠杆！',
  'common.max': '最大值',
  'common.max_only': '最大值',
  'common.market_info': '市场信息',
  'common.mobile_app': '移动应用',
  'common.mobile_app.desc': '智能手机应用程序。在哪里都可以确认和管理交易。',
  'common.mobile_app.title': '随时随地确认订单和跟踪您的交易！',
  'common.no_select': '全部删除',
  'common.chose_select': '选择',
  'common.order_status.canceled': '取消',
  'common.order_status.filled': '成交',
  'common.order_status.partial_filled': '部分成交',
  'common.placeholders.email': '电子邮件地址',
  'common.validate.email': '电子邮件地址',
  'common.placeholders.login_password': '登录密码',
  'common.placeholders.otp': '谷歌认证码',
  "common.placeholders.otp_2": "Authenticator Code",
  'common.placeholders.password': '密码',
  'common.placeholders.referral': '邀请ID（任意）',
  'common.placeholders.repeat_password': '确认密码',
  'common.placeholders.confirm_password': '确认密码',
  'common.validate.confirm_password': '确认密码',
  'common.processing': '处理中',
  'common.sales_point': '销售处',
  'common.no_file_chosen': '没有选择任何文件',
  'common.sales_point.desc': '从一个钱包转发到另一个钱包*。130个以上的虚拟货币和24小时365日的实况录音支持简单易用的服务。',
  'common.sales_point.title': '交易虚拟货币的最快方法',
  'common.slogan_create_account': '安心·安全比特币交易Demo',
  'common.spot_exchange': '现货交易所',
  'common.spot_exchange.desc': '从一个钱包转发到另一个钱包*。130个以上的虚拟货币和24小时365日的实况录音支持简单易用的服务。',
  'common.spot_exchange.title': '最先进的虚拟货币交易',
  'common.trade_type.buy': '买',
  'common.trade_type.sell': '卖',
  'common.transaction_status.cancel': '取消',
  'common.transaction_status.error': '错误',
  'common.transaction_status.pending': '待定',
  'common.transaction_status.rejected': '不承认',
  'common.transaction_status.success': '成功',
  'common.transaction_status.submitted': '提交',
  'common.window_title': '{APP_NAME}',
  'common.action.cancel': '取消',
  'common.action.confirm': '确认',
  'common.action.ok': 'OK',
  'common.date.warning': '日期范围无效。结束日期比开始日期为过去的日期。',
  'common.alert.create.success': '已创建。',
  'common.alert.update.success': '已更新',
  'common.alert.delete.success': '已删除',
  'contact.contact_us': '查询',
  'contact.got_question': '有问题吗？',
  'contact.message.sendEmailSuccess': '邮件已发送。',
  'contact.non_account_related': '关于账户以外的交流，请加入我们的网络社区。',
  'contact.please': '找不到你要找的东西吗？',
  'contact.please_check': '首先确认官方的{APP_NAME}常见问题，确认你的提问是否已经被回答',
  'contact.submit_request': '提出委托',
  'contact.view_suport': '查看支持文件',
  'currency.fullname.variable': '货币。货币名称.全名',
  'currency.ada.fullname': '卡尔达诺',
  'currency.ada.shortname': 'ADA',
  'currency.amal.fullname': 'Demo',
  'currency.amal.shortname': '4IRE',
  'currency.mgc.fullname': '芒果硬币',
  'currency.mgc.shortname': 'MGC',
  'currency.bch.fullname': '比特币现金',
  'currency.bch.shortname': 'BCH',
  'currency.btc.fullname': '比特币',
  'currency.btc.shortname': 'BTC',
  'currency.eos.fullname': 'EOS',
  'currency.eos.shortname': 'EOS',
  'currency.eth.fullname': '以太坊',
  'currency.eth.shortname': 'ETH',
  'currency.ltc.fullname': '莱特币',
  'currency.ltc.shortname': 'LTC',
  'currency.usdt.fullname': 'USDT',
  'currency.usdt.shortname': 'USDT',
  'currency.tomo.fullname': 'TomoChain',
  'currency.tomo.shortname': 'TOMO',
  'currency.tusd.fullname': 'TrueUSD',
  'currency.tusd.shortname': 'TUSD',
  'currency.usd.fullname': '美元',
  'currency.usd.shortname': 'USD',
  'currency.xlm.fullname': '恒星币',
  'currency.xlm.shortname': 'XLM',
  'currency.xrp.fullname': '瑞波币',
  'currency.xrp.shortname': 'XRP',
  "currency.bnb.fullname": "Binance Coin",
  "currency.bnb.shortname": "BNB",
  "currency.aave.fullname": "Aave Token",
  "currency.aave.shortname": "AAVE",
  "currency.atom.fullname": "Cosmos Token",
  "currency.atom.shortname": "ATOM",
  "currency.doge.fullname": "Dogecoin",
  "currency.doge.shortname": "DOGE",
  "currency.dot.fullname": "Polkadot Token",
  "currency.dot.shortname": "DOT",
  "currency.fil.fullname": "Filecoin",
  "currency.fil.shortname": "FIL",
  "currency.link.fullname": "ChainLink Token",
  "currency.link.shortname": "LINK",
  "currency.mana.fullname": "Decentraland MANA",
  "currency.mana.shortname": "MANA",
  "currency.uni.fullname": "Uniswap",
  "currency.uni.shortname": "UNI",
  "currency.sol.shortname": "SOL",
  'denial_page.amount': '数量',
  'denial_page.btn_detail': '详细',
  'denial_page.btn_search': '搜索',
  'denial_page.created_date': '创建日期',
  'denial_page.currency': '货币',
  'denial_page.heading_title': '非授权交易',
  'denial_page.no': 'No',
  'denial_page.transaction_id': '交易ID',
  'denial_page.user_name': '电子邮件地址',
  'emails.account': '数量',
  'emails.account_info': '银行：:bank，账户号码：:accountNumber，帐户名义：:name',
  'emails.amount': '数量：',
  'emails.cannot_click_link': '如果不能点击链接，请复制地址粘贴到地址栏。非常感谢。',
  'emails.confirm_email': '要启用账户，请点击下面的链接。通过确认您的邮件，我们将努力为客户提供更加便利、更安全的虚拟货币交易服务。',
  'emails.confirm_kyc': '您的 KYC 是',
  'emails.date': '时间：',
  'emails.deposit_alerts.text1': '我们收到了订单',
  'emails.deposit_alerts.text2': 'from you.',
  'emails.deposit_alerts.text3': '这个金额与{APP_NAME}的余额相加。',
  'emails.deposit_alerts.title': '【{APP_NAME}】已提出加值要求',
  'emails.deposit_approved_text1': ':email，您的充值请求被审核了。',
  'emails.deposit_approved_title': '【{APP_NAME}】充值已经完成。',
  'emails.deposit_rejected_text1': ':email，您的充值请求失败。',
  'emails.deposit_rejected_text2': '请确认充值规则、账户信息、充值代码，再次适用。',
  'emails.deposit_rejected_title': '【{APP_NAME}】充值失败。',
  'emails.deposit_usd_alerts.account_name': '账户名义',
  'emails.deposit_usd_alerts.account_no': '帐号',
  'emails.deposit_usd_alerts.amount': '数量',
  'emails.deposit_usd_alerts.bank_branch': '分店名称',
  'emails.deposit_usd_alerts.bank_name': '银行名称',
  'emails.deposit_usd_alerts.code': '代码',
  'emails.deposit_usd_alerts.text1': '系统收到了确认用户再充值交易的要求。',
  'emails.deposit_usd_alerts.text2': '交易信息',
  'emails.deposit_usd_alerts.title': '新的充值要求',
  'emails.hello': '您好、',
  'emails.kyc_rejected': '不承认',
  'emails.kyc_tilte': '【：APP_NAME】在上确认KYC',
  'emails.kyc_verified': '已承认',
  'emails.new_deposit_amount': '数量：',
  'emails.new_deposit_text1': '我收到了充值要求。',
  'emails.new_deposit_title': '要求新充值',
  'emails.new_device.text1': '您最近试图从新终端登录{APP_NAME}帐号。作为安全对策，{APP_NAME}在允许访问账户之前需要追加确认。',
  'emails.new_device.text2': '如果这是合法的行为，则可以验证新设备。',
  'emails.new_login.text1': '系统从未使用的IP地址检测到账户已登录。',
  'emails.new_login.text2': '如果此操作不是自己的操作，请禁用该设备，并立即与我们联系。',
  'emails.new_login.new_ip_title': '【Demo】警告：用新的IP登陆了。',
  'emails.new_withdrawal_text1': '收到了提现要求。',
  'emails.new_withdrawal_title': '要求新提现',
  'emails.no_reply': '这封邮件是自动发送邮件。请不要回复这封邮件。',
  'emails.on': '打开',
  'emails.say_hello': ':email，您好。',
  'emails.team': '{APP_NAME}团队',
  'emails.team_address': '(CO) {APP_NAME} - street xxx',
  'emails.team_inc': '© {APP_NAME} 保留所有权利。',
  'emails.team_inform': '会通知您',
  'emails.team_service_center': '服务中心/邮件地址<a href=\'mailto: :email \' target=\'_blank\'> :email </a> / tel. :phone',
  'emails.team_slogan': '最好的虚拟货币交易',
  'emails.thankyou': '非常感谢。',
  'emails.warning': '如果这个操作不是自己的操作，请马上联系我。',
  'emails.warning_title': '{APP_NAME}安全警告',
  'emails.welcome': '欢迎来到{APP_NAME}',
  'emails.footer.the_best_cryptocurrency': '最好的虚拟货币交易',
  'emails.footer.service_center': '服务中心',
  'emails.registed.confirmation_email_subject': '[{APP_NAME}]{APP_NAME}帐户激活',
  'emails.registed.click_on_link': '注册尚未完成。要完成确认，请点击以下链接。确认后我们会为您提供更方便更安全的虚拟货币交易服务。',
  'emails.registed.valid_24h': '收到本邮件后，请在24小时内完成账户确认。',
  'emails.registed.please_complete': '收到本邮件后，请在24小时内完成账户确认。',
  'emails.registed.thank_you': '非常感谢。',
  'emails.confirmation_reset_password.subject': '【Demo】重新设置密码',
  'emails.confirmation_reset_password.dear_account': '尊敬的',
  'emails.confirmation_reset_password.receiving_text': '因为收到了账号密码重新设定的要求，所以接收到这封邮件。',
  'emails.confirmation_reset_password.please_click': '请完成以下链接的密码变更。',
  'emails.confirmation_reset_password.valid_24h': '上述链接24小时有效。',
  'emails.confirmation_reset_password.please_confirm': '收到本邮件后，请在24小时内重新设置密码。',
  'emails.confirmation_reset_password.thank_you': '非常感谢。',
  'emails.login_new_device.subject': '警告：新设备授权',
  'emails.login_new_device.dear_account': '尊敬的',
  'emails.login_new_device.attemped_access': '您最近试图从新终端登录Demo交易所的账户。作为安全对策，在允许访问Demo帐户之前需要追加的确认。',
  'emails.login_new_device.email': '电子邮件地址',
  'emails.login_new_device.device': '设备',
  'emails.login_new_device.time': '日期',
  'emails.login_new_device.ip': 'IP地址',
  'emails.login_new_device.legitimate_activity': '如果这是合法的行为，则可以验证新设备。',
  'emails.login_new_device.team': 'Demo团队',
  'emails.login_new_device.thank_you': '非常感谢。',
  'emails.confirm_kyc.dear_name': '尊敬的先生/女士',
  'emails.confirm_kyc.subject': '【Demo】KYC确认：status',
  'emails.confirm_kyc.title_header': '【Demo】确定你的KYC',
  'emails.confirm_kyc.line_1': '这是Demo的支持。',
  'emails.confirm_kyc.line_2': '谢谢您的等待。',
  'emails.confirm_kyc.line_3': '因为正在进行本人确认的审查，请从这边登录到用户页面，确认审查结果。',
  'emails.confirm_kyc.line_4': '如果您没有在您的主页上方显示表明您需要发送身份证的消息，则您的身份证已成功完成。',
  'emails.confirm_kyc.line_5': '如果信件显示在自己的页面上，由于发送或图像错误未被授权。为此，请再确认本人确认文件后再提交。',
  'emails.confirm_kyc.line_6': '虽然无法确认提交的文件不合适的理由，但是不合适的理由主要如下，所以请确认一下提交过一次的照片是否符合以下内容。',
  'emails.confirm_kyc.line_7': '没有指定本人确认文件',
  'emails.confirm_kyc.line_8': '身份证和自拍照的脸不一样',
  'emails.confirm_kyc.line_9': '提交给ID SERPHY的文件，交换名称，日期，此人本人未一起显示',
  'emails.confirm_kyc.line_10': '没有向正面',
  'emails.confirm_kyc.line_11': '自拍照上没有显示“全脸”（没有显示全头）',
  'emails.confirm_kyc.line_12': '图像暗淡,面目不清楚',
  'emails.confirm_kyc.line_13': '上传图像失败',
  'emails.confirm_kyc.line_14': '对不起，给您添麻烦了。谢谢您的合作。',
  'emails.contact.subject': '【Demo】咨询',
  'emails.contact.dear_account': '尊敬的',
  'emails.contact.line_1': '谢谢您的咨询。',
  'emails.contact.line_2': '我们将从负责人处再次与您联系。',
  'emails.received_verify_document.dear_account': '尊敬的',
  'emails.received_verify_document.subject': '【Demo】我收到了本人确认文件。',
  'emails.received_verify_document.line_1': '感谢您继续支持Demo。',
  'emails.received_verify_document.line_2': '收到了本人确认文件。',
  'emails.received_verify_document.line_3': '按照提交的文件的顺序审查本人确认文件。',
  'emails.received_verify_document.line_4': '请等待确认。',
  'emails.received_verify_document.line_5': '根据应用程序的状态，可能会花更多的时间。谢谢您的理解。',
  'emails.received_verify_document.line_6': '请继续支持Demo。',
  'emails.received_verify_document.line_7': '这封邮件是从本公司的发送专用邮件地址发送的，不能回复。',
  'emails.withdraw_verify.subject': '【Demo】确认支出',
  'emails.withdraw_verify.line_1': '尊敬的',
  'emails.withdraw_verify.line_2': '您有以下出款请求：',
  'emails.withdraw_verify.line_3': '货币',
  'emails.withdraw_verify.line_4': '数量',
  'emails.withdraw_verify.line_5': '提现地址',
  'emails.withdraw_verify.line_6': '创建日期',
  'emails.withdraw_verify.line_7': '要确认这笔交易，请点击以下链接。',
  'emails.withdraw_verify.line_8': '非常感谢。',
  'emails.withdraw_alerts.subject': '【Demo】确认支出',
  'emails.withdraw_alerts.line_1': '尊敬的',
  'emails.withdraw_alerts.line_2': '此提现要求被审核了。',
  'emails.withdraw_alerts.line_3': '货币',
  'emails.withdraw_alerts.line_4': '数量',
  'emails.withdraw_alerts.line_5': '提现地址',
  'emails.withdraw_alerts.line_6': '创建日期',
  'emails.withdraw_alerts.line_7': '从这里转到提现处理。',
  'emails.withdraw_alerts.line_8': '感谢Demo交易所的持续支持。',
  'emails.withdraw_alerts.line_9': '这个邮件是从发送专用的电子邮件地址发送的。',
  'emails.withdraw_alerts.line_10': '因此，即使回信也不能确定内容。',
  'emails.withdraw_alerts.line_11': '非常感谢。',
  'emails.withdraw_errors_alerts.subject': '【Demo】拒绝提现',
  'emails.withdraw_errors_alerts.line_1': '您好',
  'emails.withdraw_errors_alerts.line_2': '此提现要求被拒绝了。',
  'emails.withdraw_errors_alerts.line_3': '货币',
  'emails.withdraw_errors_alerts.line_4': '数量',
  'emails.withdraw_errors_alerts.line_5': '提现地址',
  'emails.withdraw_errors_alerts.line_6': '创建日期',
  'emails.withdraw_errors_alerts.line_7': '因为发生了未知错误，所以必须拒绝请求。',
  'emails.withdraw_errors_alerts.line_8': '请慎重确认要求，再提交一次。',
  'emails.withdraw_errors_alerts.line_9': '非常感谢。',
  'emails.ban_account.subject': '【Demo】账号锁定了',
  'emails.ban_account.dear_name': '尊敬的<strong>：电子邮件</ strong>，',
  'emails.ban_account.line_1': '您的帐户已被Amapuri交易所的管理员锁定。',
  'emails.ban_account.line_2': '目前无法登录。',
  'emails.ban_account.line_3': '要解锁账户，请联系此链接。',
  'emails.withdraw_alerts.text1': '{APP_NAME}账户提现请求已完成。',
  'emails.withdraw_alerts.text2': '从app_name帐户成功实施。',
  'emails.withdraw_alerts.text3': '您可以在这里跟踪确认状态。',
  'emails.withdraw_alerts.title': '【{APP_NAME}】提现请求已经完成。',
  'emails.withdraw_errors_alerts.text1': '要求提现的交易',
  'emails.withdraw_errors_alerts.text2': '别担心，你的案子正在处理。请等待我们的反馈。',
  'emails.withdraw_errors_alerts.title': '【{APP_NAME}】提现有错误。',
  'emails.withdraw_usd_alerts.account_name': '账户名义',
  'emails.withdraw_usd_alerts.account_no': '帐号',
  'emails.withdraw_usd_alerts.amount': '数量',
  'emails.withdraw_usd_alerts.bank_branch': '分店名称',
  'emails.withdraw_usd_alerts.bank_name': '银行名称',
  'emails.withdraw_usd_alerts.text1': '系统收到了用户的提现请求。',
  'emails.withdraw_usd_alerts.text2': '交易信息',
  'emails.withdraw_usd_alerts.title': '请求新的提现',
  'emails.withdrawal_approved_text1': ':email,您的提现请求已被处理。',
  'emails.withdrawal_approved_title': '【{APP_NAME}】提现完成了。',
  'emails.deposit_withdraw_usd_alerts.hello': '<strong>：email</strong>您好',
  'emails.deposit_withdraw_usd_alerts.time': '日期',
  'emails.deposit_withdraw_usd_alerts.deposit.approved.title': '【Demo】充值已经完成。',
  'emails.deposit_withdraw_usd_alerts.deposit.approved.line_1': '你的充值要求已经完成了。',
  'emails.deposit_withdraw_usd_alerts.deposit.approved.line_2': '请登录确认余额。',
  'emails.deposit_withdraw_usd_alerts.deposit.approved.amount': '充值额',
  'emails.deposit_withdraw_usd_alerts.deposit.rejected.title': '【Demo】充值失败。',
  'emails.deposit_withdraw_usd_alerts.deposit.rejected.line_1': '你的充值要求失败了。',
  'emails.deposit_withdraw_usd_alerts.deposit.rejected.line_2': '请确认充值规则、账号信息、充值编码，再试一次。',
  'emails.deposit_withdraw_usd_alerts.deposit.rejected.amount': '充值额',
  'emails.deposit_withdraw_usd_alerts.withdrawal.approved.title': '【Demo】提现完成了。',
  'emails.deposit_withdraw_usd_alerts.withdrawal.approved.line_1': '你的提现要求已经完成了。',
  'emails.deposit_withdraw_usd_alerts.withdrawal.approved.amount': '提现额',
  'emails.deposit_withdraw_usd_alerts.withdrawal.approved.account_bank': '银行帐户',
  'emails.deposit_withdraw_usd_alerts.withdrawal.approved.account_number': '帐号',
  'emails.deposit_withdraw_usd_alerts.withdrawal.approved.account_holder': '账户名义',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.title': '【Demo】提现失败。',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.line_1': '你的提现要求失败了。',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.line_2': '请确认提现规则和账号信息，再试一次。',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.amount': '提现额',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.account_bank': '银行帐户',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.account_number': '帐号',
  'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.account_holder': '账户名义',
  'exchange.basic.chart.btn_add_chart': '添加图表',
  'exchange.basic.chart.buy_order': '买单',
  'exchange.basic.chart.candle': 'K线',
  'exchange.basic.chart.depth': '交易深度',
  'exchange.basic.chart.msg_close_chart': '可以关闭这个图表吗？',
  'exchange.basic.chart.price': '价格',
  'exchange.basic.chart.sell_order': '卖单',
  'exchange.basic.label_hour': '点',
  'exchange.basic.label_minute': '分',
  'exchange.basic.time.hour': '{number}时间',
  'exchange.basic.time.hours': '{number}时间',
  'exchange.basic.time.minute': '{number}分钟',
  'exchange.basic.time.minutes': '{number}分钟',
  'exchange.basic.time.one_day': '一天',
  'exchange.basic.time.one_month': '一个月',
  'exchange.basic.time.one_week': '一星期',
  'exchange.basic.trading_page.change_24h': '前一天比',
  'exchange.basic.trading_page.confirm': '确认',
  'exchange.basic.trading_page.evaluation_amount': '评价',
  'exchange.basic.trading_page.high': '高',
  'exchange.basic.trading_page.high_24h': '高价',
  'exchange.basic.trading_page.holding_balance': '馀额\r\n',
  'exchange.basic.trading_page.last_price': '最近的价格',
  'exchange.basic.trading_page.low': '低',
  'exchange.basic.trading_page.low_24h': '低价',
  'exchange.basic.trading_page.total_purchase_amount': '购买',
  'exchange.basic.trading_page.volume': '成交额',
  'exchange.basic.trading_page.volume_24h': '二十四小时成交额',
  'exchange.basic.trading_page.yeild': '成交率',
  'exchange.basic.trading_page.yeild_tooltip.row1': '1.基于USD换算值。',
  'exchange.basic.trading_page.yeild_tooltip.row2': '2.BTC、ETH市场也被换算成USD值。',
  'exchange.basic.trading_page.yeild_tooltip.row3': '3.支出时，根据收款及出款时的现金美元，收款被视为“买”，出款被视为“卖”。',
  'exchange.basic.trading_page.yeild_tooltip.row4': '4.成交率=（评价额-购买合计数量）÷购买合计数量×100',
  'exchange.basic.trading_page.yeild_tooltip.row5': '5.出售资产不包含在计算中。只把现在持有的资产作为对象。',
  'exchange.basic.trading_page.yeild_tooltip.row6': '6.这种收益率不代表投资的绝对范围。只为了投资目的请作为参考使用。',
  'favourite.market_price.change': '更改',
  'favourite.market_price.coin': '名称',
  'favourite.market_price.current_price': '最近的价格',
  'favourite.market_price.favorites': '收藏夹',
  'favourite.market_price.percent_day_before': '± %',
  'favourite.market_price.transaction_amount': '成交额',
  'favourite.market_price.volume': 'Vol',
  'fee_guide.actual_purcharse': '实际购买数量',
  'fee_guide.actual_sell': '实际出售',
  'fee_guide.commission_rate': '按交易量的手续费率',
  'fee_guide.commission_tip1': '{APP_NAME}根据上述交易额的不同适用不同的手续费。手续费的评价可能会有变更',
  'fee_guide.commission_tip2': '成交量排名一天进行一次。',
  'fee_guide.commission_tip3': '提取/提供者费用相同。',
  'fee_guide.example': '示例：',
  'fee_guide.fee': '手续费',
  'fee_guide.fomula_actual_pucharse': '=成交数量 (1 BTC) - 1 BTC x transaction fee rate (0.2%) = 0.998 BTC',
  'fee_guide.for_example': '示例：',
  'fee_guide.formula_actual_sell': '= 成交量（1 BTC）',
  'fee_guide.formula_fee': '= 成交数量 (1 BTC) x Transaction Fee Rate (0.2%) = 0.002 BTC',
  'fee_guide.formula_sell_fee': '= 成交数量 (1 BTC) x Price (5,000,000 USD) x Transaction Fee Rate (0.2%) = 10,000 USD',
  'fee_guide.formula_subtotal': '= 数量（1 BTC）x 价格（5,000,000美元）= 5,000,000美元',
  'fee_guide.formula_transaction_value': '= Quantity (1 BTC) x Price (USD 5,000,000) - Fees (USD 5,000) = 4,990,000 USD',
  'fee_guide.last_30_days': '过去三十天',
  'fee_guide.less_than': '少于',
  'fee_guide.level_name': '等级：',
  'fee_guide.level_title': '当前级别为',
  'fee_guide.rating': '等级',
  'fee_guide.subtotal': '合计USD(交易值)',
  'fee_guide.text13': '提取/提供者费用相同。',
  'fee_guide.text14': '购买订单的话，从成交数量中扣除手续费的价值反映在账户上。',
  'fee_guide.text15': '出售订单的话，从销售价格中扣除手续费率后的价格反映在账户上。',
  'fee_guide.text16': '订单成交后，手续费率为0.2%，价格为5,000,000USD，数量为1 BTC。',
  'fee_guide.text20': '出售订单被成交的话，手续费率是0.2％，价格是5,000,000USD，数量是1 BTC。',
  'fee_guide.text24': '实际的手续费，折扣等在订单画面能确认。',
  'fee_guide.title': '手续费信息',
  'fee_guide.transaction_fee': '交易手续费计算方法',
  'fee_guide.transaction_value': 'USD支付(交易值)',
  'funds.action.deposit': '充值',
  'funds.action.placeholder_input_coin': '请输入代币的关键字',
  "fund.action.chain_name": "Chain Name",
  'funds.action.withdraw': '提现',
  'funds.balances.amount_is_positive': '必须输入数量。',
  'funds.balances.amount_over_0': '最少金额必须比0大。',
  'funds.balances.amount_can_not_greater_than_available_balance': '可用余额不足。',
  'funds.balances.amount_can_not_greater_than_available_dividend_balance': '可用的股息余额不足。',
  'funds.balances.amount_can_not_greater_than_available_main_balance': '可用的主余额不足。',
  'funds.balances.amount_can_not_greater_than_exchange_available_balance': '主余额不足',
  'funds.balances.amount_can_not_greater_than_exchange_available_balance_without_orderbook': '可用余额不足。',
  'funds.balances.amount_can_not_greater_than_margin_available_balance': '可用保证金余额不足。',
  'funds.balances.approx': '约4IRE值',
  'funds.balances.assign': '分配',
  'funds.balances.avaliable_balance': '可用余额',
  'funds.balances.available_airdrop_balance': '可用股息余额',
  'funds.balances.balance': '余额',
  "funds.balances.balance_spot": "Balance",
  'funds.balances.convert_small_balance_success': '余额换算已完成。',
  'funds.balances.curency': '货币',
  'funds.balances.exchange_available_balance': '交易所可用余额',
  'funds.balances.available': 'Available',
  'funds.balances.action': 'Action',
  'funds.balances.total_spot_balance': 'Total Spot Balance',
  'funds.balances.total_futures_balance': 'Total Futures Balance',
  'funds.balances.exchange_balance': '交易余额',
  'funds.balances.airdrop_balance': '股息余额',
  'funds.balances.estimated_airdrop_value': '持有比例:',
  'funds.balances.unlock_date': '解锁日期\r\n',
  'funds.balances.lock_balance': '已锁住餘額',
  'funds.balances.no_data': '没有资金。',
  'funds.balances.btc_value': 'BTC値',
  'funds.balances.convert_to_amal': '换算为OGE',
  'funds.balances.convert_sm_balance': '将少额余额换算为4IRE',
  'funds.balances.coin': '代币',
  'funds.balances.deposit': '充值',
  'funds.balances.estimated_value': '总资产(BTC换算)',
  'funds.balances.from': '从',
  'funds.balances.hide': '隐藏',
  'funds.balances.hide_small_assets': '隐藏少额资产',
  'funds.balances.interval': '间距',
  'funds.balances.in_order': '等待成交',
  'funds.balances.in_use': '使用中',
  'funds.balances.infomation': '信息',
  'funds.balances.main_account': '主要帐户',
  "funds.balances.margin_balance": "Futures Balance",
  'funds.balances.mam_balance': 'MAM余额',
  'funds.balances.min_amount_is_invalid': '数量必须在0.00000000001以上。',
  'funds.balances.name': '名称',
  'funds.balances.show_all': '全部显示',
  'funds.balances.small_balance': '少额余额',
  'funds.balances.small_balance_notice': 'BTC值小于:amount',
  'funds.balances.hide_small_balance': '隐藏小数量余额',
  "funds.balances.hide_small_balance_spot": "Hide Small Balance",
  'funds.balances.P_L': 'P/L',
  'funds.balances.revoke': '撤销',
  'funds.balances.to': '直到',
  'funds.balances.tranfer': '转发',
  "funds.header":"Wallet Overview",
  'funds.balances.transfer': '转发',
  'funds.balances.transfer_balance_fails': '无法转发余额。',
  'funds.balances.airdrop_has_disable': '股利分配方案结束。您不能将钱转移到股息钱包',
  'funds.balances.transfer_balance_success': '余额转发已完成。',
  'funds.balances.total_balance': '全部余额',
  'funds.balances.total_airdrop_balance': 'Total Dividend Balance',
  'funds.balances.withdrawal': '提现',
  'funds.balances.suspend': '一時停止',
  'funds.balances.trade': '交易',
  'funds.balances.withdrawal_limit_24': '二十四小时限制支出',
  'funds.convert_to_amal': '换算为OGE',
  'funds.deposit.available_balance': '可用余额',
  'funds.deposit.choice': '选择',
  'funds.deposit.coppy_address': '复制地址',
  'funds.deposit.copy_error': '复制出错',
  'funds.deposit.copy_success': '已复制',
  'funds.deposit.copy_tag': '复制标签',
  'funds.deposit.deposit_address': ':coin提现地址',
  'funds.deposit.deposit_tag': ':coin提现标签',
  'funds.deposit.history': '历史',
  'funds.deposit.important.text1': '<span class=\'icon-favorites-2\'></span>这是ERC20 {name}存放地址, 请勿将OMNI {name}代币存放到该地址。',
  'funds.deposit.important.text2': '<span class="icon-favorites-2"></span>请只将:name发送到我们的收款地址。向这个地址发送其他货币的话，汇款交易可能会丢失。',
  'funds.deposit.in_order': '等待成交',
  'funds.deposit.not_arrive': '无法充值',
  'funds.deposit.no_data': '没有充值历史。',
  'funds.deposit.show_qr': '显示二维码',
  'funds.deposit.tips.text1': '请注意',
  'funds.deposit.tips.text2': ':name在确认:count的网络后马上就会收款。',
  'funds.deposit.tips.text3': '收款后，可以在<a class="link-primary" href="/funds/history·type=deposit" target="_blank">history</a>页面追踪进度情况。',
  'funds.deposit.title_page': '充值',
  'funds.deposit.tooltip': '“如果您的收款长时间未到货的话，可能会造成连锁店拥挤或不完整的交易。”<a class=\'link-primary\' href="#">More Reference</a>',
  'funds.deposit.total_balance': '全部余额',
  'funds.deposit.view_all': '显示全部',
  'funds.deposit.what': ':name是什么？',
  'funds.deposit_usd.cancel_deposit_usd': '取消',
  'funds.deposit_usd.deposit_amount': '充值额',
  'funds.deposit_usd.deposit_note': '请按照以下信息提现。确认一下这个金额，汇入你的账号。',
  'funds.deposit_usd.errors.min_amount': '最少金额必须比:min_amount大。',
  'funds.deposit_usd.errors.required': '必须输入充值。',
  'funds.deposit_usd.guide.text1': '1.请按充值的数量提现。',
  'funds.deposit_usd.guide.text10': '4.延迟付款时，请联系我们的客服。',
  'funds.deposit_usd.guide.text11': '如果必要的充值数量和汇款数量不同，或者忘记输入充值代码，请向支持中心发送请求。',
  'funds.deposit_usd.guide.text12': '※银行系统的入住期间限制提现。',
  'funds.deposit_usd.guide.text2': '・充值数量与实际充值数量不同的情况下，不会进行充值处理。',
  'funds.deposit_usd.guide.text3': '2.请务必输入“充值代码”。',
  'funds.deposit_usd.guide.text4': '・充值的时候，请输入充值代码作为转账内容。转发内容只使用充值代码，其他请不要使用。如果不输入充值代码的话，充值处理可能会延迟。',
  'funds.deposit_usd.guide.text7': '3.最多10分钟内充值。',
  'funds.deposit_usd.guide.text8': '·通常情况下，为了处理充值需要约3~5分钟。',
  'funds.deposit_usd.guide.text9': '充值处理后会通知你。',
  'funds.deposit_usd.notes': '备注',
  'funds.deposit_usd.other_deposit': '其他交易',
  'funds.deposit_usd.pending_transaction.account_name': '账户名义',
  'funds.deposit_usd.pending_transaction.account_no': '帐号',
  'funds.deposit_usd.pending_transaction.amount': '数量',
  'funds.deposit_usd.pending_transaction.bank_branch': '分店名称',
  'funds.deposit_usd.pending_transaction.bank_name': '银行名称',
  'funds.deposit_usd.pending_transaction.code': '代码',
  'funds.deposit_usd.submit_deposit_usd': '提交',
  'funds.deposit_usd.success_message': '完成交易。',
  'funds.deposit_usd.transaction_history_table.account': '数量',
  'funds.deposit_usd.transaction_history_table.amount': '数量',
  'funds.deposit_usd.transaction_history_table.bank': '银行',
  'funds.deposit_usd.transaction_history_table.code': '代码',
  'funds.deposit_usd.transaction_history_table.status': '状态',
  'funds.deposit_usd.transaction_history_table.time': '日期',
  'funds.history.address': '邮箱地址',
  'funds.history.amount': '数量',
  'funds.history.coin': '代币',
  'funds.history.date': '日期',
  'funds.history.deposit': '充值',
  'funds.history.export_complete_deposit_history': '输出完整的充值历史记录',
  'funds.history.export_complete_withdraw_history': '输出完整的提现历史记录',
  'funds.history.from': '从',
  'funds.history.history': '历史',
  'funds.history.infomation': '信息',
  'funds.history.status': '状态',
  'funds.history.tag': '标记',
  'funds.history.to': '直到',
  'funds.history.transaction_history': '交易历史',
  "funds.history.spot_overview": "Spot",
  "funds.history.future_overview": "Futures",
  'funds.history.txid': 'Txid',
  'funds.history.withdrawal': '提现',
  'funds.select_coin': '选择代币',
  'funds.withdraw_usd.account_info': '账户信息',
  'funds.withdraw_usd.account_name': '账户名义',
  'funds.withdraw_usd.account_no': '帐号',
  'funds.withdraw_usd.amount': '数量',
  'funds.withdraw_usd.available': '可用',
  'funds.withdraw_usd.bank_branch': '分店名称',
  'funds.withdraw_usd.bank_info': '银行信息',
  'funds.withdraw_usd.bank_name': '银行名称',
  'funds.withdrawals.add_new_address': '请在下面输入新的充值地址',
  'funds.withdrawals.add_whitelist_address': '没有白名单的地址。请在{APP_NAME}网站管理你的地址。',
  'funds.withdrawals.amount': '数量',
  'funds.withdrawals.available_balance': '可用余额',
  'funds.withdrawals.choice': '选择',
  'funds.withdrawals.no_data': '没有提现历史。',
  'funds.withdrawals.no_usd_data': '没有USD提现历史。',
  'funds.withdrawals.confirm_otp': 'OTP的确认',
  'funds.withdrawals.confirm_withdraw': '确认提现',
  'funds.withdrawals.did_not_receive_the_mail': '无法接收邮件时',
  'funds.withdrawals.empty_whitelist.address_management': '邮件地址管理',
  'funds.withdrawals.empty_whitelist.text': '没有白名单的地址。',
  'funds.withdrawals.error_message.address_not_exist_in_whitelist': '此地址不在白名单地址中。',
  'funds.withdrawals.error_message.amount_withdraw_is_positive': '提现数量必须是负数。',
  'funds.withdrawals.error_message.minimum_withdraw': '你的提现比最小单位少。',
  'funds.withdrawals.error_message.not_enough_balance': '交易需要的余额不足。',
  'funds.withdrawals.error_message.over_daily_limit': '提现了一天的限额。',
  'funds.withdrawals.error_message.over_limit': '已经提现了限额。',
  'funds.withdrawals.error_message.over_one_time_limit': '超过了每次的限额提现。',
  'funds.withdrawals.error_message.withdraw_is_blocking': '提现已被鎖住。',
  'funds.withdrawals.errors.account_no_length': '账户号码无效。',
  'funds.withdrawals.errors.blockchain_address': '提现地址无效。',
  'funds.withdrawals.errors.exist_withdraw_address': '这个地址已经存在。',
  "funds.withdrawals.errors.invalid": "The withdrawal address is not valid",
  'funds.withdrawals.errors.max_balance': '账户余额不够。',
  'funds.withdrawals.errors.max_once_amount': '提现数量超过了一次最大数量。',
  'funds.withdrawals.errors.min_amount': '提现的最少金额是:min_amount。',
  'funds.withdrawals.errors.not_allowed_withdraw': '您的安全水平不允许提现。',
  'funds.withdrawals.errors.otp_length_digits': '认证码必须是6位。',
  'funds.withdrawals.errors.otp_length_6_digits': '认证码必须是6位。',
  'funds.withdrawals.errors.otp_required': '必须输入认证码。',
  'funds.withdrawals.errors.required': '必须输入充值。',
  'funds.withdrawals.history': '历史',
  'funds.withdrawals.important.text1': '重要',
  'funds.withdrawals.important.text2': '最少的提现额',
  'funds.withdrawals.important.text3': '如果从本交易所直接提现给云台或ICO的话，有可能无法收到在那里购买的令牌，所以请不要这样做。关于本公司以外的收取代币纠纷，本公司概不负责。',
  'funds.withdrawals.in_order': '等待成交',
  'funds.withdrawals.input_address_error': '无效的地址',
  'funds.withdrawals.loading': '处理中',
  'funds.withdrawals.submit': '提交',
  'funds.withdrawals.success_message': '完成交易。',
  'funds.withdrawals.tips.text1': '请注意',
  'funds.withdrawals.tips.text2': '如果发送了收款请求，确认邮件就会发送，请点击确认链接。',
  'funds.withdrawals.tips.text3': '充值后，可以在<a style="color: 2e9bdb;font-weight: bold;" href="/funds/history-wallet?type=withdraw" target="_blank">history</a>页面追踪进度状况。',
  'funds.withdrawals.title_page': '提现',
  "funds.withdrawals.title_chain_name": "Chain Name",
  'funds.withdrawals.tooltip': '“如果找不到邮件，请检查垃圾邮件和其他文件夹。',
  'funds.withdrawals.total_balance': '全部余额',
  'funds.withdrawals.transaction_fee': '交易手续费',
  'funds.withdrawals.use_a_new_address': '使用新地址',
  'funds.withdrawals.view_all': '显示全部',
  'funds.withdrawals.what': ':name是什么？',
  'funds.withdrawals.withdrawal_address': '提现地址',
  'funds.withdrawals.withdrawal_limit_24': '二十四小时限制提现',
  'funds.withdrawals.withdrawal_placeholder_address': '邮箱地址',
  'funds.withdrawals.withdrawal_placeholder_available': '可用',
  'funds.withdrawals.withdrawal_placeholder_label': '标签',
  'funds.withdrawals.xrp_tag': '提现标签',
  'funds.withdrawals.you_will_get': '你会得到',
  'funds.disable_coin_msg': '本功能已禁用，请等待升级。',
  "funds.spot_esstimate": "Estimated Total Spot Balance",
  "funds.futures_esstimate": "Estimated Total Futures Balance",
  'landing.banner.desc': '最大杠杆100倍。永续合约的交易。行业最先进的安全。欢迎来到比特币最先进的交易平台。',
  'landing.banner.title.span': 'Smart Bitcoin -',
  'landing.banner.title.text': 'Lựa chọn thông minh cho tương lai của bạn',
  "landing.banner.title.sub": "Buy, sell and market digital assets at exchange Sotatek",
  "landing.signup": "Đăng ký với email hoặc số điện thoại",
  "landing.sub.button": 'or',
  "landing.log_in": "Log in and Start Trading",
  "landing.info_title": "Why Sotatek?",
  "landing.info_title_sub_high": "High Security",
  "landing.info_content_high": "We protect mobile users data as well as the web and use all security's best practices",
  "landing.info_title_sub_inter": "Intuitive Interface",
  "landing.info_content_inter": "Dễ dàng sử dụng và thực hiện nhanh chóng các thao tác để mua, chuyển và giao dịch mã hóa",
  "landing.info_title_sub_chat": "Chat Support",
  "landing.info_content_chat": "24/7 live chat support in the app will help you find a solution to your problems.",
  "landing.title_market": "Markets",
  "landing.content_market": "Crypto assets overview",
  "landing.title_spot": "Spot",
  "landing.content_spot": "A crypto market where you can buy and sell cryptocurrencies for immediate delivery with real-time price.",
  "landing.title_future": "Futures",
  "landing.content_future": "An agreement contract for you to own, with the power of buying or selling a specific cryptocurrency at a later date.",
  "landing.title_saving": "Saving",
  "landing.content_saving": "Earn a passive crypto income with your deposited cryptocurrencies.",
  "landing.title_staking": "Staking",
  "landing.content_staking": "Way to put your crypto to work and earn rewards on it.",
  "landing.title_copy": "Copytrade",
  "landing.content_copy": "Copy and get your profit.",
  "landing.title_market": "Markets",
  "landing.content_market": "Crypto assets overview",
  "landing.title_spot": "Spot",
  "landing.content_spot": "A crypto market where you can buy and sell cryptocurrencies for immediate delivery with real-time price.",
  "landing.title_future": "Futures",
  "landing.content_future": "An agreement contract for you to own, with the power of buying or selling a specific cryptocurrency at a later date.",
  "landing.title_saving": "Saving",
  "landing.content_saving": "Earn a passive crypto income with your deposited cryptocurrencies.",
  "landing.title_staking": "Staking",
  "landing.content_staking": "Way to put your crypto to work and earn rewards on it.",
  "landing.sub_info_1":"Trade Anywhere",
  'landing.change': '前一天比',
  'landing.chart.change': '更改',
  'landing.chart.last_price': '最近的价格',
  'landing.clients_download': '下载',
  'landing.clients_text1': '获取{APP_NAME}的其他方法',
  'landing.clients_text2': '我们为您提供了一些随时随地交易所需的工具。',
  'landing.coin': '代币',
  'landing.coin_markets': '{coin}市场',
  'landing.favorites': '收藏夹',
  'landing.high': '高价',
  'landing.last_price': '最近的价格',
  'landing.low': '低价',
  'landing.pair': '交易对',
  'landing.price': '价格',
  'landing.register': '马上注册',
  'landing.gotrade': '进行交易',
  'landing.slogan': 'Exchange the World',
  'landing.volume': '二十四小时成交额',
  'landing.current_rate': '当前<br/>匯率',
  "landing.market.title": "Markets",
  "landing.title_volume" : "Top Volume Coin",
  "landing.title_listing" : "New Listing",
  "landing.title_gainer": "Top Gainer Coin",
  "landing.title_loser": "Top Loser Coin",
  "landing.title_Spot": "Spot",
  "landing.title_Future": "Futures",
  "landing.title_Favorites": "Favorites",
  'login.active_device_failed': '认证链接无效或过期。',
  'login.active_device_success': '新设备的认证成功。<br/>请再登录一次。<p></p><p style="color: #12575f; font-size:14px">Device: <strong style="font-family :"Roboto-Bold", sans-serif">:platform :operating_system</strong></p><p style="color: #12575f; font-size:14px">IP address: <strong style="font-family :"Roboto-Bold", sans-serif">:latest_ip_address</strong> </p>',
  'login.confirm_failed': '确认链接无效或过期。',
  'login.confirm_email_failed': '找不到拥有那个邮箱地址的用户。',
  'login.confirm_success': '确认了邮件地址。',
  'login.dont_has_account': '您要注册账户吗？',
  'login.forgot': '您忘记登录密码了吗',
  'login.sub_title': '请确认访问的网站是否正确。',
  'login.title': '登录',
  'login.title_otp': '谷歌认证系统',
  'login.resend_confirm_mail_success': '<strong title=":email">:email</strong>再次发送确认邮件',
  'm_account.btn_continue': '明白了。继续。',
  'm_account.change_pass': '更改密码',
  'm_account.gg_auth': '谷歌认证系统',
  'm_account.go_pc': '要完成Google认证系统的设定，请访问{APP_NAME}电脑的网站。',
  'm_account.id': 'ID',
  'm_account.identity_auth': '识别认证',
  'm_account.language': '语言',
  'm_account.logout': '退出',
  'm_account.lv': 'Lv',
  'm_account.referral.commission': '发生报酬',
  'm_account.referral.commission_rate': '发生报酬比例：',
  'm_account.referral.count': 'No.',
  'm_account.referral.detail': '程序详情',
  'm_account.referral.detail_notice': '{APP_NAME}有权根据市场的变化、欺诈风险、或者与本公司相关联的其他因素，随时改变介绍程序的条件。',
  'm_account.referral.estimate': '报酬额',
  'm_account.referral.get_link': '1.获取链接',
  'm_account.referral.info_get_link': '介绍链接和二维码的生成',
  'm_account.referral.info_invite': '经由介绍链接或二维码注册的朋友进行交易可以领取报酬',
  'm_account.referral.info_reward': '实时收取最多40%的报酬。',
  'm_account.referral.invite': '2.邀请朋友',
  'm_account.referral.line1': '2018/05/19 0:00 AM (UTC)当前有效',
  'm_account.referral.line2': '从介绍程序接受的报酬，最初设定为20%。如果您想要保留:COIN_HOLDING或更多金额的账户，此比例将增加到40%。',
  'm_account.referral.line3': '被介绍人完成交易后，手续费会立即发送到您的{APP_NAME}帐号，并支付原始手续费的令牌/密码货币支付。',
  'm_account.referral.line4': '虽然你介绍的朋友数量没有限制，但是介绍项目的规定有权让运营方随时调整或变更。',
  'm_account.referral.line5': '被介绍的人必须通过你的介绍链接、二维码或介绍ID签名。',
  'm_account.referral.line6': '{APP_NAME}检查重复登录和假账户的不正当登录，不向这些账户支付介绍费。如果有重复或共享的信息则失去资格。',
  'm_account.referral.my_referral': '推荐人',
  'm_account.referral.notice': '*重要通知：',
  'm_account.referral.referral_friend': '介绍的朋友',
  'm_account.referral.referral_id': '推荐人ID：',
  'm_account.referral.referral_link': '介绍链接：',
  'm_account.referral.reward': '3.获得报酬',
  'm_account.referral.text29': '邀请朋友的时候请扫描二维码，获得报酬。',
  'm_account.referral.title': '介绍程序',
  'm_account.title': '{APP_NAME}请勿向任何人公开Google认证码，包括客户支持。',
  'm_account.title_identity': '要完成相关设定，请访问{APP_NAME} PC的网站(www.mango.com)。',
  'm_account.unverified': '未承认',
  'm_account.verified': '已承认',
  'm_common.action.cancel': '取消',
  'm_common.action.confirm': '确认',
  'm_common.action.more': '再看看',
  'm_common.action.off': '关闭',
  'm_common.action.on': '开启',
  'm_common.time.hour': '{number}时间',
  'm_common.time.hours': '{number}时间',
  'm_common.time.label_minute': '分',
  'm_common.time.minute': '{number}分钟',
  'm_common.time.minutes': '{number}分钟',
  'm_exchange.chart.amount': '数量',
  'm_exchange.chart.buy': '买',
  'm_exchange.chart.candle': 'K线',
  'm_exchange.chart.charts': '图表',
  'm_exchange.chart.depth': '交易深度',
  'm_exchange.chart.high': '高',
  'm_exchange.chart.low': '低',
  'm_exchange.chart.market_trade_history': '市场交易记录',
  'm_exchange.chart.price': '价格',
  'm_exchange.chart.sell': '卖',
  'm_exchange.chart.time': '日期',
  'm_exchange.chart.trade_detail': '交易详情',
  'm_exchange.chart.trade_history': '交易历史',
  'm_exchange.chart.volume': 'Vol',
  'm_exchange.open_order.open_order': '订单一览',
  'm_exchange.trade.available': '可用',
  'm_exchange.trade.buy': '买',
  'm_exchange.trade.sell': '卖',
  'm_exchange.trade.trade': '交易',
  'm_funds.coin_info.available': '可用',
  'm_funds.coin_info.deposit': '充值',
  'm_funds.coin_info.estimate': '预测',
  'm_funds.coin_info.go_to_trade': '进行交易',
  'm_funds.coin_info.in_order': '等待成交',
  'm_funds.coin_info.total': '合计',
  'm_funds.coin_info.withdraw': '提现',
  'm_funds.current': '现在',
  'm_funds.deposit.save_qr_code': '保存二维码',
  'm_funds.deposit.select_coin': '选择硬币',
  'm_funds.deposit_usd.available_balance': '可用余额',
  'm_funds.deposit_usd.deposit_amount': '充值额',
  'm_funds.deposit_usd.deposit_usd_tab': 'USD充值',
  'm_funds.deposit_usd.errors.required': '必须输入充值。',
  'm_funds.deposit_usd.guide.text1': '1.请按充值的数量提现。',
  'm_funds.deposit_usd.guide.text10': '4.延迟付款时，请联系我们的客服。',
  'm_funds.deposit_usd.guide.text11': '如果必要的充值数量和充值数量不同，或者忘记输入充值代码，请向客服发送请求。',
  'm_funds.deposit_usd.guide.text12': '※银行系统的入住期间限制提现。',
  'm_funds.deposit_usd.guide.text2': '・充值数量与实际充值数量不同的情况下，不会进行充值处理。',
  'm_funds.deposit_usd.guide.text3': '2.请务必输入“充值代码”。',
  'm_funds.deposit_usd.guide.text4': '・充值的时候，请输入充值代码作为转账内容。转发内容只使用充值代码，其他请不要使用。如果不输入充值代码的话，充值处理可能会延迟。',
  'm_funds.deposit_usd.guide.text7': '3.最多10分钟内充值。',
  'm_funds.deposit_usd.guide.text8': '·通常情况下，为了处理充值需要约3~5分钟。',
  'm_funds.deposit_usd.guide.text9': '充值处理后会通知你。',
  'm_funds.deposit_usd.history_tab': '历史',
  'm_funds.deposit_usd.in_order': '等待成交',
  'm_funds.deposit_usd.notes': '注意',
  'm_funds.deposit_usd.submit_deposit_usd': '提交',
  'm_funds.deposit_usd.total_balance': '全部余额',
  'm_funds.deposit_usd.transaction_history_table.cancel': '取消',
  'm_funds.deposit_usd.transaction_history_table.no': 'No',
  'm_funds.deposit_usd.transaction_history_table.text1': '确认取消吗？',
  'm_funds.deposit_usd.transaction_history_table.yes': '是',
  'm_funds.transaction_history.deposit_history': '充值履历',
  'm_funds.transaction_history.no_deposit_history': '没有充值履历。',
  'm_funds.transaction_history.no_withdraw_history': '没有提现履历。',
  'm_funds.transaction_history.withdraw_history': '提现履历',
  'm_funds.withdraw_usd.history_tab': '历史',
  'm_funds.withdraw_usd.limit_and_notice': '指数&通知',
  'm_funds.withdraw_usd.withdraw_usd_tab': 'USD提现',
  'm_funds.withdrawals.but_withdraw': '提现',
  'm_funds.withdrawals.but_withdrawal': '提现',
  'm_funds.withdrawals.errors.required': '必须输入此项。',
  'm_funds.withdrawals.fee': '手续费',
  'm_funds.withdrawals.limit_and_notice': '指数&通知',
  'm_funds.withdrawals.limit_and_notice_modal.in_use': '使用中',
  'm_funds.withdrawals.limit_and_notice_modal.title': '指数&通知',
  'm_funds.withdrawals.limit_and_notice_modal.withdrawal_limit_24': '二十四小时限制取款',
  'm_funds.withdrawals.notes': '<span>最少額の提现: :min :coin</span>',
  'm_funds.withdrawals.notes2': '如果从本交易所直接提现给云台或ICO的话，有可能无法收到在那里购买的令牌，所以请不要这样做。关于本公司以外的收取代币纠纷，本公司概不负责。',
  'm_funds.withdrawals.notes3': '如果发送了提现请求，确认邮件就会发送，请点击确认链接。',
  'm_funds.withdrawals.select_coin': '选择代币',
  'm_funds.withdrawals.withdrawal_amount': '提现额',
  'm_landing.change_24h': '前一天比',
  'm_landing.deposit': '充值',
  'm_landing.gainers': '受益者',
  'm_landing.losers': '損失者',
  'm_landing.more': '再看看',
  'm_landing.support': '支持',
  'm_landing.top24btc': 'BTC的24小时完成量首位',
  'm_landing.withdraw': '提现',
  'm_menu.deposits': '充值',
  'm_menu.home': '主页',
  'm_menu.language': '语言',
  'm_menu.markets': '市场',
  'm_order_history.avg': '平均',
  'm_order_history.conditions': '条件',
  'm_order_history.more': '再看看',
  'm_order_history.trade_detail': '交易详情',
  'm_order_history.trading_price': '交易价格',
  'm_pair_navigation.change_24h': '前一天比',
  'm_pair_navigation.last_price': '最近的价格',
  'm_pair_navigation.name': '名称',
  'm_pair_navigation.vol': 'Vol',
  'm_salespoint.buy_history': '购买记录',
  'm_margin.trade_history': '交易历史',
  'm_margin.order_history': '历史订单',
  'm_margin.contracts': '\r\n合约',
  'menu.about': '基本信息',
  'menu.account': '数量',
  "menu.preferences": 'Preferences',
  "menu.notifications": 'Notifications',
  "menu.notification_language": 'Notification Language',
  "menu.sub_notification_language": 'Email and app push notification language settings.',
  "menu.onsite_notification": 'On-site Notifications',
  "menu.sub_onsite_notification": 'Once enabled, you will receive relevant notifications within the app and website.',
  "menu.maket_email": "Marketing Emails",
  "menu.sub_maket_email": "Select whether you want to receive marketing emails from us.",
  "menu.default": 'Default',
  "menu.activities_trade": 'Activities,Trade Notification, System Messages',
  "menu.on": 'On',
  "menu.kyc_status": "KYC Status",
  "menu.kyc_status_verified": "Verified",
  "menu.kyc_status_unverified": "Unverified",
  'menu.address': '邮件地址管理',
  'menu.api': 'API',
  'menu.apply_to_list': '添加到列表',
  'menu.balances': '余额',
  'menu.change_password': '更改密码',
  'menu.contact': '查询',
  'menu.demo': '演示',
  'menu.deposit_usd': 'USD充值',
  'menu.deposits': '充值',
  'menu.estimated_value': '总资产(BTC换算)',
  'menu.exchange': '交易所',
  'menu.fees': '交易手续费',
  'menu.funds': '资产',
  'menu.history': '历史',
  'menu.history_title': '历史',
  'menu.info': '信息',
  'menu.join_us': '录取信息',
  'menu.margin_exchange': '杠杆交易所',
  'menu.lang.en': '英语',
  'menu.lang.ja': '日语',
  'menu.lang.vis': 'Visayan',
  'menu.lang.il': 'Ilocano',
  'menu.lang.tl': 'Tagalog',
  'menu.login': '登录',
  'menu.logout': '退出',
  'menu.news': '通知',
  'menu.one_day': '一天',
  'menu.one_month': '一月',
  'menu.one_week': '一周',
  'menu.open_orders': '订货一览',
  'menu.or': 'or',
  'menu.order_history': '历史订单',
  'menu.privacy': '隐私政策',
  'menu.register': '新建注册',
  'menu.sales_point': '销售处',
  'menu.support': '支持',
  'menu.support_withdrawal': '提现指南',
  'menu.spot_exchange': '现货交易所',
  'menu.terms': '使用规章',
  'menu.three_months': '3月',
  'menu.trade_history': '交易历史',
  'menu.transaction_history': '交易历史',
  'menu.wallet': '钱包',
  'menu.withdraw_usd': 'USD提现',
  'menu.withdrawals': '提现',
  "menu.off": 'Off',
  "security.2fa": "Two-Factor Authentication (2FA)",
  "security.google_authenticator": "Google Authenticator",
  "security.sub_google_authenticator": "Protect your account and transactions",
  "security.addvanced_security": "Advanced Security",
  "security.change_password": "Change Password",
  "security.phone_number": "Phone Number",
  "security.sub_change_password": "Login password is used to log in to your account",
  "security.withdrawal_whitelist": "Withdrawal Whitelist",
  "security.sub_withdrawal_whitelist": "Once this function is enabled, your account will only be able to withdraw to addresses on your whitelist",
  "security.address_management": "Address Management",
  "security.anti_phishing_code": "Anti-Phishing Code",
  "security.sub_anti_phishing_code": "Protect your account from phishing attempts and ensure that your notification emails are from Sotatek only",
  "security.sub_phone_number": "Use your phone number to protect your account and transactions.",
  "security.devices_activities": "Devices and Activities",
  "security.device_management": "Device Management",
  "security.sub_device_management": "Manage devices allowed to access your acoount.",
  "security.account_activity": "Account Activity",
  "security.manage": "Manage",
  "security.more": "More",
  'messages.error.balance_insufficient': '余额不足。',
  'messages.error.buy.empty_base_price': '请输入止損价格订购的价格。',
  'messages.error.buy.empty_limit': '请输入购买指数订购的价格。',
  'messages.error.buy.empty_price': '请输入购买价格。',
  'messages.error.buy.empty_quantity': '请输入购买数量。',
  'messages.error.empty_total': '必须输入总和。',
  'messages.error.minimum_base_price': '止損价格必须在:minimum以上。',
  'messages.error.minimum_limit': '限价必须在:minimum以上。',
  'messages.error.minimum_price': '价格必须在:minimum以上。',
  'messages.error.minimum_quantity': '数量必须在:minimum以上。',
  'messages.error.minimum_quantity_convert': '{underlying_asset} amount must be higher than {minimum}.',
  'messages.error.minimum_total': '总计必须在:minimum以上。',
  'messages.error.minimum_total_convert': '{quote_asset} amount must be higher than {minimum}.',
  'messages.error.sell.empty_base_price': '请输入止損价格订购的价格。',
  'messages.error.sell.empty_limit': '请输入卖限价订单的价格。',
  'messages.error.sell.empty_price': '请输入售价。',
  'messages.error.sell.empty_quantity': '请输入卖量。',
  'messages.insufficient_balance': '余额不足。',
  'messages.error.balance_insufficient1': '余额不足。请充值您的交易账号。',
  'messages.error.balance_insufficient_convert': 'Your balance is insufficient. Please check again',
  'enable_trading.validation.insufficient_balance': '余额不足。请充值您的交易账号。',
  'messages.send_contact_success': '邮件已发送。',
  'messages.send_contact_wrong_data': '数据不正确。',
  'messages.sesstion_terminated': '因为从其他设备或浏览器登录到这个账户，所以当前会话结束。',
  'messages.successful_login': '{APP_NAME}登录:email',
  'messages.unauthorize': '不承认',
  'messages.your_otp_code': '认证代码是:otp。',
  'messages.disable_coin_msg': '本功能已禁用，请等待升级。',
  'modal_trading_pair_information.amount_limit': '数量限制',
  'modal_trading_pair_information.btn_cancel': '取消',
  'modal_trading_pair_information.btn_submit': '提交',
  'modal_trading_pair_information.day': '日',
  'modal_trading_pair_information.days': '日',
  'modal_trading_pair_information.fee': '手续费',
  'modal_trading_pair_information.market_price': '行市',
  'modal_trading_pair_information.minimum_amount': '',
  'modal_trading_pair_information.minimum_total': '',
  'modal_trading_pair_information.pair': '交易对',
  'modal_trading_pair_information.popup_title': '交易配对信息',
  'modal_trading_pair_information.precision': '价格精度',
  'modal_trading_pair_information.time_reset': '时间复位',
  'modal_trading_pair_information.total_limit': '合计限制',
  'modal_trading_pair_information.trading_fee': '交易手续费',
  'modal_trading_pair_information.trading_limit': '交易限制',
  'modal_trading_pair_information.trading_pair': '交易配对',
  'order.open_order.no_data': '现在没有订单',
  'order.open_order.no_data.all': '没有订单',
  "order.open_order.no_data.all_sub_message":"You currently have no open orders to cancel",
  'order.open_order.no_data.limit': '没有限价订单',
  "order.open_order.no_data.limit_sub_message":"You currently have no open limit orders to cancel",
  'order.open_order.no_data.stop_limit': '没有止损限价单',
  "order.open_order.no_data.stop_limit_sub_message": "You currently have no open stop limit orders to cancel",
  'order.open_order.no_data.market': '没有市场秩序',
  "order.open_order.no_data.market_sub_message":"You currently have no open market orders to cancel",
  'order.open_order.no_data.stop_market': '没有停止市场秩序',
  "order.open_order.no_data.stop_market_sub_message":"You currently have no open stop market orders to cancel",
  "fee_withdraw": "Fee has changed",
  'limit_withdraw': "The amount you withdraw is more than once allowed",
  'daily_limit_withdraw': "Daily limit has changed",
  "over_one_time_limit": "The amount you withdraw is more than once allowed",
  'order.open_order.action': '动作',
  'order.open_order.amount': '数量',
  'order.open_order.cancel': '取消',
  'order.open_order.cancel_all': '取消全部',
  'order.open_order.cancel_all_message': '要取消所有的订单吗？',
  "order.open_order.cancel_all_title":"Cancel All Orders",
  'order.open_order.cancel_limit_orders': '取消定价',
  'order.open_order.cancel_market_orders': '取消市场订单',
  'order.open_order.cancel_stop_market_orders': '取消停止成交订单',
  'order.open_order.cancel_stop_limit_orders': '取消停止限额',
  'order.open_order.cancel_limit_price_message': '取消所有限价订单吗？',
  "ordder.open_order.cancel_limid_price_title": "Once you confirm, all open stop limit orders will be cancelled",
  'order.open_order.cancel_one_message': '取消这个订单吗？',
  "order.open_order.cancel_one_title": "Cancel order?",
  'order.open_order.cancel_order_success': '订单已取消',
  'order.open_order.match_order_success': 'Your order has been matched!',
  'order.open_order.cancel_orders_success': '订单已取消',
  'order.open_order.cancel_stop_limit_order': '取消停止限额',
  'order.open_order.cancel_stop_limit_price_message': '取消所有停止限额订单吗？',
  "order.open_order.cancel_stop_limit_price_title": "Cancel All Stop Limit Orders",
  "order.open_order.cancel_limit_order_title":"Hủy tất cả lệnh Limit",
  "order.open_order.cancel_limit_order_message":"Once you confirm, all open limit orders will be cancelled",
  "order.open_order.cancel_market_orders_title": "Cancel All Market Orders",
  "order.open_order.cancel_market_orders_message": "Once you confirm, all open market orders will be cancelled",
  "order.open_order.cancel_stop_market_orders_title": "Cancel All Stop Market Orders",
  "order.open_order.cancel_stop_market_orders_message": "Once you confirm, all open stop market orders will be cancelled",
  "order.open_order.cancel_stop_market_order": "Cancel Stop Market Order",
  "order.open_order.cancel_stop_market_price_message": "Do you want to cancel all Stop Market Orders?",
  'order.open_order.cancel_stop_market_order': '取消停止成交订单',
  'order.open_order.cancel_stop_market_price_message': '取消所有的停止成交订单吗？',
  "order.open_order.cancel_stop_market_price_title":"Cancel All Market Orders",
  'order.open_order.date': '日期',
  'order.open_order.deposit': '充值',
  'order.open_order.empty_open_order': '现在没有订单。',
  'order.open_order.filled': '成交',
  'order.open_order.hide_other_pairs': '隐藏其他配对',
  'order.open_order.hide_small_assets': '隐藏少额资产',
  'order.open_order.infomation': '信息',
  'order.open_order.limit_order': '限价订单',
  'order.open_order.market': '市场',
  'order.open_order.open_order': '订单一览',
  'order.open_order.pair': '交易对',
  'order.open_order.price': '价格',
  'order.open_order.side': '侧面',
  "order.open_order.exec_type": "Exec Type",
  "trade.exec_type_sell" : "Trading",
  "trade.exec_type_buy" : "Trading",
  "trade.exec_type_trading" : "Trading",
  "trade.exec_type_funding" : "Funding",
  'order.open_order.stop_limit_order': '止盈限价订单',
  'order.open_order.total': '合计',
  'order.open_order.trigger_conditions': '触发条件',
  'order.open_order.type': '类别',
  'order.open_order.withdrawal': '提现',
  'order.open_order.withdrawal_limit_24': '二十四小时限制支出',
  'order.order_book.amount': '数量',
  'order.order_book.decimals': '小数位数',
  'order.order_book.orderBook': 'Order Book',
  'order.order_book.price': '价格',
  'order.order_book.total': '合计',
  'order.order_form.amount': '数量',
  'order.order_form.balance': ':param余额',
  'order.order_form.buy': '买',
  'order.order_form.limit': '现价',
  'order.order_form.market': '市场',
  'order.order_form.stop_limit': '限价止损',
  'order.order_form.stop_market': '市价止损',
  'order.order_form.limited_price': '现价',
  'order.order_form.login': '登录',
  'order.order_form.or': 'or',
  'order.order_form.price': '价格',
  'order.order_form.register': '新建注册',
  'order.order_form.sell': '卖',
  'order.order_form.stop': '止盈',
  'order.order_form.stop_limit_tooltip': '止盈限价订单是指定价触发价格达到指定价格后，以那个价格买卖硬币的订单。',
  'order.order_form.stop_market_tooltip': '止盈市价订单是达到指定价格的触发价格后，以市场价格买卖硬币的订单。',
  'order.order_form.success': '{trade_type}完成订单！',
  'order.order_form.total': '合计',
  "order.order_form.trade": "to start trading",
  'order.order_form.limit_tooltip': 'Limit order<br>' +
      '                To buy or sell a coin once the\n' +
      '                price reaches a specified price.',
  'order.order_form.market_tooltip': 'Market order<br> Immediately matched to the best available market price.',

  'order.order_form.view_more': '再看看',
  'order.order_form.available': 'Available',
  'circuit_breaker.blocking': '交易配对受阻！',
  'circuit_breaker.unblocking': '交易配对畅通无阻！',
  'circuit_breaker.remain_second_text': '断路器阻止了交易，將在{minutes}分钟内解锁。',
  'beta_tester.header': '该版本是beta版。',
  'beta_tester.content': '希望使用beta版的用户请确认以下内容并在复选框中复选，并向管理者申请。<br>※由于是BETA版，一部分功能可能出现故障。发现问题时，请立即向管理员报告。<br><a href ="mailto: kim@demo.io">kim@demo.io</a>',
  'beta_tester.ignore_tester': '忽略测试',
  'beta_tester.dont_show_again': '不再显示',
  'beta_tester.agree_term': '同意我们的条款和条件！',
  'beta_tester.ok': 'OK',
  'beta_tester.or': '或是',
  'beta_tester.cancel': '取消',
  'beta_tester.validate.agree_term': '请同意条款和条件',
  'beta_tester.register_success': '注册Beta Tester成功',
  'beta_tester.register_fail': '注册Beta  Tester失败',
  'beta_tester.disable_by_beta_tester': '请成为Beta Tester後进行交易',
  'beta_tester.wait_admin_verify.header': '等待管理员确认',
  'beta_tester.wait_admin_verify.content': '请等待管理员确认您的注册Beta  Tester请求。',
  'order.order_history.action': '动作',
  'order.order_history.no_data': '没有订单履历。',
  'order.order_history.all': '全部',
  'order.order_history.amount': '数量',
  'order.order_history.average': '平均',
  'order.order_history.buy': '买',
  'order.order_history.cancel': '取消',
  'order.order_history.cancel_all': '取消全部',
  'order.order_history.coin': '代币',
  'order.order_history.date': '日期',
  'order.order_history.deposit': '充值',
  'order.order_history.empty_order_history': '没有订单历史',
  'order.order_history.export_complete_order_history': '导出订单历史',
  'order.order_history.export_complete_order_history_tooltip': '导出6个月份的订单记录',
  'order.order_history.export_complete_trade_history': '导出交易历史',
  'order.order_history.export_complete_trade_history_tooltip': '导出6个月的交易历史',
  'order.order_history.fee': '手续费',
  'order.order_history.filled': '成交',
  'order.order_history.hide_all_canceled': '隐藏全部取消',
  'order.order_history.infomation': '信息',
  'order.order_history.limit_order': '限价订单',
  'order.order_history.market': '市场',
  'order.order_history.order_history': '历史订单',
  'order.order_history.pair': '交易对',
  'order.order_history.price': '价格',
  'order.order_history.reset': '重置',
  'order.order_history.search': '搜索',
  'order.order_history.sell': '卖',
  'order.order_history.side': '侧面',
  'order.order_history.status': '状态',
  'order.order_history.stop_limit_order': '止盈限价订单',
  'order.order_history.total': '合计',
  'order.order_history.trigger_conditions': '触发条件',
  'order.order_history.type': '类别',
  'order.order_history.withdrawal': '提现',
  'order.order_history.withdrawal_limit_24': '二十四小时限制支出',
  'order.recent_trades.market': '市场',
  'order.recent_trades.recent_trades': '最近的交易',
  'order.recent_trades.yours': '您的',
  'order.trade_history.action': '动作',
  'order.trade_history.no_data': '没有交易历史。',
  'order.trade_history.all': '全部',
  'order.trade_history.amount': '数量',
  'order.trade_history.average': '平均',
  'order.trade_history.buy': '买',
  'order.trade_history.cancel': '取消',
  'order.trade_history.cancel_all': '取消全部',
  'order.trade_history.coin': '代币',
  'order.trade_history.date': '日期',
  'order.trade_history.deposit': '充值',
  'order.trade_history.export_complete_trade_history': '导出交易历史',
  'order.trade_history.fee': '手续费',
  'order.trade_history.filled': '成交',
  'order.trade_history.hide_all_canceled': '隐藏全部取消',
  'order.trade_history.infomation': '信息',
  'order.trade_history.limit_order': '限价订单',
  'order.trade_history.market': '市场',
  'order.trade_history.my_history': '我的订单历史',
  'order.trade_history.pair': '交易对',
  'order.trade_history.price': '价格',
  'order.trade_history.reset': '重置',
  'order.trade_history.search': '搜索',
  'order.trade_history.sell': '卖',
  'order.trade_history.side': '侧面',
  'order.trade_history.status': '状态',
  'order.trade_history.stop_limit_order': '止盈限价订单',
  'order.trade_history.total': '合计',
  'order.trade_history.trade_history': '交易历史',
  'order.trade_history.trigger_conditions': '触发条件',
  'order.trade_history.type': '类别',
  'order.trade_history.withdrawal': '提现',
  'order.trade_history.withdrawal_limit_24': '二十四小时限制支出',
  'order.order_trade_form.order': '订单',
  'order.order_trade_form.trades': '商业',
  "order.order_trade_form.price": "价格",
  "order.order_trade_form.size": "大小",
  "order.order_trade_form.time": "时间",
  'order_mobile.charts': '图表',
  'order_mobile.group': '分组',
  'order_mobile.max_amount': '最大数量',
  'order_mobile.open_order': '订单一览',
  'order_mobile.total': '合计',
  'order_mobile.trade': '交易',
  'passwords.password': '密码要6个字符以上，需要与确认一致。',
  'passwords.reset': '您的密码已重置，现在可以登录。',
  'passwords.sent': '密码重新设定链接已通过邮件发送。',
  'passwords.token': '此密码重新设置令牌无效。',
  'passwords.user': '找不到拥有那个邮箱地址的用户。',
  'refferal.alert': '没有登录。请登录与朋友共享。',
  'refferal.alert_bank_account_content': '在确认NI Bank账户之前，请提交<span style="color: #f29600;>KYC</span>。确认银行账户使用您的KYC信息。',
  'refferal.confirm_bank_account_content': '还没有NI Bank账户。请建个账户。',
  'refferal.confirm_bank_account_title': '使用KYC信息确认NI Bank的USD出款吗？',
  'refferal.get_rewards': '获得报酬',
  'refferal.login': '登录',
  'refferal.not_on_site': '还没有{APP_NAME}。',
  'refferal.register': '新建注册',
  'refferal.copy_link': '复制链接',
  'refferal.text1': '介绍链接和二维码的生成',
  'refferal.text10': '介绍的朋友',
  'refferal.text11': '日期',
  'refferal.text12': '程序详情',
  'refferal.text13': ':effectTime(UTC)当前启用',
  'refferal.text14': '从介绍程序接受的报酬，最初设定为20%。如果您持有500 :COIN_HOLDING或更多金额的账户，此比例将增加到40%。',
  'refferal.text15': '被介绍人完成交易后，手续费会立即发送到您的{APP_NAME}帐号，并支付原始手续费的令牌/密码货币支付。',
  'refferal.text16': '虽然你介绍的朋友数量没有限制，但是介绍项目的规定有权让运营方随时调整或变更。',
  'refferal.text18': '被介绍的人必须通过你的介绍链接、二维码或介绍ID签名。',
  'refferal.text19': '{APP_NAME}检查重复登录和假账户的不正当登录，不向这些账户支付介绍费。如果有重复或共享的信息则失去资格。',
  'refferal.text2': '邀请朋友',
  'refferal.text20': '*重要通知：',
  'refferal.text21': '{APP_NAME}有权根据市场的变化、欺诈风险、或者与本公司相关联的其他因素，随时改变介绍程序的条件。',
  'refferal.text22': '发生报酬',
  'refferal.text23': '<br/>发生报酬',
  'refferal.text60': '报酬额<br/>Margin Exchange',
  'refferal.text24': '最新报酬记录',
  'refferal.text25': '已复制',
  'refferal.text26': '输出',
  'refferal.text3': '经由介绍链接或二维码注册的朋友进行交易可以领取报酬',
  'refferal.text4': '领报酬\r\n',
  'refferal.text5': '实时收取最多{value}%的报酬。',
  'refferal.text6': '推荐人ID',
  'refferal.text7': '发生报酬比例：',
  'refferal.text8': '介绍链接',
  'refferal.text9': '共享：',
  'refferal.title': '介绍程序',
  'refferal.title1': '获取链接',
  'refferal.top': 'No.',
  'register.error_terms': '必须输入同意的使用规则。',
  'register.has_account': '您已经有账号了吗？',
  'register.sub_title': '注册账户',
  'register.success': '<span>恭喜您！</span><strong>:email</strong> <p>请检查邮箱并确认账号。</p>',
  'register.terms_1': '同意使用规章。',
  'register.terms_2': '条款',
  'register.title': '新建注册',
  'register.sendConfirmEmail': '发送确认邮件',
  'register.congratulation': 'Congratulation',
  'reset_passsword_complete': '密码重置已完成。',
  'reset_password.resetted_password': '您的密码已重置，现在可以登录。',
  'reset_password.send_mail_title': '发送重置密码的电子邮件',
  'reset_password.send_mail_title_2': '已发送密码重置电子邮件',
  'reset_password.sent_mail': '<strong style="line-height:25px;color: 33;font-size:16px;font-weight:400 ">已将密码重新设定邮件发送到注册的电子邮件地址。</strong> <br>请按照邮件的指示，在收到后24小时内重新设置密码。',
  'reset_password.sent_mail_2': '请在收到邮件后的24小时内访问URL，重新设定密码。',
  'reset_password.sub_title_1': '请输入电子邮件地址。',
  'reset_password.sub_title_2': '请输入新密码。',
  'reset_password.submit_btn': '提交',
  'reset_password.back_to': 'Back to',
  'reset_password.title': '重新设置密码',
  'reset_password.title_forgot': '忘记密码的用戶',
  'policy.title': 'Demo隐私声明',
  'policy.last_revised': '[最新修訂: 24 May 2018]',
  'policy.content_general': '本隐私权政策解释了Demo（Demo LLC）如何收集，使用，共享及保护通过<a href="{APP_URL}">{APP_HOST}</a>  网站所获得的用户信息。 “我们”在这里特指Demo（Demo LLC）及其相关公司。在收集用户指定个人信息时， 我们均出于法律及相关特定需求。 对于非必要信息 ，您有权决定是否提供。非不要信息的缺失，可能会导致您无法使用某些特定权限。<br>使用本网站，表示您同意本文中所有条例。我们会根据法律及个人数据收集和使用办法的变化，不时调整本隐私权政策。 修改后的公告会在官网发布，若您的信息被用于本文未覆盖的其他用途，我们将提前通知并征得您的同意。',
  'policy.information_amanpuri_collects': '我们收集哪些信息：',
  'policy.information_amanpuri_collects_intro': '以下是您注册及使用Demo时，我们收集的信息类型：<br>注册时所需信息:',
  'policy.information_amanpuri_collects_content': '当注册Demo账户时， 您需提供包括邮箱，姓名，密码等信息。为增加账户安全性可申请谷歌二次验证。<br>验证用户身份时所需信息:<br>为遵守包括反洗钱（AML），了解用户（KYC）以及反恐怖主义融资（CTF）在内的全球行业监管标准，我们被要求收集身份证明证件， 此规定同时适用于个人和企业账户。',
  'policy.service_usage_information': '使用Demo相关服务时所需信息:<br>使用平台信息',
  'policy.service_usage_information_content': '在使用Demo平台过程中， 我们会监控和收集如（包含且不限于）访问日期与时间，设备标识，操作系统，浏览器以及IP地址等相关数据。 这些信息可能直接由Demo或第三方服务商获取。这些服务使用数据的收集会帮助系统确保我们的界面适用于所有平台的用户， 同时也可在刑事调查期间提供支持。',
  'policy.transaction_information': '交易信息',
  'policy.transaction_information_content': '对于所有企业及个人账户， 我们收集交易信息包括（且不限于）存款快照，账户余额，交易记录，提款，订单活动和分发记录。 这些数据的收集用于监控可疑交易行为，以防止用户欺诈行为以及辅助法律案件的判决。',
  'policy.why_collects': 'Demo收集信息的原因：',
  'policy.why_collects_title_1': '1.提供和维护服务',
  'policy.why_collects_content_1': '使用收集的信息来维护我们的服务并验证用户身份。<br>我们使用您Cookie中存储的IP地址和唯一标识符来验证您的身份并提供服务。基于法律义务和系统要求，我们无法在没有身份证明， 联系信息和交易相关信息等数据的情况下为您提供服务。',
  'policy.why_collects_title_2': '2.保护用户',
  'policy.why_collects_content_2': '使用收集到的信息来保护平台，用户账户和档案。<br>使用IP地址和cookie数据来防止如垃圾邮件，网络钓鱼以及分布式拒绝服务（DDoS）攻击。<br>分析交易活动以便尽早检测欺诈行为和资金流向可疑账户。',
  'policy.why_collects_title_3': '3.遵守法律和法规的要求',
  'policy.why_collects_content_3': '在执行监管， 政府要求以及用户一般请求的时候，Demo以尊重个人隐私与数据安全为原则。 我们不会在未经法律团队的审核及征得用户同意的情况下， 向第三方披露或提供任何个人信息。',
  'policy.why_collects_title_4': '4.衡量网站性能',
  'policy.why_collects_content_4': '我们通过分析网站数据以更好的了解用户的产品使用体验。 运营团队持续性的进行数据分析以确保用户使用体验得以持续优化， 并及时解决在使用过程中遇到的各类问题。',
  'policy.why_collects_title_5': '5.与用户沟通',
  'policy.why_collects_content_5': '为于用户进行直接交流， 我们收集用户个人信息如邮件地址等，以帮助用户解决工单，及时通知用户登录、交易，和账户安全等相关活动。 如在沟通前没有先验证身份，我们将不能回复用户提交的请求及问题。所有沟通均会被妥善保存于Demo内部，用于复核准确性。',
  'policy.why_collects_title_6': '6.执行使用条款和其他协议',
  'policy.why_collects_content_6': '对于Demo和我们的用户，不断审查复核， 以防止潜在的违规行为非常重要。为维护全体用户权益，我们谨慎严谨执行与第三方签署的协议， 并严肃调查任何违反我们使用条款的行为。Demo有权力保留为任何违反使用条款的用户提供服务的权力。',
  'policy.how_protect': 'Demo如何保护用户数据：',
  'policy.how_protect_intro': 'Demo已实施了多项安全措施以确保用户信息不会丢失，滥用或被篡改。我们的数据安全措施包括但不限于：PCI扫描、SSL加密技术、拟匿名化， 内部数据连结访问限制以及严格的办公室和档案管理限制。但互联网及电子存储的形式不能保证100%的信息安全。因此，我们建议您了解并采取独立地安全预防措施以保护个人信息的安全。<br>若您怀疑个人信息尤其是账户或密码信息已被泄露，请立刻冻结账户并联系Demo客服人员。',
  'policy.contact_us': '联系我们：',
  'policy.contact_us_intro': 'Demo尊重所有用户的自由和权利。如您对本隐私政策有任何问题或疑虑，或者您想提交数据保护请求，请参阅我们的常见问题解答， 并在我们的支持页面上与我们联系。',
  'terms.title': '利用条款',
  'terms.introduce_1': 'Demo 提供用户（用户）的数字资产交易机会及相关服务，运营网站 <a href=\'{APP_URL}\'>{APP_URL}</a>（以下简称“本网站”）。本网站是提供数字交易专用或相关服务的平台（以下简称本服务）。为了简洁地描述此条约，本条约中将Demo和本网站与“Demo”或其它合适的第一人称并称为“Demo”。登录本网站的所有自然人或其他主体都是本网站的用户。为了简洁地记述本规定，用户及Demo总称为「两当事人」，分别称呼用户或Demo为「当事人」。<br>然后把Demo提供的全部服务称为「该服务」数字资产交易的风险很高，不适合很多人。',
  'terms.introduce_2': '用户必须认识到数字资产投资的一部分或全部可能受到损害，并在充分理解的基础上考虑能够承受损失的自身的限度来决定投资额。并且，也有上述风险以外不能预测的风险。因此，用户在作出关于数字资产买卖的判断之前，必须考虑财务状况及上述风险，慎重判断。并且，根据这个全部的损失成为用户的自我负担，Demo无论在怎样的情况下也不承担责任。',
  'terms.term_1.title': '第1条使用条约',
  'terms.term_1.content_1_1': '总则1.1本网站提供的服务的用户，请务必阅读本条约的全文。如果有不明白的地方或者其他疑问的话请咨询专业律师。如果不同意本条款及随时变更的内容，请立即停止使用该服务并停止登录本网站。登录本网站或者利用本服务进行其他类似活动的情况下，用户完全理解本条约的所有条款、条件（包括本网站随时变更的内容等）等全部内容，并同意本条约。',
  'terms.term_1.content_1_2': '视为已经1.2根据网站的要求，填写相关信息，经过其他相关手续，注册完成的用户成为本网站的会员（以下简称“会员”）。在注册手续中，点击“同意”按钮，用户将通过电子签名与Demo签订合同。另外，在使用本网站时，点击“同意”按钮或类似按钮时，如果使用本网站的许可，而实际使用该服务，则用户应理清本条约的所有条款的内容。解析，视为完全同意。在这种情况下，即使没有手写签名，也不会影响本条约对用户的法律约束力',
  'terms.term_1.content_1_3': '成为1.3本网站的会员的话，领取会员帐号和那个对应的密码。那个密码是会员自己适当保管的。对该帐号被进行了的全部的活动和事件的法律的责任全部有会员，Demo不承担一切的责任。',
  'terms.term_1.content_1_3_1': '一般用户不能通过本网站进行数字资产交易，也不能使用根据本网站的规则和条例对会员专有的服务，除非该用户成为本网站的会员；如果用户不是本网站的成员，则用户只能浏览本网站，及本网站的使用规则和法规上准许的內容。',
  'terms.term_1.content_1_4': '1.4本网站注册为会员，如果使用本网站提供的任何服务和功能，用户将被视为阅读和理解了此条约。同时被视为同意下列条款。',
  'terms.term_1.content_1_4_1': '1.4.承担本条约中所有条款的制约。',
  'terms.term_1.content_1_4_2': '1.4.2用户确认符合法律所要求的条件，并确认在本网站上使用数字资产交易时具有充分的能力。',
  'terms.term_1.content_1_4_3': '1.4.3用户将合法获得与本章程有关交易的所有数字资产，并承诺用户本人所有。',
  'terms.term_1.content_1_4_4': '1.4.4用户承担其交易和非交易活动所造成的损害和利益、相关责任，Demo对于这些不负任何责任。',
  'terms.term_1.content_1_4_5': '1.4.5视为确认登录时提供的信息是真实的、正确的。',
  'terms.term_1.content_1_4_6': '1.4.6纳税的交易利润申报，视为同意所有相关法律的遵守。',
  'terms.term_1.content_1_4_7': '1.4.7本章程承诺用户与Demo之间的权利和义务，涉及本网站的用户之间以及本网站的用户与其他网站之间的数字资产交易的法律关系和法律纠纷没有。',
  'terms.term_2.title': '第2条本条约的变更',
  'terms.term_2.content_2_1': 'Demo，不是随时变更本条约，对用户另外通知变更内容，有在本网站以广播的形式公布的权利。修改后的日期在本规约的第一页上显示。修改后的条约内容将在网站上发表后立即生效。Demo建议用户随时阅览本章程，确认变更的日期及变更内容。用户不同意变更内容时，请立即停止使用本服务。如果您继续使用本服务，我们将视为同意修改的条款。',
  'terms.term_3.title': '第3条 注册',
  'terms.term_3.title_1': '3.1注册资格',
  'terms.term_3.content_3_1_1': '用户在完成注册手续时或者使用本网站所许可的其他方法时，根据适用的法律，具有签署本条约的能力的自然人、法人、法人确认是其他组织。点击“同意”登录按钮的话，用户自己同意本规约的内容之后，登录，或者持有该用户许可的代理人代替该用户，在同意本规约的内容之后，在本网站上登录。注册后视为使用了该服务。如果用户不是具有上述能力的自然人、法人或者其他组织，则用户和用户的代理人必须承担这一切后果。另外，Demo有权删除或永久停止该账户，并追究该用户和该用户许可的代理人的责任。此外，用户将表明，它不是过去和现在、反社会势力或不符合此标准的，并保证在未来也不会适用。通过提供资金和其他手段，表明不参与或支持反社会势力等的维持、运营，并保证将来不再参与。',
  'terms.term_3.content_3_1_2': 'If the user is not a natural person, legal person or organization with the abovementioned ability, the user and the user’s authorized agent shall bear all the consequences of that, and Demo reserves the right to cancel or permanently freeze the user’s account and to hold the user and the user’s authorized agent accountable.',
  'terms.term_3.title_2': '3.2注册的目的',
  'terms.term_3.content_3_2_1': '确认了用户违反了所适用的法律或者规定，侵害了本网站数字资产交易的秩序，并不是在本网站进行注册的目的。',
  'terms.term_3.title_3': '3.3注册流程',
  'terms.term_3.content_3_3_1': '3.3.1用户同意根据本网站的新用户注册页的要求提供有效的电子邮件地址、手机号码和其他信息。同时，利用从用户提供或者被确认了的电子邮件地址，手机号码，或者被本网站许可了的其他方法，能登录本网站。如果用户需要，可根据适用于相关管辖区域的法律和限制要求，提供本名及身份证资料等适用法、规则、隐私规约及经纪人渲染防止条款所要求的信息。必须得做。<br>另外，为了让用户的登录数据更恰当更详细更准确，必须经常更新最新的信息。所有数据将被用户输入，然后作为注册信息被引用。用户对于这些信息的真实性、完整性和准确性负有责任，对于直接或间接的损失及其导致的不利结果也负有责任。',
  'terms.term_3.content_3_3_2': '3.3.2用户所在的主权国或地区的法律、规则、命令和其他规章文件中的任意一个手机账户必须基于实名登记时，用户必须在实名登记手续中登记合格的手机号码。同意提供。<br>在没有按照规定提供这种电话号码的情况下，直接或间接的损失及由此引起的损害将全部由用户承担。',
  'terms.term_3.content_3_3_3': '3.3.3以法律上完整有效的方式提供必要的登录信息，经过确认后，用户有权获得该网站的账号和密码。通过取得这样的帐号和密码，用户注册被认为是成功的，用户可以作为其正式会员登录本网站。',
  'terms.term_3.content_3_3_4': '3.3.4用户同意接收电子邮件或短信，以管理和操作从本网站发送的本网站。',
  'terms.term_3.title_4': '3.4密码和用户ID的管理',
  'terms.term_3.content_3_4_1': '3.4密码和用户ID的管理',
  'terms.term_3.content_3_4_2': '3.4密码和用户ID的管理',
  'terms.term_3.content_3_4_3': '3.4密码和用户ID的管理',
  'terms.term_4.title': '第4条 服务',
  'terms.term_4.content_4_0': '本网站仅向用户通过本网站提供数字资产交易活动（包括数字资产交易等，但不限于这些）的在线交易平台服务。表示动作正在进行。本网站不作为买方或卖方参与数字资产交易。',
  'terms.term_4.title_1': '4.1服务范围',
  'terms.term_4.content_4_1_1': '4.1.1用户有权通过本网站查看数字资产商品实时行情及交易信息，并通过本网站提交数字资产交易指令，完成数字资产交易。',
  'terms.term_4.content_4_1_2': '4.1.2用户有权参加本网站所发布的活动规则。',
  'terms.term_4.content_4_1_3': '4.1.3本网站承诺提供给用户的其他服务。',
  'terms.term_4.title_2': '4.2服务规则',
  'terms.term_4.content_4_2_0': '用户应承诺在本网站遵守下列服务规则。',
  'terms.term_4.content_4_2_1': '4.2.1用户遵守所适用的法律、规则和政策要求的条款，保证帐户内所有数字资产的出处合法性，在本网站上或者利用本网站的违法行为，或者对其进行违法行为不能进行损害其他本网站及第三者利益的活动。例如，违反法律、违反规定、收发侵害他人权利和利益的信息，或者未经本网站许可利用或伪造本网站的电子邮件头部的消息。',
  'terms.term_4.content_4_2_2': '4.2.2用户应当遵守适用的法律和规定，正确使用并保管本网站的账号和登录密码、交易密码、账号登录时相关联的移动电话号码。对。使用本网站的帐号、登录密码、交易密码、用户的手机所发送的认证代码进行一切操作，以及对其产生的结果的所有责任由用户承担。对。如果该网站的账户、登录密码、交易密码或移动电话的认证代码被非法第三方利用，或与账户安全相关的其他问题被查明请使用快速和有效的方法与本网站取得联系，并要求该账户暂时停止服务。本网站有权在合理的时间内按照用户的要求行动。但是，本网站包含用户可能承担的损失，而且不限于这些，对进行行为之前产生的全部结果不负任何责任。用户未经本网站许可，不得将本网站的账户转让给第三方、借贷、转让、担保设定等处置。',
  'terms.term_4.content_4_2_3': '4.2.3用户利用自己的账号和密码，点击批准、提交的各种规章、在线规约，点击并批准、发布信息、在线认可“同意”按钮我们同意承担更新、或继续购买服务等不限于这些）的责任。',
  'terms.term_4.content_4_2_4': '4.2.4在网站上交易数码资产时，不能恶意妨碍或扰乱交易订单。用户不能以技术手段妨碍本网站的正常运营，或利用其他手段妨碍其他用户的服务利用。用户不能因为伪造虚假的事实等，对本网站怀有恶意在商务上诽谤。',
  'terms.term_4.content_4_2_5': '4.2.5在线交易，如果与其他用户发生纠纷，无法从法律执行机关和政府机关以外寻求信息提供。',
  'terms.term_4.content_4_2_6': '4.2.6本网站提供的服务时，与用户有关的硬件、软件，以及附带的所有税金，以及所有手续费均由用户承担。',
  'terms.term_4.content_4_2_7': '4.2.7用户必须遵守本网站上随时公布的本条约和其他服务条件及运行规则。用户有权终止本服务的使用。',
  'terms.term_4.title_3': '4.3产品规则',
  'terms.term_4.content_4_3_1': '4.3.1密码货币之间的交易规则',
  'terms.term_4.content_4_3_1_0': '用户登录本网站，通过本网站进行货币交易时，同意遵守以下交易规则。',
  'terms.term_4.content_4_3_1_1': '4.3.1.1参照交易信息',
  'terms.term_4.content_4_3_1_1.introduce': '参照本网站上的货币交易信息（包括价格、成交量、手续费、交易显示等，但不限于这些）阅读交易信息的全部内容，并接受其所包含的全部点击交易按钮可继续交易。',
  'terms.term_4.content_4_3_1_2': '4.3.1.2提出订单',
  'terms.term_4.content_4_3_1_2.introduce': '阅读并确认交易信息后，可以提交交易订单。提交交易订单后，本网站被认为同意中介该交易。本网站无需事先通知，只要有符合委托价格的交易订单，将自动匹配，完成交易。',
  'terms.term_4.content_4_3_1_3': '4.3.1.3交易详细的参照',
  'terms.term_4.content_4_3_1_3.introduce': 'Buy history及Trade history可以参照交易明细对应的交易记录进行确认。',
  'terms.term_4.content_4_3_1_4': '4.3.1.4交易订单的取消和变更<br>用户有权在交易完成之前随时取消或变更交易订单。',
  'terms.term_5.title': '第5条本网站的权利和义务',
  'terms.term_5.content_5_1': '5.1本规定没有被同意了的登记资格的情况下，本网站有拒绝登记的权利。如果已经注册完毕，本网站有权撤销该会员的账户，并保留向用户或拥有用户权限的代理人追究责任的权利。并且，本网站保留决定其他状况是否接受登记申请的权利。',
  'terms.term_5.content_5_2': '5.2本网站如果发现账户的使用者不是该账户的初始注册者，将有权暂停或终止对该账户的访问。',
  'terms.term_5.content_5_3': '如果通过5.3技术测试或人工采样，被怀疑提供给本网站的信息有错误或不完整，本网站有权要求修改或更新信息我们有权终止服务。',
  'terms.term_5.content_5_4': '5.4本网站，如果发现本网站所显示的信息明显是错误的，有权进行修改。',
  'terms.term_5.content_5_5': '5.5个网站保留随时更改、中断或终止本服务的权利。没有事先通知用户，可以停止本服务的变更和提供。结束本网站被提供的服务的一个或多个的情况下，结束在网站上的结束发表日生效。',
  'terms.term_5.content_5_6': '5.6本网站为确保本网站的正常运营采取必要的技术手段及管理措施，提供必要的、可靠的交易环境及交易服务，维持数字资产交易的秩序。',
  'terms.term_5.content_5_7': '5.7本网站负有义务通过强化技术和加强安全措施，确保用户的数字资产安全，提前通知用户的账户可预测的安全风险。',
  'terms.term_5.content_5_8': '5.8本网站采取措施，根据用户所在的主权国家或地区的法律、规则、命令和其他限制文件，要求用户更多信息或数据，合理满足当地标准的要求保留权利。用户有义务为这些措施提供适当的援助。本网站有权根据用户所在的主权国家或地区的法律、规则、命令和其他规章文件，向用户停止或永久终止本服务的一部分。',
  'terms.term_6.title': '第6条损害赔偿',
  'terms.term_6.content_6_1': '6.1无论在任何情况下，Demo对用户直接损害的赔偿责任，不超过本服务3个月利用的总费用。',
  'terms.term_6.content_6_2': '6.2违反本规约或所适用的法律或行政规定的，用户将支付至少200万美元的赔偿金，并承担与违反条款相关的全部费用（包括律师费用）。如果这些补偿费用无法弥补实际损失，则用户将补偿差额。',
  'terms.term_7.title': '第7条 差别救济的权利',
  'terms.term_7.content_7_0': '用户和我们，对于有违反规章和违反规章的可能性的事，认识着在一般习惯法上的救济策略不能填补我们的损失。因此，在有违反规章或者有违反规章的可能性的情况下，没有违约的当事人，有寻求差遣救济及一般习惯法或者平衡法被认可的其他的救济措施的权利。',
  'terms.term_8.title': '第8条 免责事项',
  'terms.term_8.content_8_1': '8.1用户无论在任何情况下，都理解并同意Demo不承担任何责任。',
  'terms.term_8.content_8_1_1': '8.1.1对于收益损失，Demo不负任何责任。',
  'terms.term_8.content_8_1_2': '8.1.2交易利润或章程上的损失，Demo不负任何责任。',
  'terms.term_8.content_8_1_3': '8.1.3对于业务中断，Demo不负任何责任。',
  'terms.term_8.content_8_1_4': '8.1.4对于可预期的货币损失，Demo不负任何责任。',
  'terms.term_8.content_8_1_5': '8.1.5信息的损失，Demo不负任何责任。',
  'terms.term_8.content_8_1_6': '8.1.6机会的丧失，对商务上的名誉或名誉的损害，Demo不承担一切责任。',
  'terms.term_8.content_8_1_7': '8.1.7数据损坏或损失，Demo不负任何责任。',
  'terms.term_8.content_8_1_8': '8.1.8替代产品或服务的购买费用，Demo不负任何责任。',
  'terms.term_8.content_8_1_9': '8.1.9侵害（包括过失）、违反规章或其他原因造成的间接、特别或附带的损失、损害，不管其损失或损害是否合理预见，都可能造成这样的损失或损失不管是否事先通知，Demo不负任何责任。',
  'terms.term_8.content_8_1_10': '8.1.1至8.1.9相互独立。',
  'terms.term_8.content_8_2': '8.2用户应理解并同意，Demo将不负责任由下列任何情况造成的任何损害。',
  'terms.term_8.content_8_2_1': '8.2.1用户的特定交易被怀疑是严重的违法或者规章违反，如果这个有正当的理由，Demo不承担一切责任。',
  'terms.term_8.content_8_2_2': '8.2.2本网站上的用户行为被怀疑是违法或不适当的，如果这个有正当的理由，Demo不承担一切责任。',
  'terms.term_8.content_8_2_3': '8.2.3通过在网站购买的服务，对于数据、信息的取得、交易等的行为，以及取而代之的行为所产生的费用和损失，Demo不负任何责任。',
  'terms.term_8.content_8_2_4': '8.2.4误解本服务时，Demo不负任何责任。',
  'terms.term_8.content_8_2_5': '8.2.5 Demo不是起因于，关于本服务关联的其他的损失，Demo不承担一切责任。',
  'terms.term_8.content_8_3': '8.3信息网络设备维护、信息网络连接故障、计算机、通信或其他系统故障、电力故障、天气意外事故、罢工、劳动争议、暴动、叛乱、骚动、生产率和生产材料缺乏、火灾、洪水、暴风、爆炸、战争、银行等有关部门失误、数字资产市场崩溃、政府管制、司法机关或行政机关措施等其他Demo无法管理的行为、Demo无法控制的状态、或如果由于第三者的原因而导致的服务的不提供，或者服务提供被延期，以及由此产生的损失，Demo不承担一切责任。',
  'terms.term_8.content_8_4': '8.4本网站不受任何病毒、特洛伊木马等恶意程序的干扰和破坏，包括网站的所有信息、程序、文本等完全安全无法确保。因此，登录本网站、利用本服务、下载程序、信息和数据，以及使用本网站被认为是用户的个人判断。因此，用户将承担可能发生的所有风险及其所造成的损失。',
  'terms.term_8.content_8_5': '8.5Demo，关于被本网站链接了的第三者的网站的所有的信息，产品，业务，以及不属于Demo的其他形式的内容，没有进行任何保证和承诺。<br>利用由第三方网站提供的所有服务、信息、产品被视为用户的个人判断。为此，用户将承担由此产生的一切责任。',
  'terms.term_8.content_8_6': '8.6 Demo对于本网站提供的服务的利用没有明确或隐含的保证（应用性、无错误或泄漏的可能性、一致性、准确性、妥当性和特定用途的应用性）包含但不限于这些。此外，Demo并不保证有关本服务的技术和信息的有效性、准确性、妥当性、质量、稳定性、完整性和适时性。登录本网站，还是利用本服务，因为是用户的个人判断，用户承担由那样的判断产生的全部的风险和可能性的损失。Demo并不涉及数字资产市场、价值及价格作出明确或隐含的保证。用户了解到数字资产市场不稳定，资产价格和价值随时可能变动或崩溃，数字资产交易是基于用户个人的自由意愿和决定的。承担由此产生的一切风险和可能性的损失。',
  'terms.term_8.content_8_7': '8.7本规约所承诺的保证和承诺是与Demo通过本规约和本网站提供的服务相关联的唯一保证和描述，以及其他方法产生的所有保证和承诺的默示性的）取而代之。无论是书面还是语言，无论是明确还是默认，这些保证和声明都不能全部表明Demo的承诺和承诺，并保证第三方的遵守。',
  'terms.term_8.content_8_8': '8.8 Demo，本条约中不包含，但适用于法律的最大范围，不放弃对损害赔偿责任的限制、免除或抵销的权利。',
  'terms.term_8.content_8_9': '8.9用户既然已经注册了，就认为Demo已经同意按照本规定所记载的规则进行所有操作。用户将承担由此产生的所有风险的责任。',
  'terms.term_9.title': '第9条解除条约',
  'terms.term_9.content_9_1': '9.1本网站有权依照本条款撤销用户账户。另外，本条约到用户的取消日期结束。',
  'terms.term_9.content_9_2': '9.2本网站有权根据本条约终止所有服务。本条约将在本网站的所有服务终止日期结束。',
  'terms.term_9.content_9_3': '9.3项条约解除后，用户不具有向本网站提供原始服务和履行义务的权利。（在网站上保留用户账户信息的服务，以及用原始账户通知用户信息的服务，以及不被用户和第三者任何阅览也不被发送的信息的传送服务等包括但不限于这些。',
  'terms.term_9.content_9_4': '9.4本规约的结束，不影响没有违反规章的当事人向违反规章的当事人追究其他的责任。',
  'terms.term_10.title': '第10条 知识产权',
  'terms.term_10.content_10_1': '10.1本网站所包含的全部知识成果（网站标志、数据库、网站设计、文本和图形、软件、图片、视频、音乐、声音及其组合包含假币等，但不限于这些。本网站拥有软件编译、相关源代码和软件（包括小程序和脚本）的知识产权。用户无法将上述内容复制、复制、修改或发送给第三方。',
  'terms.term_10.content_10_2': '10.2本网站的名称中包含的所有权利（包括商业上的信用、标识和logo，但不限于这些）由Demo所有。',
  'terms.term_10.content_10_3': '10.3用户同意本条约，并在本网站上刊登的各种形式的版权（复制权、发行权、租赁权、展示权、表演权、放映权、放映权、信息的普及权、摄影权、改编权、翻译权包括编辑权，但不限于此，或者其他版权人可以转让的权利将被视为免费转让给本网站。本网站有权在以上权益被侵犯时独自向侵害者提起法律诉讼，取得全部赔偿。本条约对用户在本网站发表的全部的著作权法被保护的东西生效。用户发表的内容与本规约签字时无关，都将成为制约对象。',
  'terms.term_10.content_10_4': '10.4用户在使用本网站时，不能擅自使用或处分本网站或他人的知识产权。用户不能以任何形式向其他网站（以及媒体）投稿或授权本网站所发布的信息。',
  'terms.term_10.content_10_5': '10.5本网站访问，并利用本服务时，不认为将任何知识产权转让给用户。',
  'terms.term_11.title': '第11条  其他',
  'terms.term_11.content_11_1': '11.1分离可能性',
  'terms.term_11.content_11_1_1': '本条约中任何条款均由管辖权的法院判明为不能执行、无效、违法的，不影响其余所有条款的有效性。',
  'terms.term_11.content_11_2': '11.2非代理人关系',
  'terms.term_11.content_11_2_1': '本条约的任何条款中，Demo都不意味着成为用户的代理人、受托人或其他代理人。本条约另有其他规定。',
  'terms.term_11.content_11_3': '11.3关于弃权',
  'terms.term_11.content_11_3_1': 'Demo和用户放弃因违反本规定而追究责任的权利时，不应该放弃追究其他违约责任的权利。同时，如果完全不行使权利和救济也不是放弃权利或救济的行使。',
  'terms.term_11.content_11_4': '11.4标题',
  'terms.term_11.content_11_4_1': '所有标题均用于简洁说明条款，而不用于扩大条约内容或范围。',
  'terms.term_12.title': '第12条禁止行为',
  'terms.term_12.content_12_1': '1.登录用户在利用本服务时，不得做下列各号中任一项的行为。',
  'terms.term_12.content_12_1_1': '1、侵害本公司或本服务的其他利用者及其他第三方的知识产权或肖像权的行为（包括直接或间接地引起这种侵害的行为）',
  'terms.term_12.content_12_1_2': '2、未经本公司事先同意，将本公司享有著作权的知识产权或肖像权的行为转载到商业利用的行为或第三方等行为',
  'terms.term_12.content_12_1_3': '3、本公司、本公司相关公司及其他与本公司有关的人或者本服务的其他利用者其侵害其他第三方隐私权、名誉、其他权利或利益的行为（包括直接或间接引起侵害的行为）',
  'terms.term_12.content_12_1_4': '4、欺诈行为、无限连锁讲座等的开设、劝诱、非法物品、服务等的购买、贩卖、犯罪导致的收益转移或基于此进行服务利用的行为',
  'terms.term_12.content_12_1_5': '5、与犯罪行为有关的行为或违反公序良俗的行为',
  'terms.term_12.content_12_1_6': '6、发送关于异性等交往的信息的行为',
  'terms.term_12.content_12_1_7': '7、广告送信等对其他登录用户的劝诱行为（但是，本公司承认的情况除外。）',
  'terms.term_12.content_12_1_8': '8、违反法令或本公司或注册用户所属的行业团体内部规则的行为',
  'terms.term_12.content_12_1_9': '9、符合虚拟货币的双重转让的行为或尝试转让的行为',
  'terms.term_12.content_12_1_10': '10・计算机病毒和其他有害计算机发送包含数据程序的信息的行为或者破坏或妨碍本公司管理的系统、服务器、网络和其他的功能，或者不必要的加重负担的行为',
  'terms.term_12.content_12_1_11': '11、与本服务有关的、或本公司管理的系统、服务器、网络和其他错误、漏洞、安全漏洞、其他利用瑕疵的行为',
  'terms.term_12.content_12_1_12': '12、本服务有关可利用的信息进行篡改的行为',
  'terms.term_12.content_12_1_13': '13、本公司规定发送一定的数据容量以上的数据的行为',
  'terms.term_12.content_12_1_14': '14、有妨碍本公司的本服务的运营的行为',
  'terms.term_12.content_12_1_15': '15、重放攻击（重放攻击）等根据登记用户，本公司或者本公司有关的公司的资产故意盗取的行为',
  'terms.term_12.content_12_1_16': '16、流传与传说和事实不同的东西，使用假计或威力等毁坏本公司的信用的行为或恐吓行为',
  'terms.term_12.content_12_1_17': '17、同一个人物制作多个帐号的行为',
  'terms.term_12.content_12_1_18': '18、多个人物为一个账号使用账户的行为或者让登记用户本人以外的第三者利用账户的行为',
  'terms.term_12.content_12_1_19': '19、他人（包括假设人）的名义试图开设或者开设账户的行为、或者有关账户的登记信息的全部部分或一部分，向本公司提供虚假信息的行为',
  'terms.term_12.content_12_1_20': '20、除事先从本公司得到书面同意的情况外，利用本服务的利用等得到的信息等，与本服务相同（虚拟货币交易包括交易、虚拟货币的转移或结算或价格信息等的转发。）或提供类似的服务，或者以向第三方提供服务或物品等商业目的，或者让子公司及其他自己支配下的第三方进行这些行为',
  'terms.term_12.content_12_1_21': '21 .在交易所操纵行市的行为或者妨碍公正价格形成的行为',
  'terms.term_12.content_12_1_22': '22、登录用户本人以外的第三者向登录用户帐号接受金钱或者第三者从登录用户帐号进行金钱的支付的行为。（但是，除非事先得到本公司明确的许可。）',
  'terms.term_12.content_12_1_23': '23、其他、本公司判断不恰当的行为',
  'terms.term_12.content_12_2': '12.2.本公司，本服务的登录用户有相当于前款各号的任意一个或者有相当的危险本公司判断了的情况，根据本公司的裁量，事先向登录用户预先判断为登记用户无需通知，该登录用户发送的全部信息或者一部分的删除、该登录用户的注册的取消或者利用的暂停、或者该登录用户持有的虚拟货币等（交换为其他货币时）根据本公司规定的交换率计算的相当数额）可以采取没收等措施。那个时候，本公司不承担返还从登记用户领受了的文件等的义务。本公司根据本项对本公司所采取的措施对注册用户造成的损害不负任何责任。',
  'terms.term_12.content_12_3': '12.3.第1项各项行为之一时，本公司会向注册用户索取本公司规定的违约金。',
  'terms.term_13.title': '第13条规定生效的时间和解释',
  'terms.term_13.content_13_1': '13.1本规定，用户在本网站登录页面点击同意按钮，完成登录手续，得到本网站的帐号和密码后生效。本条约对用户和网站有约束力',
  'terms.term_13.content_13_2': '13.2本协议的最终解释权归本网站所有。',
  'terms.term_13.content_13_2_0_1': '重要通知',
  'terms.term_13.content_13_2_0_2': 'Demo将如下通知各位用户。',
  'terms.term_13.content_13_2_1': '1.数字资产本身不会被任何金融机构或政府所证实。数字资产市场不具备完全新、明确、稳定的预期。',
  'terms.term_13.content_13_2_2': '2.数字资产交易不受行情涨幅和降价幅度的限制，24小时持续进行，风险非常高。',
  'terms.term_13.content_13_2_3': '3.根据各国法律、规章和规章文件的制定或修改，数字资产交易有可能随时中断或禁止。',
  'terms.term_13.content_13_2_4': '4.Demo不服务于美国、古巴、伊朗、朝鲜、克里米亚、苏丹、叙利亚、孟加拉国、玻利维亚、厄瓜多尔、吉尔吉斯坦用户。',
  'terms.term_end_note.title': '3.4密码和用户ID的管理',
  'terms.term_end_note.content_1': '3.4密码和用户ID的管理',
  'terms.term_end_note.content_2': '3.4密码和用户ID的管理',
  'terms.term_end_note.content_3': '3.4密码和用户ID的管理',
  'terms.term_end_note.content_4': '3.4密码和用户ID的管理',
  'sendConfirmEmail': '发送确认邮件',
  'service_center.send_contact_subject': '将联系人发送到{APP_NAME}',
  'shared_components.alert.error': '错误',
  'shared_components.alert.primary': '信息',
  'shared_components.alert.success': '成功',
  'shared_components.alert.warning': '警告',
  'shared_components.common.confirmation_modal.awesome': '太棒了',
  'shared_components.common.confirmation_modal.danger': '危险',
  'shared_components.common.confirmation_modal.info': '信息',
  'shared_components.common.confirmation_modal.warning': '警告',
  'shared_components.google_authentication_modal.lost_code': '您忘记Google认证了吗？',
  'shared_components.google_authentication_modal.otp_code_invalid': '谷歌认证码无效。',
  'shared_components.google_authentication_modal.submit_button': '提交',
  'shared_components.google_authentication_modal.title': '谷歌认证系统',
  'shared_components.pagination.next': '下一步',
  'shared_components.pagination.pre': '返回',
  'sales_point.sales_point': '销售处',
  'sales_point.title': '设置4IRE',
  'sales_point.price_setting': '价格设定',
  'sales_point.total_amal_sold': '4IRE总售出金额',
  'sales_point.currency': '货币',
  'sales_point.total_received': '收到的总数',
  'sales_point.price_setting.default_price': '默认价格',
  'sales_point.price_setting.presenter': '邀请价格',
  'sales_point.price_setting.presentee': '被邀请价格',
  'sales_point.price_setting.total_supply': '可提供的4IRE总数量',
  'sales_point.price_setting.remaining_supply': '4IRE总余额',
  'sales_point.indeicates_required': '“*”是必须输入的项目。',
  'sales_point.price_setting.amal_btc': '4IRE/BTC',
  'sales_point.price_setting.amal_eth': '4IRE/ETH',
  'sales_point.price_setting.asterisk': '*',
  'sales_point.price_setting.usd': 'USD',
  'sales_point.price_setting.amal': '4IRE',
  'sales_point.edit': '编辑',
  'sales_point.submit': '提交',
  'sales_point.return': '返回',
  'sales_point.update_success_msg': '已更新',
  'sales_point.error.lose_default_price': '必须输入默认价格。',
  'sales_point.error.lose_presenter': '必须输入邀请的价格。',
  'sales_point.error.lose_persentee': '必须输入被邀请的价格。',
  'sales_point.error.lose_total_supply': '必须输入可提供的4IRE总数量。',
  'sales_point.error.price_persenter': '参考的价格要大于0。',
  'sales_point.error.price_persentee': '参考的价格要大于0。',
  'sales_point.error.price_default_price': '默认价格必须大于0。',
  'sales_point.error.price_total_supply': '可提供的4IRE总数量必须大于0。',
  'masterdata.text': '主数据已更改。</br>请重新装入页面。',
  'unregistered_session.login': '登录',
  'unregistered_session.text': '会话中断。请再登录一次。',
  'validation.messages._default': ':0值无效。',
  'validation.messages.after': ':0必须大于:1。',
  'validation.messages.after2': ':0必须在:1以上。',
  'validation.messages.alpha_dash': ':0可以包括字母数字、连字符和下划线。',
  'validation.messages.alpha_num': ':0只能包含英文数字。',
  'validation.messages.alpha_spaces': ':0只能包含字符和空格。',
  'validation.messages.alpha': ':0中仅包含字母。',
  'validation.messages.before': ':0必须小于:1。',
  'validation.messages.before2': ':0必须在:1以下。',
  'validation.messages.between': ':0必须从:1到:2。',
  'validation.messages.confirmed': ':0的确认不匹配。',
  'validation.messages.credit_card': ':0项目无效。',
  'validation.messages.date_between': ':0必须从:1到:2。',
  'validation.messages.date_format': ':0必须是:1格式。',
  'validation.messages.decimal': ':0可以包括少数点以下的:1位数。',
  'validation.messages.digits': ':0是数字，必须包含:1位数。',
  'validation.messages.dimensions': ':0必须是:1像素×:2像素。',
  'validation.messages.email': ':0必须是有效的电子邮件地址。',
  'validation.messages.ext': ':0必须是有效的文件。',
  'validation.messages.image': ':0必须是图像。',
  'validation.messages.in': ':0必须是有效值。',
  'validation.messages.integer': ':0必须是整数。',
  'validation.messages.ip': ':0必须是有效的IP地址。',
  'validation.messages.length': ':0字符数必须是:1位数。',
  'validation.messages.length2': ':0字符数必须从:1到:2。',
  'validation.messages.max': ':0必须在:1字符以下。',
  'validation.messages.max_value': ':0必须在:1以下。',
  'validation.messages.mimes': ':0需要有效的文件类型。',
  'validation.messages.min': ':0必须在:1字符以上。',
  'validation.messages.min_value': ':0必须在:1以上。',
  'validation.messages.not_in': ':0必须是有效值。',
  'validation.messages.numeric': ':0只能包含数字。',
  'validation.messages.regex': ':0格式无效。',
  'validation.messages.required': ':0必须输入项目。',
  'validation.messages.size': ':0请将尺寸设为:1以内。',
  'validation.messages.url': ':0不是有效的URL。',
  'validation.accepted': ':attribute必须被接受。',
  'validation.active_url': ':attribute不是有效的URL。',
  'validation.after': ':attribute必须是:date更大的日期。',
  'validation.after_or_equal': ':attribute必须是:date以后的日期',
  'validation.alpha': ':attribute只能包含字符。',
  'validation.alpha_dash': ':attribute只能包含字符、数字和连字符。',
  'validation.alpha_num': ':attribute只能包含字符和数字。',
  'validation.array': ':attribute必须排列。',
  'validation.attributes.account_name': '账户名义',
  'validation.attributes.account_number': '帐号',
  'validation.attributes.bank_id': '银行',
  'validation.attributes.base_price': '止損价格',
  'validation.attributes.date_of_birth': '出生年月日',
  'validation.attributes.new_password': '新密码',
  'validation.attributes.otp_recovery_code': '恢复代码',
  'validation.attributes.recovery_code': '恢复代码',
  'validation.attributes.password': '密码',
  'validation.attributes.quantity': '数量',
  'validation.attributes.wallet_address': '钱包地址',
  'validation.attributes.withdrawal_address': '提现地址',
  'validation.attributes.authentication_code': '认证代码',
  'validation.before': ':attribute必须是:date更小的日期。',
  'validation.before_or_equal': ':attribute必须是:date以前的日期。',
  'validation.between.array': ':attribute需要从:min到:max事情。',
  'validation.between.file': ':attribute必须从:min到:max千字节。',
  'validation.between.numeric': ':attribute必须从:min到:max。',
  'validation.between.string': ':attribute必须从:min到:max文字。',
  'validation.boolean': ':attribute必须是true或false。',
  'validation.confirmed': ':attribute的确认不一致。',
  'validation.correct_otp': '认证代码不正确。',
  'validation.custom.agree_term.required': '您必须阅读并同意使用条款。',
  'validation.custom.attribute-name.rule-name': '客户信息',
  'validation.custom.base_price.min': '止損价格必须在:min以上。',
  'validation.custom.base_price.precision': '止損价格必须是:precision的精度',
  'validation.custom.id_back.image': '文件必须是图像。',
  'validation.custom.id_back.mimes': '文件必须是:values格式的文件。',
  'validation.custom.id_front.image': '文件必须是图像。',
  'validation.custom.id_front.mimes': '文件必须是:values格式的文件。',
  'validation.custom.id_selfie.image': '文件必须是图像。',
  'validation.custom.id_selfie.mimes': '文件必须是:values格式的文件。',
  'validation.custom.image': '文件必须是图像。',
  'validation.custom.image.mimes': '文件必须是{values}格式的文件。',
  'validation.custom.password.confirmed': '密码必须与确认密码一致。',
  'validation.custom.password.correct_password': '密码不正确。',
  'validation.custom.password.min': '密码包含大写字母、小写字母、数字等8个字符以上，必须与确认用密码一致',
  'validation.custom.password.regex': '密码包含大写字母、小写字母、数字等8个字符以上，必须与确认用密码一致',
  'validation.custom.price.min': '价格必须最低:min',
  'validation.custom.price.precision': '止盈价格必须是:precision的值',
  'validation.custom.quantity.min': '数量必须在:min以上。',
  'validation.custom.quantity.precision': '金额的值必须是:precision',
  'validation.custom.total.min': '总计必须最低:min',
  'validation.custom.total.precision': '总和必须是:precision的值',
  'validation.date': ':attribute不是有效的日期。',
  'validation.date_format': ':attribute与格式:format不一致。',
  'validation.different': ':attribute和:other必须不同。',
  'validation.digits': ':attribute必须是:min位数。',
  'validation.digits_between': ':attribute必须是从:min到:max的数字。',
  'validation.dimensions': ':attribute的图像大小无效。',
  'validation.distinct': ':attribute的值重复。',
  'validation.email': ':attribute项目必须是有效的电子邮件地址。',
  'validation.exists': '选中的:attribute无效。',
  'validation.file': ':attribute必须是文件。',
  'validation.filled': ':attribute的输入是必须的。',
  'validation.image': ':attribute必须是图像。',
  'validation.in': '选中的:attribute无效。',
  'validation.in_array': ':attribute不存在:other。',
  'validation.integer': ':attribute必须是图像。',
  'validation.ip': ':attribute必须是有效的IP地址。',
  'validation.ipv4': ':attribute必须是有效的IP4地址。',
  'validation.ipv6': ':attribute必须是有效的IP6地址。',
  'validation.is_withdrawal_address': ':attribute无效。',
  'validation.json': ':attribute必须是有效的JSON字符串。',
  'validation.max.array': ':attribute不能超过:max个。',
  'validation.max.file': ':attribute必须在:max千字节以下。',
  'validation.max.numeric': ':attribute不能比:max大。',
  'validation.max.string': ':attribute必须在:max字符以下。',
  'validation.mimes': ':attribute必须是:values类型的文件。',
  'validation.mimetypes': ':attribute必须是:values类型的文件。',
  'validation.min.array': ':attribute需要:min件以上。',
  'validation.min.file': ':attribute必须在:min千字节以上。',
  'validation.min.numeric': ':attribute必须在:min以上。',
  'validation.min.string': ':attribute必须在:min字符以上。',
  'validation.min_value': ':attribute必须在:min以上。',
  'validation.not_in': '选中的:attribute无效。',
  'validation.numeric': ':attribute必须是数字。',
  'validation.otp': '认证失败',
  'validation.otp_not_used': '请等待下一个认证代码生成。',
  'validation.otp_or_google_auth_required': '需要输入谷歌认证代码',
  'validation.otp_incorrect': '认证代码不正确。',
  'validation.password_white_space': '请不要在密码中包含空白。',
  'password_white_space': '请不要在密码中包含空白。',
  'validation.precision': ':attribute的值必须是:precision',
  'validation.present': ':attribute必须是true或false。',
  'validation.regex': ':attribute格式无效。',
  'validation.required': ':attribute的输入是必须的。',
  'validation.required_if': 'other}是:value的情况下，:attribute必须输入。',
  'validation.required_unless': '只要:other未包含在:values中，:attribute的输入是必须的',
  'validation.required_with': '如果:values存在，:attribute必须输入。',
  'validation.required_with_all': '如果:values存在，:attribute必须输入。',
  'validation.required_without': '如果:values不存在，:attribute必须输入。',
  'validation.required_without_all': '如果:values不存在，:attribute必须输入。',
  'validation.same': ':attribute和:other必须一致。',
  'validation.size.array': ':attribute必须包含:size条目。',
  'validation.size.file': ':attribute必须是:size千字节。',
  'validation.size.numeric': ':attribute必须是:size。',
  'validation.size.string': ':attribute必须是:size字符。',
  'validation.string': ':attribute必须是字符串',
  'validation.timezone': ':attribute必须是有效区域。',
  'validation.unique': ':attribute已经被使用。',
  'validation.unique_email': '为了启用账户请检查邮件',
  'validation.unique_referrer_code': '邀请代码无效。',
  'validation.unique_withdrawal_address_in_user': '提现地址已经存在。',
  'validation.uploaded': ':attribute上传失败。',
  'validation.url': ':attribute格式无效。',
  'validation.verified_email': '邮件还没有确认。',
  'validation.verify_otp_or_google_auth': '需要正确输入谷歌认证代码',
  'validation.verify_otp_recovery_code': ':attribute不正确。',
  'validation.verify_otp_recovery_code_with_auth': ':attribute不正确。',
  'validation.authen_code_required': '必须输入认证码。',
  'validation.unverified_email': '为了启用账户请检查邮件',
  'withdraw_guide.currency': '货币',
  'withdraw_guide.deposit_fee': '充值手续费',
  'withdraw_guide.email': '确认邮件',
  'withdraw_guide.gauthen': '谷歌认证系统',
  'withdraw_guide.fee': '手续费',
  'withdraw_guide.fee_withdrawal': '提现手续费',
  'withdraw_guide.free': '免费',
  'withdraw_guide.gotp': 'Google OTP',
  'withdraw_guide.identity_verification': '本人确认',
  'withdraw_guide.level': '各级别',
  'withdraw_guide.level_name': '级别',
  'withdraw_guide.level_title': '当前认证级别',
  'withdraw_guide.limit_tip1': '提现限制根据认证水平而不同。',
  'withdraw_guide.limit_tip2': '根据市场情况和相关银行（银行）的规定，上述提款限额可能会更改，恕不另行通知。',
  'withdraw_guide.limit_tip3': '如果怀疑有不正当的交易，有可能限制提现。',
  'withdraw_guide.limit_tip4': '出款手续费不论是货币的金额都以固定金额支付。',
  'withdraw_guide.limit_tip5': '虚拟货币提现的情况，实际的手续费，也有根据块链网络的状态，比被表示的手续费高(贵)的情况，也低。',
  'withdraw_guide.limit_title1': '1.根据认证步骤的提现限制',
  'withdraw_guide.limit_title2': '2.充值/提现手续费和提现的最少额',
  'withdraw_guide.minimum_withdrawal': '提现的最少额',
  'withdraw_guide.one_day': '一天',
  'withdraw_guide.one_time': '一次',
  'withdraw_guide.phone': '电话认证',
  'withdraw_guide.security_method': '认证方法',
  'withdraw_guide.support_withdrawal': '充值/提现指示',
  'withdraw_guide.usd': 'USD',
  'trade_type.buy': '买',
  'trade_type.sell': '卖',
  'common.message.network_error': '无法连接到服务器。',
  'common.status.expired': 'Expired',
  'common.status.new': '新',
  'common.status.success': '成功',
  'common.status.pending': '待定',
  'common.status.cancel': '取消',
  'common.status.error': '错误',
  'common.status.untriggered': 'Untriggered',
  'common.search': '搜索',
  'common.action.confirm': '确认',
  'common.action.reject': '不承认',
  'common.kyc.pending': '待定',
  'common.kyc.verified': '已承认',
  'common.order_status.pending': '待定',
  'common.empty_data': '没有数据。',
  'menu.orders.orders': '订单',
  'menu.orders.open_order': '订单一览',
  'menu.orders.order_history': '历史订单',
  'menu.orders.trade_history': '交易历史',
  'menu.notices': '通知',
  'menu.email_marketing': '电子邮件营销',
  'menu.home': '主页',
  'usd_transaction.time': '日期',
  'usd_transaction.user': '电子邮件地址',
  'usd_transaction.user1': '用户',
  'usd_transaction.account': '数量',
  'usd_transaction.account_name': '账户名义',
  'usd_transaction.bank_name': '银行',
  'usd_transaction.bank_branch': '分店',
  'usd_transaction.status': '状态',
  'usd_transaction.amount': '数量',
  'transactions.deposit_usd.yes': '是',
  'transactions.deposit_usd.no': '否',
  'transactions.deposit_usd.confirm': '承认这笔交易吗？',
  'transactions.deposit_usd.reject': '拒绝这笔交易吗？',
  'transactions.withdrawal.send': '发送这笔交易吗？',
  'transactions.withdrawal.cancel': '取消这笔交易吗？',
  'kyc.list': 'KYC一览',
  'kyc.input_search': '搜索',
  'kyc.created_at': '日期',
  'kyc.email': '电子邮件地址',
  'kyc.name': '名称',
  'kyc.country': '国家',
  'kyc.id_number': '护照/ID号码',
  'kyc.status': '状态',
  'kyc.gender': '性别',
  'kyc.id_front': '身份证的正面/护照的封面',
  'kyc.id_back': '身份证背面/护照数据页面',
  'kyc.id_selfie': '身份证和备忘录一起的自拍',
  'kyc.btn_detail': '详情',
  'kyc.btn_verify': '确认',
  'kyc.btn_reject': '拒絕',
  'kyc.notice_verify_confirm': '承认这个KYC吗？',
  'kyc.notice_reject_confirm': '拒绝此KYC吗？',
  'kyc.detail_kyc': 'KYC详细信息',
  'kyc.msg_verified': '管理员会批准KYC。无法更改信息。',
  'kyc.msg_verified.successfully': '已确认。',
  'kyc.msg_rejected.successfully': '被拒绝了。',
  'user.id': 'ID',
  'user.user': '电子邮件地址',
  'user.user_information': '用户信息',
  'user.date': '日期',
  'user.email': '电子邮件地址',
  'user.fee_level': '手续费等级',
  'user.security_level': '安全级别',
  'user.max_security_level': '最大安全级别',
  'user.referrer_code': '邀请码',
  'user.referrer_mail': '介绍邮件',
  'user.type': '类别',
  'user.status': '状态',
  'user.group': '分组',
  'user.memo': '备忘录',
  'user.normal': '常规',
  'user.bot': 'bot',
  'user.inactive': '禁用',
  'user.active': '启用',
  'user.save': '保存',
  'user.edit': '编辑',
  'user.device': '设备',
  'user.recent_activity': '最近的活动',
  'mam.manage_sub_orders': '子订货管理',
  'mam.mam_funds': '资产',
  'mam.create_master_account': 'Create Master Account',
  'mam.create_account': 'Create Account',
  'mam.close_account': 'Close Account',
  'mam.create': '创造',
  'mam.id': 'ID:',
  'mam.show_pending_only': 'Show Pending Only',
  'mam.initial_amount_btc': 'Initial amount (BTC)',
  'mam.initial_amount': 'initial amount',
  'mam.forced_close_condition': 'Your fund will be forced close if you have no trading action in 3 months or the Max Drawdown reach 30% or over.',
  'mam.search_master': 'You can get the Master\'s ID from the MAM leaderboard or from social communities.',
  'mam.guide_1': '* MAM service is a solution that helps a professional trader called Master to create a fund, manage capitals from one or more Followers accounts and helps to automatize profit/loss distribution from margin trading using fund\'s capital.',
  'mam.guide_2': '* Trading Interval is a time period, during which the Master trades to gain profits. At the end of every Trading Interval, the profit is shared between Followers and the Master, Master Performance fee is paid in accordance with the fund\'s setting before starting a new Trading Interval.',
  'mam.guide_3': '* A Trading Interval will be ended at 24:00 of the last day of a month, then the Rollover procedure will be processed, during which the following operations are carried out:',
  'mam.guide_4': '- Fees are calculated and paid to the Master account.',
  'mam.guide_5': '- Joining, assignment and revocation requests are processed.',
  'mam.guide_6': '- Follower and Master share is recalculated and distributed.',
  'mam.guide_7': '* The Freeze Time of each Trading Interval, 24 hours before Trading Interval ends, is the time period preceding the Rollover within which no request is accepted from the Master or the Follower to be processed during the Rollover procedure if the Current Trading Interval. If the new request (assignment, revocation, etc.) is submitted during the freeze time period, the request will be processed during the Rollover of the next Trading Interval.',
  'mam.guide_8': '* The Performance Fee specifies the percent from the Follower’s profit, which the Master receives when the profit is distributed between the Master and the Follower at the end of the Trading Interval.',
  'mam.guide_9': '* The Capital is the Follower’s funds assigned to the Master account. The Master\'s Performance fee is calculated based on the Capital. The value of Capital is only changed during Rollover, when the assignment/revocation requests were made by Follower and be approved by Master before Freeze Time. If the Follower gaines the profit during the Trading Interval and doesn\'t revoke it, the Capital is automatically increased at the end of the Trading Interval.',
  'mam.guide_10': '* The Balance is the net amount of funds that is assigned and revoked by the Follower to the Master as for the moment after the latest Rollover performed, considering the results of the Master\'s trading activity. It’s calculated every day.',
  'mam.initial_amount_note_1': '* Only top 10 traders on margin\'s leaderboard (both by notional or ROE) can open a fund.',
  'mam.initial_amount_note_2': '* If you want to open a fund account, you need to join your own fund. Minimum amount is 0.5 BTC.',
  'mam.initial_amount_note_3': '* If the trading on the fund account is loss-making, you will suffer losses as well. However, the bigger master capital is the more attractive fund looks for potential followers.',
  'mam.join': '参加',
  'mam.joined_date': '参加日',
  'mam.join_fund': '参加资金',
  'mam.overview': 'Overview',
  'mam.followers': 'Followers',
  'mam.commission_history': 'Commission History',
  'mam.create_close_master': 'Create/Close Master Account',
  'mam.follower_id': 'Follower ID',
  'mam.total_capital': 'Total Capital',
  'mam.total_balance': 'Total Balance',
  'mam.high_watermark': 'High Watermark',
  'mam.unrelised_pnl': 'Unrealised Pnl',
  'mam.joined_at': '参加',
  'mam.interval': 'Interval',
  'mam.entry_capital': 'Entry Capital',
  'mam.exit_capital': 'Exit Capital',
  'mam.entry_balance': 'Entry Balance',
  'mam.exit_balance': 'Exit Balance',
  'mam.commission': 'Commission',
  'mam.assigned_amount': '分配金额',
  'mam.current_investment': 'Current Investment',
  'mam.requests': 'Requests',
  'mam.report': '报告',
  'mam.find': '找寻',

  'mam.note': '留言',
  'mam.request_to_join': '请求参加',
  'mam.fund_not_exist': 'The ID is invalid.',
  'mam.fund_not_exist_2': 'The fund ID is invalid!',

  'mam.revokable_amount': 'Revokable amount',
  'mam.freeze_time': '* It is freeze time of this month, your request will be executed in next month.',
  'user.action.add_to_group': '添加到分组',
  'user.action.delete_from_group': '从分组中删除',
  'user.alert.no_user_selected': '请选择一个或多个用户。',
  'user.alert.no_group_selected': '请选择一个或多个分组。',
  'device_management.title_device_management': '设备管理',
  'user.succes': '已更新。',
  'user.user_setting': '用户设置',
  'notice.edit_title_page': '更新通知',
  'notice.new_title_page': '创建通知',
  'notice.title': '标题',
  'notice.date': '日期',
  'notice.search': '搜索',
  'notice.reset': '重置',
  'notice.new': '新',
  'notice.support': '支持链接',
  'notice.start': '开始',
  'notice.end': '退出',
  'notice.edit': '编辑',
  'notice.delete': '删除',
  'notice.start_at': '开始',
  'notice.end_at': '退出',
  'notice.banner': '横幅',
  'notice.submit': '提交',
  'notice.cancel': '取消',
  'notice.confirm': '确认',
  'notice.search_by_title': '查找标题',
  'notice.choose_file': '选择文件',
  'notice.delete_data': '删除此通知吗？',
  'notice.submit_data': '要提交这个通知吗？',
  'notice.errors.required': '必须输入此項目。',
  'notice.errors.title.required': '必须输入标题。',
  'notice.errors.support_url.required': '必须输入支持链接。',
  'notice.errors.banner_url.required': '必须输入吸尘器。',
  'notice.errors.maxsize': '请把图像尺寸设为10MB以内。',
  'notice.errors.date': '结束日期请从开始日期设定未来的日期。',
  'notice.noticeEdit': '通知编辑',
  'notice.banner_url': '横幅',
  'notice.validate.image_type': '作为jpg、.jpeg、.png的扩展名的文件是必须的。',
  'orders.open_order.open_order': '订单一览',
  'orders.open_order.date': '日期',
  'orders.open_order.pair': '交易对',
  'orders.open_order.search_by_email': '电子邮件搜索',
  'orders.open_order.search': '搜索',
  'orders.open_order.reset': '重置',
  'orders.open_order.time': '日期',
  'orders.open_order.trade_id': '交易标识',
  'orders.open_order.order_id': '订单ID',
  'orders.open_order.email': '电子邮件地址',
  'orders.open_order.price': '价格',
  'orders.open_order.filled': '成交',
  'orders.open_order.fee': '手续费',
  'orders.open_order.total': '合计',
  'orders.open_order.type': '类别',
  'orders.open_order.action': '动作',
  'orders.open_order.amount': '数量',
  'orders.open_order.trigger_condition': '成交条件',
  'orders.open_order.status': '状态',
  'orders.open_order.average': '平均',
  'orders.open_order.side': '侧面',
  'orders.open_order.buy': '买',
  'orders.open_order.sell': '卖',
  'orders.open_order.all': '全部',
  'orders.open_order.trade_history': '交易历史',
  'orders.open_order.index': 'No.',
  'orders.open_order.view_detail': '显示细节',
  'orders.open_order.market': '市场',
  'orders.order_history.order_history': '历史订单',
  'orders.order_history.date': '日期',
  'orders.order_history.pair': '交易对',
  'orders.order_history.search_by_email': '电子邮件搜索',
  'orders.order_history.search': '搜索',
  'orders.order_history.reset': '重置',
  'orders.order_history.time': '日期',
  'orders.order_history.trade_id': '交易标识',
  'orders.order_history.order_id': '订单ID',
  'orders.order_history.email': '电子邮件地址',
  'orders.order_history.price': '价格',
  'orders.order_history.filled': '成交',
  'orders.order_history.fee': '手续费',
  'orders.order_history.total': '合计',
  'orders.order_history.type': '类别',
  'orders.order_history.action': '动作',
  'orders.order_history.amount': '数量',
  'orders.order_history.trigger_condition': '成交条件',
  'orders.order_history.status': '状态',
  'orders.order_history.average': '平均',
  'orders.order_history.side': '侧面',
  'orders.order_history.buy': '买',
  'orders.order_history.sell': '卖',
  'orders.order_history.all': '全部',
  'orders.order_history.hide_all_canceled': '隐藏全部取消',
  'orders.order_history.trade_history': '交易历史',
  'orders.order_history.index': 'No.',
  'orders.order_history.view_detail': '详情',
  'orders.order_history.market': '市场',
  'orders.trade_history.trade_history': '交易历史',
  'orders.trade_history.date': '日期',
  'orders.trade_history.pair': '交易对',
  'orders.trade_history.search_by_email': '电子邮件搜索',
  'orders.trade_history.search': '搜索',
  'orders.trade_history.reset': '重置',
  'orders.trade_history.time': '日期',
  'orders.trade_history.trade_id': '交易标识',
  'orders.trade_history.original_buy_order_id': '原购买订单',
  'orders.trade_history.buyer_email': '购买者的电子邮件',
  'orders.trade_history.original_sell_order_id': '原售定单',
  'orders.trade_history.seller_email': '销售者的电子邮件地址',
  'orders.trade_history.price': '价格',
  'orders.trade_history.filled': '成交',
  'orders.trade_history.buy_fee': '购买手续费',
  'orders.trade_history.sell_fee': '出售手续费',
  'orders.trade_history.total': '合计',
  'orders.trade_history.market': '市场',
  'orders.trade_history.all': '全部',
  'email.modal': '要提交这个邮件营销吗？',
  'email.edit_title_page': '邮件营销编辑',
  'email.new_title_page': '邮件营销制作',
  'email.send_title_page': '发送邮件',
  'email.new': '邮件营销制作',
  'email.title': '标题',
  'email.content': '内容',
  'email.submit_data': '确认要提交吗？',
  'email.delete_data': '删除吗？',
  'email.send_all': '发送给所有用户',
  'email.list_user': '发送到用户列表',
  'email.send': '发送',
  'email.errors.title.required': '必须输入标题。',
  'email.errors.content.required': '必须输入内容。',
  'withdraw_fee_setting.title': '充值/提现手续费设定',
  'withdraw_fee_setting.daily_limit': '一天的限制',
  'withdraw_setting.change_confirm': '要更改提现手续费吗？',
  'withdraw_fee_setting.disable_confirm': '禁用提现功能吗?',
  'withdraw_fee_setting.disable_all_confirm': '禁用所有提现吗？',
  'withdraw_fee_setting.enable_confirm': '开启提现吗？',
  'withdraw_fee_setting.enable_all_confirm': '开启提现吗？',
  'withdraw_fee_setting.disable_deposit_confirm': '禁用充值吗？',
  'withdraw_fee_setting.disable_all_deposit_confirm': '禁用所有充值吗？',
  'withdraw_fee_setting.enable_deposit_confirm': '开启充值吗？',
  'withdraw_fee_setting.enable_all_deposit_confirm': '开启所有充值吗？',
  'withdraw_fee_setting.update_success_msg': '已更新。',
  'withdraw_fee_setting.disable_success_msg': '已禁用！',
  'withdraw_fee_setting.disable_all_success_msg': '全部无效了！',
  'withdraw_fee_setting.enable_success_msg': '已开启！',
  'withdraw_fee_setting.enable_all_success_msg': '全部开启了！',
  'withdraw_fee_setting.withdraw_setting': '充值设定',
  'withdraq_fial_popup_confirmation_label': '承认这笔交易吗？',
  'currency.amal': '4IRE',
  'salespoint.balances': '余额',
  'salespoint.bonus': '奖励',
  'salespoint.buy': '买',
  'salespoint.buy_history': '购买记录',
  'salespoint.buy_history.amount': '数量',
  'salespoint.buy_history.amal': '4IRE',
  'salespoint.buy_history.bonus': '奖励代币',
  'salespoint.buy_history.currency': '货币',
  'salespoint.buy_history.time': '日期',
  'salespoint.buy_history.cash_back': '推薦費',
  'salespoint.buy_history.email': '电子邮件地址',
  'salespoint.buy_success': '订单完成。',
  'salespoint.buy_fail': '订单失败。',
  'salespoint.export_complete_buy_history': '导出完整的4IRE历史记录',
  'salespoint.export_complete_buy_history_tooltip': '导出6个月份的购买记录',
  'salespoint.login': '登录',
  'salespoint.or': 'or',
  'salespoint.register': '新建注册',
  'salespoint.to_trade': '去交易',
  'salespoint.total_remaining_supply': '4IRE总余额',
  'margin.positions': '仓位位置',
  'margin.close_positions': '平仓',
  'margin.active_orders': '有效订单',
  'margin.funding_8_hours': '每8小时',
  'margin.active_order': '您没有有效订单。',
  'margin.stops': '停止',
  'margin.fills': '成交',
  'margin.order_history': '历史订单',
  'margin.balance': '馀额\r\n',
  'margin.isolated_balance': '逐仓余额',
  'margin.cross_equity': '交叉股权',
  'margin.unrealised_pnl': '未实现盈亏',
  'margin.cross_margin': '交叉保证金',
  'margin.order_margin': '订单保证金',
  'margin.available_balance': '可用余额',
  "margin.close_position_at": "Close Order at",
  'margin.symbol': 'Symbol',
  'margin.symbol.btc': 'BTC',
  'margin.symbol.eth': 'ETH',
  'margin.symbol.eth.coinname': '以太坊',
  'margin.symbol.btc.coinname': '比特币',
  'margin.symbol.ada.coinname': '卡尔达诺',
  'margin.symbol.bch.coinname': '比特币现金',
  'margin.symbol.eos.coinname': 'EOS',
  'margin.symbol.ltc.coinname': '莱特',
  'margin.symbol.trx.coinname': '波场',
  'margin.symbol.xrp.coinname': '瑞波币',
  'margin.symbol.usd.coinname': 'USD',
  'margin.symbol.xbtusd': '比特币',
  'margin.symbol.xbt7d_u105': 'XBT7D_U105',
  'margin.symbol.xbt7d_d95': 'XBT7D_D95',
  'margin.symbol.xbtu19': 'XBTU19',
  'margin.symbol.ethusd': '以太币现金',
  'margin.symbol.btcusd': '比特币现金\r\n',
  'margin.symbol.ada': 'ADA',
  'margin.symbol.bch': 'BCH',
  'margin.symbol.eos': 'EOS',
  'margin.symbol.ltc': 'LTC',
  'margin.symbol.trx': '波场币',
  'margin.symbol.xrp': 'XRP',
  'margin.instrument.guide': '{symbol} ({coinname})指南',
  'margin.positions_symbol': '記号',
  'margin.contract.label.bitcoin_index_minute': '比特币指数1分钟价格',
  'margin.bitcoin_index_minute': 'Bitcoin Index 1-Minute Price',
  'margin.size': '尺寸',
  'margin.value': '価値',
  'margin.entry': '进入',
  'margin.minimum_amount': '最少保证金（BTC）',
  'margin.exit': '出口',
  'margin.entry_price': '入场价',
  'margin.close_price': '收盘价',
  'margin.mark_price': '标记价格',
  'margin.liq_price': '液价',
  'margin.margin': '余量',
  'margin.unrealised_PNL': '未实现盈亏（ROE％）',
  'margin.realised_PNL': '已兌现的PNL',
  'margin.close': '关闭',
  'margin.last_price': '最近的价格',
  'margin.bid_price': '买价',
  'margin.ask_price': '询问价格',
  'margin.open_value': '开放价值',
  'margin.contract_value': '合约价值',
  'margin.expiry_date': '到期日',
  'margin.prev_price_24h': '前24小时价格',
  'margin.last_change': '最后变动％',
  'margin.reference': '参考资料',
  'margin.reference_symbol': '参考商品',
  'margin.qty': '数量',
  'margin.order_price': '订购价格',
  'margin.filled': '成交',
  'margin.remaining': '剩余的',
  'margin.order_value': '订单价值',
  'margin.fill_price': '补价',
  'margin.type': '类别',
  'margin.status': '状态',
  'margin.time': '日期',
  'margin.cancel': '取消',
  'margin.confirm': '确认',
  'margin.stop_price': '止損价格',
  'margin.trigger_price': '触发价',
  'margin.exec_qty': '执行数量',
  'margin.exec_price': '执行数量',
  'margin.order_id': '订单编号',
  'margin.orders': '订单',
  'margin.trades': '商业',
  'margin.limit': '现价',
  'margin.market': '市场',
  'margin.stop_limit': '限价止损',
  'margin.stop_market': '市价止损',
  'margin.trailing_stop': '追踪止损',
  'margin.take_profit_market': '市价止盈委托',
  'margin.take_profit_limit': '限价止盈委托',
  'margin.oco': 'OCO',
  'margin.ifd': 'IFD',
  'margin.limit_id': 'Limit_:id',
  'margin.stop_limit_id': 'Stop_Limit_:id',
  'margin.quantity': '数量',
  "margin.fee_rate": "Fee Rate",
  'margin.limit_price': '限价',
  'margin.trail_value': '追踪价格',
  'margin.buy_long': '买/买入',
  'margin.sell_short': '卖/卖出',
  'margin.buy_market': '购买市价',
  'margin.sell_market': '卖出市价',
  'margin.set_buy_stop': '设定买入止损',
  'margin.sell_buy_stop': '卖出买入止损',
  'margin.btn_buy_limit': '买/买入',
  'margin.btn_buy_market': '购买市价',
  'margin.btn_buy_stop_limit': '设定买入止损',
  'margin.btn_buy_stop_market': '设定买入止损',
  'margin.btn_buy_trailing_stop': '设定买入止损',
  'margin.btn_buy_take_profit_market': '获利买入',
  'margin.btn_buy_take_profit_limit': '获利买入',
  'margin.btn_buy_oco': '买/买入',
  'margin.btn_buy_ifd': '买/买入',
  'margin.btn_sell_limit': '卖/卖出',
  'margin.btn_sell_market': '卖出市价',
  'margin.btn_sell_stop_limit': '设置止损',
  'margin.btn_sell_stop_market': '设置止损',
  'margin.btn_sell_trailing_stop': '设置止损',
  'margin.btn_sell_take_profit_market': '获利卖出',
  'margin.btn_sell_take_profit_limit': '获利卖出',
  'margin.btn_sell_oco': '卖/卖出',
  'margin.btn_sell_ifd': '卖/卖出',
  'margin.buy': '买',
  'margin.sell': '卖',
  'margin.trigger': '触发',
  'margin.cost': '成本',
  'margin.mark': '标注',
  'margin.last': '最后',
  'margin.index': '指数',
  'margin.close_on_trigger': '触发时关闭',
  'margin.post_only': '仅供发布',
  'margin.hidden': '隐藏',
  'margin.reduce_only': '仅减少',
  'margin.display_qty': '显示数量',
  'margin.your_position': '您的仓位',
  'margin.contracts': '\r\n合约',
  'margin.contract.perpetual': '永续的',
  'margin.roe': '净资产收益率',
  'margin.risk_limit': '风险限额',
  'margin.leverage': '杠杆作用',
  'margin.maximum_leverage': '最大杠杆',
  'margin.pricing_source_details': '用于定价数据的来源。',
  'margin.buy_sell_information_limit': '点击以{price}的{quantity}数量的{symbol}合约提交{side} {type}订单。如果完全执行，这会将您的仓位从{positionSize}更改为{afterPositionSize}合约。<br> <br> 按钮底部的白杠（如果存在）表示当您的订单落在多少金额可能立即触及该交易板成交<br> <br>您执行后的估计清算价格为{liquidationPrice}。',
  'margin.buy_sell_information_market': '点击以提交于市场{quantity}数量的{symbol}合约的{side} {type}订单。如果完全执行，这会将您的仓位从{positionSize}更改为{afterPositionSize}合约。<br> <br>您的预计清算量执行后的价格为{liquidationPrice}。',
  'margin.buy_sell_information_stop_limit': '点击以{price}提交{quantity}数量的{symbol}合约{side} {type}订单，它将在{triggerType}为{stopPrice}或更高价格时触发。如果完全执行，这将改变您的仓位从{ positionSize}到{afterPositionSize}合约。',
  'margin.buy_sell_information_stop_market': '点击以提交于市场{quantity}的{symbol}合约{side} {type}订单。它将在{triggerType}为{stopPrice}或更高价格时触发。如果完全执行，这仓位将从{positionSize}改变到{afterPositionSize}合约。',
  'margin.buy_sell_information_trailing_stop': '点击以提交于市场{quantity}的{symbol}合约{side} {type}订单。它将在{triggerType}为{stopPrice}或更高价格时触发。如果完全执行，这仓位将从{positionSize}改变到{afterPositionSize}合约。',
  'margin.buy_sell_information_take_profit_limit': '点击以{price}提交{quantity}数量的{symbol}合约{side} {type}订单，它将在{triggerType}为{stopPrice}或更高价格时触发。如果完全执行，这将改变您的仓位从{ positionSize}到{afterPositionSize}合约。',
  'margin.buy_sell_information_take_profit_market': '点击以提交于市场{quantity}的{symbol}合约{side} {type}订单。它将在{triggerType}为{stopPrice}或更高价格时触发。如果完全执行，这仓位将从{positionSize}改变到{afterPositionSize}合约。',
  'margin.buy_sell_information_oco': 'OCO order: To place a stop-limit order and a limit order at the same time. When either of the order pairs is triggered, the other order will be cancelled. And if either of the order pairs is cancelled, the other order will be cancelled, too.',
  'margin.buy_sell_information_ifd': 'If-done orders are two step orders where one order is triggered only if another is activated.',
  'margin.perpetual_contract_tooltip': '这是一个无期限的永续合约。',
  'margin.contract_guide_tooltip': '{symbol}的根符号是{rootSymbol}。单击以查看系列指南。',
  'margin.index_price_tooltip': '指数价格：标的资产的价格。这是AMI的价格。',
  'margin.mark_price_tooltip': '标记价格：当前标记价格。',
  'margin.cost_tooltip': '费用：{cost} BTC。执行此订单的成本（保证金）。这包括选定的杠杆和当前头寸。减少头寸不会增加保证金。',
  'margin.order_value_tooltip': '订单价值：{orderValue} BTC。该订单的总价值',
  'margin.avai_balance_tooltip': '可用余额：{avaiBalance} BTC。订单可用余额',
  'margin.post_only_tooltip': 'A Post-Only Order 不会立即执行在市场上。用于确保制造商回扣。如果对其余定单执行，则将被取消。',
  'margin.hidden_tooltip': '隐藏的订单未显示在交易板上。',
  'margin.display_qty_tooltip': '对于完全隐藏的订单，设置为零（0）”或设置小于总订单高度的金额来创建Iceberg订单。',
  'margin.reduce_only_tooltip': 'Reduce-Only仅减少仓位，而不增加仓位。如果此訂單增加您的头寸，则会对其进行修改或取消。',
  'margin.time_in_force_tooltip': '此订单的结单日期。预设值为” Good Till Cancel“。如果设置为“ Immediate Or Cancel”，则任何未交易的仓位将在分配后立即取消。如果设置为“ Fill Or Kill”，则仅当所有仓位数量都可以立即填充时，订单才会执行。',
  'margin.trigger_tooltip': '点择将触发此平仓的价格：<br> <br>最终价格：Demo交易所的最终交易价格<br>指数价格：参考交易最终价格<br>标记价格：Demo交易所标记价格（指数+基础）',
  'margin.close_trigger_tooltip': '如果点选，将为平仓订单。平仓订单只能减少您的头寸，不能增加头寸。如果在触发平仓订单时帐户的可用余额不足，则其他订单将被取消或修改。<br> <br>无论其他未结订单如何，用来确保您的止损降低您的头寸。',
  'margin.wallet_balance_tooltip': '钱包余额=（存款-提款+已实现的PNL）。',
  'margin.unrealised_pnl_tooltip': '未实现的PNL：所有未平仓的当期损益。',
  'margin.cross_equity_tooltip': '交叉资产：您在交易所持有的总资产。交叉资产=（钱包余额-订单保证金+未实现的PNL）。',
  'margin.isolated_balance_tooltip': '孤立的余额：您的保证金处于孤立的仓位。',
  'margin.cross_margin_tooltip': '交叉保证金：您在交叉仓位中的保证金',
  'margin.order_margin_tooltip': '订单保证金：维持未平仓订单必须在交易所持有的最低资金。金额是所有未平仓订单的价值除以选定的杠杆。',
  'margin.available_balance_tooltip': '新头倉的可用保证金。可用余额=（保证金余额-订单保证金-仓位保证金）。',
  'margin.24h_turnover_tooltip': '最近24小时的合約交易金额。',
  'margin.open_value_tooltip': '现有期货或期权合约的总价值。',
  'margin.funding_rate_tooltip': '此处显示的数字是下一个资金筹措期的预估资金費率，买方将这个利率支付给卖方。如果为负，则卖方购买付款給买方。',
  'margin.contract_value_tooltip': '单个合约的当前价值。',
  'margin.your_position_tooltip': '使用此滑块调整杠杆。只有分配到的保证金会更改。',
  'margin.roe_tooltip': 'ROE（净资产收益率）',
  'margin.position_symbol_tooltip': '此仓位代表的合约股票代码。',
  'margin.last_price_tooltip': '此合约的最后交易价。',
  'margin.last_price_24h_tooltip': '24小时前的最后一笔交易价格',
  'margin.last_change_tooltip': '最近24小时内的价格变化率',
  'margin.reference_tooltip': '交易所用来计算到期日的结算价格',
  'margin.reference_symbol_tooltip': '交易所用来计算到期日的结算价格',
  'margin.instrument_mark_price_tooltip': '标记该合约的价格。 这是用于计算损益和保证金的价格',
  'margin.bid_price_tooltip': '卖出该合约的最高价格卖出订单',
  'margin.ask_price_tooltip': '此合约的最低价格买入订单',
  'margin.expiry_date_tooltip': '合约停止交易的日期和时间',
  'margin.limit_order_tooltip': '限价订单是一种以给定价格或更好的价格买卖的订单。这是最常见的订单类型。',
  'margin.market_order_tooltip': '市价订单是将订单进入市场交易的最快方法。它将在执行时以交易板中当前的最佳价格执行。',
  'margin.stop_limit_order_tooltip': 'A Stop Limit Order is like a Stop Order, but allows you to set the price of the order once your Stop Price is triggered. Use this as an alternative to Stop orders if you wish to control your exit.<br/>Note that, if your triggered order does not match against any orders in the book, your position may remain open. Set a deep price for best results.',
  'margin.stop_market_order_tooltip': 'A Stop Order is an order that does not enter the order book until the market reaches a certain Trigger Price. Traders use this type of order for two main strategies:<br/>1. As a risk-management tool to limit losses on existing positions <br/>2. As an automatic tool to enter the market at a desired entry point without manually waiting for the market to place the order.<br/>A Stop Order will become a Market Order when the Stop Price is reached.<br/>',
  'margin.trailing_stop_order_tooltip': 'A Trailing Stop Order is similar to a Stop Market Order, whereby you specify the Trailing Value differential to the Trigger Price, and if triggered then a Market Order will be placed.<br/>Note, a positive Trail Value indicates a trailing Buy whilst a negative Trail Value indicates a trailing Sell.',
  'margin.take_profit_limit_order_tooltip': 'A Take Profit Limit Order can be used to set a target price on a position. It is like a Stop, but triggers are set in the opposite direction.<br/>Use this to exit a position in profit, or to set an entry point for a new position.',
  'margin.take_profit_market_order_tooltip': 'A Take Profit Order can be used to set a target price on a position. It is like a Stop, but triggers are set in the opposite direction.<br/>Use this to exit a position in profit, or to set an entry point for a new position. A Take Profit Order becomes a Market Order once triggered.',
  'margin.order_quantity_tooltip': 'Number of contracts in an order.',
  'margin.order_price_tooltip': 'Limit price.',
  'margin.order_filled_tooltip': 'Number of contracts in an order that have been bought/sold. If the order has completed, this is equal to the quantity.',
  'margin.order_remaining_tooltip': 'Number of contracts in an order that remain to be bought/sold.',
  'margin.order_value_contract_tooltip': 'Notional value of the contracts in an order at the limit price.',
  'margin.order_filled_price_tooltip': 'Calculated average price of all fills in this order.',
  'margin.order_type_tooltip': 'The type of the order. See the available order types in the Order Controls.',
  'margin.order_status_tooltip': 'The status of the order. This tells you if an order is New, Partially Filled, Filled, or Canceled. For Trigger Orders, the order has two states when new: Untriggered, or Triggered. When a Trigger Order is untriggered it is not yet in the book and does not consume initial margin. Once an order is triggered it will also be in your orders List.',
  'margin.order_time_tooltip': 'The time at which order was submitted or last amended, used for matching time priority.',
  'margin.order_executed_quantity_tooltip': 'The number of contracts bought/sold in this particular execution. This is equal to or less than the order quantity.',
  'margin.order_executed_price_tooltip': 'The price of this particular execution. This may be equal to or better than the order price.',
  'margin.value_tooltip': 'The value of the contracts bought/sold on this execution.',
  'margin.stop_price_tooltip': 'If this is a Stop order, this is the price at which the stop will be triggered and the order will be entered into the book. On a sell stop, the stop is triggered when the current price of the contract goes below the stop price. On a buy stop, the stop is triggered when the current price rises above the stop price.',
  'margin.position_size_tooltip': 'Your current position on this instrument. If positive, you are long, if negative, short.',
  'margin.position_value_tooltip': 'The current notional value of this position.',
  'margin.position_entry_price_tooltip': 'Average executed buy/sell price for your current long/short position.',
  'margin.position_mark_price_tooltip': 'The latest mark price for this contract. This is the price used for PNL and margin calculations, and may differ from the last price for the purposes of avoiding price manipulation. This does not affect settlement.',
  'margin.position_liq_price_tooltip': 'If the mark price of the contract reaches below this price (when long) or above this price (when short), your position will be liquidated.',
  'margin.position_margin_tooltip': 'The amount of margin locked by each position. If you have isolated margin on a position, this number will go down as the margin remaining decreases, and your effective leverage rises. Drag the leverage slider in the sidebar to adjust the margin assigned to your position.',
  'margin.position_unrealised_pnl_tooltip': 'Unrealised profit and loss on this contract, and return on equity percentage.',
  'margin.position_lastest_realised_tooltip': 'This is your raw realised PNL since the last RealisedPNL wallet entry, which happens daily. When not hovering, we show realised PNL since opening the position.',
  'margin.trigger_price_tooltip': 'This is the mark or last price of the underlying contract. Compare this to your stop price to determine how far the stop is from triggering.',
  'margin.position_realised_pnl_tooltip': '自开仓以来已实现盈亏。',
  'margin.cross': '交叉',
  'margin.contract_details': '合约明细',
  'margin.pricing_source': '定价来源',
  'margin.amanpuri_index': 'Demo 指数',
  'margin.amanpuri_index_price': 'Demo 指数价格',
  'margin.24h_volume': '24小时交易量',
  'margin.open_interest': '未平仓交易',
  'margin.funding_rate': '资金費率',
  'des.des_spot_leaderboard': '排行榜交易量排名仅显示{start}至{end}日期范围内的数据',
  'title.Spot_Exchange_Leaderboard': '现货交易排行榜',
  'leaderboard.top_25_traders_by_vol': '交易量排名前25位',
  'table.trading_volume': '交易量',
  'table.email': '电子邮件地址',
  'menu.leader_board': '交易板',
  'margin.in_hour': 'In {0}h {1}m {2}s',
  'margin.more_details': '更多细节…',
  'margin.price': '价格',
  'margin.total': '合计',
  'margin.instruments': '商品',
  'margin.indices': '指标',
  'margin.timestamp': '时间戳记',
  'margin.funding_interval': '资金費率间隔',
  'margin.funding_rate_daily': '每日资金費率',
  'margin.wallet_balance': '钱包余额',
  'margin.settled_price': '结算价',
  'margin.option_strike_price': '期权行使价',
  'margin.option_underlying_price': '标的价格',
  'margin.profit_loss': '利润/损失',
  'margin.target_price': '目标价',
  'margin.liquidation_price': '清算价格',
  'margin.position': '仓位',
  'margin.contract': '合同',
  'margin.cont': 'Cont',
  'margin.side': '侧面',
  'margin.long': '买',
  'margin.short': '卖',
  'margin.exit_price': '退出价',
  'margin.roe_percent': '净资产收益率 %',
  'margin.isolated': '逐仓',
  'margin.profit_loss_percent': '利润/损失%',
  'margin.entry_value': '买入价值',
  'margin.exit_value': '脱手价格',
  'margin.min_leverage_error': '值不得小于 {leverage}',
  'margin.max_leverage_error': '值不得大于 {leverage}',
  'margin.reduce_only_error': '无法下达{symbol}订单：订单的负荷仅限关闭或减少，且一部分为{quantity}，但当前仓位为{current_qty}。',
  'margin.add_margin_successful': '添加保证金成功！',
  'margin.remove_margin_successful': '删除保证金成功！',
  'margin.add_remove_max': '最大值\r\n',
  'margin.current_qty': '当前数量',
  'margin.resulting_qty': '结果数量',
  'margin.wallet': '钱包',
  'margin.buy_limit': '限价购买',
  'margin.sell_limit': '限价卖出',
  'margin.insufficient_vailable_balance': '无法提交订单。 {cost} BTC的总保证金需求大于您的{availableBalance} BTC可用余额',
  'margin.contract_of_symbol_at_limit_price': '在 {limitPrice},{symbol}的{quantity} {contract} ',
  'margin.contract_of_symbol_at_market': '市场上 {symbol} 的{quantity} {contract}',
  'margin.contract_of_symbol_at_limit_price_oco': '{symbol}的{quantity} {contract} 分別在 {limitPrice} 和 {stopPrice}.',
  'margin.contract_of': '合約',
  'margin.contracts_of': '的合約',
  'margin.at': '在',
  'margin.and': '和',
  'margin.do_not_show_again': '不再显示',
  'margin.grouping': '分组 {value}',
  'margin.note': '注意',
  'margin.alert_close_trigger_checked': '该停损订单开启“触发时关闭”。平仓定单只能减少您的仓位，而不能增加仓位。如果在触发关闭订单时帐户的可用余额不足，则其他BTCUSD订单将被取消或下调。这是預設的行为，以确保您的停止将如按预期发生。',
  'margin.alert_close_trigger_uncheck': '该停损订单没有“触发时关闭”指令。此订单有可能打开或增加仓位，并且如果其他订单在此停止触发时消耗了可用余额，它将不会被执行。如果您不希望这样做，请返回并选择“触发时关闭”。',
  'margin.index_price': '指数价格',
  'margin.and_below': '及以下',
  'margin.and_above': '及以上',
  'margin.trailing_stop_offset': '追踪止损抵消',
  'margin.currently': '目前',
  'margin.ge_equal': '>=',
  'margin.le_equal': '<=',
  'margin.buy_take_profit_limit': '购买获利限价',
  'margin.sell_take_profit_limit': '卖出获利限价',
  'margin.buy_take_profit_market': '买入获利市价',
  'margin.sell_take_profit_market': '卖出获利市价',
  'margin.position_after_ex': '执行后的仓位规模',
  'margin.est_liqui_price': '估计清算价格',
  'margin.est_mark_price': '标记价格/预估清算差额',
  'margin.order.error.cost_gt_balance': '无法提交订单。 {cost} BTC的总保证金要求大于您的{balance} BTC的可用余额。',
  'margin.order.error.join_funds_empty': '子帐户选择空白！',
  'margin.order.succes.limit_market': '{side} {quantity} {contract}  {symbol} at {price}.',
  'margin.contract.pluralization': '合約|合约',
  'margin.order.succes.stop_limit_market': '{side} {quantity} {contract} of {symbol} at {price}.<br />触发: {trigger} @ {trigger_price} {condition}.',
  'margin.order.succes.trailing_stop': '{side} {quantity} {contract} of {symbol} at {price}.<br />追踪止损: {trail_value} (当前为 {triggerPrice})',
  'margin.order.succes.take_profit_limit_market': '{side} {quantity} {contract} of {symbol} at {price}.<br />触发: {trigger} @ {trigger_price} {condition}.',
  'margin.order.submitted': '已提交订单',
  'margin.order.filled': '订单成交',
  'margin.order.success.limit_market.filled': '{quantity} 個 {symbol}以 {price}出售。订单已全成交。',
  'margin.order.success.limit_market.partial_filled': '{quantity} 個 {symbol} 以 {price}出售',
  'margin.position.liquid': '平仓',
  'margin.position.liquid.mes': '{symbol} 仓位已结算',
  'margin.order.canceled': '订单已取消',
  'margin.order.canceled_success': '您的订单已取消！',
  'margin.order.succes.close_positions': '{side} {quantity} 关闭',
  'margin.order.succes.head_model_positions': '{quantity}关闭此 头寸吗？',
  'margin.order.succes.content_model_positions': '<span class="{class}">{side}</span> {quantity} {symbol}的合约价格为 {price}{market}.',
  'margin.order.succes.bottom_model_positions_close': '执行后，这将关闭您的整个仓位。',
  'margin.order.succes.bottom_model_positions_market': '这将在可用的市场价格中平仓您的全部仓位。',
  'margin.symbol.guide_title': '{coinname} 系列 ({symbol}) 指南',
  'margin.init_margin': '初始保证金',
  'margin.maint_margin': '维护余量',
  'margin.entry_taker_fee': '进场提取费用',
  'margin.exit_taker_fee': '退出提供费用',
  'margin.funding_base_symbol': '资金費率基础商品',
  'margin.funding_quote_symbol': '资金費率报价商品',
  'margin.funding_premium_symbol': '资金費率溢价商品',
  'margin.funding_interval_time': '每{h}小时',
  'margin.funding_timestamp': '资金費率时间戳',
  'margin.indicative_funding_rate': '指示性资金費率',
  'margin.adl_enabled': '已启用Adl',
  'margin.adl_enabled.desc': '是：该合约具有高度投机性，并通过杠杆自动化管理损失。',
  'margin.mark_method': '标记方法',
  'margin.fair_price': '合理的价格',
  'margin.fair_basis': '公平基础',
  'margin.fair_basis_rate': '公平基准利率',
  'margin.fair_method': '公平方法',
  'margin.fair_method.desc': '该金融商品的合理基础由资金費率的年度计算确定。',
  'margin.risk_step': '风险步骤',
  'margin.turnover24h': '24h营业额',
  'margin.24hturnover': '24H Turnover',
  'margin.total_volume': '总交易量',
  'margin.type.desc': '以 {settle_currency}结算, 以 {quote_currency}估价',
  'margin.contract_size': '合约大小',
  'margin.contract_dont_settle': '该合約是永续性的，不会被结算。',
  'margin.contract_has_settle': '该合约以 {time}的 {settlement_index}指数值结算。',
  'margin.settlement': '結算',
  'margin.noSettlement_history': '您没有结算历史记录',
  'margin.no_funding_history': '您没有资金費率记录',
  'margin.commission': '发生报酬',
  'margin.commission.desc': '请参见费用参考获取更多详细信息。',
  'margin.min_increment': '最低价格涨幅',
  'margin.max_price': '最高价格',
  'margin.max_order_qty': '最大订购数量',
  'margin.lot_size': '批量',
  'margin.contract_calculations': '合约计算',
  'margin.multiplier': '乘数',
  'margin.bitcoin_multiplier': '每1美元的比特币乘数',
  'margin.symbol_value': '{symbol} 值',
  'title.settlement': '結算',
  'title.then': '然后',
  'title.or': 'or',
  'margin.symbol_contract_value': '{symbol} 合約价值',
  'margin.btc.eth_contract_value.desc': '乘数*期货价格 * 1 ETH',
  'margin.btc.btc_contract_value.desc': '乘数/ BTCUSD价格',
  'margin.usd.eth_contract_value.desc': 'BTC合约价值 * BTCUSD',
  'margin.usd.btc_contract_value.desc': '1 美元',
  'margin.eth.pnl_calculation': '# 合约*乘数*（退出价格-进入价格）',
  'margin.btc.pnl_calculation': '# 合约*乘数*（1 /进入价格-1 /退出价格）',
  'margin.pnl_calculation': 'PnL 计算',
  'margin.symbol_value.desc.eth.btc': 'ETHUSD 价格*比特币乘数',
  'margin.symbol_value.desc.eth.usd': 'BTC值* BTC现货价格',
  'margin.symbol_value.desc.eth.eth': 'BTC价值/ .ETHBTC现货价格',
  'margin.bitcoin_pnl_calculation': '比特币PNL计算',
  'margin.bitcoin_pnl_calculation.desc': '（ETHUSD退出价格-ETHUSD进入价格）*比特币乘数*＃合约',
  'margin.formula': '算式',
  'margin.formula.i': 'I = ( Q - B ) / T',
  'margin.formula.f': 'F = P + Clamp( I - P, -0.05%, 0.05% )',
  'margin.result': '结果',
  'margin.sub_account': '子账户',
  'margin.sub_account.manage_allocation': 'Manage Allocation管理分配',
  'margin.sub_account.id': 'ID',
  'margin.sub_account.name': '名称',
  'margin.sub_account.is_active': '激活',
  'margin.sub_account.real_balance': '馀额\r\n',
  'margin.sub_account.enable': '已启用',
  'margin.sub_account.disable': '已关闭',
  'margin.sub_account.lot_percent': '%Lot',
  'margin.sub_account.allocation_method': '分配方法',
  "Over_one_time_limit" : "The amount you withdraw is more than once allowed.",
  'mam.allocation.lot': '批次分配',
  'mam.allocation.percent': '百分比分配',
  'mam.allocation.balance': '余额分配',
  'mam.allocation.equity': '股权分配',
  'margin.order_history.no_data': '您没有交易记录',
  'margin.add_remove_margin': '添加/删除仓位保证金',
  'margin.add_margin': '增加保证金',
  'margin.remove_margin': '删除保证金',
  'margin.your_current_position': '您现在的仓位',
  'margin.currently_assigned_margin': '当前分配的保证金',
  'margin.available_margin': '可用保证金',
  'margin.available_margin_1': '可用保证金',
  'margin.add': '加',
  'margin.remove': '去掉',
  'margin.required': '保证金区域是必填字段。',
  'margin.insufficient': '保证金是不够的。',
  'margin.cannot_add': '无法添加保证金。',
  'margin.adjust_risk_limit': '调整{contract}风险限额',
  'margin.des_risk_limit': 'Demo采用了滑动比例风险限制功能。在BTCUSD中，基本风险限额为{base} BTC。<br/>每增加<strong> {step} BTC </ strong>仓位规模，维持和初始保证金<br/>要求就会增加<strong> {stepPercent}％</ strong>。',
  'margin.des_more_risk_limit': '请查看<a href="{link}">风险限额文档</a>以获取更多信息。',
  'margin.change_risk_limit': '变更风险限额（(BTC)',
  'margin.maintenance_margin': '维持保证金\r\n',
  'margin.initial_margin': '初始保证金',
  'margin.current': '现在',
  'margin.new': '新',
  'site_setting.android_app_link': '安卓应用链接',
  'site_setting.site_email': '电子邮件地址',
  'site_setting.app_name': '应用程序名称',
  'site_setting.short_name': '快捷方式',
  'site_setting.copyright': '版権',
  'site_setting.facebook_icon': 'Facebook图标',
  'site_setting.facebook_link': 'Facebook链接',
  'site_setting.ios_app_link': 'iOS应用链接',
  'site_setting.language': '语言',
  'site_setting.site_phone_number': '电话号码',
  'site_setting.phone_number': '电话号码',
  'site_setting.phone_number_valid': '电话号码必须以文字\'+\'和国别编码开始，长度必须在7～15位之间。',
  'site_setting.site_setting': '网站设置',
  'site_setting.twitter_icon': '推特图标',
  'site_setting.twitter_link': 'Twitter链接',
  'site_setting.update_success_msg': '已更新。',
  'site_setting.youtube_icon': 'Youtube图标',
  'site_setting.youtube_link': 'Youtube链接',
  'site_setting.name': '文本，教材',
  'site_setting.icon': '文件夹',
  'site_setting.icon_hover': '文本，教材',
  'site_setting.link': '文本，教材',
  'site_setting.general': '一般',
  'site_setting.mobile_application': '移动应用',
  'site_setting.name_table': '名称',
  'site_setting.icon_table': 'Icon Class',
  'site_setting.icon_hover_table': 'Icon hover',
  'site_setting.type_table': '类别',
  'site_setting.link_table': '链接',
  'site_setting.add_row_table': '+ 追加行',
  'site_setting.status_table': '状态',
  'site_setting.social_network.title': '社交网络',
  'site_setting.social_network.confirm_remove': '删除社交网络吗？',
  'site_setting.social_network.create_success': '添加了社交网络。',
  'site_setting.social_network.update_success': '社交网络已更新。',
  'site_setting.social_network.remove_success': '社交网络已删除。',
  'site_setting.social_network.errors.required.name': '必须输入名称',
  'site_setting.social_network.errors.required.link': '必须输入链接。',
  'site_setting.social_network.errors.required.icon_class': '必须输入图标类。',
  'site_setting.social_network.errors.required.type': '必须输入类型。',
  'site_setting.social_network.errors.required.phone_number': '必须输入电话号码。',
  'trading_fee_setting.fee_maker': '挂单的手续费',
  'trading_fee_setting.fee_taker': '吃单的手续费',
  'trading_fee_setting.coin_hodling': ':COIN_HOLDING所有',
  'trading_fee_setting.msg_coin_holding': '必须为每个级别增加硬币设置。',
  'trading_fee_setting.id': 'ID',
  'trading_fee_setting.coin': '代币',
  'trading_fee_setting.trading_fee_setting': '手续费',
  'trading_fee_setting.trading_feeSetting': '设定交易手续费',
  'trading_fee_setting.trading_withdrawFeeSetting': '提现手续费设定',
  'trading_fee_setting.update_confirm': '要更改交易手续费吗？',
  'trading_fee_setting.update_success_msg': '已更新。',
  'trading_fee_setting.trading_selectMarket': '市场选择',
  'button.done': '已完成',
  'button.reset': '重置',
  'user_setting.coin': '代币',
  'user_setting.id': 'Id',
  'user_setting.blockchain_address': '区块链接地址',
  'user_setting.balance': '馀额\r\n',
  'user_setting.available_balance': '可用余额',
  'user_setting.confirm_off_otp': '禁用OTP吗？',
  'user_setting.confirm_on_otp': '启用OTP吗？',
  'user_setting.update_otp_msg': 'OTP设定的更新成功了！',
  'user_setting.confirm_disable_account': '禁用账户吗？',
  'user_setting.disable_account_success_msg': '账户已禁用！',
  'user_setting.confirm_enable_account': '启用账户吗？',
  'user_setting.enable_account_success_msg': '已启用账户！',
  'not_found.title': '找不到页面',
  'not_found.text1': '找的页面找不到。',
  'not_found.text2': '返回上一页，或访问我们的主页，或与我们的支持团队联系。',
  'not_found.landing': '着陆',
  'login.admin': '登录管理员',
  'login.email': '电子邮件地址',
  'login.email2': '电子邮件地址',
  'user.referrer': '推荐人',
  'user.otp': 'OTP',
  'email.errors.required': '您必须发送给所有用户或用户列表',
  'email.email': '电子邮件地址',
  'email.email_title': '这是题目。',
  'email.email_content': '这是内容。',
  'email.status': '状态',
  'email.message': '信息，留言',
  'email.fail': '失败',
  'exchange_balance.available_balance': '可用余额',
  'exchange_balance.exchange_balance': '交易余额',
  'exchange_fee.level': '等级',
  'withdraw_setting.disable_all': '全部禁用',
  'withdraw_setting.enable_all': '启用全部',
  'withdraw_setting.enable': '设定',
  'withdraw_setting.disable': '无效',
  'withdraw_fee_setting.id': 'ID',
  'withdraw_fee_setting.currency': '货币',
  'withdraw_fee_setting.limit': '现价',
  'withdraw_fee_setting.fee': '手续费',
  'withdraw_fee_setting.is_visible': '看得见',
  'withdraw_fee_setting.minium_withdrawal': '最少的提现',
  'withdraw_setting.id': 'ID',
  'withdraw_setting.enable_confirm': '开启提现吗？',
  'withdraw_setting.enable_all_confirm': '开启提现吗？',
  'withdraw_setting.disable_deposit_confirm': '禁用充值吗？',
  'withdraw_setting.disable_all_deposit_confirm': '禁用所有充值吗？',
  'withdraw_setting.enable_deposit_confirm': '开启充值吗？',
  'withdraw_setting.enable_all_deposit_confirm': '开启所有充值吗？',
  'withdraw_setting.name': '名称',
  'withdraw_setting.deposit': '充值',
  'withdraw_setting.withdraw': '提现',
  'withdraw_setting.update_success_msg': '已更新。',
  'withdraw_setting.disable_success_msg': '已禁用！',
  'withdraw_setting.disable_all_success_msg': '全部无效了！',
  'withdraw_setting.enable_success_msg': '已开启！',
  'withdraw_setting.enable_all_success_msg': '全部开启了！',
  'withdraw_setting.withdraw_setting': '充值设定',
  'withdraw_setting.disable_confirm': '禁用提现功能吗?',
  'withdraw_setting.disable_all_confirm': '禁用所有提现吗？',
  'user.login_history': '历史',
  'trezor_address_for_deposit': '充值的TREZOR地址',
  'trezor_device': 'TREZOR设备',
  'trezor_device.created_at': '创建时间',
  'trezor_device.device_id': '设备ID',
  'trezor_device.device_name': '设备名称',
  'trezor_device.disable': '无效',
  'trezor_device.enable': '设定',
  'trezor_device.model': '模型',
  'trezor_device.register_new_device': '注册新设备',
  'trezor_device.title': 'TREZOR设备',
  'trezor_device_information': 'TREZOR设备信息',
  'trezor_label': 'TREZOR等级',
  'trezor_path_for_deposit': '出金的托盘路径',
  'trezor_wallet': 'TREZOR钱包',
  'trezor_wallet.address': '邮箱地址',
  'trezor_wallet.balance': '馀额\r\n',
  'trezor_wallet.currency': '货币',
  'trezor_wallet.details': '详细信息',
  'trezor_wallet.device': '设备',
  'trezor_wallet.device_name': '设备名称',
  'trezor_wallet.path': '传球',
  'trezor_wallet.summary': '概要',
  'trezor_wallet.title': 'TREZOR钱包',
  'trezor_wallet.total_wallet': '总钱包',
  'trezor.landing.title': '你的交易是社会支援。敝社特别致力于这边的支援。',
  'trezor.landing.desc': '本公司作为SDGS支援企业为了支援利益的一部分使用。你通过利用Demo，可以设立学校，也可以拯救贫困。',
  'trezor.landing.title1': '进阶API',
  'trezor.landing.desc1': '我们的交易引擎是使用投资银行和对冲基金使用的相同技术构建的。',
  'modal.trezor_device_information': 'TREZOR设备信息',
  'modal.device_name': '设备名称',
  'modal.device_id': '设备ID',
  'modal.model': '模型',
  'datatable_empty': '表格中没有可用的数据。',
  'datatable_search_empty': '没有结果匹配搜索。',
  'wallet.create_receive_address.currency': '货币',
  'wallet.create_receive_address.currency_list': '货币一览表',
  'wallet.create_receive_address.generate_address': '地址创建',
  'wallet.create_receive_address.the_number_of_remaining': '剩余数目',
  'wallet.create_receive_address.title': '创建收件地址',
  'wallet.create_receive_address.get_req_success': '地址创建成功！',
  'wallet.create_receive_address.return_req_leave': '要退出吗？',
  'wallet.create_receive_address.address': '{coin_name}地址',
  'wallet.create_receive_address.coin_title': '{coin_full_name} ({coin_name})创建收件地址',
  'wallet.create_receive_address.total_number': '总数',
  'wallet.create_receive_address.lose_address': '{field}的输入是必须的。',
  'receive_address_creation': '接受地址创建',
  'receive_address_creation.warning_text': '输入是整数，必须大于0。',
  'receive_address_creation.author': '作者',
  'receive_address_creation.input_contents_to_be_created': '输入内容已创建。',
  'receive_address_creation.number_created': '创建编号',
  'receive_address_creation.please_do_not_use_trezor_for_transmission': '请不要用TREZOR发送。',
  'receive_address_creation.start_creating': '开始创建',
  'receive_address_creation.title': '接受地址创建',
  'receive_address_creation.trezor_label': 'TREZOR等级',
  'user_wallet': '用户钱包',
  'user_wallet.address': '邮箱地址',
  'user_wallet.available_balance': '可用余额',
  'user_wallet.balance': '馀额\r\n',
  'user_wallet.currency': '货币',
  'user_wallet.details': '详细信息',
  'user_wallet.device_name': '设备名称',
  'user_wallet.path': '传球',
  'user_wallet.summary': '概要',
  'user_wallet.title': '用户钱包',
  'user_wallet.total_wallet': '总钱包',
  'user_wallet.total_wallet_2': '总钱包',
  'user_wallet.user_name': '电子邮件地址',
  'coin_information.btn_back': '返回',
  'coin_information.btn_choose_file': '选择文件',
  'coin_information.btn_next': '下一步',
  'coin_information.contact_address': '合约地址',
  'coin_information.decimals': '小数位数',
  'coin_information.explorer': '区块浏览器\r\n',
  'coin_information.heading_title': '新ERC20注册',
  'coin_information.icon': 'Icon',
  'coin_information.image_note': '用png的扩展名文件是必须的。',
  'coin_information.required_confirmations': '必须确认',
  'coin_information.tab_title': '代币信息',
  'coin_information.token': '代币',
  'coin_information.token_name': '代币名',
  'coin_information.type': '类别',
  'validation.is_contract_address': '合约地址无效',
  'trading_information.btn_back': '返回',
  'trading_information.btn_delete': '删除',
  'trading_information.btn_edit': '编辑',
  'trading_information.btn_next': '下一步',
  'trading_information.btn_register_trading_pair': '登记交易对',
  'trading_information.delete_msg': '成功',
  'trading_information.fee': '手续费',
  'trading_information.heading_title': '新ERC20注册',
  'trading_information.market_price': '行市',
  'trading_information.minimum_amount': '最少数额',
  'trading_information.minimum_total': '最小总和',
  'trading_information.pair': '交易对',
  'trading_information.trading_information': '交易信息',
  'withdrawal_information.back': '返回',
  'withdrawal_information.currency': '货币',
  'withdrawal_information.day': '日',
  'withdrawal_information.days': '日',
  'withdrawal_information.fee': '手续费',
  'withdrawal_information.heading_title': '新ERC20注册',
  'withdrawal_information.limit': '现价',
  'withdrawal_information.minimum_withdrawal': '最低提现',
  'withdrawal_information.next': '下一步',
  'withdrawal_information.tab_title': '提现信息',
  'withdrawal_information.time_reset': '时间复位',
  'review_register_erc_2_0.*_check_register_erc20_information': '*检查登记erc20信息',
  'review_register_erc_2_0.amount_limit': '数量限制',
  'review_register_erc_2_0.btn_back': '返回',
  'review_register_erc_2_0.btn_register': '新建注册',
  'review_register_erc_2_0.contract_address': '合约地址',
  'review_register_erc_2_0.currency': '货币',
  'review_register_erc_2_0.days': '日',
  'review_register_erc_2_0.decimals': '小数位数',
  'review_register_erc_2_0.error_msg': '设置时发生错误。请再登记一次。',
  'review_register_erc_2_0.explorer': '区块浏览器\r\n',
  'review_register_erc_2_0.fee': '手续费',
  'review_register_erc_2_0.icon': 'Icon',
  'review_register_erc_2_0.limit': '现价',
  'review_register_erc_2_0.market_price': '行市',
  'review_register_erc_2_0.minimum_amount': '最少数额',
  'review_register_erc_2_0.minimum_total': '最小总和',
  'review_register_erc_2_0.minimum_withdrawal': '最少的提现额',
  'review_register_erc_2_0.pair': '交易对',
  'review_register_erc_2_0.precision': '値',
  'review_register_erc_2_0.register_new_erc20': '新ERC20注册',
  'review_register_erc_2_0.required_confirmations': '必须确认',
  'review_register_erc_2_0.time_reset': '时间复位',
  'review_register_erc_2_0.token': '代币',
  'review_register_erc_2_0.token_information': '代币信息',
  'review_register_erc_2_0.token_name': '代币名',
  'review_register_erc_2_0.total_limit': '总共限制',
  'review_register_erc_2_0.trading_fee': '交易手续费',
  'review_register_erc_2_0.trading_limit': '交易限制',
  'review_register_erc_2_0.trading_pair': '交易配对',
  'review_register_erc_2_0.type': '类别',
  'review_register_erc_2_0.withdrawal_information': '提现信息',
  'review_register_erc_2_0.success_msg': '注册完成！',
  'remittance_complete_registration': '已注册汇款',
  'remittance_ordered.amount': '数量',
  'remittance_ordered.btn_detail': '详细',
  'remittance_ordered.btn_search': '搜索',
  'remittance_ordered.currency': '货币',
  'remittance_ordered.execution_date': '实施日期',
  'remittance_ordered.heading_title': '汇款交易',
  'remittance_ordered.no': 'No',
  'remittance_ordered.transaction_id': '交易ID',
  'remittance_ordered.user_name': '电子邮件地址',
  'remittance_ordered.withdraw_approval': '提现审核人',
  'remittance_transaction_page.administrator_information': '管理员信息',
  'remittance_transaction_page.withdrawal_currency': '提现货币',
  'remittance_transaction_page.withdrawal_address': '提现地址',
  'remittance_transaction_page.transaction_detail': '交易详情',
  'remittance_transaction_page.customer_information': '顾客情报',
  'remittance_transaction_page.transaction_hash': '交易哈希',
  'remittance_transaction_page.remark': '<备考>',
  'remittance_transaction_page.approved_date': '审核日期',
  'remittance_transaction_page.approved_by': '批准者',
  'remittance_transaction_page.country': '国家',
  'remittance_transaction_page.created_date': '创建日期',
  'remittance_transaction_page.sent_at': '汇款时间',
  'remittance_transaction_page.sent_by': '汇款人',
  'remittance_transaction_page.email': '电子邮件地址',
  'remittance_transaction_page.header_title': '[详细]交易：:transaction_id',
  'remittance_transaction_page.quantity': '数量',
  'remittance_transaction_page.transaction_id': '交易ID',
  'remittance_transactions': '汇款交易',
  'remitted_transaction': '汇款交易',
  'erc20_loading_modal.create_account_message': '创建账户。。。',
  'erc20_loading_modal.create_migration_message': '创建迁移….',
  'erc20_loading_modal.done_message': '完成。。。。',
  'erc20_loading_modal.loading_message': '加载。。。',
  'erc20_loading_modal.set_market_price_message': '行情设定。。。',
  'erc20_loading_modal.update_masterdata_message': '主数据更新。。。',
  'eth_wallet_information': 'ETH钱包信息',
  'user_not_confirmed.amount': '数量',
  'user_not_confirmed.btn_search': '搜索',
  'user_not_confirmed.created_date': '创建日期',
  'user_not_confirmed.currency': '货币',
  'user_not_confirmed.no': 'No',
  'user_not_confirmed.title': '未确认用户',
  'user_not_confirmed.transaction_id': '交易ID',
  'user_not_confirmed.user_name': '电子邮件地址',
  'user_not_confirmed.user_not_confirmed': '未确认用户',
  'pending_transaction_page.approved_date': '审核日期',
  'pending_transaction_page.back': '返回',
  'pending_transaction_page.birthdate': '出生年月日',
  'pending_transaction_page.country': '国家',
  'pending_transaction_page.created_date': '创建日期',
  'pending_transaction_page.customer_information': '客户信息',
  'pending_transaction_page.detail': '清单',
  'pending_transaction_page.email': '电子邮件地址',
  'pending_transaction_page.header_title': '[详细]交易：{transaction_id}',
  'pending_transaction_page.name': '名称',
  'pending_transaction_page.open_notification_rejected': '交易被拒绝。',
  'pending_transaction_page.open_notification_verified': '交易被批准了。',
  'pending_transaction_page.quantity': '数量',
  'pending_transaction_page.reject': '不承认',
  'pending_transaction_page.remarks': '<备考>',
  'pending_transaction_page.tel': 'Tel',
  'pending_transaction_page.transaction': '交易',
  'pending_transaction_page.transaction_detail': '交易详情',
  'pending_transaction_page.transaction_id': '交易ID',
  'pending_transaction_page.trezor_address_for_deposit': '充值的TREZOR地址',
  'pending_transaction_page.trezor_path_for_deposit': '出金的托盘路径',
  'pending_transaction_page.verify': '确认',
  'pending_transaction_page.withdrawal_address': '提现地址',
  'pending_transaction_page.withdrawal_currency': '提现代币',
  'pending_transaction_page.field_require': '必须输入的项目',
  'rejected_transaction_page.administrator_information': '管理员信息',
  'rejected_transaction_page.withdrawal_currency': '提现货币',
  'rejected_transaction_page.withdrawal_address': '提现地址',
  'rejected_transaction_page.transaction_detail': '交易详情',
  'rejected_transaction_page.customer_information': '顾客情报',
  'rejected_transaction_page.transaction_hash': '交易哈希',
  'rejected_transaction_page.remark': '<备考>',
  'rejected_transaction_page.country': '国家',
  'rejected_transaction_page.created_date': '创建日期',
  'rejected_transaction_page.email': '电子邮件地址',
  'rejected_transaction_page.header_title': '[详细]交易：:transaction_id',
  'rejected_transaction_page.quantity': '数量',
  'rejected_transaction_page.reject_by': '拒绝者',
  'rejected_transaction_page.reject_date': '拒绝日',
  'rejected_transaction_page.transaction_id': '交易ID',
  'transactions_pending': '待定事务处理',
  'transactions_history': '交易历史',
  'salespoint.buy_history.buy_history': '购买记录',
  'salespoint.buy_history.date': '日期',
  'salespoint.buy_history.pair': '交易对',
  'salespoint.buy_history.coin': '代币',
  'salespoint.buy_history.all': '全部',
  'salespoint.buy_history.search_by_email': '电子邮件搜索',
  'salespoint.buy_history.search': '搜索',
  'salespoint.buy_history.reset': '重置',
  'salespoint.buy_history.buyer_email': '电子邮件地址',
  'cold_wallet_setting.title_page': '冷钱包设置',
  'cold_wallet_setting.receive_title': '接收地址',
  'cold_wallet_setting.btc_address': 'BTC地址',
  'cold_wallet_setting.bch_address': 'BCH地址',
  'cold_wallet_setting.eth_address': 'ETH/ERC20地址',
  'cold_wallet_setting.xrp_address': 'XRP地址',
  'cold_wallet_setting.ltc_address': 'LTC地址',
  'cold_wallet_setting.eos_address': 'EOS地址',
  'cold_wallet_setting.ada_address': 'ADA地址',
  'cold_wallet_setting.usdt_address': 'USDT地址',
  'cold_wallet_setting.usd_address': 'USD地址',
  'cold_wallet_setting.address': '{currency} 地址',
  'cold_wallet_setting.min_balance': '最低余额',
  'cold_wallet_setting.max_balance': '最高余额',
  'cold_wallet_setting.notification_title': '通知',
  'cold_wallet_setting.holder_email': '冷钱包所有者的电子邮件地址',
  'cold_wallet_setting.holder_name': '冷钱包所有者的姓名',
  'cold_wallet_setting.holder_mobile': '冷钱包所有者的电话号码',
  'cold_wallet_setting.address.invalid': '地址无效',
  'cold_wallet_setting.xrp.sub_address_placeholder': '',
  'cold_wallet_setting.eos.sub_address_placeholder': '',
  'permission.role.required': ':Role必须输入。',
  'funds.transaction_history.no_deposit_data': '没有充值历史。',
  'funds.transaction_history.no_withdraw_data': '没有提现履历。',
  'barstyle_chart.save_chart': '保存图表',
  'barstyle_chart.load_chart': '下载图表',
  'barstyle_chart.bars': 'Bars',
  'barstyle_chart.candles': '蜡烛状',
  'barstyle_chart.hollow_candles': 'Hollow Candles綠色中空的燭形',
  'barstyle_chart.heikin_ashi': 'Heikin Ashi烛状图',
  'barstyle_chart.line': '线',
  'barstyle_chart.area': '区域',
  'withdraw_setting.currency': '货币',
  'menu.user_group_setting': '分组设置',
  'group_setting.date': '日期',
  'group_setting.search_by_name': '按名称查找',
  'group_setting.search': '已完成',
  'group_setting.reset': '重置',
  'group_setting.add_new': '添加到分组',
  'group_setting.name': '名称',
  'group_setting.memo': '备忘录',
  'group_setting.delete_data': '删除此组吗？',
  'group_setting.edit': '编辑分组',
  '_validation.precision': '{attribute}的精度必须是{precision}',
  '_validation.accepted': '{attribute}必须被接受。',
  '_validation.active_url': '{attribute}不是有效的URL。',
  '_validation.after': '{attribute}必须是{date}更大的日期。',
  '_validation.after_or_equal': '{attribute}必须是{date}以后的日期',
  '_validation.alpha': '{attribute}只能包含字符。',
  '_validation.alpha_dash': '{attribute}只能包含字母、数字、短划线和下划线。',
  '_validation.alpha_num': '{attribute}只能包含字符和数字。',
  '_validation.array': '{attribute}必须排列。',
  '_validation.before': '{attribute}必须是{date}更小的日期。',
  '_validation.before_or_equal': '{attribute}必须是{date}以前的日期。',
  '_validation.between.numeric': '{attribute}必须从{min}到{max}。',
  '_validation.between.file': '{attribute}必须从{min}到{max}千字节。',
  '_validation.between.string': '{attribute}必须从{min}到{max}文字。',
  '_validation.between.array': '{attribute}需要从{min}到{max}事情。',
  '_validation.boolean': '{attribute}必须是true或false。',
  '_validation.confirmed': '{attribute}的确认不一致。',
  '_validation.date': '{attribute}不是有效的日期。',
  '_validation.date_format': '{attribute}与格式{format}不一致。',
  '_validation.different': '{attribute}和{other}必须不同。',
  '_validation.digits': '{attribute}必须是{min}位数。',
  '_validation.digits_between': '{attribute}必须是从{min}到{max}的数字。',
  '_validation.dimensions': '{attribute}的图像大小无效。',
  '_validation.distinct': '{attribute}的值重复。',
  '_validation.email': '{attribute}项目必须是有效的电子邮件地址。',
  '_validation.exists': '选中的{attribute}无效。',
  '_validation.file': '{attribute}必须是文件。',
  '_validation.filled': '{attribute}的输入是必须的。',
  '_validation.gt.numeric': '{attribute}必须比{value}大。',
  '_validation.gt.file': '{attribute}必须比{value}千字节大。',
  '_validation.gt.string': '{attribute}必须比{value}文字大。',
  '_validation.gt.array': '{attribute}需要{value}以上的项目。',
  '_validation.gte.numeric': '{attribute}必须在{value}以上。',
  '_validation.gte.file': '{attribute}必须在{value}千字节以上。',
  '_validation.gte.string': '{attribute}必须在{value}字符以上。',
  '_validation.gte.array': '{attribute}必须具有{value}以上的项目。',
  '_validation.image': '{attribute}必须是图像。',
  '_validation.in': '选中的{attribute}无效。',
  '_validation.in_array': '{attribute}不存在{other}。',
  '_validation.integer': '{attribute}必须是图像。',
  '_validation.ip': '{attribute}必须是有效的IP地址。',
  '_validation.ipv4': '{attribute}必须是有效的IP4地址。',
  '_validation.ipv6': '{attribute}必须是有效的IP6地址。',
  '_validation.json': '{attribute}必须是有效的JSON字符串。',
  '_validation.lt.numeric': '{attribute}必须比{value}小。',
  '_validation.lt.file': '{attribute}必须小于{value}千字节。',
  '_validation.lt.string': '{attribute}必须在{value}字符以下。',
  '_validation.lt.array': '{attribute}的项目数必须在{value}以下。',
  '_validation.lte.numeric': '{attribute}的项目数必须在{value}以下。',
  '_validation.lte.file': '{attribute}必须在{value}千字节以下。',
  '_validation.lte.string': '{attribute}必须在{value}字符以下。',
  '_validation.lte.array': '{attribute}不能超过{value}个。',
  '_validation.max.numeric': '{attribute}不能比{max}大。',
  '_validation.max.file': '{attribute}必须在{max}千字节以下。',
  '_validation.max.string': '{attribute}必须在{max}字符以下。',
  '_validation.max.array': '{attribute}不能超过{max}个。',
  '_validation.mimes': '{attribute}必须是{values}类型的文件。',
  '_validation.mimetypes': '{attribute}必须是{values}类型的文件。',
  '_validation.min.numeric': '{attribute}必须在{min}以上。',
  '_validation.min.file': '{attribute}必须在{min}千字节以上。',
  '_validation.min.string': '{attribute}必须在{min}字符以上。',
  '_validation.min.array': '{attribute}需要{min}件以上。',
  '_validation.not_in': '选中的{attribute}无效。',
  '_validation.not_regex': '{attribute}格式无效。',
  '_validation.numeric': '{attribute}必须是数字。',
  '_validation.present': '{attribute}必须是true或false。',
  '_validation.regex': '{attribute}格式无效。',
  '_validation.required': '{attribute}的输入是必须的。',
  '_validation.required_if': 'other}是{value}的情况下，{attribute}必须输入。',
  '_validation.required_unless': '只要{other}未包含在{values}中，{attribute}的输入是必须的',
  '_validation.required_with': '如果{values}存在，{attribute}必须输入。',
  '_validation.required_with_all': '如果{values}存在，{attribute}必须输入。',
  '_validation.required_without': '如果{values}不存在，{attribute}必须输入。',
  '_validation.required_without_all': '如果{values}不存在，{attribute}必须输入。',
  '_validation.same': '{attribute}和{other}必须一致。',
  '_validation.size.numeric': '{attribute}必须是{size}。',
  '_validation.size.file': '{attribute}必须是{size}千字节。',
  '_validation.size.string': '{attribute}必须是{size}字符。',
  '_validation.size.array': '{attribute}必须包含{size}条目。',
  '_validation.string': '{attribute}必须是字符串',
  '_validation.timezone': '{attribute}必须是有效区域。',
  '_validation.unique': '{attribute}已经被使用。',
  '_validation.uploaded': '{attribute}上传失败。',
  '_validation.url': '{attribute}格式无效。',
  '_validation.old_password': '{attribute}不正确。',
  '_validation.no_space': '不能在{attribute}中包含空白。',
  '_validation.valid_ethereum_address': '{attribute}必须是有效的Ethereum地址。',
  '_validation.valid_bitcoin_address': '{attribute}必须是有效的比特币地址。',
  '_validation.valid_tetherus_address': '{attribute}必须是有效的TetherUS地址。',
  '_validation.verified_email': '为了启用账户请检查邮件',
  '_validation.unverified_email': '为了启用账户请检查邮件',
  '_validation.unregistered_email': '{attribute}已注册。',
  '_validation.is_not_temp_email': '{attribute}是一次性的邮件',
  '_validation.send_verify_user': '{attribute}无效。',
  '_validation.email_reset_password_exists': '您输入的电子邮件地址不存在',
  '_validation.voucher_existed': '对不起。代码不存在',
  '_validation.voucher_is_expired': '对不起。代码过期',
  '_validation.unique_voucher': '对不起。代码已被使用',
  '_validation.is_invalid_otp_code': 'OTP代码无效',
  '_validation.unique_metadata_bounty': '链接已被使用。',
  '_validation.unique_currency_address': '地址已被使用。',
  '_validation.email_active': '你的账号锁定了。',
  '_validation.password_white_space': '请不要在密码中包含空白。',
  '_validation.correct_password': '密码不匹配。',
  '_validation.google_authentication_code_valid': 'Google认证代码无效',
  '_validation.is_invalid_google_authenticator_code': 'Google认证代码无效',
  '_validation.email_change_unregistered': '注册的电子邮件地址',
  '_validation.email_change_not_pending': '注册的电子邮件地址',
  '_validation.blockchain_address': '{attribute}无效。',
  '_validation.law_accepted': '选择“否”时无法登录',
  '_validation.otp_not_used': '请等待下一个认证代码生成。',
  '_validation.is_contract_address': '合约地址无效',
  '_validation.unregistered_token': '令牌已经被使用。',
  '_validation.unregistered_token_name': '令牌名称已经被使用。',
  '_validation.unregistered_coin_name': '令牌名称已经被使用。',
  '_validation.unregistered_contract_address': '联系人地址已经存在。',
  '_validation.custom.referral_id.exists': '介绍代码无效。',
  '_validation.custom.base_price.min': '止損价格必须在{min}以上。',
  '_validation.custom.base_price.precision': '止盈价格必须是{precision}的精度',
  '_validation.custom.quantity.min': '数量必须在{min}以上。',
  '_validation.custom.quantity.precision': '金额的值必须是{precision}',
  '_validation.custom.total.min': '总计必须最低{min}',
  '_validation.custom.total.precision': '总和必须是{precision}的值',
  '_validation.custom.price.min': '价格必须最低{min}',
  '_validation.custom.price.precision': '止盈价格必须是{precision}的值',
  '_validation.custom.google_authenticator_code.length': '谷歌认证代码必须是6位。',
  '_validation.custom.tel.numeric': '请输入数字。',
  '_validation.custom.zip_code.numeric': '请输入数字。',
  '_validation.attributes.email': '电子邮件地址',
  '_validation.attributes.user_id': '用户ID',
  '_validation.attributes.password': '密码',
  '_validation.attributes.repeat_password': '重新输入密码',
  '_validation.attributes.new_password': '新密码',
  '_validation.attributes.confirm_new_password': '新密码(确认)',
  '_validation.attributes.agree': '同意',
  '_validation.attributes.google_authenticator_code': '谷歌认证代码',
  '_validation.attributes.recovery_code': '恢复代码',
  '_validation.attributes.confirm_email': '确认邮件',
  '_validation.attributes.blockchain_address': '区块链地址',
  '_validation.attributes.transaction_explorer': '区块浏览器',
  '_validation.attributes.minium_quantity': '最小数量',
  '_validation.attributes.minium_amount': '最少額',
  '_validation.attributes.minium_total': '最小合計',
  '_validation.attributes.total_limit': '合計制限',
  '_validation.attributes.amount_limit': '数量制限',
  '_validation.attributes.minium_withdrawal': '最少額的提现',
  '_validation.attributes.zip_code': 'Zip代码',
  '_validation.attributes.state_region': '国家/地区',
  '_validation.attributes.building_room': '大厦/房间',
  '_validation.attributes.coin_name': '名字',
  '_validation.attributes.token_name': '代币名',
  '_validation.attributes.precision': '値',
  '_validation.attributes.contract_address': '合约地址',
  '_validation.attributes.coin': '代币',
  '_validation.attributes.token': '代币',
  '_validation.attributes.icon': '图标',
  '_validation.attributes.time_reset': '复位时间',
  '_validation.attributes.market_price': '行情',
  '_validation.attributes.minimum_amount': '最少額',
  '_validation.attributes.minimum_total': '最小合計',
  '_validation.attributes.minimum_withdrawal': '最少額的提现',
  '_validation.attributes.limit': '限价',
  '_validation.attributes.fee': '手续费',
  '_validation.attributes.pair': '交易对',
  '_validation.attributes.name': '名字',
  '_validation.attributes.send_confirmer': '交易哈希',
  '_validation.attributes.tx_hash': '事务散列',
  'emails.kyc_notification.subject': '【app_name}】KYC确认- {date}',
  'emails.kyc_notification.name': '尊敬的先生/女士{name}',
  'emails.kyc_notification.text1': '感谢您使用本公司的服务。',
  'emails.kyc_notification.text2': '是Demo的支持。',
  'emails.kyc_notification.text3': '谢谢您的等待。',
  'emails.kyc_notification.text4': '因为正在进行本人确认的审查，请从这边登录到用户页面，确认审查结果。',
  'emails.kyc_notification.text5': '如果您没有在您的主页上方显示表明您需要发送身份证的消息，则您的身份证已成功完成。',
  'emails.kyc_notification.text6': '如果信件显示在自己的页面上，由于发送或图像错误未被授权。为此，请再确认本人确认文件后再提交。',
  'emails.kyc_notification.text7': '虽然无法确认提交的文件不合适的理由，但是不合适的理由主要如下，所以请确认一下提交过一次的照片是否符合以下内容。',
  'emails.kyc_notification.text8': '没有指定本人确认文件',
  'emails.kyc_notification.text9': '身份证和自拍照片的脸不一样。',
  'emails.kyc_notification.text10': '提交给ID SERPHY的文件，交换名称，日期，此人本人未一起显示',
  'emails.kyc_notification.text11': '没有向正面',
  'emails.kyc_notification.text12': '自拍照上没有显示“全脸”（没有显示全头）',
  'emails.kyc_notification.text13': '中国和美国的住处',
  'emails.kyc_notification.text14': '图像暗淡,面目不清楚',
  'emails.kyc_notification.text15': '上传图像失败',
  'emails.kyc_notification.text16': '对不起，给您添麻烦了。谢谢您的合作。',
  'emails.approved_notification.subject': '【{app_name}】批准出款。- {date}',
  'emails.approved_notification.name': '{name}您好',
  'emails.approved_notification.text1': '此提现要求被审核了。',
  'emails.approved_notification.text2': '货币',
  'emails.approved_notification.text3': '数量',
  'emails.approved_notification.text4': '收件人地址',
  'emails.approved_notification.text5': '要求日',
  'emails.approved_notification.text6': '从这里转到提现处理。',
  'emails.approved_notification.text7': '感谢您继续支持Demo。',
  'emails.approved_notification.text8': '3.4密码和用户ID的管理',
  'emails.approved_notification.text9': '3.4密码和用户ID的管理',
  'emails.approved_notification.text10': '3.4密码和用户ID的管理',
  'emails.approved_notification.text11': '3.4密码和用户ID的管理',
  'emails.approved_notification.text12': '3.4密码和用户ID的管理',
  'excel.account_registrant.no': 'No',
  'excel.account_registrant.file_name': '账户注册者',
  'excel.account_registrant.already': '已经',
  'excel.account_registrant.not_yet': '没有',
  'excel.account_registrant.mail_address': '电子邮件地址',
  'excel.account_registrant.mail_auth': '认证',
  'excel.account_registrant.registered_information': '登录信息',
  'excel.account_registrant.registered_date': '登录日期',
  'excel.account_registrant.last_login': '最终登录',
  'excel.registered_person.no': 'No',
  'excel.registered_person.file_name': '登录者',
  'excel.registered_person.mail_address': '电子邮件地址',
  'excel.registered_person.name': '名称',
  'excel.registered_person.tel': '电话号码',
  'excel.registered_person.country': '国家',
  'excel.registered_person.upload_at': '上传日期',
  'excel.registered_person.last_login': '最终登录',
  'excel.id_registrant.no': 'No',
  'excel.id_registrant.file_name': 'KYC登录者',
  'excel.id_registrant.country_name': '国家',
  'excel.id_registrant.name': '名称',
  'excel.id_registrant.tel': '电话号码',
  'excel.id_registrant.mail_address': '电子邮件地址',
  'excel.id_registrant.created_at': '创建日期',
  'excel.id_registrant.updated_at': '上传日期',
  'excel.id_registrant.last_login': '最终登录',
  'excel.payment_history.file_name': '支付履历',
  'excel.payment_history.id': '交易ID',
  'excel.payment_history.user_name': '用户名',
  'excel.payment_history.currency': '货币',
  'excel.payment_history.amount': '数量',
  'excel.payment_history.created_at': '创建日期',
  '_auth.failed': '用户ID或密码未被正确输入。',
  '_auth.throttle': '登录次数太多了。{seconds}秒后请再试一次。',
  '_auth.ip_verify': '请确认邮件以便这个IP地址能够访问你的账号。',
  '_pagination.previous': '返回',
  '_pagination.next': '下一步',
  '_passwords.password': '密码要6个字符以上，需要与确认一致。',
  '_passwords.reset': '密码已重新设置。',
  '_passwords.sent': '密码重新设定链接已通过邮件发送。',
  '_passwords.token': '此密码重新设置令牌无效。',
  '_passwords.user': '找不到拥有那个邮箱地址的用户。',
  'account.identity.errors.status_pendding': '等待管理员的确认。',
  'address.add_whitelist': '添加到白名单',
  'common.create.success': '已创建。',
  'common.update.success': '已更新',
  'common.delete.success': '已删除',
  'messages.user_cannot_withdraw_fiat': '请启用Google认证，从管理者接受KYC的认可。',
  'messages.error': '错误',
  'messages.primary': '主要',
  'messages.success': '成功',
  'messages.info': '信息',
  'messages.warning': '警告',
  'messages.user_must_enable_google_auth': '必须启用谷歌认证。',
  'sales_point.error.lose_persentor': '需要输入介绍人的价格。',
  'sales_point.error.price_persentor': '介绍人的价格要大于0。',
  'validation.custom.banner_url.image': '文件必须是图像。',
  'validation.custom.banner_url.mimes': '文件必须是:values格式的文件。',
  'validation.custom.new_password.min': '密码包含大写字母、小写字母、数字等8个字符以上，必须与确认用密码一致',
  'validation.custom.new_password.regex': '密码包含大写字母、小写字母、数字等8个字符以上，必须与确认用密码一致',
  'validation.valid_currency_address': '提现地址无效。',
  'validation.user_id_coin_wallet': '收款地址或标记/备忘录/...已经存在。',
  'validation.user_id_coin_wallet_2': '收款地址或标记/备忘录/...已经存在。',
  'validation.check_exist_email': '为了启用账户请检查邮件',
  'messages.ban_account': '你的账号已经更改了。',
  'cold_wallet_setting.btc_address.required': '必须输入BTC地址。',
  'cold_wallet_setting.btc_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.btc_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.bch_address.required': '必须输入BCH地址。',
  'cold_wallet_setting.bch_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.bch_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.eth_address.required': '必须输入ETH地址。',
  'cold_wallet_setting.eth_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.eth_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.xrp_address.required': '必须输入XRP地址。',
  'cold_wallet_setting.xrp_sub_address.required': '必须输入XRP子地址。',
  'cold_wallet_setting.xrp_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.xrp_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.ltc_address.required': '必须输入LTC地址。',
  'cold_wallet_setting.ltc_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.ltc_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.eos_address.required': '必须输入EOS地址。',
  'cold_wallet_setting.eos_sub_address.required': '必须输入EOS子地址。',
  'cold_wallet_setting.eos_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.eos_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.ada_address.required': '必须输入ADA地址。',
  'cold_wallet_setting.ada_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.asa_max_balance.required': '必须输入此项。',
  'cold_wallet_setting.usdt_address.required': '必须输入USDT地址。',
  'cold_wallet_setting.usdt_min_balance.required': '必须输入此项。',
  'cold_wallet_setting.usdt_max_balance.required': '必须输入此项。',
  'group_setting.error.exist': '重复的组名。',
  'account.discount_percent': '({percent} discount)',
  'address.cancel_success': '已取消。',
  'funds.balances.default_balance': '0',
  'funds.balances.you_have_selected_coin': '<span class=\'coin-count\'>{coin}</span>选择了硬币。',
  'funds.depositUSD.no_data': '没有USD充值历史。',
  'funds.deposit.tips.text4': '{name}在确认{count}的网络后马上就会充值。',
  'funds.withdrawals.errors.blockchain_address_exists': '这个地址已经存在。',
  'funds.withdrawals.errors.blockchain_address_sub_address_exists': '收款地址或标记/备忘录/...已经存在。',
  'funds.withdrawals.errors.kyc': '请启用Google认证，从管理者接受KYC的认可。',
  'funds.withdrawals.confirm_withdrawal': '确认了提现交易。',
  'funds.withdrawals.no_memo': '没有备忘录',
  'menu.investments': '投资',
  'menu.request': '申请',
  'menu.investors': '投资人',
  'menu.lang.mn': '日语',
  'menu.lang.ko': '韩语',
  'menu.lang.zh': '汉语',
  'menu.lang.acr.en': 'EN',
  'menu.lang.acr.mn': 'MN',
  'menu.lang.acr.ko': 'KO',
  'menu.lang.acr.zh': 'ZH',
  'menu.lang.acr.ja': 'JA',
  'menu.lang.acr.ru': 'RU',
  'menu.lang.acr.vi': 'VI',
  'menu.mam': 'MAM',
  'register.success_2': '<div><p style=\'line-height: 28px;color: #333;font-size: 14px;margin: 0;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;\'>我们发送了一封确认邮件给 <span title={email}>{email}</span>.</div><div>请按照说明完成注册。</p></div>',
  "register.success_3": "You have been successfully registered. To activate your account check your email and confirm your registration.",
  'register.title_2': '重新发送邮件',
  'register.title_3': '无法接收时，请执行以下操作：',
  'register.paragraph_1': '请确认注册的电子邮件地址是否正确。',
  'register.paragraph_2': '请确认垃圾邮件和其他文件夹。',
  'register.paragraph_3': '在此设定电子邮件地址的白名单。',
  'register.paragraph_4': '请确认邮件客户端正常工作。',
  'withdraw_guide.partner': '合作伙伴（咨询）',
  'withdraw_guide.contract_admin': '请联系客服',
  'withdraw_guide.kyc': 'KYC确认',
  'withdraw_guide.verf_doc': '通过KYC',
  'common.action.approve': '批准',
  'salespoint.amal': '4IRE',
  'salespoint.enter_amount': '请输入数量',
  'salespoint.login_or_register': '登录交易</a> or <a href="{register}">',
  'menu_bottom.withdrawals_guide': '提现指南',
  'menu_bottom.terms_of_service': '使用规则',
  'menu_bottom.api_document': 'API文档',
  'menu_bottom.faq': 'FAQ',
  "menu_bottom.leverage_reference": "Leverage Reference",
  'menu_bottom.white_paper': '白皮书',
  'title.settlement_history_table': '结算履历表',
  'title.des.this_list_contains': '这个名单包含了过去的结算。',
  'search.placeholder.click_values_below_to_fillter': '点击下面的值进行过滤。',
  'button.clear': '清除',
  'button.save_as_CSV': '以CSV格式保存',
  'table.timestamp': '时间戳记',
  'table.symbol': '記号',
  'table.settlement_type': '结算类型',
  'table.settled_price': '结算价',
  'table.option_strike_price': '期权行使价',
  'title.daily_insurance_fund_balance': '保险基金每日余额',
  'title.des.daily_insurance_fund_balance': '在Demo，使用保险基金，防止交易位置杠杆自动消除。该基金在继承杠杆自动消除系统之前，汇总未约定的清算订单。<br/> <br/>保险基金，如果在市场上能以比特定位置的破产价格有利的价格进行清算订单，则通过清算增大。<br/><br/>保险基金的现有余额及过去的余额可见如下。',
  'table.wallet_balance': '钱包余额',
  'title.funding_history_table': '资金費率履历表',
  'title.header_form.futures_guide': '期货指南',
  'leaderboard.top_25_traders_by_notional': '按理论排名前25位的交易者',
  'leaderboard.top_25_traders_by_roe': 'ROE排名前25位的交易者',
  'leaderboard.top_25_traders_by_volume': '交易量排名前25位',
  'table.profit': '利润',
  'table.volume': '成交额',
  'title.des.referrence.btc': '<ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#how_is_the_perpetual_contract_quoted">BTCUSD永续合约如何报价？</a> </li> <li> <a href="#margin_and_leverage">保证金和杠杆</a> </li> <li> <a href="#price_index">价格指数</a> </li> <li> <a href="#marking_and_settlement">标记和结算</a> </li> </ul>',
  'title.how_is_the_perpetual_contract_quoted': '{symbol} 永续合约如何报价？',
  'title.des.how_is_the_btc_perpetual_contract_quoted': '<p> BTCUSD合约的基础价格为<a href="{BTCIndex}"> BTC指数</a>。它是使用在Bitstamp、Coinbase Pro、OKCoin、GEMINI和Kraken USD BTC / USD上价格的同等加权指数。基础合约和掉期合约均以美元报价。保证金和PNL以比特币计价。</ p>',
  'title.des.how_is_the_btc_perpetual_contract_quoted2': '<p>想要从比特币/美元价格上涨中获利的交易者，将会购买BTCUSD合约。相反地，如果他们认为价格会下跌，他们将会出售合约。</ p>',
  'title.btc.margin_and_leverage.desc': '<p>所有保证金都用比特币，这意味着交易者可以仅使用比特币来做多或做空该合约。 BTCUSD合约具有高达100倍的高杠杆。</ p> <p>例如，要购买価値100比特币的合约，您只需要1个比特币作为初始保证金即可。</ p>',
  'title.btc.price_index.desc': '<p> <a href="{BTCIndex}"> Demo .BTC指数</a>当前用于<a href="{BTCUSDPerpetualContract}"> BTCUSD永续合约</a>和BTC期货合约。 </ p> <p>有关成分及其交易所的信息，请参考<a href="{BTCCompositeIndexBreakdown}#composite-index-breakdown"> BTC综合指数分解</a>。</ p> < p>在此时，权重相等。将来，我们可能会调整该指数。任何调整都将在充分通知的情况下进行。</ p>',
  'title.btc.marking_and_settlement.desc': '<p>由于BTCUSD合约是永续性的，因此没有结算期限。未实现的PNL和清算目的的标记是根据“合理价格标记”系统完成的。</ p> <p>另请注意：由于该产品是永续性，因此每8个小时进行一次注资。请参阅《永久合同指南》中的<a href="{perpetualContractsGuide}#funding">资金費用部分</a>，有关当前汇率，请参见<a href="{BTCUSDContractSpecifications}>中的资金计算。 BTCUSD合约规格</a>中的資金費用計算。</ p> <p> <strong> BTCUSD交易示例</strong></p> <blockquote style="font-size: 14px;    font-style: italic;"> <p>交易者以600美元的价格做多100 BTC的BTCUSD。他多头为100 BTC * 600 USD = 60,000张合约。几天后，合同价格上涨至700美元。</ p> <p>交易者的利润为：<strong> 60,000 * 1 *（1/600-1/700）= 14.286 BTC </ strong> </ p> <p>如果价格实际下跌至500美元，交易者的损失将是：<strong> 60,000 * 1 *（1/600-1/500）= -20 BTC </ strong>。由于合約的<em>逆和非线性</ em>性质，损失更大。相反，如果交易者做空，那么如果价格下跌，交易者的利润将大于损失，如果上涨则亏损。</ p> </ blockquote> </ div>',
  'title.contract_specification': '合约规格',
  'title.contract.description.futures_contract': '<a href="{contractSpecifications}"> {symbol} </a>是设定在<a href="{routerIndex}"> {settlementIndex}指数</a>上的{base_underlying} / {quote_currency}期货合约。每个合约的价值等于其在比特币中的价格。该合约是投机的理想选择。',
  'title.description': '描述',
  'title.full_contract_details': '完整合約明细',
  'common.the_base_currency_is_symbol': '基本货币为 {symbol}',
  'common.the_quote_currency_is_symbol': '报价货币为 {symbol}',
  'title.des.description': '<a href="{contractSpecifications}"> {symbol} </a>是根据<a href="{routerIndex}"> {base_underlying}指数</a>定价的{base_underlying} / {quote_currency}永续合约。每份合约都相当于比特币的{contract_value}。<br/>资金每{funding_interval}小时进行支付與与收取。下一次支付会在{nextDate}。<br/> <a href="{contractSpecifications}"> {symbol} </a>使用溢价指数来计算资金費率。基础利率根据<a href="{routerFBase}"> {funding_base_index}指数</a>和<a href="{routerFQuote}"> {funding_quote_index}指数</a>进行报价，溢价率根据<a href="{routerFPremium}"> {funding_premium_index}指数</a>进行报价。以上这些被用于计算最终资金費率。<br/>今天，多头将支付{fundingRate}％，空头将在{date}获取{fundingRate}％。 Demo不收取任何资金费用。',
  'title.funding_calculation': '资金費率计算',
  'title.des.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'title.des.bitcoin_series_eth_guide': '<p>以太坊是一个运行智能合约的去中心化平台：以完全按照区块链上的程序运行的应用程序，不会出现停机、审查、欺诈或第三方干扰的可能性。 该项目由<a href="https://www.ethereum.org/foundation">以太坊基金会</a>开发。 以太坊货币以货币代码ETH表示，通常称为以太币。 有关ETH和以太坊项目的更多信息，可以在<a href="https://www.ethereum.org/">此处</a>找到。</ p> <p> Demo当前对于交易者提供两种类型的ETH衍生产品。 第一种形式为以太币/比特币（ETH / BTC）<a href="{futuresGuide}">期货合约</a>，第二种形式为以太币/美元（ETH / USD）<a href="{perpetualContractsGuide}">永续合約</a>。</ p>',
  'title.des.referrence.eth': '<ul class="list_link_head clearfix" style="list-style-type: none; padding-left: 25px;"> <li> <a href="#Futures-Contracts">期货合约</a> <ul style="list-style-type: disc; padding-left: 25px;"> <li><a href="#How-Are-ETHBTC-Futures-Quoted">如何报价ETHBTC期货？</a> </ li> <li> <a href="#Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Settlement">结算</a> </ li> <li> <a href="#ETHBTC-Futures-Contract-Example"> ETHBTC期货合约示例</a></li> </ul> </li> <li> <a href="#Perpetual-Contracts">永续合約</a> <ul style="list-style-type: disc; padding-left: 25px;"> <li><a href="#How-Is-The-ETHUSD-Perpetual-Contract-Quoted">ETHUSD永续合约如何报价</a> </ li> <li> <a href="#Perpetual-Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Perpetual-Settlement">结算</a> </ li> <li> <a href="#ETHUSD-Perpetual-Contract-Example"> ETHUSD永续合约示例</a> <ul style="list-style-type: '- '; padding-left: 25px;"> <li><a href="#Trade-Inception">交易开始</a> </ li> <li> <a href="#Trade-Expiry">交易結束</a> </ li> < / ul> </ li> </ ul> </ li> </ ul>',
  'title.des.how_is_the_eth_perpetual_contract_quoted': '<p> ETH期货的基础是在Poloniex，Kraken和Demo上的ETH / BTC汇率。<a href="{DemoETHIndex}"> ETH/BTC指数</a>期货用比特币报价，所有保证金和PNL计算都用比特币计价。</ p>',
  'title.des.how_is_the_eth_perpetual_contract_quoted2': '<p>那些认为以太坊价格将上涨的交易者将会购买期货合约。相反的，认为价格会下跌的将会出售期货合约。</ p>',
  'title.eth.margin_and_leverage.future.desc': '<p>所有保证金都用比特币，这意味着交易者可以仅使用比特币来做多或做空该合约。 ETH期货合约的杠杆高达50倍。</ p> <p>例如，要购买価値50比特币的合约，您只需要1个比特币作为初始保证金即可。</ p>',
  'title.eth.marking_and_settlement.desc': '<p> ETH期货合约以<a href="{ETHBTC30MIndex}"> ETHBTC30M指数价格结算</a>。结算将在结算月的最后一个星期五进行。</ p>',
  'title.des.eth_future_contract_example': '<blockquote style="font-size: 14px; font-style: italic;"> <p>某交易商想做多10 BTC的ETH期货合约。 ETHU18（ETH期货合约于2018年9月到期）的交易价格为0.0500 BTC。由于杠杆率为50倍，交易者仅需要0.2 BTC的保证金即可进行此交易。</ p> <p>但交易者必须购买200张合约：<code> 10 BTC /（0.0500 BTC * 1）</ code>。< / p> <p>几天后，价格升至0.0550 BTC，交易者卖出了所有合约。</ p> <p>交易者的利润将是：<code> 200 * 1 *（0.0550-0.0500） = 1 BTC </ code> </ p> </ blockquote>',
  'title.eth.margin_and_leverage.perpetual.desc': '<p>所有保证金都用比特币，这意味着交易者可以仅使用比特币来做多或做空该合约。 ETHUSD永续合约的杠杆高达50倍。</ p> <p>例如，要购买価値50比特币的合约，您只需要1个比特币作为初始保证金即可。</ p>',
  'title.eth.perpetual_settlement.desc': '<p>由于ETHUSD合约是永续合约，因此没有结算期限。未实现的PNL和清算目的的标记是根据“合理价格标记”系统完成的。</ p> <p>另请注意：由于该产品是永续合约，因此每8个小时进行一次注资。请参阅《永续合约指南》中的<a href="{perpetualContractsGuide}#funding">资金費用部分</a>有关信息，请参阅永续合約指南，有关当前汇率，请参阅<a href="{ETHUSDContractSpecifications}"> ETHUSD合约规格</a>.</ p>中的资金计算。',
  'title.symbol_perpetual_contract_example': '{symbol} 永续合約示例',
  'title.des.eth_perpetual_contract_example': '<blockquote style =“ font-size：14px; font-style：italic;”> <pre style =“ padding-bottom：20px; padding-top：20px; color：＃31708f; background-color：＃d9edf7;”> <code> Demo衍生产品：ETHUSD永续掉期</br>合约：10,000 </br>比特币乘数每1 USD：0.000001 BTC </br> BTC现货价格：$ 10,000 </br> ETHUSD掉期价格：$ 500 </br> ETHBTC现货价格：0.05 BTC</br></code></pre> <h5 id="Trade-Inception" style="font-weight: 700; font-size: 15px; font-style: italic; margin: 15px 0 7px;">交易开始</ h5> <p> Jaewon和Wang相互交易ETHUSD永久掉期以换取10,000张合约。Jaewon买入，Wang卖出。每移动1美元，合约将支付0.000001 BTC；这就是所谓的比特币乘数。</ p> <p>他们同意双方可以使用50倍的杠杆，这意味着他们向Demo挂上了2％的初始保证金以开始交易。为了计算比特币保证金，他们首先计算了他们的ETHUSD Quanto Swap的比特币价值。</ p> <p> <code> BTC值= ETHUSD价格*比特币乘数*＃合约</ code> </ p> <p> <code> 5 BTC = $ 500 * 0.000001 BTC * 10,000 </ code> </ p> <p> <code>初始比特币保证金= 5 BTC * 2％= 0.1 BTC </ code> </ p> <p>他们两者都喜欢以ETH条款来思考任何给定的ETHUSD价格。在Demo仓位表上，他们能够以ETH条款查看其仓位的当前值。</ p> <p> <code> ETH值= BTC值/ ETHBTC现货价格</ code> </ p> <p > <code> 100 ETH = 5 BTC / 0.05 BTC </ code> </ p> <p>他们注意到ETH值可以在ETHUSD价格变化时或ETHBTC现货价格变化时变化。 Quanto导数中唯一固定的数字是乘数。</p> <h5 style="font-weight: 700; font-size: 15px; font-style: italic; margin: 15px 0 7px;" id="Trade-Expiry">交易到期</ h5> <p> ETHUSD掉期价格升至505美元，让我们计算Jaewon和Wang的比特币PNL。</ p> <p> <code> Bitcoin PNL =（ETHUSD退出价格– ETHUSD入场价格）*比特币乘数*＃合约</ code> </ p> <p> <code> Jaewon比特币PNL =（$ 505-$ 500）* 0.000001 BTC * +10,000 = 0.05 BTC利润</ code> </ p> <p> <code> Wang Bitcoin PNL =（$ 505-$ 500）* 0.000001 BTC * -10,000 = 0.05 BTC损失</ code> </ p> <p>请注意，唯一会影响PNL的变化是变动的ETHUSD价格。 BTC或ETHBTC汇率都不会影响任何交易者的PNL。</ p> </ blockquote>',
  'title.des.bitcoin_series_ada_guide': '<p>在Demo，ADA衍生产品采用<a href="{futuresGuide}">期货合约</a>的形式，并允许交易员推测卡尔达诺/比特币（ADA / BTC）的未来价值汇率。交易者不需要Cardano来交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'title.des.referrence.ada': '<div class="staticContent seriesGuideADA "> <div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-ADA-Futures-Quoted"> ADA期货如何报价？</a></li><li><a href="#Margin-and-Leverage">保证金和杠杆</a></li><li><a href="#Settlement">结算</a></li></ul></div><p></p> <h3 id="How-Are-ADA-Futures-Quoted"><a class="header-anchor" href="#How-Are-ADA-Futures-Quoted">如何报价ADA期货？</a> </ h3> < p> ADA期货的基础是<a href="/margin-exchange/contracts/indices-data/ADA"> ADA指数</a>中记录的ADA / BTC汇率。期货以比特币报价，所有保证金和PNL计算均以比特币计价。.</p> <div class="table_detail_contracts"><table class="table"> <thead> <tr> <th></th> <th>合约计算</ th> </ tr> </ thead> <tbody> <tr> <td>乘数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC合约价值</ td> <td>乘数*期货价格* 1 ADA </ td> </ tr> <tr> <td> USD合约价值</ td> <td> BTC合约价值* BTCUSD </ td> < / tr> <tr> <td> PnL计算</ td> <td>＃合约*乘数*（退出价格-进入价格）</ td> </ tr> </ tbody> </ table> </ div> <h3 id =“ Margin-and-Leverage”> <a class="header-anchor" href="#Margin-and-Leverage">保证金和杠杆</a> </ h3> <p>所有保证金已发布在比特币中，这意味着交易者可以仅使用比特币来做多或做空该合约。 ADA期货合约的杠杆高达20倍。</ p> <p>例如，要购买10个比特币的合约，您只需要0.5比特币的初始保证金。</ p> <h3 id =“ Settlement “> <a class="header-anchor" href="#Settlement">结算</a> </ h3> <p> ADA期货合约以 <a href="/margin-exchange/contracts/indices-data/ADA30M"> ADA30M指数价格</a>。</ p> <p> <strong>交易示例</ strong> </ p> <blockquote> <p>交易者想要买入ADA的10 BTC期货合约。 ADAJ18（每月ADA期货合约）的交易价格为0.10 BTC。由于杠杆率是20倍，交易者只需要0.5 BTC的保证金即可进行交易。</ p> <p>交易者必须购买100张合约：<strong> 10 BTC /（0.10 BTC * 1）</ strong>。< / p> <p>几天后，价格升至0.15 BTC，交易者出售了所有合约。</ p> <p>交易者的利润将是：<strong> 100 * 1 *（0.15-0.10） = 5 BTC </ strong> </ p> </ blockquote> </ div>',
  'title.des.referrence.bch': '<div class="staticContent seriesGuideBCH "> <div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-BCH-Futures-Quoted"> BCH期货如何报价？</a> </ li> <li> <a href="#Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Settlement">结算</a></li></ul></div><p></p> <h3 id="How-Are-BCH-Futures-Quoted"><a class="header-anchor" href="#How-Are-BCH-Futures-Quoted">BCH期货如何报价？</a> </ h3> < p> BCH期货的基础是<a href="/margin-exchange/contracts/indices-data/BCH"> BCH指数</a>中记录的BCH / BTC汇率。期货以比特币报价，所有保证金和PNL计算均以比特币计价。.</p> <div class="table_detail_contracts"><table class="table"> <thead> <tr> <th></th> <th>合约计算</ th> </ tr> </ thead> <tbody> <tr> <td>乘数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC合约价值</ td> <td>乘数*期货价格* 1 BCH </ td> </ tr> <tr> <td> USD合约价值</ td> <td> BTC合约价值* BTCUSD </ td> < / tr> <tr> <td> PnL计算</ td> <td>＃合约*乘数*（退出价格-进入价格）</td> </tr> </tbody> </table></div> <h3 id="Margin-and-Leverage"><a class="header-anchor" href="#Margin-and-Leverage">保证金和杠杆</a> </ h3> <p>所有保证金以比特币计算，这意味着交易者可以仅使用比特币来做多或做空该合约。 BCH期货合约的杠杆高达20倍。</ p> <p>例如，要购买10个比特币的合约，您只需要0.5比特币的初始保证金。</p> <h3 id="Settlement"><a class="header-anchor" href="#Settlement">结算</a> </ h3> <p> BCH期货合约结算在<a href =” / margin-exchange / contracts / indices -data / BCH30M“> BCH30M指数价格</a>。</ p> <p> <strong>交易示例</ strong> </ p> <blockquote> <p>交易者想要买入10 BTC的BCH期货合约。 BCHX17（每月BCH期货合约）的交易价格为0.10 BTC。由于杠杆率是20倍，交易者只需要0.5 BTC的保证金即可进行交易。</ p> <p>交易者必须购买100张合约：<strong> 10 BTC /（0.10 BTC * 1）</ strong>。< / p> <p>几天后，价格升至0.15 BTC，交易者出售了所有合约。</ p> <p>交易者的利润将是：<strong> 100 * 1 *（0.15-0.10） = 5 BTC </ strong> </ p> </ blockquote> </ div>',
  'title.des.referrence.eos': '<div class="staticContent seriesGuideEOS "><div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-EOS-Futures-Quoted">如何报价EOS期货？</a> </ li> <li> <a href="#Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Settlement">结算</a></li></ul></div><p></p> <h4 id="How-Are-EOS-Futures-Quoted"><a class="header-anchor" href="#How-Are-EOS-Futures-Quoted">如何报价EOS期货？</a> </ h4> < p> EOS期货的基础是<a href="/margin-exchange/contracts/indices-data/EOS"> EOS指数</a>中记录的EOS / BTC汇率。期货以比特币报价，所有保证金和PNL计算均以比特币计价。.</p> <div class="table_detail_contracts"><table class="table"> <thead> <tr> <th></th> <th>合约计算</ th> </ tr> </ thead> <tbody> <tr> <td>乘数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC合约价值</ td> <td>乘数*期货价格* 1 EOS </ td> </ tr> <tr> <td> USD合约价值</ td> <td> BTC合约价值* BTCUSD </ td> < / tr> <tr> <td> PnL计算</ td> <td>＃合约*乘数*（退出价格-进入价格）</ td> </ tr> </ tbody> </ table> </ div> <p> </ p> <p>认为EOS价格将上涨的交易者将购买该期货合约。相反，认为价格会下跌的交易者将出售期货合约。</p> <h4 id="Margin-and-Leverage"><a class="header-anchor" href="#Margin-and-Leverage">保证金和杠杆</a> </ h4> <p>所有保证金都使用比特币，这意味着交易者可以仅使用比特币来做多或做空该合约。 EOS期货合约的杠杆高达20倍。</ p> <p>例如，要购买10个比特币的合约，您只需要0.5比特币的初始保证金。</p> <h4 id="Settlement"><a class="header-anchor" href="#Settlement">>结算</a> </ h4> <p> EOS期货合约以<a href =” / margin-exchange / contracts / indices解决-data / EOS30M“> EOS30M指数价格</a>。结算将在结算月的最后一个星期五进行。</ p> <p> <strong>交易示例</ strong> </ p> <blockquote> <p>一个交易商想要做多10 BTC的EOS期货合约，其交易价格为0.0200 BTC。由于杠杆率为20倍，交易者仅需要0.5 BTC的保证金即可进行交易。</ p> <p>交易者必须购买500张合约：<strong> 10 BTC /（0.0200 BTC * 1）</ strong>。< / p> <p>几天后，价格升至0.0250 BTC，交易者出售了所有合约。</ p> <p>交易者的获利为：<strong> 500 * 1 *（0.0250-0.0200） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
  'title.des.referrence.ltc': '<div class="staticContent seriesGuideLTC "><div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-LTC-Futures-Quoted">如何报价LTC期货？</a> </ li> <li> <a href="#Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Settlement">结算</a></li></ul></div><p></p> <h4 id="How-Are-LTC-Futures-Quoted"><a class="header-anchor" href="#How-Are-LTC-Futures-Quoted">如何报价LTC期货？</a> </ h4> < p> LTC期货的基础是<a href="/margin-exchange/contracts/indices-data/LTC"> LTC指数</a>中记录的LTC / BTC汇率。期货以比特币报价，所有保证金和PNL计算均以比特币计价。</p> <div class="table_detail_contracts"><table class="table"> <thead> <tr> <th></th> <th>合约计算</ th> </ tr> </ thead> <tbody> <tr> <td>乘数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC合约价值</ td> <td>乘数*期货价格* 1 LTC </ td> </ tr> <tr> <td> USD合约价值</ td> <td> BTC合约价值* BTCUSD </ td> < / tr> <tr> <td> PnL计算</ td> <td>＃合约*乘数*（退出价格-进入价格）</ td> </ tr> </ tbody> </ table> </ div> <p> </ p> <p>那些认为LTC价格将上涨的交易者将购买期货合约。相反，认为价格会下跌的交易者将出售期货合约。</p> <h4 id="Margin-and-Leverage"><a class="header-anchor" href="#Margin-and-Leverage">保证金和杠杆</a> </ h4> <p>所有保证金都使用比特币，这意味着交易者可以仅使用比特币来做多或做空该合约。 LTC期货合约的杠杆高达33倍。</ p> <p>例如，要购买10个比特币的合约，您只需要0.3比特币的初始保证金。</p> <h4 id="Settlement"><a class="header-anchor" href="#Settlement">结算</a> </ h4> <p> LTC期货合约结算在 <a href="/margin-exchange/contracts/indices-data/LTC30M"> LTC30M指数价格</a>。结算将在结算月的最后一个星期五进行。</ p> <p> <strong>交易示例</ strong> </ p> <blockquote> <p>一个交易商想要多头10 BTC的LTC期货合约。 LTCM17（LTC期货合约于2017年6月到期）的交易价格为0.0200 BTC。由于杠杆率为33倍，交易者仅需要0.3 BTC的保证金即可进行该交易。</ p> <p>交易者必须购买500张合约：<strong> 10 BTC /（0.0200 BTC * 1）</ strong>。< / p> <p>几天后，价格升至0.0250 BTC，交易者出售了所有合约。</ p> <p>交易者的获利为：<strong> 500 * 1 *（0.0250-0.0200） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
  'title.des.referrence.trx': '<div class="staticContent seriesGuideTRX "><div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-TRON-Futures-Quoted">如何报价TRON期货？</a> </ li> <li> <a href="#Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Settlement">结算</a> </ li> </ ul> </ div> <p> </ p> <h4 id =“ <a class="header-anchor" href="#How-Are-TRON-Futures-Quoted">如何报价TRON期货？</a> </ h4> < p> TRON期货的基础是<a href="/margin-exchange/contracts/indices-data/TRX"> TRX指数</a>中记录的TRX / BTC汇率。期货以比特币报价，所有保证金和PNL计算均以比特币计价。</p> <div class="table_detail_contracts"><table class="table"> <thead> <tr> <th></th> <th>合约计算</ th> </ tr> </ thead> <tbody> <tr> <td>乘数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC合约价值</ td> <td>乘数*期货价格* 1 TRX </ td> </ tr> <tr> <td> USD合约价值</ td> <td> BTC合约价值* BTCUSD </ td> < / tr> <tr> <td> PnL计算</ td> <td>＃合约*乘数*（退出价格-进入价格）</ td> </ tr> </ tbody> </ div> </ table> <p> </ p> <p>认为TRON价格将上涨的交易者将购买期货合约。相反，认为价格会下跌的交易者将出售期货合约。</p> <h4 id="Margin-and-Leverage"><a class="header-anchor" href="#Margin-and-Leverage">保证金和杠杆</a> </ h4> <p>所有保证金都使用比特币，这意味着交易者可以仅使用比特币来做多或做空该合约。 TRON期货合约的杠杆高达20倍。</ p> <p>例如，要购买10个比特币的合约，您只需要0.5比特币的初始保证金。</p> <h4 id="Settlement"><a class="header-anchor" href="#Settlement">结算</a> </ h4> <p> TRON期货合约结算在<a href =” / margin-exchange / contracts / indices -data / TRX30M“> TRX30M指数价格</a>。结算将在结算月的最后一个星期五进行。</ p> <p> <strong>交易示例</ strong> </ p> <blockquote> <p>一个交易商想要做多10 BTC的TRON期货合约，其交易价格为0.0200 BTC。由于杠杆率为20倍，交易者仅需要0.5 BTC的保证金即可进行交易。</ p> <p>交易者必须购买500张合约：<strong> 10 BTC /（0.0200 BTC * 1）</ strong>。< / p> <p>几天后，价格升至0.0250 BTC，交易者出售了所有合约。</ p> <p>交易者的获利为：<strong> 500 * 1 *（0.0250-0.0200） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
  'title.des.referrence.xrp': '<div class="staticContent seriesGuideTRX "><div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-TRON-Futures-Quoted">如何报价XRP期货？</a> </ li> <li> <a href="#Margin-and-Leverage">保证金和杠杆</a> </ li> <li> <a href="#Settlement">结算</a></li></ul></div><p></p> <h4 id="How-Are-XRP-Futures-Quoted"><a class="header-anchor" href="#How-Are-XRP-Futures-Quoted"> XRP期货如何报价？</a> </ h4> < p> XRP期货的基础是<a href="/margin-exchange/contracts/indices-data/XRP"> XRP指数</a>中记录的XRP / BTC汇率。期货以比特币报价，所有保证金和PNL计算均以比特币计价。</ p> <div class =“ table_detail_contracts”> <table class =“ table”> <thead> <tr> <th> </ th> <th>合约计算</ th> </ tr> </ thead> <tbody> <tr> <td>乘数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC合约价值</ td> <td>乘数*期货价格* 1 XRP </ td> </ tr> <tr> <td> USD合约价值</ td> <td> BTC合约价值* BTCUSD </ td> < / tr> <tr> <td> PnL计算</ td> <td>＃合约*乘数*（退出价格-进入价格）</ td> </ tr> </ tbody> </ table> </ div> <p> </ p> <p>认为XRP价格将上涨的交易者将购买期货合约。相反，认为价格会下跌的交易者将出售期货合约。</p> <h4 id="Margin-and-Leverage"><a class="header-anchor" href="#Margin-and-Leverage">保证金和杠杆</a> </ h4> <p>所有保证金都发布在比特币中，这意味着交易者可以仅使用比特币来做多或做空该合约。 XRP期货合约的杠杆高达20倍。</ p> <p>例如，要购买10个比特币的合约，您只需要0.5比特币的初始保证金。</p> <h4 id="Settlement"><a class="header-anchor" href="#Settlement">结算</a></h4> <p>The XRP futures contracts settle on the <a href="/margin-exchange/contracts/indices-data/XRP30M"> XRP30M指数价格</a>。结算将在结算月的最后一个星期五进行。</ p> <p> <strong>交易示例</ strong> </ p> <blockquote> <p>交易者想要多头10 BTC的XRP期货合约。 XRPM17（XRP期货合约于2017年6月到期）的交易价格为0.00002 BTC。由于杠杆率是20倍，交易者仅需要0.5 BTC的保证金即可进行交易。</ p> <p>交易者必须购买500,000张合约：<strong> 10 BTC /（0.00002 BTC * 1）</ strong>。< / p> <p>几天后，价格升至0.000025 BTC，交易者卖出了所有合约。</ p> <p>交易者的利润将是：<strong> 500,000 * 1 *（0.000025-0.00002） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
  'title.des.bitcoin_series_bch_guide': '<p>在Demo，BCH衍生产品采用<a href="{futuresGuide}">期货合约</a>的形式，并允许交易员推测比特币现金/比特币（BCH / BTC）的未来价值。 ) 汇率。交易者不需要比特币现金来交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'title.des.bitcoin_series_eos_guide': '<p> <a href="https://eos.io/"> EOS.IO </a>软件引入了一种新的区块链架构，旨在实现分散式应用程序的垂直和水平扩展。这是通过创建可在其上构建应用程序的类似于操作系统的构造来实现的。该软件在数百个CPU内核或群集中提供帐户，身份验证，数据库，异步通信和应用程序调度。由此产生的技术是一种区块链体系结构，每秒可扩展至数百万个事务，消除了用户费用，并允许快速，轻松地部署去中心化应用程序。</ p> <p>在Demo上，EOS衍生商品形式为<a href="{futuresGuide}">期货合约</a>，并允许交易者推测EOS代币/比特币（EOS / BTC）汇率的未来价值。交易者不需要EOS代币来交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'title.des.bitcoin_series_ltc_guide': '<p> Litecoin是比特币的替代数字货币，但能够处理更高的交易量，并以货币代码LTC命名。由于更频繁的区块生成，网络能支援更多事务，而无需将来修改软件。因此，交易者可获得更快的确认时间，同时在销售较大的合約项目时有能力等待更多确认。有关Litecoin项目和LTC的更多信息，可以在<a href="https://litecoin.org/">此处</a>找到。</ p> <p>在Demo，LTC衍生商品形式为<a href="{futuresGuide}">期货合约</a>，并允许交易者推测Litecoin /比特币（LTC / BTC）汇率的未来价值。交易者不需要莱特币来交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'title.des.bitcoin_series_trx_guide': '<p>在Demo，TRON衍生商品采用<a href="{futuresGuide}">期货合约</a>的形式，并允许交易员推测TRON /比特币（TRX / BTC）的未来价值汇率。交易者不需要TRON交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'title.des.bitcoin_series_xrp_guide': '<p> Ripple是一家由风险投资支持的初创公司，提供全球金融结算解决方案，使世界能够交换价值。 Ripple与比特币的不同之处在于，Ripple是一个去中心化交易网络，其中还包含货币Ripple，以货币代码XRP表示。与使用比特币区块链的工作量证明相比，它使用迭代共识流程来简化网络流程。这使得Ripple可以比比特币更快地完成交易，此外Ripple网络可以跟踪任何类型的信息，而不仅仅是Ripple货币。有关Ripple网络和货币XRP的更多信息，可以在<a href="https://ripple.com/">此处</a>找到。</ p> <p>在Demo，XRP衍生商品为<a href="{futuresGuide}">期货合约</a>的形式，并允许交易者推测瑞波币/比特币（XRP / BTC）汇率的未来价值。交易者不需要瑞波币来交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'title.indice_description.ada.paragraphs': '<p class="pre">Demo ADA指数每分钟跟踪一次Cardano价格。Cardano价格是根据Demo指数的最后价格计算的。 ADA指数价格在很多页面上显示为当前Cardano价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.ada30m.paragraphs': '<p class="pre">Demo ADA30M指数是是30-分钟在Demo指数的时间加权的Cardano价格，并在 12:00 UTC 完结 <a href="/margin-exchange/contracts/indices-data/ADA"> ADA索引</a>。这些值用于结算。 TWAP是使用Demo ADA指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.bch.paragraphs': '<p class="pre">Demo BCH指数跟踪比特币的现金价格每一分钟。比特币现金价格是根据Demo指数的最后格计算得出的。 BCH指数价格在许多页面上显示为当前比特币现金价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.bch30m.paragraphs': '<p class="pre">Demo EOS30M指数是30-分钟在Demo指数的时间加权的比特币现金价，并在 12:00 UTC 完结<a href="/margin-exchange/contracts/indices-data/BCH"> BCH 索引</a>。这些值用于结算。 TWAP是使用Demo BCH 指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.eos.paragraphs': '<p class="pre">Demo EOS指数每分钟跟踪一次EOS代币价格。 EOS代币价格是根据Demo指数的最后价格计算得出的。 EOS指数价格在许多页面上显示为当前EOS代币价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.eos30m.paragraphs': '<p class="pre">Demo EOS30M指数是30-分钟在Demo指数的时间加权的EOS代币价格，并在 12:00 UTC 完结<a href="/margin-exchange/contracts/indices-data/EOS"> EOS索引</a>。这些值用于结算。 TWAP是使用Demo EOS指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.ltc.paragraphs': '<p class="pre">Demo LTC指数每分钟跟踪一次莱特币价格。 莱特币的价格是根据Demo指数的最后价格计算得出的。 LTC指数价格在许多页面上显示为当前莱特币价格。</ p> <p</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.ltc30m.paragraphs': '<p class="pre">Demo LTC30M指数是30-分钟在Demo指数的时间加权的Litecoin价格，并在 12:00 UTC 完结 <a href="/margin-exchange/contracts/indices-data/LTC"> LTC索引</a>。这些值用于结算。 TWAP是使用Demo LTC指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.trx.paragraphs': '<p class="pre">Demo TRX指数每分钟跟踪一次Tron价格。 Tron价格是根据Demo指数的最后价格计算得出的。 TRX指数价格在许多页面上显示为当前Tron价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.trx30m.paragraphs': '<p class="pre"> Demo TRX30M指数是30-分钟在Demo指数 时间加权的Tron价格，并在 12:00 UTC 完结<a href="/margin-exchange/contracts/indices-data/TRX"> TRX索引</a>。这些值用于结算。所述TWAP使用从Demo TRX索引值来计算。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.xrp.paragraphs': '<p class="pre">  Demo XRP指数每分钟跟踪一次瑞波价格。瑞波价格是根据Demo指数的最后价格计算得出的。 XRP指数价格在许多页面上显示为当前的瑞波价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.xrp30m.paragraphs': '<p class="pre">Demo XRP30M指数是从<a href="/margin-exchange/contracts/indices-data/XRP">XRP Index</a> XRP索引</a>。这些值用于结算。 TWAP是使用Demo XRP指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.btc.paragraphs': '<p class="pre">BTC指数每分钟跟踪一次比特币价格。比特币价格是根据指数的最后价格计算得出的。 BTC指数价格在许多页面上显示为当前比特币价格。</ p> <p> BTC定价当前来自相等部分的Bitstamp，Coinbase Pro，OKCoin，GEMINI和Kraken。由于空前的汇率不稳定，这种成分可能会发生变化。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.btc30.paragraphs': '<p> Demo BTC30指数每分钟跟踪一次比特币价格。比特币价格是根据Demo指数的最后价格计算得出的。 BTC指数价格在许多页面上显示为当前比特币价格。</ p> <p> BTC定价当前来自相等部分的Bitstamp，Coinbase Pro，OKCoin，GEMINI和Kraken。由于空前的汇率不稳定，该成分可能会发生变化。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.btc30m.paragraphs': '<p class="pre"> BTC30M指数是30-分钟时间加权的比特币价格，并在 12:00 UTC 完结<a href="/margin-exchange/contracts/indices-data/BTC"> BTC指数</a>。这些值用于结算。 TWAP是使用BTC指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.btcbon.paragraphs': 'BTCBON指数每分钟跟踪一次指数的比特币借贷利率。它是从深度加权的资金提供费率换算的。<br> <br>该指数不再从Bitfinex获取，而是由于极端的利率波动性而被设置为恒定的比率。',
  'title.indice_description.btcbon2h.paragraphs': 'Demo BTCBON2H指数是 2-小时 时间加权的BTCBON溢价率，參考交易所Demo<a href="{BTCBONIndex}"> BTCBON指数</a>这些数据用于计算资金费率，并会在 2小时 前提供。',
  'title.indice_description.btcbon8h.paragraphs': 'Demo BTCBON8H指数是 8-小时 时间加权的BTCBON溢价率，參考交易所Demo<a href="/margin-exchange/contracts/indices-data/BTCBON"> BTCBON指数</a>这些数据用于计算资金费率，并会在 8 小时前提供。',
  'title.indice_description.ethbon.paragraphs': 'Demo ETHBON指数每分钟在Demo指数上跟踪以太坊借贷费率。它是从深度加权的资金提供费率换算的。',
  'title.indice_description.ethbon2h.paragraphs': 'Demo ETHBON2H指数是 2-小时 时间加权的ETHBON溢价率，參考交易所Demo<a href="/margin-exchange/contracts/indices-data/ETHBON"> ETHBON指数</a>这些数据用于计算资金费率，并会在2小时前提供',
  'title.indice_description.ethbon8h.paragraphs': 'Demo ETHBON8H指数是 8-小时 时间加权的 ETHBON溢价率，參考交易所Demo<a href="/margin-exchange/contracts/indices-data/ETHBON"> ETHBON指数</a>这些数据用于计算资金费率，并会在 8 小时 前提供。',
  'title.indice_description.usdbon.paragraphs': 'Demo USDBON指数每分钟在Demo指数上跟踪美元借贷费率。它是从深度加权的资金提供费率换算的。',
  'title.indice_description.usdbon2h.paragraphs': 'Demo USDBON2H指数是 2-小时 时间加权的 .USDBON溢价率，參考交易所Demo<a href="/margin-exchange/contracts/indices-data/USDBON"> USDBON指数</a>。这些数据用于计算资金费率，并会在2小时前提供',
  'title.indice_description.usdbon8h.paragraphs': 'Demo USDBON8H指数是 8-小时 时间加权的 USDBON溢价率，參考交易所Demo<a href="/margin-exchange/contracts/indices-data/USDBON"> USDBON指数</a>这些数据用于计算资金费率，并会在 8 小时 前提供。',
  'title.indice_description.btcusdpi.paragraphs': 'Demo BTCUSDPI指数每分钟在Demo跟踪BTCUSD的溢价率。',
  'title.indice_description.btcusdpi2h.paragraphs': 'Demo BTCUSDPI2H指数是 2-小时 时间加权的 BTCUSDPI 溢价率 。参考交易所Demo<a href="/margin-exchange/contracts/indices-data/BTCUSDPI"> BTCUSDPI指数</a>。这些数据用于计算资金费率，并会在 2 小时 前提供。',
  'title.indice_description.btcusdpi8h.paragraphs': 'Demo BTCUSDPI8H指数是 8-小时 时间加权的BTCUSDPI 溢价率。參考交易所Demo<a href="/margin-exchange/contracts/indices-data/BTCUSDPI"> BTCUSDPI指数</a>。这些数据用于计算资金费率，并会在 8 小时 前提供。',
  'title.indice_description.ethbtcpi.paragraphs': 'Demo ETHBTCPI指数每分钟在Demo跟踪ETHBTC溢价率。',
  'title.indice_description.ethbtcpi2h.paragraphs': 'Demo ETHBTCPI2H指数是ETHBTC指数中Demo的ETHBTC溢价率的 2-小时时间加权。这些数据用于计算资金费率，并会在 2 小时 前提供。',
  'title.indice_description.ethbtcpi8h.paragraphs': 'Demo ETHBTCPI8H指数是ETHBTC指数中Demo的ETHBTC溢价率的8小时时间加权。这些数据用于计算资金费率，并会在 8 小时 前提供。',
  'title.indice_description.ethusdpi.paragraphs': 'Demo ETHUSDPI指数每分钟在Demo追踪ETHUSD溢价率。',
  'title.indice_description.ethusdpi2h.paragraphs': 'Demo ETHUSDPI2H指数是ETHUSD指数中Demo的ETHUSD溢价率的2小时时间加权。这些数据用于计算资金费率，并会在 2 小时 前提供。',
  'title.indice_description.ethusdpi8h.paragraphs': 'Demo ETHUSDPI8H指数是ETHUSD指数中Demo的ETHUSB溢价率的8小时时间加权。这些数据用于计算资金费率，并会在 8 小时 前提供。',
  'title.indice_description.eth.paragraphs': '<p class="pre"> Demo ETH指数每分钟跟踪以太坊价格。以太坊价格是根据Demo指数的最後后价格计算得出的。 ETH指数价格在许多页面上显示为当前的以太坊价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.eth_btc.paragraphs': '<p class="pre">  Demo ETHBTC指数每分钟跟踪以太坊价格。以太坊价格是根据Demo指数的最后价格计算得出的。 ETHBTC指数价格在许多页面上显示为当前以太坊价格。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.indice_description.eth30m.paragraphs': '<p class="pre">Demo ETH30M指数是以Demo指数在12:00 UTC结束时以太坊价格的30分钟TWAP <a href="/margin-exchange/contracts/indices-data/ETH">ETH指数</a>。这些值用于结算。 TWAP是使用Demo ETH指数中的值计算的。</ p> <p>该指数是综合指数，意味着价格取自多个交易所。有关成分交易所的信息，请参见阅下面的“综合指数分解”。如果某交易所停止服务，并且超过15分钟未发布任何交易，Demo会自动从指数中移除该交易所，直至其交易恢复。</ p>',
  'title.symbol_index_detail': '{symbol} 指数详细信息',
  'title.margin_instruments_using_index': '使用该指数的商品',
  'title.margin_indices_using_index': '使用该指数的指数',
  'title.symbol_index_historical_values': '{symbol}指数历史值',
  'title.margin_index_breakdown': '指数值',
  'title.margin_composite_index_breakdown': '综合指数细目',
  'margin.contract.label.price_index_symbol': '价格 {symbol}',
  'margin.contract.label.premium_index_symbol': '{symbol} 溢价',
  'title.des.funding_history_table': '这个名单包含了过去所有符号的资金費率。',
  'title.des.settlement_history_table': '这个名单包含了过去的结算。',
  'table.funding_interval': '资金費率间隔',
  'table.funding_rate': '资金費率',
  'table.funding_rate_daily': '每日资金費率',
  'des.des_margin_leaderboard': '・以下是Demo中拥有最高收益率的交易商们。<br/>·此列表是匿名基准，名字分别表示同一用户，但身份无法确定。',
  'des.des_mam_leaderboard': '・以下是Demo中拥有最高收益率的交易商们。<br/>·此列表是匿名基准，名字分别表示同一用户，但身份无法确定。',
  'title.Leaderboard': 'Leaderboard',
  'title.Leaderboard.des_title': '錯誤情况下，我们在排行榜中显示您的帐户，但名称是无法识别的。此处的更改最多可能需要半小时才能生效。',
  'leaderboard.show_real_username': '您要显示假用户名吗？',
  'leaderboard.show_fake_username': '您要显示真实的用户名吗？',
  'leaderboard.off_to_show_fake_username': '单击关闭以在排行榜中显示您的真实用户名。',
  'leaderboard.your_fake_name_is': '您的假名是：',
  'leaderboard.on_to_show_real_username': '在排行榜显示您的假用户名。',
  "leaderboard.top_25_teams_by_roe_entry": "ROE中的前25名交易者（登录制）",
  'margin.total_roe': '合计ROE',
  'margin.average_roe': 'Average ROE',
  'table.rofit': '利益',
  'table.rank': '级别',
  'table.is_real_name': '是实名',
  'title.overview': '概要',
  'title.des.overview': '<p> <strong>期货合约</ strong>是衍生产品，并且是在将来的指定时间以预定价格买卖商品、货币或其他合約的协议。它们可以通过实物结算或现金结算。 Demo以带有现金结算的期货合约的形式提供其几种交易产品。</ p> <p>期货合约不需要交易者以100％的抵押品作为保证金，因此，在Demo您可以最高杠杆率进行交易一些合約到100倍。 Demo的所有保证金都以比特币计价，允许交易者仅使用比特币来推测其产品的未来价值。</ p> <p> Demo提供的另一种衍生产品是<a href="{perpetualContractsGuide}">永续合約</a>。要查看于特定商品的期货合约信息，请单击顶部的<strong>合约</ strong>顶部标签。</ p>',
  'title.mechanics_of_futures_markets': '期货市场的结构',
  'title.header_form.perpetual contracts_guide': '永续合約指南',
  'title.des.overview.perpetual_contracts_guide': '<p> <strong>永续合約</ strong>是一种衍生产品，类似于传统的<a href="{futuresGuide}">期货合約</a>但具有一些不同的规格:</p> <ul style="list-style-type: disc; padding-left: 25px;"> <li>没有到期或结算。</ li> <li>永续掉期合约类似于一个保证金现货市场，因此它的交易价格接近于标的参考指数价格。<li>这与<a href="{futuresGuide}">期貨合約</a>不同，由于基差的原因，期货合约的交易价差可能存在显著的不同。</ li> <li>锚定现货价格的主要机制是是<a href="#funding">資金費用</a>。</ li></ li> </ ul>',
  'title.des.mechanics_of_perpetual_contracts_markets': '<p>交易永续合约时，交易者需要了解市场的几种机制。交易者需要注意的关键部分是：</ p> <ol style =“ padding-left：25px;”> <li> <strong>位置标记</ strong>：永续掉期合约使用 合理价格标记 方法。 标记价格决定了 未实现盈亏 以及 强平价格。</ li> <li> <strong>起始保证金和维持保证金</ strong>：这些关键的保证金水平决定了可以使用多大的杠杆，以及在什么价格会触发强制平仓。</ li> li> <li> <strong>资金費用</ strong>：买方和卖方之间每隔 8 小时定期支付费用。 如果费率为正，多仓将支付 而 空仓将获得 资金费率，如果费率为负，则相反。<li> <strong>仅当您在“资助时间戳记”持有仓位，您才会支付或获得资助。</ strong> </ li> </ li> <li> <strong>资金时间戳记</ strong>：04:00 UTC，12：00 UTC和20:00 UTC。</ li> </ ol> <p>交易者可以观察当前的资金利率在“合同详细信息”左下“交易”标签左下角的合同。同样，可以在单独的“合同规范”中查看此汇率。历史汇率在<a href="{fundingHistory}">资金历史记录</a>中。</ p>',
  'title.mechanics_of_perpetual_markets': '永续合约市场的机制',
  'title.des.more_information.futures_guide': '<p>有关更多信息，请访问:</p> <ul style="list-style-type: disc; padding-left: 25px;"> <li>期货</ li> <li>月份代码</ li > <li>基础</ li> <li>示例</ li> </ ul>',
  'title.des.mechanics_of_futures_markets': '<p>交易期货合约时，交易者需要了解期货市场的几种机制。交易者需要注意的关键部分是：</ p> <ol style =“ padding-left：25px;”> <li> <strong>乘数</ strong>：一张合约价值多少？您可以在每种商品的“合約规格”下看到此信息。</ li> <li> <strong>位置标记</ strong>：期货合约是根据合理价格标记方法标记的。 合理价格标记方法。 标记价格决定了 未实现盈亏 以及 强平价格。</ li> <li> <strong>初始保证金和维持保证金</ strong>：这些关键保证金水平决定着人们可以交易多少杠杆以及何时进行清算。</ li > <li> <strong>结算</ strong>：期货合约如何以及何时到期或结算，对于交易者来说很重要。为了避免价格操纵，Demo在结算之前的一段时间内采用平均法。此时间范围可能因工具而异，交易者应阅读单个合约规格以了解何时到期以及单个结算程序。</ li> <li> <strong>基础</ strong>：该基础指的是期货交易的溢价或折价与基础现货价格相比，通常以年百分比形式报价。基础存在是因为期货合约将在未来到期，并且到期的不确定性附带有正或负时间值元素。</ li> </ ol>',
  'title.funding': '筹措资金',
  'title.des.funding': '<p>资金費用每8小时在UTC 04：00、12：00 UTC和20:00 UTC产生一次。 <strong>只有在以上几个时间点持有仓位，您才需要收取或支付资金费用。</ strong>如果您在收费时间之前平仓，那么您就不需要收取或支付资金费用。</ p> <p >您支付或收到的资金的计算方式如下：</p> <pre style="background-color: #d9edf7;"><code style="color: #31708f; background-color: #d9edf7;">资金費用=仓位价值*资金費率</ code> </ pre> <p>您的仓位价值与杠杆无关。例如，如果您持有100BTCUSD合约，则将按照这些合约的名义价值收取/收取资金，而不是基于您为该仓位分配了多少保证金。</ p> <p>当<code>资金費率</ code>为正，多头支付空头。如果为负，则空头支付多头。查看示例。</ p>',
  'title.funding_rate_calculations': '资金費率的计算',
  'title.des.funding_rate_calculations': '<p>资金費率由两个主要部分组成：<strong>利率</ strong>和<strong>溢价/折扣</ strong>。此费率旨在确保永续掉期合约的交易价格紧跟标的参考价格。 通过这种方式，掉期合约类似于保证金交易的现货市场，买家和卖家定期交换资金费率。</ p>',
  'title.interest_rate_component': '利率构成要素',
  'title.des.interest_rate_component': '<p>在Demo上交易的每份合约均包含两种：基础货币和报价货币。例如，在BTCUSD上，基础货币为BTC，而报价货币为USD。利率是这两种货币之间的利率的函数:</p> <pre style="padding-bottom: 0px; padding-top: 20px; color: #31708f; background-color: #d9edf7;"><code>利率（I）=（利率报价指数-利率基础指数）/资金间隔</br>其中<ol style =“ padding-left：25px; margin-bottom：0; line-height：10px; list- style：none;“> <li>基础利率指数 = 基础货币的借贷利率</ li> <li>计价利率指数 = 计价货币的借贷利率</ li> <li资金费率间隔 = 3 (因为资金每 8 小时产生)</ li> </ ol> </ code> </ pre> <p> <em>注意：在每个合约的明细页面里都注明了每个利率指数对应的借贷市场。',
  'title.premium_discount_component': '溢价/折扣元素',
  'title.des.premium_discount_component': '<p>永续合約的交易价格可能会比标记价格高或低出很多。在这种情况下，将使用溢价指数将下一个融资利率提高或降低至与合约交易地点一致的水平。每张合约的溢价指数可在特定商品的“合约规格”页面上获得，其计算方式如下：</ p> <p> <code>溢价指数（P）=（Max（0，深度加权买价-标记价格）-Max（ 0，标记价格-深度加权卖价） ）/现货价格+标记价格的合理基差</ code> </ p> <p>要了解有关深度加权买价和深度加权卖价的更多信息，请阅读合理价格标记。 </ p>',
  'title.final_funding_rate_calculation': '最终资金費率的计算',
  'title.des.final_funding_rate_calculation': '<p> Demo每分钟计算一次<strong>溢价指数<code>（P）</ code> </ strong>和<strong>利率<code>（I）</ code> </ strong>，然后每分钟发布8小时时间加权平均价格（TWAP）。</ p> <p>接下来，资金费率根据每 8 小时的利率和溢价／折价部分计算而得。添加+/- 0.05％的缓冲。</ p> <p> <code>资金费率（F）=溢价指数（P）+clamp（利率（I）-溢价指数（P），0.05％，- 0.05％）</ code> </ p> <p>因此，如果（I-P）在+/- 0.05％之内，则F = P +（I-P）=I。换句话说，资金費率将等于利率。</ p> <p>该计算出来的资金费率将会用于计算交易员的仓位价值，然后在相应时间戳算出需要支付或收取的资金费用</ p>',
  'title.funding_rate_caps': '资金費率的上限',
  'title.des.funding_rate_caps': '<p> Demo对资金費率设定上限，以确保可利用最大杠杆。为此设置了两个上限:</p> <ol style="padding-left: 25px;"> <li>绝对资金筹措率的上限为<em>初始保证金-维持保证金</ strong> em>的75%。如果初始保证金为1％，维护保证金为0.5％，则最高资助率将为75％*（1％-0.5％）= 0.375％。</ li> <li>在两次投资间隔之间资金筹措率不可能超过维持保证金的75％。</ li> </ ol>',
  'title.funding_fees': '资金費率費',
  'title.des.funding_fees': '<p> Demo不收取任何融资费用；它是直接对等交易的。</ p>',
  'title.more_information': '更多信息',
  'title.des.more_information': '<p>更多信息和资金費率计算示例。</ p>',
  'title.bitcoin_series_xbt_guide': '比特币系列（XBT）指南',
  'title.des.bitcoin_series_btc_guide': '<p>您可以在Demo上交易比特币（BTC）通过称为<a href="{perpetualContractsGuide}">永续合約</a>的新型创新合約，该合約旨在复制基础现货市场，但具有强化杠杆特性。该产品没有有效期，可以通过各种机制密切追踪基础参考<a href="#price_index">价格指数</a>，其主要为<a href="{perpetualContractsGuide}#funding">资金筹措率</a>。</ p> <p>要查看当前费率和计算以确定当前资金，请参见 <a href="{BTCUSDContractSpecifications}">中的资金计算。 BTCUSD合约规格</a>，更详细可参见<a href="{perpetualContractsGuide}">永续合约指南</a>。</ p> <p>该产品适合喜欢长期持有头寸的交易者并且不希望他们的头寸因基础大幅度波动而波动。</ p>',
  'title.how_is_the_XBTUSD_perpetual_contract_quoted': 'BTCUSD无限期合约是怎么拍卖的？',
  'title.des.how_is_the_XBTUSD_perpetual_contract_quoted': '',
  'title.des.how_is_the_XBTUSD_perpetual_contract_quoted2': '',
  'title.price_index': '价格指数',
  'title.des.price_index': '',
  'title.margin_and_leverage': '保证金和杠杆',
  'title.des.margin_and_leverage': '',
  'title.marking_and_settlement': '标记和结算',
  'title.des.marking_and_settlement': '',
  'menu.mam_follower': '投资',
  'menu.mam_master': '投资人',
  'menu.mam_exchange': '交易所',
  'menu.mam_comissions': '手续费',
  'comomon.current_interval': '当前间隔',
  'comomon.withdraw_history': '提现记录',
  'menu.comissions': '手续费',
  'comomon.high_watermark': '高水位线',
  'common.perfomance_fee': '成功报酬',
  'common.management_fee': '管理费',
  'common.flat_fee': '统一的费用',
  'common.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.ethusd.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.ethbtc.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.ethu19.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.btcusd.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.btcu19.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.btcz19.rate_funding': 'I =利率，B =利息基数，Q =利息报价，T =每天出资金额<br/> P =溢价率，F =资金費率',
  'common.des.rate_funding': '<span style =“ background-color：#ececec; color：＃333333; display：inline-block; padding：0px 3px”>资金費率 </ span>是用户之间交换的汇率。<br/> <span style =“ background-color：#ececec; color：＃333333; display：inline-block; padding：0px 3px”>溢价率</ span>用于计算溢价，最多可根据利率调整0.05％。',
  'common.curious_formula': 'I = (Q - B) / T<br/>F = P + Clamp(I - P, -0.05%, 0.05%)',
  'common.curious_result': 'I = (0.06% - 0.03%) / 3<br/>F = 1.4240% + Clamp(0.0100% - 1.4240%, -0.05%, 0.05%)',
  'common.view_contract_series_guide': '查看{root_symbol}系列指南',
  'common.ticker_root': '代号',
  'common.expiry': '到期',
  'common.futures': '期货',
  'common.perpetual': '永续的',
  'account.modal.lost_otp.guide.common': '要取消谷歌认证，必须输入恢复代码。',
  'server.logs': '30秒内请求过多。',
  'landing.swiper.amal.title': '4IRE持有排榜大赛！',
  'landing.swiper.amal.time': '2019年12月30日21:00（GMT+9）〜2020年1月31日21：00（GMT+9）',
  "roe_person_info": '{num}人 | {num}人以上 | {num} BTC',
  "roe_num_ranking_one": "第一名 | 第1名 | 1 位",
  "roe_num_ranking_two": "第二名 | 第2名 | 2 位",
  "roe_num_ranking_three": "第三名 | 第3名 | 3 位",
  "roe_num_ranking_four": "第四〜十名 | 第4〜10名 | 4〜10 位",
  "roe_num_ranking_rate":"各 {btc}",
  "roe_activity_tit": "OG Exchange永续合约交易ROE竞赛",
  "roe_activity_subtit": "OG Exchange将举办通过杠杆交易即可入场的ROE竞赛！<br />在此期间ROE（净资产收益率）竞争上位的使用者，并会在排行榜上实时显示。",
  "roe_activity_competition_content": "ROE竞赛大纲：",
  "roe_activity_competition_content_desc": "使用公开合约进行交易，在竞赛结束后具有较高ROE的用户将获得奖励。用户可以自行入场参加竞赛。奖金根据入场的用户总数而有所不同。",
  "roe_activity_compute2": "保证金=买入价 ÷ 杠杆倍数",
  "roe_act_time_range": "{fromTime} 至 {toTime} / UT（UTC）{allDay} 周",
  "roe_activity_quil": "参加资格：",
  "roe_activity_quil_money": "{money}BTC以上的保证金",
  "roe_acti_table": "竞赛入场人数和总奖金",
  "roe_acti_table_person": "参加人数",
  "roe_acti_table_money": "总奖金",
  "roe_acti_rule": "赏金分配规则：",
  "roe_acti_rule_ranking": "排名",
  "roe_acti_rule_rate": "收益率",
  "roe_acti_rule_reward": "奖励",
  "roe_act_money_time": "奖金分发时间： <br />竞赛结束后，将确认参赛人数及公正行为的确认，并在{day}天内将确定排名的优胜者。在{day_m}日内分配给胜者。",
  "roe_act_money_time_table": "例：当参加人数为{person}人，且总奖金为{btcNum} BTC时",
  "roe_act_warn": "风险警告：由于加密货币交易涉及价格快速波动等高风险，因此请在风险承受能力范围内做出合理的决定并谨慎投资。",
  "roe_act_desc_tit": "竞赛补充事项：",
  "roe_act_desc_list":["如果在参赛期间未满20人，则中止比赛（个人赛），但开始团体战。","如在入场期间聚集了20人并举行了比赛，但由于没有交易或提现等原因导致参赛人数少于20人，即使在此期间内也不会进行比赛，并且也不会有奖励奖金。","如果您在报名期间拥有仓位并持仓在比赛期间进入，则ROE将从您在比赛期间完全平仓后的时间点算起。","参赛后，如果您在竞赛期间提取了保证金或不进行交易，则您的参赛资格将被取消。","竞赛结束后，参赛者的数量和排名将在20天内确定并公布。","我们有权取消任何被视为洗售交易或非法注册帐户，自我交易或市场操纵交易的资格。","我们保留竞赛或竞赛规则取消或修改的权利。"],
  "roe_act_desc_cancel": "取消参赛资格条件： ",
  "roe_act_desc_cancel_list1": " 如果您在竞赛期间持有头寸，但保证金在竞赛前少於{btc} BTC以下：参赛资格将被取消。 （可以重新入场） ",
  "roe_act_desc_cancel_list2": " 如果您在竞赛期间持有仓位跨越比赛开始日期，将在结算后才算入排名。 如果在结算时保证金跌至{btc} BTC以下，则该参赛资格将被取消。",
  "roe_act_desc_cancel_list3": " 如果您在竞赛期间持有仓位跨越比赛开始日期，将在结算后才算入排名。则该参赛资格将被取消。 ",
  "roe_act_desc_cancel_list4": " 如果竞赛期间没有进行任何交易，参赛资格将被取消。 ",
  "roe_act_about_money_tit": "关于奖金：",
  "roe_act_about_money_list": ["申请参加时保证金余额中奖金为资金的100％（无上限）", "奖金可以与保证金余额一起用作保证金。", "不可转移/提现", "如果用户转移资金，奖金就会消失", "交易手续费和资金费率可从保证金余额中扣除", "可从保证金余额中减去交易损失", "如果只有奖金，就不能交易（可以通过添加保证金余额进行交易，奖金也可以用作保证金）", "爆仓时从保证金余额范围内执行", "奖金在比赛结束时消失", "如果您在比赛结束时有使用奖金的仓位，奖金将在取消仓位的同时消失（如果您在下一次参赛时使用奖金持有仓位，虽可以参赛，但不会发给奖金）"],

  "profit_ranking_contest_time": {
    "banner": "近期开放",
    "activity": "现在未开放注册",
    "contest": "现在没有开始",
  },
  roe_competition_conten:[{
    tit:'ROE竞赛大纲',
    desc:'使用公开的永续合约进行交易，在竞赛结束后具有较高ROE的用户将获得奖励。用户可以自行入场参加竞赛。奖金根据入场的用户总数而有所不同。<br />ROE竞赛计算与参赛者的资金量并无影响。<br />示例：保证金0.05BTC的用户跟保证金5BTC的用户将公平的计算ROE成绩。'
  },{
    tit:'ROEの計算方法',
    desc:'ROE（所有期间）= [（ROE（第1天）+1）*（ROE（第2天）+1）*（ROE（第3天）+1）*…（持续至结束日期）]-1<br />* 请参阅下面每日ROE计算方法'
  },{
    tit:'当天的ROE计算方法（一日）',
    desc:`ROE（当天的ROE）=保证金余额（当天的结束）÷ 保证金余额（当天的开始）– 1<br />
    * 当天是指日本时间的12:00至第二天11:59。<br />  * 结束时保证金余额的计算方法请参见以下内容`
  },{
    tit:'保证金余额计算方法（一天结束时）',
    desc:'保证金余额（一天结束时）=保证金余额（一天开始时）+已实现的损益（当天交易时）+未实现的损益（一天结束时）<br />-未实现的损益（一天开始时）'
  },
  // {
  //   tit:'ROE算法',
  //   desc:'净资产收益率=（买入价/卖出价）÷保证金'
  // },
  {
    tit:'ROE竞赛入场期间',
    desc:'8/2 09:00 ～ 8/12 16:59（GMT+8）<br />* 您不能在竞赛入场期间外入场。亦不允许中途参加。'
  },{
    tit:'ROE竞赛期间',
    desc:'8/12 17:00 ～ 8/30 16:59（GMT+8）'
  },{
    tit:'参加资格',
    desc:'0.02 BTC以上的保证金'
  }],
  'coin_information_btn_link': '币种信息',
  'profit_ranking_contest_tit': '交易大赛（竞争ROE）',
  'profit_ranking_contest_btnTxt': '杠杆交易',
  'deposit_bonus_tit': '充值奖励',
  'deposit_bonus_subtit': '你充值，我送币！',
  'deposit_bonus_time': '3月20日～3月26日',
  'amal_campaign_tit': '4IRE<span style=\'font-size:52px; vertical-align: top; display:inline-block;line-height:70px;\'>交易量大赛&</span><br />4IRE<span style=\'font-size:52px; vertical-align: top; display:inline-block;line-height:70px;\'>交易奖励</span>',
  'amal_campaign_time': '活动时间 : 3月11日～3月22日',
  'amal_campaign_btctxt': '奖金2BTC',
  'btc_campaign_tit': 'BTC <span style=\'font-size:70px; vertical-align: top; display:inline-block;\'>交易奖励</span>',
  'btc_campaign_time': '活动时间：3月24日～3月26日',
  'btc_campaign_btctxt': '奖金合计10BTC',
  'index_cooperative_partner': '合作伙伴',
  'index_cooperative_plan': '招聘计划',
  'index_buyback_fund': '回购基金',
  'index_insurance': '黑客保险基金',
  
  'cooperation_tit': '我们现在招聘世界各地的合作伙伴',
  'cooperation_tit_bonus': '每天可以得到 <span style=\'color:#2DAC91;\'>BTC </span>的分红（分红需要持有<span style=\'color:#2DAC91;\'>10,0004IRE</span>以上）',
  'cooperation_privilege': '合作伙伴特权',
  'cooperation_privilege_reward': '合作伙伴奖励机制',
  'cooperation_privilege_payment': '实施性支付机制',
  'cooperation_privilege_manage': '邀请奖励管理机制',
  'cooperation_choose': '选择合作伙伴',
  'cooperation_choose_media': '媒体/博客',
  'cooperation_choose_internet': '网 红',
  'cooperation_choose_manage': '社群管理员',
  'cooperation_invite': '邀请奖励',
  'cooperation_invite_become': '成为顶级交易所的合作伙伴',
  'cooperation_first': '第一名',
  'cooperation_second': '第二名',
  'cooperation_three': '第三名',
  'cooperation_four': '第四名',
  'cooperation_bonus': '获得奖金',
  'invite_recommend_id': '我的推荐ID',
  'invite_recommend_scale': '当前返佣比例',
  'invite_recommend_link': '推荐链接',
  'invite_recommend_share': '分享',
  'invite_recommend_person': '已推荐的朋友',
  'invite_recommend_money': '已获得的佣金预估',
  'invite_recommend_record': '已获得的佣金预估',
  'invite_recommend_entry': '导出',
  'invite_recommend_email': '邮箱',
  'invite_recommend_time': '时间',
  'invite_recommend_none': '您暂无返佣记录',
  'invite_recommend_history': '最近返佣记录',
  
  'joinUs_tit': '加入我们',
  'joinUs_subtit': '让我们共同创造，打造不同的未来',
  'joinUs_duty': '责任和义务',
  'joinUs_sen': '所需资格',
  'contract_time': '2020/03/27 OG Exchange杠杆交易终于发布。',
  'contract_explain': '在这里，对杠杆交易进行说明。',
  'contract_release': '发行合同',
  'contract_btc': 'BTC/USD无限期合同',
  'contract_eth': 'ETH/USD无限期合同',
  'contract_month_3': 'BTC/USD 3 months Future Contract',
  'contract_month_6': 'BTC/USD 6 months Futur',
  'contract_release_time': '发布时间',
  'contract_release_time_txt': '2019/03/27 05:00 (UTC)',
  'contract_release_trait_tit': 'OG Exchange杠杆交易的特点',
  'contract_release_trait_tit_desc': 'Demo Ex change的杠杆交易有OG Exchange特有的独特的特征。',
  'contract_times': '最大杠杆可以挂100倍。',
  'contract_services': '平台代币$可以使用4IRE支付半价手续费。',
  'contract_mam': '可以使用MAM账户。',
  'contract_api': '支持使用API的系统交易。',
  'contract_transition': '持有超过10,0004IRE可以获得交易所利润的一部分。',
  'contract_explain_tit': '杠杆交易的说明',
  'contract_explain_subtit': 'OG Exchange杠杆交易平台，是可以交易杠杆商品，以比特币为保证金交易的平台。',
  'contract_explain_li_1': 'OG Exchange，现在只把比特币当作证据来使用。所有损益都用比特币计算。如果用Altoconto硬币买卖了对比度也同样用比特币计算损益。在OG Exchange不经营法定货币。',
  'contract_explain_li_2': 'OG Exchange可以悬挂最高100倍的杠杆。',
  'contract_contract_tit': 'OG Exchange合同',
  'contract_contract_subtit': '在OG Exchange，可以无限期合同和期货交易。',
  'contract_contract_li_1': '无限期合同和期货不同，没有到期日没有结算期限。',
  'contract_contract_li_2': '无限期合同每8小时产生资金筹措费用（Funding Rate）。如果超过了筹集资金的时间戳，就产生筹集资金的费用。',
  'contract_contract_li_3': '期货合同结算时位置是以合同结算价格结算的。',
  'contract_contract_subtit_2': '通过买卖这些，我们可以做到“长期或短期合同”。另外，因为即使没有合同也能进行空卖，所以OG Exchange可以说是空卖目的的有益交易平台。',
  'contract_transition_tit': '保证金交易',
  'contract_transition_subtit': '在OG Exchange，提供了一些合同最高100倍的杠杆。',
  'contract_transition_li_1': '例如，1BTC的保证金最多可以购买100BTC的合同。同时，高杠杆能扩大利益,不过，同时损失也有变得大。',
  'contract_transition_li_2': 'OG Exchange采用了自动消除杠杆的结构。因此，如果在市场上无法执行清算订单（市场订单）的话，在特定的期间内会有包含有利可图的杠杆位置被减额。',
  'contract_methods_tit': '杠杆交易的开始方法',
  'contract_methods_subtit': '在OG Exchange，从余额Wallet可以把BTC从主要账户转为杠杆账户。',
  'contract_methods_li_1': 'OG Exchange的余额访问，点击BTC的转账，从主要账户将BTC转移到杠杆余额。',
  'contract_methods_li_2': '请访问杠杆交易所，进行杠杆交易。',
  recruit: [{
      tit: '海外品牌总监',
      duty: ["负责公司海外市场战略企划的实施，制定公司的整体市场工作计划，并就市场推广、品牌行销、公共关系、活 动等提出具体的方向和实行计划；", "建立促销机制，开发市场资源，负责开发和维护客户，媒体和营销渠道；", "制定公司的全球公关战略和公共关系应对；", "负责业务推广和营销活动的想发；", "追踪市场动态和竞争产品，总结和分析市场扩展效果，提供给公司的高级管理层作为决策依据。"],
      need: ["在互联网或国际金融产业具有3-5年以上品牌推广相关的工作经验。具有日本、韩国、欧美等区块链产业和加密货币经验者优先;", "学士或以上学历，英语6级以上，有海外学习或工作经验者优先。能用英语与人流利地沟通。"]
  }, {
      tit: '风险和内部管理经理',
      duty: ["带领全体企业业务，负责排定与支援公司内部管理。负责运营过程中的风险管理；", "分析用户的交易行为、账户状态、识别风险并设计有效的风险管理措施；", "追踪、监控、管理关键数据指标，分析和优化现有可解决方案，增强用户体验；", "评估新项目、新用户、用户交易和转帐，分析和确认潜在风险以及设计和执行风险管理；", "为每个部门撰写及传达指导和训练资料，并定期报告风险讯息；", "进一步发展企业风险管理流程。完成其他相关工作。"],
      need: ["本科系以上学历毕业，金融、经济学、法律、计算机等专业；", "1-3年工作经验，有金融机构风险管理、区块链产业、数字加密货币领域经验优先；", "熟悉相关法律，法规和管制政策，熟悉数字加密货币特色、操作方法和风险管理工具；", "具有较强的逻辑思维能力和分析能力，善于独立和缜密的思考；", "负责任，善于沟通和团队合作，充满工作热情，有较强的项目推广能力。"],
  }, {
      tit: '运营专员（英语，韩语，日语，俄语，越南语）',
      duty: ["制定社区级别目标和计划，并负责建立和管理用户的海外社区（包括但不限于Facebook，BitcoinTalk，Twitter，Telegram，Medium等），以达到并达到用户管理和运营目的；", "收集用户需求并推广产品，帮助技术上和运营面改善；", "为用户解决问题。"],
      need: ["学士或以上学历；有海外学习或工作经验者优先;", "1-3年的互联网社群营运经验；具有两年以上主流金融媒体或区块炼亦或数字资产垂直媒体工作经验者优先;", "熟悉海外社交媒体平台，如Facebook、Twitter、telegram、medium；", "对区块链产业有一定的了解；", "需要中英文专业知识。在各领域的营运专员要求具备可相对应的韩语，日语或俄语的专业知识。"],
  }, {
      tit: '平台运营专员',
      duty: ['负责平台日常数据的分析；', "负责代币/代币的挂牌工作，以及项目持有人和业务部门的对接；", "协助完成与各个不同部门（例如：客户服务、市场营销部门）相关的活动，以支援部门内的目标；", "提出、建议和执行流程改进，以提高效率和服务的提供，在必要时作为部门之间的联络人；", '以简明扼要的方式提出解决办法，并调查责任领域中出现的异常的问题；', "由经理分配其他岗位职责和相关职责。"],
      need: ["要求相关领域的学士学位；有海外学习或工作经验者优先;", "1-3年的运营工作经验；具有主流金融媒体，区块炼或数字资产垂直媒体两年以上工作经验者优先;", "较强的组织能力和学习与执行能力"]
  }],
  'contract_perpetual_tit': '<span style=\'letter-spacing:16px;\'>永续合约</span>',
  'contract_perpetual_subtit': 'Demo&nbsp;&nbsp;<span style=\'letter-spacing:8px;\'>交易所的杠杆交易终于上线</span>',
  'contract_perpetual_time': '2020 年 3 月 27 日 05:00 (UTC+00)',
  'contract_perpetual_btnText': '<span>详&nbsp;&nbsp;&nbsp;细</span>',
  'tranding_bonus_tit': '交易奖励',
  'tranding_bonus_time': '2020年2月29日16：00（UTC+00）〜2020年3月4日16：00（UTC+00）',
  'tranding_bonus_btnText': '30万4IRE瓜分',
  'btc_tranding_bonus_tit': '<span style=\'font-size:83px;display:inline-block;margin:24px 85% 22px 0px\'>BTC</span>交易奖励',
  'btc_tranding_bonus_time': '2020年3月7日00：00（UTC+00）〜2020年3月9日23：59（UTC+00）',
  'btc_tranding_bonus_btnText': '瓜分 10 BTC',
  'symbol_detail_left':
    [{ title_txt: '比特币（BTC）', id: 'btc' },
    { title_txt: '以太坊（ETH）', id: 'eth' },
    { title_txt: '瑞波币（XRP）', id: 'xrp' },
    { title_txt: '比特币现金（BCH）', id: 'bch' },
    { title_txt: '莱特币（LTC）', id: 'ltc' },
    { title_txt: 'EOS（EOS）', id: 'eos' },
    { title_txt: '卡尔达诺（ADA）', id: 'ada' },
    { title_txt: '4IRE（4IRE）', id: '4ire' }],
  'symbol_detail_article':
    {
      btc:
        {
          article_tit: '比特币（BTC）',
          article_detail: '比特币（Bitcoin，简称BTC）是目前使用最为广泛的一种数字货币，它诞生于2009年1月3日，是一种点对点（P2P）传输的数字加密货币，总量2100万枚。比特币网络每10分钟释放出一定数量币，预计在2140年达到极限。比特币被投资者称为“数字黄金”。比特币依据特定算法，通过大量的计算产生，不依靠特定货币机构发行，其使用整个P2P网络中众多节点构成的分布式数据库来确认并记录所有的交易行为，并使用密码学设计确保货币流通各个环节安全性，可确保无法通过大量制造比特币来人为操控币值。基于密码学的设计可以使比特币只能被真实拥有者转移、支付及兑现。同样确保了货币所有权与流通交易的匿名性。',
          article_link: [`https://bitcoin.org/zh_CN/`,`https://www.blockchain.com/explorer`,`https://bitcoin.org/bitcoin.pdf`]
        },
      eth:
        {
          article_tit: '以太坊（ETH）',
          article_detail: '以太坊（Ethereum）是下一代密码学账本，可以支持众多的高级功能，包括用户发行货币，智能协议，去中心化的交易和设立去中心化自治组织(DAOs)或去中心化自治公司（DACs）。以太坊并不是把每一单个类型的功能作为特性来特别支持，相反，以太坊包括一个内置的图灵完备的脚本语言，允许通过被称为“合同”的机制来为自己想实现的特性写代码。一个合同就像一个自动的代理，每当接收到一笔交易，合同就会运行特定的一段代码，这段代码能修改合同内部的数据存储或者发送交易。',
          article_link: [`https://ethereum.org/zh/`,`https://etherscan.io/`,`https://github.com/ethereum/wiki/wiki/%5BJapanese%5D-Ethereum-TOC`]
        },
      xrp:
        {
          article_tit: '瑞波币（XRP）',
          article_detail: '瑞波币（Ripple/XRP）提供一个无阻碍的利用区块链技术的全球支付网络，是世界上第一个开放的支付网络，通过加入Ripple正在成长的全球支付网络可以转账任意一种货币，包括美元、欧元、人民币、日元或者比特币，简便易行快捷，交易确认在几秒以内完成，交易费用几乎是零，没有所谓的跨行异地以及跨国支付费用。 Ripple是开放源码的点到点支付网络，它可以使任何机构或个人轻松、廉价并安全的把金钱转账到互联网上的任何机构或个人，无论在世界的哪个地方。Ripple是p2p软件，没有任何个人、公司，或政府操控，任何人可以创建一个ripple账户。',
          article_link: [`https://ripple.com/`,`https://xrpcharts.ripple.com/#/graph`,``]
        },
      bch:
        {
          article_tit: '比特币现金（BCH）',
          article_detail: '比特币现金是为网络而生的点对点数字现金。它完全去中心化，没有中央银行，更不需要信任任何第三方。',
          article_link: [`https://www.bitcoinabc.org/`,``,``]
        },
      ltc:
        {
          article_tit: '莱特币（LTC）',
          article_detail: '莱特币诞生于2011年11月9日，被称为是“数字白银”。莱特币在技术上和比特币具有相同的实现原理。它是第一个基于Scrypt算法的网络数字货币，与比特币相比，莱特币拥有更快的交易确认时间，更高的网络交易容量和效率。莱特币现在拥有完整的产业链，充分的流动性，足以证明其是成熟、安全、稳定的商用金融系统。',
          article_link: [`https://litecoin.com/en/`,`http://explorer.litecoin.net/chain/Litecoin`,``]
        },
      eos:
        {
          article_tit: 'EOS（EOS）',
          article_detail: 'EOS (Enterprise Operation System)是由 Block.one公司主导开发的一种全新的基于区块链智能合约平台，旨在为高性能分布式应用提供底层区块链平台服务。EOS 项目的目标是实现一个类似操作系统的支撑分布式应用程序的区块链架构。该架构可以提供账户，身份认证，数据库，异步通信以及可在数以万计的 CPU/GPU群集上进行程序调度和并行运算。EOS最终可以支持每秒执行数百万个交易，同时普通用户执行智能合约无需支付使用费用。',
          article_link: [`https://eos.io/`,`https://bloks.io/`,``]
        },
      ada:
        {
          article_tit: '卡尔达诺（ADA）',
          article_detail: '卡尔达诺是一个分散且公开的区块链，也是ㄧ个加密货币项目，而且是完全开源的。卡尔达诺正在开发一个智能合约平台，旨在提供比以前开发的任何协议更先进的功能。它是第一个从科学哲学和以研究为首驱使导向，进而演变而来的区块链平台。开发团队由全球专业工程师和研究人员组成。',
          article_link: [`https://www.cardano.org/en/home/`,`https://cardanoexplorer.com/`,``]
        },
      amal:
        {
          article_tit: '4IRE（4IRE）',
          article_detail: '4IRE是代表OG Exchange的平台代币，主要用于股息，手续费折扣和社区投票权等。\n                    它的发行量上限为2.1亿，其中60％在二级市场上交易流通。\n                    ',
          article_link: [`https://demo.io/spot-exchange/basic?coin=4ire&currency=usdt`,``,``]
        }
    },
  'symbol_detail_introduction': '简介',
  'symbol_detail_org': '官方：',
  'symbol_detail_block': '区块查询：',
  'symbol_detail_book': '白皮书：',
  'mam.transfer.success': '转帐成功',
  'mam.transfer.fail': '转帐失败\r\n',
  'mam.confirm.disable': '您要停用资金吗？',
  'mam.confirm.out': '您要退出吗？',
  'mam.status.approve': '批准',
  'mam.status.reject': '拒絕',
  'mam.status.pending': '待定',
  'mam.status.cancel': '取消',
  'mam.status.out': '退出',
  'mam.empty.investor_list': '您没有投资者',
  'mam.empty.assigned_history': '您没有指定的历史记录',
  'system.title': '正在进行维修',
  'system.des': '由于维护停机或容量问题，服务器暂时无法满足您的请求。我们将儘快回覆您。',
  'account.wallet_fee': '钱包服务费',
  'account.wallet_fee_description': '您可在每笔交易中选择使用哪个4IRE钱包支付费用。',
  'account.api.create_fail': '无法创建此API密钥',
  'client_connection.fail': '连接失败！',
  'common.datatable.data_empty.approved': '您尚未被批准。',
  'common.datatable.data_empty.out': '你还没退出',
  'common.datatable.data_empty.assigned_history': '您没有指定的历史记录',
  'common.datatable.data_empty.current_interval': '您没有当前间隔',
  'common.datatable.data_empty.commissions_history': '您没有佣金历史紀錄',
  'common.datatable.data_empty.commissions_setting': '您没有設置佣金。',
  "common.datatable.data_empty.reward": "No vouchers",
  'common.datatable.empty_data.stop': '您没有停止',
  'common.datatable.empty_data.fill': '您沒有填满',
  'common.datatable.empty_data.positions': '您没有仓位',
  'common.order_id': '订单编号',
  'common.order_status.new': '新',
  'common.action.apply': '申請',
  'amal.amal_main_balance': '钱包余额',
  'amal.lock_by_admin': '永续股息余额',
  'amal.lock_by_user': '股利余额',
  'amal.amal_spot_balance': '现货余额',
  'amal.amal_margin_balance': '保证金余额',
  "funds.balances.available_margin_balance": "Future Available Balance",
  'funds.balances.available_amount': '可用金额',
  'funds.balances.my_invesment': '我的投资',
  'funds.balances.revokeable_amount': '可撤销金额',
  'order.open_order.cancel_market_price_message': '您要取消所有市价订单吗？',
  "order.open_order.cancel_market_order_price_message":
  "Once you confirm, all open stop market orders will be cancelled",
"order.open_order.cancel_market_order_price_title":"Cancel All Stop Market Orders",
  'order.order_form.all': '全部',
  'google_recaptcha.errors': 'Google Recaptcha为必填区块。',
  'server.errors': '请您30秒后重新注册',
  'mam.investor_list': '投资者名单\r\n',
  'mam.assigned_history': '分配的历史',
  'mam.out': '退出',
  'mam.btn.request_to_join': '要求加入',
  'funds.balances.my_investment': '我的投资',
  'orders.open_order.exec_type': 'Exec Type',
  'margin.insurance.wallet_balance': '{balance} {symbol}',
  'margin.weight': '重量',
  'margin.partially_filled': '部分成交',
  'margin.contract.call_option': '看涨期权',
  'margin.contract.put_option': '看跌期权',
  'margin.profit_loss.notice': '所有以BTC计价的货币单位',
  'table.instrument_symbol': '商品品名',
  'table.exec_type': 'Exec Type',
  'table.exec_type.buy': '买',
  'table.exec_type.sell': '卖',
  'table.side.buy': '买',
  'table.side.sell': '卖',
  'table.text': '內文',
  'table.note': '注意',
  'table.order_id': '订单编号',
  'title.perpetual contracts': '永续合約',
  'title.desc.perpetual contracts': '<p>当前，Demo仅接受比特币作为抵押。这意味着保证金、利润和损失必须以比特币支付或接收。但是，通过我們的金融工程，Demo可以使用称为Quanto的衍生工具为用户提供任何基础价格的敞口。</ p> <p>一个比特币Quanto ETH / USD合约具有固定的比特币乘数，但与美元 ETH的价格无关。这允许交易者做多或做空ETH / USD汇率而无需接触ETH或USD。交易者将以比特币作为保证金，并在ETH / USD汇率变化时赚取或损失比特币。</ p>',
  'title.futures_contracts': '期货合约',
  'title.desc.futures_contract': '<p>在Demo，ETH期货合约允许交易者推测以太币/比特币（ETH / BTC）汇率的未来价值。交易者不需要以太币来交易期货合约，因为它只需要比特币作为保证金。</ p>',
  'des.des_page_leaderboard': '・以下是Demo中拥有最高收益率的交易商们。<br/>·此列表是匿名基准，名字分别表示同一用户，但身份无法确定。',
  'table.interest_base': '利息基础',
  'table.interest_quote': '利息报价',
  'table.premium': '溢价',
  'title.view_btc_guide': '查看BTC系列指南',
  'title.des.ethusd.description': '<a href="#"> ETHUSD </a>是以<a href="/margin-exchange/contracts/indices-data/ETH"> ETH指数</a>定价的ETH / USD永续合约。每份合约价值1美元的以太坊。<br/> <br/>资金每8小时进行支付和收取。下一个支付时间是UTC + 7下午7:00。<br/> <br/> <a href="#"> ETHUSD </a>使用溢价指数来计算资金費率。基本利率以<a href="/margin-exchange/contracts/indices-data/ETHBON8H"> ETHBON8H指数</a>和<a href="/margin-exchange/contracts/indices-data/USDBON8H"> USDBON8H指数</a>进行报价；而溢价率以<a href="/margin-exchange/contracts/indices-data/ETHUSDPI8H"> ETHUSDPI8H指数</a>进行报价。这些被用于计算最资金費率。<br/> <br/>今天，在UTC + 7下午7:00，多头将支付0.3750％，而空头将获取0.3750％。 Demo不收取任何资金费用。',
  'title.des.ethbtc.description': '<a href="#"> ETHBTC </a>是以<a href="/margin-exchange/contracts/indices-data/ETH"> ETH指数</a>定价的ETH / BTC永续合约。每份合约价值1 BTC的以太坊。<br/> <br/>資金每8小时进行支付并收取。下一个支付时间是UTC + 7下午7:00。<br/> <br/> <a href="#"> ETHBTC </a>使用溢价指数来计算资金費利率。基本利率以<a href="/margin-exchange/contracts/indices-data/ETHBON8H"> ETHBON8H指数</a>和.<a href="/margin-exchange/contracts/indices-data/BTCBON8H">BTCBON8H Index</a>BTCBON8H指数</a>进行报价；而溢价率以<a href="/margin-exchange/contracts/indices-data/ETHBTCPI8H"> ETHBTCPI8H指数</a>进行报价。这被些用于计算最終资金費率。<br/> <br/>今天，在UTC + 7下午7:00，多头将支付0.3750％，而空头将获取0.3750％。 Demo不收取任何资金费用。',
  'title.des.ethu19.description': '<a href="#"> ETHU19 </a>是以<a href="/margin-exchange/contracts/indices-data/ETH"> ETH指数</a>定价的ETH / U19永续合约。每份合约价值1 U19的以太坊。<br/> <br/>資金每8小时进行支付并收取。下一个支付时间是UTC + 7下午7:00。<br/> <br/> <a href="#"> ETHU19 </a>使用溢价指数来计算资金費率。基本利率以<a href="/margin-exchange/contracts/indices-data/ETHBON8H"> ETHBON8H指数</a>和<a href="/margin-exchange/contracts/indices-data/U19BON8H"> U19BON8H指数</a>进行报价；而溢价率则以<a href="/margin-exchange/contracts/indices-data/ETHU19PI8H"> ETHU19PI8H指数</a>进行报价。这些被用于计算最终资金費率。<br/> <br/>今天，在UTC + 7下午7:00，多头将支付0.3750％，而空头将获取0.3750％。 Demo不收任何取资金费用。',
  'title.des.btcusd.description': '<a href="#"> BTCUSD </a>是以<a href="/margin-exchange/contracts/indices-data/BTC"> BTC指数</a>定价的BTC / USD永续合约。每份合约价值1美元的比特币。<br/> <br/>資金每8小时进行支付并收取。下一个支付时间是UTC + 7下午7:00。<br/> <br/> <a href="#"> BTCUSD </a>使用溢价指数来计算资金費利率。基本利率以<a href="/margin-exchange/contracts/indices-data/BTCBON8H"> BTCBON8H指数</a>和<a href="/margin-exchange/contracts/indices-data/USDBON8H"> USDBON8H指数</a>进行报价；而溢价率以<a href="/margin-exchange/contracts/indices-data/BTCUSDPI8H"> BTCUSDPI8H指数</a>进行报价。这些用于计算最终融资率。<br/> <br/>今天，在UTC + 7下午7:00，多头将支付0.3750％，而空头将获取0.3750％。 Demo不收取任何资金费用。',
  'title.des.btcu19.description': '<a href="#"> BTCU19 </a>是在<a href="/margin-exchange/contracts/indices-data/BTC"> BTC指数</a>中定价的BTC / U19永续合约。每份合约价值1 U19的比特币。<br/> <br/>資金每8小时进行支付并收取。下一个支付时间是UTC + 7下午7:00。<br/> <br/> <a href="#"> BTCU19 </a>使用溢价指数来计算资金費率。基本利率以<a href="/margin-exchange/contracts/indices-data/BTCBON8H"> BTCBON8H指数</a>和<a href="/margin-exchange/contracts/indices-data/U19BON8H">U19BON8H指数</a>进行报价；而溢价率则以<a href="/margin-exchange/contracts/indices-data/BTCU19PI8H"> BTCU19PI8H指数</a>进行报价。这些用于被计算最终资金費率。<br/> <br/>今天，在UTC + 7下午7:00，多头将支付0.3750％，而空头将获取0.3750％。 Demo不收取任何资金费用。',
  'title.des.btcz19.description': '<a href="#"> BTCZ19 </a>是在<a href="/margin-exchange/contracts/indices-data/BTC"> BTC指数</a>中定价的BTC / Z19永续合约。每份合约价值1 Z19的比特币。<br/> <br/>資金每8小时进行支付并收取。下一个支付时间是UTC + 7下午7:00。<br/> <br/> <a href="#"> BTCZ19 </a>使用溢价指数来计算资金費率。基本利率以<a href="/margin-exchange/contracts/indices-data/BTCBON8H"> BTCBON8H指数</a>和<a href="/margin-exchange/contracts/indices-data/Z19BON8H"> Z19BON8H指数</a>进行报价；而溢价率以<a href="/margin-exchange/contracts/indices-data/BTCZ19PI8H"> BTCZ19PI8H指数</a>进行报价。这些用于被计算最终资金費率。<br/> <br/>今天，在UTC + 7下午7:00，多头将支付0.3750％，而空头将获取0.3750％。 Demo不收取任何资金费用。\r\n',
  'title.how_are_the_futures_contract_quoted': '{symbol}期货如何报价？',
  'title.des.how_are_the_futures_contract_quoted': '{symbol}期货如何报价？',
  'title.eth.price_index.desc': '与普遍的看法相反，Lorem Ipsum不仅仅是简单的随机文本。它起源于公元前45年的古典拉丁文学作品，距今已有2000多年的历史。弗吉尼亚州汉普顿-悉尼学院的拉丁学教授理Richard McClintock从Lorem Ipsum的一段话中查阅了一个较为晦涩的拉丁词consectetur，并在古典文学中对该词的引用进行了研究。<br/>发现了无疑的来源。Lorem Ipsum出自西塞罗（Cicero）写于公元前45年的《论至善和至恶》中的第1.0.32和1.10.33节。这本书是关于道德理论的论文，在文艺复兴时期非常流行。 Lorem Ipsum的第一行“ Lorem ipsum dolor sit amet ..”来自第1.10.32节中的一行。',
  'title.symbol_future_contract_example': '{symbol} 期货合约示例',
  'title.des.ethusd.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'title.des.ethbtc.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'title.des.ethu19.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'title.des.btcusd.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'title.des.btcu19.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'title.des.btcz19.funding_calculation': '有关资金費率的详细信息，请参见<a href="{perpetualGuide}">永续指南。</a>',
  'menu.mam_investment': '投资',
  'menu.mam_investor': '投资人',
  'menu.mamcommissions': '佣金',
  'menu.mam_leaderboard': 'Leaderboard',
  'common.current_interval': '当前间隔',
  'common.commissions_history': '佣金历史',
  'common.commissions_setting': '佣金设定',
  'common.withdraw_history': '提取历史',
  'menu.commissions': '佣金',
  'common.high_watermark': '高水位线条款',
  'admin.change_password_admin_success': '管理员密码已更改。 请重新登录！',
  'common.order_status.stop_price': '止損价格',
  'common.order_status.untriggered': 'Untriggered',
  'emails.unlock_airdrop_fail.text1': '对不起',
  'emails.unlock_airdrop_fail.text2': '解锁失败的通知',
  'emails.unlock_airdrop_fail.text3': '在您的股息余额中的 4IRE，我们已将其取消并在下一个时期尝试',
  'emails.unlock_airdrop_fail.title': '【{APP_NAME}】解锁Airdrop失败',
  'emails.received_liquid_position.subject': '【Demo】清算通知：您的：商品仓位已被结算',
  'emails.liquid_position_line_1': '您的卖出：商品仓位current_qty合约空头已经结算。',
  'emails.liquid_position_line_2': '商品的标记价格最近升至：mark_price。您的仓位的清算价格为：liquidation_price。该仓位已由结算引擎接管。',
  'emails.liquid_position_line_3': '：商品仓位详细信息',
  'emails.liquid_position_line_4': '您在卖出位置，已以杠杆比率XBTUSD的：current_qty合约。',
  'emails.liquid_position_line_5': '使用：maint_margin％维持保证金，您的清算价格为：liquidation_price，破产价格为：bankrupt_price（即0％保证金）',
  'emails.liquid_position_line_6': '在：date清算时，。：商品指数的价格升至：index_price。您正在交易的合约：商品的标记价格为：mark_price，该价格基于该指数。',
  'emails.liquid_position.side': '侧面',
  'emails.liquid_position.qty': '数量',
  'emails.liquid_position.lev': 'Lev.',
  'emails.liquid_position.mark_price': '标记价格',
  'emails.liquid_position.liq_price': '清算价',
  'emails.unlock_airdrop_fail_alert.title': ' 解锁Airdrop失败',
  'emails.unlock_airdrop_fail_alert.text1': '系统无法解锁用户股息钱包中的4IRE。',
  'emails.unlock_airdrop_fail_alert.text2': '解锁细节',
  'emails.unlock_airdrop_fail_alert.email': '电子邮件地址',
  'emails.unlock_airdrop_fail_alert.amount': '数量',
  'emails.withdrawal_canceled.subject': '【Demo】取款取消',
  'emails.withdrawal_canceled.dear_name': '尊敬的<strong>：电子邮件</ strong>，',
  'emails.withdrawal_canceled.line_1': '您以下的提款请求已被Demo系统取消。',
  'emails.withdrawal_canceled.line_2': '货币',
  'emails.withdrawal_canceled.line_3': '数量',
  'emails.withdrawal_canceled.line_4': '提现地址',
  'emails.withdrawal_canceled.line_5': '创建日期',
  'emails.withdrawal_canceled.line_6': '有两种情况可以取消您的请求。',
  'emails.withdrawal_canceled.line_7': '情况1：管理员出于某些原因取消了您的请求。',
  'emails.withdrawal_canceled.line_8': '情况2：您的请求已过期',
  'emails.withdrawal_canceled.line_9': '非常感谢。',
  'emails.change_coldWallet_setting.subject': '【Demo】更改冷钱包设置完成',
  'emails.change_coldWallet_setting.line_1': '因为您更改了冷钱包设置所以收到此电子邮。',
  'emails.change_coldWallet_setting.line_2': '详细信息更改设置：',
  'emails.change_coldWallet_setting.line_3': '：硬币地址从：oldAddress更改为：newAddress',
  'emails.change_coldWallet_setting.line_4': '冷钱包持有人的电子邮件从：oldEmail更改为：newEmail',
  'emails.register_completed.subject': '【Demo】注册完成',
  'emails.register_completed.hello': '您好<strong>：电子邮件</ strong>，',
  'emails.register_completed.line_1': '恭喜，您的注册已完成。',
  'emails.register_completed.line_2': '请登录：APP_NAME开始交易。',
  'emails.margin_deleverage.title': '【Demo】保证金杠杆通知',
  'emails.margin_deleverage.body1': '您已经解除杠杆化了',
  'emails.margin_deleverage.body2': '您可以在保证金交易页面上重新输入仓位。',
  'emails.register_beta_tester.subject': '【Demo】 Beta Tester登录需求',
  'emails.register_beta_tester.dear_name': 'Dear',
  'emails.register_beta_tester.line_1': '我們有Beta Tester的登录需求:',
  'emails.register_beta_tester.email': 'Email:',
  'emails.beta_tester_active.subject': '感谢您参加beta版本',
  'emails.beta_tester_active.dear_name': '感谢您参加beta版本',
  'emails.beta_tester_active.line_1': '这版本是beta版。<br>※由于是BETA版，一部分功能可能出现问题。发现问题时，请立即向管理员报告。<br><a href = \'mailto: :email\'>:email</a>',
  'beta_tester.block_trading': 'Please become a Beta Tester to trade',
  'messages.error.spot.balance_insufficient': '汇兑余额不足',
  'messages.error.airdrop.balance_insufficient': '空投余额不足',
  'messages.error.margin.balance_insufficient': '保证金余额不足',
  'messages.error.main.available_balance_insufficient': '可用余额不足',
  'messages.error.spot.available_balance_insufficient': '可用的 汇兑余额不足',
  'messages.error.airdrop.available_balance_insufficient': '可用的空投余额不足。',
  'messages.error.margin.available_balance_insufficient': '可用保证金余额不足。',
  'messages.error.order_child.existing': '可以查看任何现有订单 ',
  'messages.error.device.existing': '可以删除任何现有的设备授权都',
  'order.open_order.cancel_limit_order': '取消定价',
  'sales_point.clear': '清除',
  'validation.messages.airdrop.airdrop_check_payout_amount': '付款金额不得大于该货币金额。',
  'airdrop.cannot_find_email': '找不到拥有那个邮箱地址的用户。',
  'airdrop.user_was_exist': '该帐户已经存在。',
  'validation.user_id_coin_wallet_xpr_eos': '收款地址或标记/备忘录/...已经存在。',
  'validation.message.join_funds': '投资者不可用。 请再试一遍',
  'validation.message.amount_join_funds': '総数量必须等于投资者数量',
  'validation.message.unique_interval': '间隔已经存在',
  'validation.message.max_deposit_fund': '可用余额不足。',
  'validation.message.max_withdraw_fund': '可撤销的余额还不够。',
  'validation.message.account_log_for_transaction': '系统是统计委员会，请过几分钟再试',
  'validation.instrument_check_difficult_than': '：属性必须与基础不同。',
  'validation.instrument_check_small_than_init_margin': '：属性必须小于初始化余量。',
  'validation.instrument_check_small_than_risk_limit': ' ：属性必须小于风险限制。',
  'validation.fee_condition': '错误：提取费和提供费之总和必须大于或等于0。',
  'validation.settlement_fee_condition': '结算费用的值必须大于0',
  'validation.instrument_check_refe_index': ':必须输入属性。',
  'validation.instrument_check_funding_base': ':必须输入属性。',
  'validation.instrument_check_funding_quote': ':必须输入属性。',
  'validation.instrument_check_require': ':必须输入属性。',
  'validation.not_zero': '金额的值必须大于0',
  'validation.instrument_check_require_future': ':必须输入属性。',
  'validation.instrument_check_require_perpetual': ':必须输入属性。',
  'validation.ip-active': ':time秒内请求过多。',
  'validation.ip-active-count': '1分钟内请求过多',
  'user.enable_fee.enable': 'enable',
  'user.enable_fee.disable': 'disable',
  'orders.open_order.search_by_coin': '通过硬币做搜索',
  'circuit_breaker_setting.title': '断路器设置',
  'circuit_breaker_setting.select_market': '选择市场',
  'circuit_breaker_setting.enable_circuit_breaker': '启用断路器',
  'circuit_breaker_setting.coin': '代币',
  'circuit_breaker_setting.range_listen_time': '范围待機时间（小时）',
  'circuit_breaker_setting.range_percent': '范围百分比（小时）',
  'circuit_breaker_setting.block_time': '阻断時間 (hour)',
  'circuit_breaker_setting.enable_column': '状态',
  'circuit_breaker_setting.enabled': '设定',
  'circuit_breaker_setting.disabled': '无效',
  'circuit_breaker_setting.update_confirm': '您要更改此记录吗？',
  'circuit_breaker_setting.update_success_msg': '已更新',
  'circuit_breaker_setting.update_enable_confirm': '您要更改状态吗？',
  'circuit_breaker_setting.validation.block_trading': '交易配对受阻！',
  'circuit_breaker_setting.validation.block_market_order': '市价订单被断路器阻止！',
  'circuit_breaker_setting.validation.block_stop_market_order': '停止市价单被断路器阻止！',
  'circuit_breaker_setting.validation.price_too_low': '订单价格过低。',
  'circuit_breaker_setting.validation.price_too_high': '订单价格过高。',
  'circuit_breaker_setting.validation.block_time': '必须输入阻断的时间。',
  'circuit_breaker_setting.validation.range_listen_time': '必须输入监听时间范围。',
  'circuit_breaker_setting.validation.circuit_breaker_percent': '必须输入百分比范围。',
  'circuit_breaker_setting.validation.range_listen_time.empty_value': '范围侦听时间的值必须大于0。',
  'circuit_breaker_setting.validation.circuit_breaker_percent.empty_value': '范围百分比的值必须大于0。',
  'circuit_breaker_setting.validation.block_time.empty_value': '阻断时间值必须大于0',
  'circuit_breaker_setting.update_fail_msg': '更新失败！',
  'user_setting.total_users': '总用户：',
  'enable_fee.user_setting.confirm_off': '您确定禁用费用设定吗？',
  'enable_fee.user_setting.confirm_on': '您确定启用费用设定吗？',
  'enable_fee.user_setting.update_success': '成功更新启用用户费用设定！',
  'enable_fee.user_setting.update_fail': '更新启用用户费用设定失败',
  'enable_fee.title': '启用用户费用设定',
  'enable_fee.remove_success': '用户已成功删除！',
  'enable_fee.remove_fail': '用户删除失败！',
  'enable_fee.currency': '货币',
  'enable_fee.coin': '代币',
  'enable_fee.no': 'No.',
  'enable_fee.status': '状态',
  'enable_fee.fee_charge': '手续费',
  'enable_fee.user_was_exist': '该帐户已经存在。',
  'enable_fee.user_not_exist': '该帐户不存在。',
  'enable_withdrawal.user_setting.confirm_off': '您确定禁用提款设定吗？',
  'enable_withdrawal.user_setting.confirm_on': '您确定启用提款设定吗？',
  'enable_withdrawal.user_setting.update_success': '更新启用提款用户设定成功！',
  'enable_withdrawal.user_setting.update_fail': '更新启用提款用户设定失败',
  'enable_withdrawal.title': '用户提款設定',
  'enable_withdrawal.remove_success': '用户已成功删除！',
  'enable_withdrawal.remove_fail': '用户删除失败！',
  'enable_withdrawal.currency': '货币',
  'enable_withdrawal.coin': '代币',
  'enable_withdrawal.no': 'No.',
  'enable_withdrawal.status': '状态',
  'enable_withdrawal.user_was_exist': '该帐户已经存在。',
  'enable_withdrawal.user_not_exist': '该帐户不存在。',
  'enable_withdrawal.validate.withdraw_is_blocking': '提现已被鎖住。',
  'enable_trading.user_setting.confirm_off': '您确定禁用交易设定吗？',
  'enable_trading.user_setting.confirm_on': '您确定启用交易设定吗？',
  'enable_trading.user_setting.update_success': '成功更新启用交易用户设定！',
  'enable_trading.user_setting.update_fail': '更新启用交易用户设定失败！',
  'enable_trading.title': '交易设定',
  'enable_trading.remove_success': '用户已成功删除！',
  'enable_trading.remove_fail': '用户删除失败！',
  'enable_trading.currency': '货币',
  'enable_trading.coin': '代币',
  'enable_trading.no': 'No.',
  'enable_trading.status': '状态',
  'enable_trading.user_was_exist': '该帐户已经存在。',
  'enable_trading.user_not_exist': '该帐户不存在。',
  'enable_trading.validation.block_trading': '您无权交易此货币。请与管理员联系以获取更多信息。',
  'withdrawal_information.fee_percent': '',
  'margin.date': '日期',
  'margin.settlement_type': '结算类型',
  'margin.order_history.date': '日期',
  'margin.order_history.symbol': '金融商品',
  'margin.order_history.type': '类别',
  'margin.order_history.side': '侧面',
  'margin.order_history.average': '平均',
  'margin.order_history.price': '价格',
  'margin.order_history.fill_price': '补价',
  'margin.order_history.order_price': '订购价格',
  'margin.order_history.filled': '成交',
  'margin.order_history.amount': '数量',
  'margin.order_history.qty': '数量',
  'margin.order_history.total': '合计',
  'margin.order_history.order_value': '订单价值',
  'margin.order_history.trigger_conditions': '触发条件',
  'margin.order_history.status': '状态',
  'margin.order_history.text': '內文',
  'margin.order_history.note': '注意',
  'margin.order_history.order_id': '订单编号',
  'margin.instrument_symbol': '金融商品',
  'margin.trade_type': '侧面',
  'margin.fee': '手续费',
  'exception.invalid_transaction': '无效的交易',
  'exception.deposit_non_exist': '存入不存在的地址: :地址',
  'exception.unconfirm_transaction': '未确认交易',
  'exception.invalid_wallet_id': 'coin的钱包ID无效',
  'exception.unknown_conversion': '硬币的未知转换率：Coin ',
  'exception.transaction_executed_canceled': '交易已执行或取消',
  'exception.row_not_found': '未找到Row of :table ',
  'exception.device_invalid': '装置无效',
  'exception.user_not_found': '找不到使用者',
  'exception.table_not_found': '表格：找不到表格',
  'exception.empty_address': '空的地址',
  'exception.cannot_calculate': '无法计算价格',
  'exception.unknown_order_type': '未知的订单类型: :type',
  'exception.amal_price_change': '价格已更改，请输入新价格',
  'exception.amal_not_enough': '4IRE剩余总供应量不足。',
  'exception.amal_remaining_not_enough': '4IRE剩余总供应量不足。',
  'exception.amal_payment_not_enough': '可用余额不足，无法付款。',
  'exception.account_mismatch': '帐户不匹配',
  'exception.bank_account_in_use': '正在使用的银行帐户',
  'exception.invalid_account': '无效账户',
  'exception.cannot_remove_super_admin': '您无法删除超級管理員S帐户。',
  'exception.not_setting_phone_admin': '没有设置管理員电话号码。',
  'exception.amal_empty_or_invalid': '4IRE设置为空或货币无效',
  'exception.otp_verified': 'Otp 验证',
  'exception.transaction_not_found': '找不到交易',
  'exception.unconfirmed_transaction': '未确认的交易 :transactionId',
  'exception.not_found': '未找到',
  'exception.cannot_change_admin_password': '这次无法更改管理员密码。请刷新，然后重试！',
  'exception.max_deposit_fund': '可用余额不足。',
  'exception.fund_balance': '余额变更，请重试。请刷新，然后重试！',
  'exception.investor_not_valid': '资金的投资者有改变。请刷新，然后重试！',
  'exception.unique_join_fund': '该资金已加入或要求加入。',
  'google.recaptcha.errors': '重新验证失败',
  'margin.order.error.instrument.expired': '无法下订单。：商品已过期！',
  'margin.order.error.side.required': '区域是必填项。',
  'margin.order.error.type.required': '必须输入类型。',
  'margin.order.error.quantity.required': '数量区域为必填项。',
  'margin.order.error.quantity.too.high': '无法下订单：数量太高。',
  'exception.inactive': ':table无效',
  'exception.max_decimal_msg': '最大小数位数为:max_decimal。',
  'exception.join_new_fund': '资金必须加入于下个月',
  'margin.change_leverage.error': '无法更改杠杆，因为您的仓位将立即结算',
  'margin.add_margin.error': '无法添加保证金，因为它是交叉仓位。',
  'margin.sub_margin.error': '无法平仓保证金，因为仓位需要最低金额。',
  'margin.risk_limit.error': '由于高杠杆率，无法更改风险限制。',
  'margin.risk_limit_down.error': '由于具有很高的价值，因此无法更改风险限制。',
  'margin.position.is_liquid': '无法下订单：您的仓位正在结算中。',
  'margin.order.error.reduce_only': 'reduce_only_error',
  'margin.order.error.price.required': '无法下订单：需要价格',
  'margin.order.error.price.too.high': '无法下订单：价格过高。',
  'margin.order.error.stop_price.required': '无法下订单：需要止損价格。',
  'margin.order.error.stop_price.gt_market_price': '无法下订单：止損价不能大于市场价。',
  'margin.order.error.stop_price.lt_market_price': '无法下订单：止損价不得低于市场价。',
  'margin.order.error.trail_value.not_negative': '无法下订单：追踪值不为负。',
  'margin.order.error.trigger_price.gt_market_price': '无法下订单：触发价格值不能大于市场价格。',
  'margin.order.error.trigger_price.lt_market_price': '无法下订单：触发价格值不得小于市场价格',
  'margin.order.error.trigger_price.required': '无法下订单：触发价必须大于0。',
  'margin.order.error.limit.gt_market_price': '无法下订单：触发价格值不能大于市场价格。',
  'margin.order.error.limit.lt_market_price': '无法下订单：触发价格值不得小于市场价格',
  'margin.order.error.trigger.not_valid': '无法下订单：触发条件无效',
  'margin.order.error.index.not_exist': '无法下订单：索引不存在',
  'exception.geetest.invalid': '验证码无效',
  "btc_trading_rebate_tit": "BTC<span style=' font-size: 54.5px;vertical-align: top; margin-left: 10px;letter-spacing:8px;'>交易返佣</span>",
  "btc_trading_rebate_subtit": "BTC / USD交易对（永续合约）<br />每{btc}BTC交易返佣{btc_m}BTC",
  "btc_trading_rebate_time": "去交易",

  "mam_tit":"MAM",
    "mam_subtit":"拥有业界首个高度透明的多账户管理系统！<br />投资者现在可以控制风险并获得安全的资本收益。",
    "mam_btnTxt":"了解更多",

    "mam_detail_whatis_tit":"什么是MAM?",
    "mam_detail_whatis":"什么是MAM：",
    "mam_detail":"MULTI<br />ACCOUNT<br />MANAGER",
    "mam_detail_whatis_tip":"一位资金经理人可以同时管理多个投资帐户的一个平台。",
    "mam_detail_whatis_desc":"参与MAM的用户可以将其帐户中的资金委托给资金经理人做运用。<br /> 资金经理人不能从用户的账户中提取、汇款或转移资金。",
    "mam_detail_methods":"参与方式：",  
    "mam_detail_methods_tip":"用户可以从平台“ MAM”中选择自己喜欢的资金经理人。<br />请确认经理人的交易成绩、最大跌幅及使用手续费等。",  
    "mam_detail_methods_desc":"可以随时提出进入（参与）和注資（追加资金）的请求，但操作将从每月的結算后（月底），隔月的第一天开始。<br />FreezeTime之后发出的请求将在该期间结算后才能執行。", 
    "mam_revoke_list":["基本上在结算之前，不可以撤回委託。","您可以在结算日的24小时前（FreezeTime）提出请求，以在平仓后撤回委託。","FreezeTime之后发出的撤回请求必须等到下一次結算后才能撤回。","結算前如资金经理人允许了早期的撤回，並在账户内有足夠的可用余额，則无需等到結算即可让特定的投資者提前撤回。","在平仓时如资金经理人持有仓位但没可用余额的情況下，撤回的请求将优先執行。","如果投资者要求提取部分或全部资金，并且在結算时存在未结仓位/未结订单，系统将按以下列顺序自动执行撤回处理。"],
    "mam_revoke_numlist":["① 系统将自动使用資金的可用余额来執行投资者申請的资金提取。","② 如果所有投资者都希望提取大笔款项，并且系统已使用了可用余额的80％，在不足的情況下，系统将取消仓位中的所有订单，将可用余额支付给投资者。","③ 如果所有投资者都想撤出产生太大金額，尽管系统取消了订单仍然还不足，那么接下来系统会将一部分的未平仓位以市价平仓，以支付给投资者。並依序将未实现損益较高的头寸先行平仓。","④ 如果所有投资者都想撤出产生太大金額，會平仓未实现损益20％或更多的头寸，在不足的情況下，则取消提出余额的申请。"],
    "mam_computed_profitloss_list": ["損益計算是使用高水位线的方式进行。","每个参与该資金的投资者都有各自持有自己的最高水位。","当您結算之后，完成损益分配并找出投资者的最后余额时，以最后余额对照高水位线，来计算資金经理人的佣金。"],
    "mam_computed_profitloss_demolist": ["例：<br />","在第一阶段开始时， 投资者A投资了1 BTC，在第一期結束時损失0.5BTC，剩下余额0.5BTC。如果在第二期产生0.5BTC的利润，而投资者A的资金变为1BTC，则只能补充前一期间的损失，因此資金经理人不会获得佣金。","如果資金经理人赚取了1 BTC的利润，而投资者A的资金余额变为1.5 BTC，则資金经理人将获得 手续费* 0.5 BTC的報酬。","如果資金经理人在第二期未能获利并造成0.4BTC的损失，则投资者A的资金将为0.1BTC，因此如果資金经理人者在第三期无法获利0.9BTC或更多，则将不会收取费用。","* MAM不保证獲利。交易所不承担任何损失。 "],
    "mam_revoke_tit":"Revoke（資金提取）：",  
    "mam_computed_tit":"损益计算方法：",  
    // "mam_becomeMam":"成为<span style='color: #ed7232;'>MAM交易者</span><br />(资金经理人)",
    "mam_becomeMam":"成为MAM交易者<br />(资金经理人)",
    
    "mam_becomeMam_desc":"作为MAM交易者，如果您符合一定的審查基準，则可以作为資金經理人来管理投资者的资产。",
    "mam_reward_tit":"報酬",
    "mam_reward_desc":"手续费：獲得利润的5％～50％（由資金经理人自己设定）<br />例） 如手续费为10％ ，从100个投资者交易100个BTC资金并获得20％的利润 (100BTC×20％)×10％= 2BTC (奖励報酬)",
    "mam_require_tit":"资格 / 要求",
    "mam_require_desc":"・在交易排行榜ROE排名前25名内<br />・提交过去的交易成绩<br />想成为资金经理人，交易所会进行审核。<br />如果您想成为资金经理人，请从这里与我们联系。<br /><a style='color: #ed7232;' href='http://amanpuriexchange.mikecrm.com/37JWADz' target='_blank'>http://amanpuriexchange.mikecrm.com/37JWADz</a>",    

    "slide_expand":"展开",
    "slide_collapse":"折叠",  
    
    "high_rebate_banner":{
      "rebate_tit":"超级高返利",
      "rebate_subtit":"邀请朋友返佣TA的交易手续费",
      "rebate_step":[{
        num:1,
        step_desc:"注册并生成专用链接<br />（二维码+邀请码）"
      },{
        num:2,
        step_desc:"通过邀请码<br />邀请朋友注册交易"
      },{
        num:3,
        step_desc:"返佣多至40%"
      }],
      "rebate_btn":"立刻注册邀请好友"
  },
  "high_rebate_detail":{
    "rebate_tit":"将您的人脉转换成收益",
    "rebate_subtit":"成为Demo社区用户，享受业内最大的返佣系统",
    "rebate_rate":"最高<span>40%</span>的邀请奖励",
    "rebate_joinin":"立刻加入",
    "rebate_register_step":[{
      "step_img":'/images/rebate/number-one.png',
      "step_num":'步骤1：注册',
      "step_desc":'立即申请加入Demo社区。 我们的社区管理员，指导您完成整个过程。'
    },{
      "step_img":'/images/rebate/number-two.png',
      "step_num":'步骤2：推广活动',
      "step_desc":'使用个人专用链接，向您的群組或朋友介绍Demo，並可在代理后台系統内查看各項明細。'
    },{
      "step_img":'/images/rebate/number-three.png',
      "step_num":'步骤3：返佣',
      "step_desc":'佣金每天实时结算！当您的用户进行交易时，用户支付的代币将返佣到您的帐户内并可立即提现。'
    }],
    "rebate_five_tit":'五层式返佣系统',
    "rebate_five_subdesc":'业内最高返佣系统',
    "rebate_five_desc":'作为社区用户，您将获得5层返佣共40%。当用户点击您的链接时，他们注册并加入Demo。只要您推荐的用户持续在Demo里进行交易，您会持续的获得返佣。',
    "rebate_five_become":"成为社区用户",
    "rebate_five_tips":"查看公示",
    "rebale_article_link":'https://demo-exchange.zendesk.com/hc/zh-cn/articles/360039635991',
    "rebate_explain":[{
      tit:'五层返佣系统',
      'desc':'10%用户的佣金+10%子用户佣金分成<br /> *（邀请了100人以上，20%用户的佣金+20%子用户佣金分成）'
    },{
      tit:'支援合作伙伴',
      'desc':'成为我们的合作伙伴<br />可以得到更多的分红机会'
    },{
      tit:'代理后台系统',
      'desc':'您可以在后台系统查看<br /> 关于您的邀请者的详细数据及信息'
    },{
      tit:'实施返佣',
      'desc':'佣金在当天結算並以BTC和USDT等<br />支付到您的帐户'
    }],
    "rebate_unique_tit":'Demo用户们独享以下特点',
    "rebate_unique":[{
      tit:'易于使用的界面',
      subtit:'即使是新手，也可以在Demo平台上轻松进行交易'
    },{
      tit:'BTC作为保证金',
      subtit:'使用您的BTC作为保证金来永续合约杠杆交易'
    },{
      tit:'高流动性',
      subtit:'Demo提供活跃的流动性和多元化的交易方式'
    },{
      tit:'安全性',
      subtit:'Demo使用多重签名冷钱包，用户的资产是与网路隔离並受保护'
    },{
      tit:'最高100倍杠杆',
      subtit:'加密货币的永续合约交易杠杆高达100倍'
    },{
      tit:'多语言在线客服',
      subtit:'Demo为所有用户提供实时多语言客服。大多数查询都可以通过我们的帮助中心解决，若无法解决时，我们客服专员随时准备帮您解答'
    },{
      tit:'低手续费',
      subtit:'业内极低的交易手续费和资金率<br />用4IRE代币减半您的交易手续费'
    },{
      tit:'合伙伙伴活动',
      subtit:'我们在全球有社区合作伙伴，给大家最新消息及聆听各位的意见'
    }],
  },
  "coopeartion_d":{
    'banner':{
      tit:'成为Demo的合作伙伴',
      subtit:'与朋友合作和Demo共同成长！',
      // login:'合伙人登录',
      login:"点击此处申请",
      manage_login:'管理您的账户',
      partner:'管理您的账户',
      manage_partner:'三分钟注册账户',
      'detail':'进一步了解Demo',
      main:'主旨',
      main_step:'Demo > 主旨',
      plan:"Demo有一个“合作伙伴标签计划”的独特制度。这个制度可以透过您在個人领域的活跃成为我们的伙伴，让自己和Demo共同發展。<br />透过成为合作伙伴，用户将成为Demo生态系统的重要一员，并且Demo会分配4IRE代币作为股息。",
    },
    'step':[{
      step_img:'/images/rebate/high_d_register.png',
      step_num:'步骤①',
      step_desc:'申请合作伙伴标签计划。<br />如果您通过了审查，则会发送合作伙伴社区邀请的链接，所以请由此加入。'
    },{
      step_img:'/images/rebate/high_d_promote.png',
      step_num:'步骤②',
      step_desc: `成为我们的合作伙伴。<br />
      成为合作伙伴，在擅长发挥的领域中积极发挥影响力。`
    },{
      step_img:'/images/rebate/high_d_rebate.png',
      step_num:'步骤③',
      step_desc: `您可以参与仅限于合作伙伴的活動企劃
      Demo定期为合作伙伴发布任务
      完成任务的前幾名參加者将获得4IRE代幣或Demo限量商品。`
    }],
    'reward':{
      tit:'合作伙伴报酬',
      step:[`Demo提供的永久配息4IRE<br />
      成为合作伙伴后，在合作伙伴任期内得到的4IRE加上自己拥有的4IRE合計持有10,000 4IRE以上，可获得BTC的每日奖励。但是，伙伴任期授予的4IRE在合作伙伴期限结束时也会消失。 （自己得到的4IRE不会消失。）`,`您所邀请用户的交易费用的一部分。（最高可達40％）<br />最多可以邀请到5个层级的用户并收取最多40％的佣金。返回的退佣<br />（例如BTC，USDT，4IRE和代币）<br />可以自由交易和提取，而不受锁定的限制。 （达到指定条件前，最多可以退还20％的佣金。如果达到条件，则将增加到40％。）`,`完成合作伙伴限定的任务<br />Demo定期为合作伙伴准备任务活动。这使合作伙伴可以获得永久配息4IRE，USDT或Demo独家商品等。`]
    },
    'func':{
      tit:'合作伙伴可使用功能',
      step:[{
        step_num:'实时支付系统',
        step_desc:'被邀请用户支付的费用将实时退还到您的钱包中。'
      },{
        step_num:'佣金管理系统',
        step_desc:'我们有一个完整的系统来管理<br />受邀用户的数量和所收取的佣金。<br />此外，您也可以将它们下载为CSV文件。'
      },{
        step_num:'SNS发布宣传',
        step_desc:'合作伙伴可以其推荐代码<br />发布到Twitter，Facebook等。'
      }]
    },
    'partner':{
      tit:'寻找合作伙伴',
      maintit:'Demo正在寻找以下合作伙伴',
      step:['KOL','会员','媒体']
    }
  },

  'cooperation_banner_tit': '成为<span style="font-weight:600;font-size: 47px;vertical-align: text-top;">Demo</span>的合作伙伴',
  'cooperation_banner_subtit': '与朋友合作和<span style="font-weight:600;font-size: 47px;vertical-align: text-top;">Demo</span>共同成长',
  'cooperation_banner_btntxt': '立刻申请',
  "roe_personal_team_slide":{
    tit:`OG Exchange<br />个人杠杆交易ROE竞赛`,
    subtit:`OG Exchange 将在杠杆交易中举行个人ROE竞赛！<br />在此竞赛中，会评比赛结束后个人/团队的总ROE（净资产收益率）
    `,
    personal_btn:`个人ROE竞赛入口`,
    team_btn:`团队ROE竞赛入口`,
    bonus:`最大奖金<br />200 BTC`
  },
  "roe_team":{
    header_txt:{
      personal:{
        tit: `<span style="letter-spacing: 1px;">OG Exchange</span><br /><span style="letter-spacing: 6.8px;">永续合约交易ROE竞赛</span>`,
        subtit:`OG Exchange将举办通过杠杆交易即可入场的ROE竞赛<br />
        在此期间ROE（净资产收益率）竞争上位的使用者，并会在排行榜上实时显示 `
      },
      team:{
        tit: `<span style="letter-spacing: 2px;">OG Exchange</span><br /><span style="letter-spacing: 2px;">团队对抗杠杆交易ROE竞赛</span>`,
        subtit:`OG Exchange将在杠杆交易中举行团队对抗ROE竞赛！<br />
        在此竞赛中，会评比赛结束后团队的平均ROE（净资产收益率）。`
      },
    },
    outline_list:[{
      tit:'ROE竞赛大纲（小组赛）',
      subtit: `使用公开的永续合约进行交易，在比赛结束后，结算整个团队的ROE最高的前几名团队可以获得奖励金。所有用户都可以成为团队领导。
      对于未达到最少参赛人数的队伍，将被取消参赛资格。奖金将根据参赛队伍的数量而有所不同。
      除了ROE成绩外，还有整个团队交易量的奖金。<br />
      ROE竞赛计算与参赛者的资金量并无影响。<br />
      示例：保证金0.05BTC的用户跟保证金5BTC的用户将公平的计算ROE成绩。`
    },{
      tit:'ROEの計算方法',
      subtit: `ROE（所有期间）= [（ROE（第1天）+1）*（ROE（第2天）+1）*（ROE（第3天）+1）*…（持续至结束日期）]-1
      <br />* 请参阅下面每日ROE计算方法`
    },{
      tit:'当天的ROE计算方法（一日）',
      subtit: `ROE（当天的ROE）=保证金余额（当天的开始）➗保证金余额（当天的结束）– 1<br />
      * 当天是指日本时间的12:00至第二天11:59。<br />
      * 结束时保证金余额的计算方法请参见以下内容`
    },{
      tit:'保证金余额计算方法（一天结束时）',
      subtit:`保证金余额（一天结束时）=保证金余额（一天开始时）+已实现的损益（当天交易时）+未实现的损益（一天结束时）<br />-未实现的损益（一天开始时）`
    },{
      tit:'ROE竞赛报名期间（团队战）',
      subtit: `2020 / 07 / 03 &nbsp;&nbsp;17:00 ～ 07 / 12 &nbsp;&nbsp;07:59 （GMT+8）`
    },{
      tit:'ROE竞赛期（团队战斗）',
      subtit:'2020 / 07 / 12 &nbsp;&nbsp;08:00 ～ 08 / 02 &nbsp;&nbsp;07:59 （GMT+8）'
    },{
      tit:'參赛资格',
      subtit:'最少1个团队  3 人 （最多20 人）'
    }],
    team_bonus:{
      tit:'竞赛期间的最低交易金额',
      money: `1队{btc} BTC <br /> 每位成员有0.05 BTC以上的保证金`
    },
    team_txt: {
      teamAndAllMoney:'参赛队伍数和总奖金',
      team:'参赛队伍',
      all_money:'总奖金',
      teamtxt:'队',
      trading_txt:'交易量竞赛',
      roe_txt:'ROE竞赛'
    },
    bonus_rules:'奖金分配规则',
    bonus_rate:'奖金比率',
    bonus_dis_demo:[{tit:'奖金分配示例（ROE）',subtit:`示例：如果有10个参赛团队并且总奖金为2 BTC<br />
    第1名&nbsp;&nbsp;1.4 BTC，第2名&nbsp;&nbsp;0.2 BTC，第3名&nbsp;&nbsp;0.1 BTC，4〜10名&nbsp;&nbsp;0.042 BTC<br />
    示例：如果有1000个参赛团队，并且总奖金为100 BTC,<br />
    第1名&nbsp;&nbsp;70 BTC，第2名&nbsp;&nbsp;10 BTC，第3名&nbsp;&nbsp;10 BTC ，4〜10名&nbsp;&nbsp;2.1 BTC
    `},{
      tit:'奖金分配示例（交易量）',
      subtit:`示例：如果有10个参赛团队并且总奖金为1 BTC<br />
      第1名&nbsp;&nbsp;0.7 BTC，第2名&nbsp;&nbsp;0.1 BTC，第3名&nbsp;&nbsp;0.05 BTC，4〜10名&nbsp;&nbsp;0.021 BTC<br />
      示例：如果有1000个参赛团队并且总奖金为100BTC，<br />
      第1名&nbsp;&nbsp;70 BTC，第2名&nbsp;&nbsp;10 BTC，第3名&nbsp;&nbsp;5 BTC，4〜10名&nbsp;&nbsp;2.1 BTC`
    }],
    "bonus_dis_demo_time":{
      tit:'奖金分发时间',
      subtit:`比赛结束后，我们将检查不公正情况，在20天内确定排名，并在10天内分发奖金。`
    },
    complement:{
      tit:'竞赛补充事项',
      list:[`参赛后，如果您在比赛期间提取保证金或不进行任何交易，则将被取消参赛资格。`,
      `比赛结束后，参赛人数和排名将在30天内最终确定并发布。`,
      `我们有权取消被视为非法注册帐户或市场操纵用户的资格。`,
      `我们保留决定撤消或修改竞赛或竞赛规则的权利。`,
      `如果您在报名期间持有仓位，并且在未平仓的情况下参加完竞赛，则将从该仓位100％平仓之后计算ROE和交易量。`,
      `奖金将平均分配给获胜团队的成员。`,
      `加入团队需要获得团队领导的批准。`,
     ` 您最多只能加入一个团队。`,
      `当您进入团队时，您的用户ID将显示给团队领导。`,
      `交易排行榜将显示即时的队伍数量和比赛后最终确定的队伍数量。`,
      `如果确认的参赛队数量少于10个，则即使在此期间不会进行比赛，也不会建立比赛。`,
      `如果比赛期间的佣金收入低于总奖金，则比赛期间净佣金收入的70％将是总奖金的上限。`]
    },
    cancel:{
      tit:'关于取消參賽的規則',
      list:[`如果您在报名期间持有仓位，并且比赛前保证金低于0.05 BTC，您的参赛将被取消。（可再次重新报名参赛）`, 
        `如果您在比赛期间完全不进行交易，则您的参赛资格将被取消。`,
        `比赛期间未达到最低交易量的队伍将被取消参赛。`
        ]
    }
  },
  license: {
    legal:"法律及担保文件",
    license_tit: "概况",
    license_footer:'许可证',
    license_subtit: `Demo交易所依据每个国家的法律运作。 在某些国家/地区，可能受到法律的限制。
    请在完全了解您所在国家/地区的法律之后，再行使用。<br />
    Demo US CO.,LTD在美国财政部金融犯罪执法网络（FinCEN）上已注册了货币服务业务（MSB），并在下列的美国辖区获得了货币服务业务的许可。某些州的居民可能对我们服务拥有询问或投诉相关的权利，您可以在下面的州中进行查看。您还可以通过单击下面的许可证类型和编号来查看每个州许可证。<br />
    如有任何疑问，请通过<span>contact@Demo.com</span>与我们联系。
    `,
    certificate_tit:'许可证',
    fincen: 'FinGEN'
  },
  "account.otp.back": "Previous",
  "account.otp.backup_text3": "This Key will allow you to recover your Authenticator in case you lost your phone. Otherwise, resetting Google Authenticator will take at least 7 days.",
  "account.otp.backup_title": "Backup Key",
  "account.otp.enable_des": "Google Authenticator",
  "account.otp.enable_title": "Enable Google Authentication",
  "account.otp.install_gg_authen": "Download and install the Authenticator app",
  "account.otp.scan_qrcode": "Scan this QR code in the Authenticator app",
  "account.otp.save_key": "Save this Backup Key in a secure location",
  "account.otp.install_title": "Download App",
  "account.otp.next": "Next",
  "account.otp.qr_text":"If you are unable to scan the QR code, please enter this code manually into the app.",
  "account.otp.qt_title": "Scan QR Code",
  "account.text_install_gg_authen": "To begin, you will need to install an <span class='text-gg'>Google Authenticator</span> application.",
  "change_password_form.palaceholder_new_password": "Please enter the new password",
  "change_password_form.palaceholder_old_password": "Please enter the old password",
  "change_password_form.confirm_new_password": "Confirm New Password",
  "change_password_form.palaceholder_confirm_new_password": "Please confirm the new password again",
  "change_password_form.palaceholder_authen_code" : "Google Authentication Code",
  "landing.market.title": "Markets",
   "landing.title_volume" : "Top Volume Coin",
  "landing.title_listing" : "New Listing",
  "landing.title_gainer": "Top Gainer Coin",
  "landing.title_loser": "Top Loser Coin",
  "landing.spot.title": "Spot",
  "landing.future.title": "Futures",
  sidebar:{
    open_order:"Open Orders",
    order_history:"Order History",
    trade_history:"Trade History"
  },
  "account.estimate_note": "Please note that the estimated balance is calculated by converting the total assets of your account into BTC, not the amount of BTC you hold",
  "account.level": "Account Level",
  "change_password_form.new_password_error": "Password must be at least 8 characters with uppercase, lowercase letter and number",
  "account.identity.errors.required": "This field is required",
  "change_password_form.error_confirm": "The confirm password confirmation does not match",
  "account.email.required": "Please enter a correct email address",

  about: {
    title: "Welcome to MONAS",
    sub_title: "The beginning of the finance, with Sotatek",
    information: "MONAS is a cryptocurrency exchange established in 2023 with the goal of being the first exchange to be operated more fairly and transparently than anyone else with a name that means number 1 and first in Greek.\n\n Anyone can easily and conveniently experience cryptocurrency, such as spot, futures, and various derivatives markets (Staking, Saving, Lending), and block chain by allowing cryptocurrency to be recognized as a stable alternative investment rather than a risky investment method. We have a grand vision to develop and be recognized as a virtual asset industry and one finance.\n\n We aim to become an exchange that is faithful to the basics by harmonizing the rapidly changing virtual currency market and the blockchain industry. The basics defined by MONAS will be the first step and leap to transparently show all our values, such as user experience and interface, excellent security, prompt response and communication, various benefits enjoyed equally by everyone, and convenient accessibility.",
    title_vision: "Our Vision",
    sub_title_vision: "The world's leading global cryptocurrency exchange.",
    information_vision: "In the fast-changing financial market, we want to lead transparent and innovative changes so that cryptocurrency can be recognized as one of finance and become a stable investment destination.",
    title_mission: "Our Mission",
    information_mission: "By providing the best infrastructure and technology, we create a cryptocurrency market where anyone can freely and equally trade cryptocurrency anywhere in the world.",
    title_transparency: "Transparency",
    title_stable: "Stable & Secure",
    title_convenient: "Convenient",
    title_value: "Our Value",
    title_reasons: "Reasons to choose MONAS",
    title_security: "Top-notch security system",
    des_security: "By introducing a powerful security solution, we keep our customers' assets safe through 24/7 monitoring.",
    title_ratio: "100% reserve ratio",
    des_ratio: "Store cryptocurrency in hot and cold wallets to maintain 100% reserve ratio at all times.",
    title_smart: "Smart and intuitive platform",
    des_smart: "Store cryptocurrency in hot and cold wallets to maintain 100% reserve ratio at all times.",
    title_customer: "24/7 customer center operation",
    des_customer: "By introducing a powerful security solution, we keep our customers' assets safe through 24/7 monitoring.",
  },
  policy: {
    title: "Privacy Policy",
    text_bold_1: "Dear Sotatek users:",
    sub: "Please read the Privacy Policy carefully.",
    text_bold_2: "Parties",
    list_policy: {
      parties_1: "Sotatek operates the Website https://www.monas.exchange (hereinafter referred to as 'this Website' or 'the Website'), which is a platform dedicated to the transaction of digital assets and the provision of related services (hereinafter referred to as 'the Service'). For the convenience of wording in this Agreement, the Company and the Website are referred to collectively as 'we' or other applicable forms of first person pronouns in this Agreement." ,
      parties_2: "All natural persons or other subjects who log onto this Website shall be users of this Website. For the convenience of wording in this Agreement, the users are referred to as 'you' or any other applicable forms of the second-person pronouns.",
      parties_3: "For the convenience of wording in this Agreement, you and we are collectively referred to as “both parties”, and individually as “one party”."
    },
    text_bold_3: "Purposes of the Privacy Policy",
    list_purposes: "The Privacy Policy stipulates the types of information of yours that we may collect through your log into this Website, your registration with this Website, and/or use the services we offer, as well as how we shall use and protect the information so collected.",
    text_bold_4: "Your consent",
    list_consent: {
      consent_1: "To ensure that you have full confidence in our handling of personal data, you are advised to read and understand the terms of this Privacy Policy in detail. In particular, upon your log into our Website, regardless of whether you register with this Website, you shall be deemed to accept, agree, undertake and confirm that:",
      consent_2: "You, on the basis of your own free will and your requisite consent, agree to disclose your personal information to us;",
      consent_3: "You will comply with all the terms and limitations of this Privacy Policy;",
      consent_4: "You agree that we may collect your information through your log into this Website, your registration with this Website, and/or your using the Services offered by us; you agree to any changes and modifications that we may make to our Privacy Policy in the future;",
      consent_5: "You agree that our branches, affiliates and employees may contact you in connection with the products and services that you may be interested in (unless you have indicated that you do not want to receive such information).",
    },
    text_bold_5: "Information Collected",
    list_collect: {
      collect_1: "When you use this Website, you agree to permit us to use cookies to track each of your actions and collect and keep all the information that you leave on this Website, including but not limited to your IP address, location, and other information.",
      collect_2: "If you are willing to use the services offered by this Website, you will be required to fill in and provide the following two categories of information:",
      collect_3: "Identity Information：Such information can help us verify whether you are eligible to be registered as a member of this Website. It includes but is not limited to your name, residence address, mailing address, other certificates and corresponding numbers thereof that are issued by your country or government to certify your identity information, as well as all other information that can help us to verify your identity (hereinafter referred to as 'identity information').",
      collect_4: "Service information. Such information helps us to contact you and provide you with the services, including but not limited to your phone number, fax number, valid email address, mailing address, and information concerning your debit card and/or other accounts (hereinafter collectively referred to as 'service information').",
      collect_5: "When you use this Website or the services this Website offers, we may collect more information necessary from our exclusive mailboxes or in other manners that we consider as in compliance with relevant requirements, for the purpose of improving the functions of this Website, enhancing your experience of using this Website and its services as well as the security thereof, or as is required by any court order, any applicable law, administrative regulation or any order of any other competent government agency.",
      collect_6: "If you visit any of links to third-party websites as are listed on this Website or any link of any of our third-party partners, you shall agree to and comply with the separate and independent Privacy Policy of such third party website. We will not bear any liability for the contents and activities of such websites or the partners.",
    },
    text_bold_6: "Cookies",
    list_cookies: {
      cookies_1: "When you visit our Website, we use Google stats via cookies to record our performance and check the effect of online advertising. Cookies are a small amount of data that is sent to your browser and stored on your computer hard drive. Only when you use your computer to access our Website can the cookies be sent to your computer hard drive.",
      cookies_2: "Cookies are usually used to record the habits and preferences of visitors in browsing the items on our Website. The information collected by cookies is non-registered and collective statistical data and does not involve personal data.",
      cookies_3: "Cookies, which enable the Website or service provider system to recognize your browser and capture and recall information, cannot be used to obtain data on your hard drive, your email address, or your personal data. Most browsers are designed to accept cookies. You can opt to set your browser to reject cookies, or to notify you as soon as possible if you are loaded on cookies. However, if you set your browser to disable cookies, it is possible that you may not be able to launch or use some functions of our Website.",
    }
  },
  terms: {
    title_terms: 'Terms of Use',
    sub: "Please read the Terms of Use carefully.",
    des: "Sotatek exchange (hereinafter referred to as 'the Company') is a company incorporated in Cayman Islands under the laws of Cayman Islands. It is a platform for users to conduct digital asset transactions and provide related services (hereinafter referred to as 'the service' or 'service'). The company operates the website https://www.monas.exchange (hereinafter referred to as 'this website') Or 'website'). For the convenience of this Agreement, the Company and the Website collectively use 'we' or other first-person names in this Agreement. As long as the natural person or other subject who visits the website is a user of this website, the convenience of this agreement is as follows, using 'you' or other second person. For the convenience of this Agreement, we and you are collectively referred to as “the parties” in this Agreement, and we or you are referred to as the “Party”. All contents of this website are for the convenience of users and may be available in multiple languages. In case of conflict or omission, the English content shall prevail.",
    terms_bold_1: "Important reminder",
    sub_1: "We hereby remind you that:",
    list_reminder: {
      reminder_1: "The digital assets themselves are not offered by any financial institution, corporation or this Website;",
      reminder_2: "The digital asset market is new and unconfirmed, and will not necessarily expand;",
      reminder_3: "Digital assets are primarily used by speculators, and are used relatively less on retail and commercial markets; digital asset transactions are highly risky, due to the fact that they are traded throughout the day without limits on the rise or fall in price, and market makers and global government policies may cause major fluctuations in their prices;",
      reminder_4: "The Company may suspend or terminate your account or use of the Service, or the processing of any digital asset transaction, at any time if it determines in its sole discretion that you have violated this Agreement or that its provision or your use of the Service in your jurisdiction is unlawful.",
    },
    para_1: "Digital assets trading is highly risky and therefore not suitable for the vast majority of people. You acknowledge and understand that investment in digital assets may result in partial or total loss of your investment and therefore you are advised to decide the amount of your investment on the basis of your loss-bearing capacity. You acknowledge and understand that digital assets may generate derivative risks. Therefore, if you have any doubt, you are advised to seek assistance from a financial adviser first. Furthermore, aside from the above-mentioned risks, there may also be unpredictable risks. Therefore, you are advised to carefully consider and use clear judgment to assess your financial position and the abovementioned risks before making any decisions on buying and selling digital assets; any and all losses arising therefrom will be borne by you and we shall not be held liable in any manner whatsoever.",
    sub_2: "You are hereby informed that:",
    list_inform: {
      inform_1: "You understand that this Website is only intended to serve as a venue for you to obtain digital asset information, find trading counterparties, hold negotiations on and effect transactions of digital assets. This Website does not participate in any of your transactions, and therefore you shall, at your sole discretion, carefully assess the authenticity, legality and validity of relevant digital assets and/or information, and solely bear the responsibilities and losses that may arise therefrom.",
      inform_2: "All opinions, information, discussions, analyses, prices, advice and other information on this Website are general market reviews and do not constitute any investment advice. We do not bear any loss arising directly or indirectly from reliance on the abovementioned information, including but not limited to, any loss of profits.",
      inform_3: "The content of this Website may be changed from time to time and at any time without notice, and we have taken reasonable measures to ensure the accuracy of the information on the Website; however, we do not and cannot guarantee the degree of such accuracy, or bear any loss arising directly or indirectly from the information on this Website or from any delay or failure caused by failure to link up with the internet, transmit or receive any notice and information.",
      inform_4: "Using internet-based trading systems also involves risks, including but not limited to failures in software, hardware or Internet links, etc. In view of the fact that we cannot control the reliability and availability of the Internet, we will not be responsible for any distortion, delay and link failure.",
      inform_5: "Sotatek.exchange ,is theonly official external information release platform for monas;",
      inform_6: "No service on this Website may be paid for by credit card;",
      inform_7: "It is prohibited to use this Website to engage in any illegal transaction activities, such as money laundering, smuggling and commercial bribery. In the event that any of such activities is uncovered, this Website will adopt all available measures, including but not limited to freezing the offender’s account, notifying relevant authorities, etc., and we will not assume any of the responsibilities arising therefrom and reserve the right to hold relevant persons accountable;",
      inform_8: "It is prohibited to use this Website for the purpose of malicious manipulation of the market, improper transactions or any other illicit trading activities. Where any of such illicit trading activities is uncovered, this Website will adopt such preventive and protective measures as warning, restricting trading and closing accounts against any and all such malicious manipulation of prices, maliciously influencing the trading system and any otherillicit behaviour; we do not assume any of the responsibilities arising therefrom and reserve the right to hold relevant persons accountable.",
    },
    terms_bold_2: "General Provisions",
    list_general: {
      general_1: "The User Agreement (hereinafter referred to as 'this Agreement' or 'these terms and conditions') consists of the main body, Terms of Privacy, Understanding Your client and Anti-money-laundering Policy, as well as any rules, statements, instructions, etc. that this Website has published or may publish in the future.",
      general_2: "Before using the services offered by this Website, you shall read this Agreement carefully, and consult a professional lawyer if you have any doubt or as may be otherwise necessary. If you do not agree to the terms and conditions of this Agreement and/or any change made thereto from time to time and at any time, please immediately stop using the service provided by this Website or stop logging onto this Website. Upon your logging into this Website or using any service offered by this Website or engaging in any other similar activity, it shall be deemed as having understood and fully agreeing to all terms and conditions of this Agreement, including any and all changes, modifications or alterations that this Website may make to this Agreement from time to time and at any time.",
      general_3: "After filling in the relevant information in accordance with the requirements of this Website, and going through other relevant procedures, you will successfully register yourself as a member of this Website (hereinafter referred to as 'Member'); in the process of registration, if you click on the 'I Agree', it shall be deemed that you have reached an agreement with the Company by way of electronic signature; or when you use this Website, you click on the “I Agree” button or a similar button, or if you use the services offered by this Website in any of the ways allowed by this Website, it shall be deemed that you fully understand, agree to and accept all the terms and conditions under this Agreement, and in this case, the absence of your handwritten signature will not affect the legal binding force that this Agreement may have on you.",
      general_4: "After you become a member of this Website, you will receive a member account and corresponding password, which shall be properly kept by you as a member of this Website; Members shall be liable for all activities and events carried out through their accounts",
      general_5: "You cannot engage in trading on the digital asset trading platform provided by this Website and gain access to the services that are exclusively available to members in accordance with the rules and regulations of this Website, unless and until you become a member of this Website; if you are not a member of this Website, you can only longin to browse the Website and have access to other services as are permitted by the rules and regulations of this Website.",
      general_6: "Upon registering yourself as a member of this Website and using any of the services and functions offered by this Website, it shall be deemed that you have read, understood this Agreement, and:",
      general_7: "1) Accepted to be bound by all terms and conditions of this Agreement;",
      general_8: "2) You confirm that you have attained the age of 18, or another statutory age for entering into contracts as is required by a different applicable law, and your registration with this Website, purchase or sale via this Website, release information on this Website and other behaviours indicating your acceptance of the Services offered by this Website shall comply with the relevant laws and regulations of the sovereign state or region that has jurisdiction over you, and you confirm having sufficient capacity to accept these terms and conditions, enter into transactions and to use this Website for digital asset transactions.",
      general_9: "3) You undertake that all your digital assets involved in transactions hereunder are legally acquired and owned by you.",
      general_10: "4) You agree to undertake any and all liabilities for your own transaction and non-transaction activities as well as any and all profits and losses therefrom.",
      general_11: "5) You confirm that the information provided at the time of registration is true and accurate.",
      general_12: "6) You agree to comply with any and all relevant laws, including the reporting of any transaction profits for tax purposes.",
      general_13: "7) This Agreement is only binding on the rights and obligations between you and us, and does not involve legal relations and legal disputes arising from and relating to the transaction of digital assets between the users of this Website, and between other websites and you.",
    },
    sub_3: "Amendment of this Agreement",
    sub_4: "We reserve the right to amend this Agreement from time to time, and disclose such amendment by way of announcement on the Website without sending a separate notice to you on your rights. The date when the amendment is made will be indicated on the first page of the amended agreement. The amended agreement will take effect immediately upon announcement on the Website. You shall browse this Website from time to time and follow information on the time and content of amendments, if any, made to this Agreement. If you do not agree with the amendments, you shall stop using the services offered by this Website immediately; if you continue to use the services offered by this Website, it shall be deemed that you accept and agree to be bound by the amended agreement.",
    sub_5: "Registration",
    terms_bold_3: "Eligibility for Registration",
    sub_6: "You confirm and promise that: you shall be a natural person, legal person or other organization with the ability to sign this Agreement and the ability to use the services of this Website, as is provided by applicable laws, when you complete the registration process or when you use the services offered by this Website in any other manner as is otherwise permitted by this Website. Upon clicking on the button indicating that you agree to register, it shall be deemed that you yourself or your authorized agent agrees to the content of this Agreement and your authorized agent will register with this Website and use the services offered by this Website on your behalf. If you are not a natural person, legal person or organization with the abovementioned ability, you and your authorized agent shall bear all the consequences of that, and the company reserves the right to cancel or permanently freeze your account and to hold you and your authorized agent accountable.",
    sub_7: "Meanwhile, by accessing and using the services, you represent and warrant that you are not on FATF (Financial Action Task Force) list, or OFAC (Office of Foreign Assets Control of the U.S. Treasury Department) designated “Specially Designated National” list or any other trade or economic sanctions lists, such as the UN Security Council Sanctions list. We maintain the right to select its markets and jurisdictions to operate and may restrict or deny the Services in certain countries at its discretion.",
    terms_bold_4: "Purpose of Registration",
    sub_8: "You confirm and promise that you do not register with this Website for the purpose of violating any of the applicable laws or regulations or undermining the order of digital asset transactions on this Website.",
    terms_bold_5: "Registration Process",
    list_process: {
      process_1: "You agree to provide a valid email address, a mobile phone number and other information in accordance with the requirements on the user registration page of this Website. You can use the email address, mobile phone number or any other manner permitted by this Website to log in to this Website. Where it is necessary and in accordance with the requirements of applicable laws and regulations of relevant jurisdictions, you shall provide your real name, identity card and other information required by applicable laws, regulations, the Terms of Privacy, and anti-money-laundering terms, and constantly update your registration data so that they will be timely, detailed and accurate as is required. All of the original typed data will be referenced as registration information. You shall be responsible for the authenticity, integrity and accuracy of such information and bear any direct or indirect loss and adverse consequences arising out of it.",
      process_2: "If any of the applicable laws, regulations, rules, orders and other regulatory documents of the sovereign country or region in which you are based requires that mobile phone accounts must be based on real names, you hereby confirm that the mobile phone number you provide for registration purposes has gone through the real-name registration procedure. If you cannot provide such a mobile phone number as is required, any direct or indirect losses and adverse consequences arising therefrom and affecting you shall be borne by you.",
      process_3: "After you provide the required registration information in a legal, complete and valid manner and such information passes relevant verification, you shall have the right to obtain an account and a password of this Website. Upon obtaining such account and password, your registration shall be deemed as successful and you can log into this Website as a member thereof.",
      process_4: "You agree to receive emails and/or short messages sent by this Website related to the management and operation thereof.",
      process_5: "You acknowledge and understand that you will be required to provide further materials and information for merchant registration if you want to become a verified merchant by us after you complete your registration of general users. The further materials and information we may ask for include but not limited to your telephone number, WeChat account, telegram account, proof of revenue, previous experience of dealing on this Website or in any other OTC exchanges, risk control strategies and other information and materials that we consider necessary to be provided and the applicable laws may require. Also, to register as a verified merchant, a part of digital assets will be locked in your OTC account as a security deposit to safeguard the security of transactions you involve in and you are unable to transfer and withdraw during your transactions. You acknowledge and agree that if you, as a verified merchant, are proved to be liable for any damages, losses, and any other payments during any transactions but you refuse to pay, we may process your security deposit to cover any third parties’ damages, losses, and any other payments you should have paid subject to applicable laws. After you complete the registration of the verified merchant, we will provide you with the verified merchant logo so as to distinguish from other users who do not complete the registration of verified merchants. You may submit a cancellation application to this Website to cancel your verification, and then this Website will proceed your application within 3 business days and unlock your security deposit if there are no any records of pending disputes with any third parties or previous negative records.",
    },
    sub_9: "Services",
    sub_10: "This Website only provides online transaction platform services for you to engage in digital asset trading activities through this Website (including but not limited to the digital asset transactions etc.). This Website does not participate in the transaction of digital assets as a buyer or seller; This Website does not provide any services relating to the replenishment and withdrawal of the legal currency of any country.",
    sub_11: "Content of Services",
    sub_12: "1) You have the right to browse the real-time quotes and transaction information of digital asset products on this Website, to submit digital asset transaction instructions and to complete the digital asset transaction through this Website.",
    sub_13: "2) You have the right to view information under the member accounts on this Website and to apply the functions provided by this Website.",
    sub_14: "3) You have the right to participate in the website activities organized by this Website in accordance with the rules of activities posted on this Website.",
    sub_15: "4) Other services that this Website promises to offer to you.",
    sub_16: "Service Rules",
    sub_17: "You undertake to comply with the following service rules of this Website:",
    sub_18: "You shall comply with the provisions of applicable laws, regulations, rules, and policy requirements, and ensure the legality of the source of all digital assets in your account, and shall refrain from engaging in any illegal activities or other activities that damages the rights and interests of this Website or any third party, such as sending or receiving information that is illegal, illicit or infringes on the rights and interests of any other person, sending or receiving pyramid scheme information or information or remarks causing other harms, unauthorized use or falsification of the email header information of this Website, inter alia.",
    sub_19: "You shall comply with applicable laws and regulations and properly use and keep your account in this Website and login password, password of your financial transactions, and the mobile phone number bound with your account that you provide upon registration of your account, as well as the security of the verification codes received via your mobile phone. You shall be solely responsible for any and all your operations carried out using your account with this Website and login password, financial transaction password, verification codes sent to your mobile phone, as well as all consequences of such operations. When you find that your account with this Website, your login password, financial transaction password, or mobile phone verification codes is used by any unauthorized third party, uncover any other problem relating to the security of your account, you shall inform this Website in a prompt and effective manner, and request this Website to temporarily suspend the services to your account with this Website. This Website shall have the right to take action on your request within a reasonable time; nonetheless, this Website does not bear any liability for the consequences that have arisen before such action is taken, including but not limited to any loss that you may sustain. You may not assign your account with this Website to any other person by way of donation, lending, leasing, transfer or otherwise without the consent of this Website.",
    sub_20: "You agree to take responsibility for all activities (including but not limited to information disclosure, information release, online click-approving or submission of various agreements on rules, online renewal of agreements or purchase service) using your account and password with this Website.",
    sub_21: "In your digital asset transactions on this Website, you may not maliciously interfere with the normal proceeding of the digital asset transaction or disrupt the transaction order; you may not use any technical means or other means to interfere with the normal operation of this Website or interfere with the other users’ use of the services; you may not maliciously defame the business goodwill of this Website on the ground of falsified fact.",
    sub_22: "If any dispute arises between you and any other user in connection with online transaction, you may not resort to any means other than judicial or governmental means to request this Website to provide relevant information.",
    sub_23: "All taxes payable as well as all fees relating to hardware, software and services that are incurred by you in the course of using the services provided by this Website shall be solely borne by you.",
    sub_24: "You shall abide by this Agreement and other terms of service and operating rules that this Website may release from time to time, and you have the right to terminate your use of the services provided by this Website at any time.",
    sub_25: "Product Rules",
    sub_26: "1) Rules for trading products",
    sub_27: "You undertake that in the process in which you log into this Website and engage in transactions with other users through this Website, you will properly comply with the following transaction rules.",
    sub_28: "All taxes payable as well as all fees relating to hardware, software and services that are incurred by you in the course of using the services provided by this Website shall be solely borne by you.",
    sub_29: "You shall abide by this Agreement and other terms of service and operating rules that this Website may release from time to time, and you have the right to terminate your use of the services provided by this Website at any time.",
    sub_30: "When you browse the transaction information on this Website, you should carefully read all the content in the transaction information, including but not limited to the price, consignment, handling fee, buying or selling direction, and you shall accept all the contents contained in the transaction information before you may click on the button to proceed with the transaction.",
    sub_31: "Browsing transaction information",
    sub_32: "Submission of Commission",
    sub_33: "After browsing and verifying the transaction information, you may submit your transaction commissions. After you submit the transaction commission, it shall be deemed that you authorize this Website to broker you for the corresponding transactions, and this Website will automatically complete the matchmaking operation when there is a transaction proposal that meets your price quotation, without prior notice to you.",
    regis_18: "Accessing transaction details",
    regis_18_1: "You can check the corresponding transaction records in the transaction statements by the Management Center, and confirm your own detailed transaction records.",
    regis_19: "Revoking/modifying transaction commission. You have the right to revoke or modify your transaction commission at any time before the transaction is concluded.",
    regis_20: "Rights and Obligations of this Website",
    regis_20_1: "If you do not have the registration qualifications agreed on in this Agreement, this Website shall have the right to refuse to allow you to register; if you have already registered, this Website shall have the right to revoke your member account, and this Website reserves the right to hold you or your authorized agent accountable. Furthermore, this Website reserves the right to decide whether to accept your application for registration under any other circumstances.",
    regis_21: "When this Website finds out that the user of an Account is not the initial registrant of that Account, it shall have the right to suspend or terminate the user’s access to that Account.",
    regis_22: "Where by means of technical testing or manual sampling, among others, this Website reasonably suspects that the information you provide is wrong, untrue, invalid or incomplete, this Website shall have the right to notify you to correct or update the information, or suspend or terminate its supply of the services to you.",
    regis_23: "This Website shall have the right to correct any information displayed on this Website when it uncovers any obvious error in such information.",
    regis_24: "This Website reserves the right to modify, suspend or terminate the Services offered by this Website, at any time, and the right to modify or suspend the Service without prior notice to you; if this Website terminates one or more of the Services offered by this Website, such termination by this Website will take effect on the date of announcement of such termination on the Website.",
    regis_25: "This Website shall take necessary technical means and management measures to ensure the normal operation of this Website, and shall provide a necessary and reliable trading environment and transaction services, and shall maintain the order of digital assets trading.",
    regis_26: "If you fail to log into this Website using your member account number and password for an uninterrupted period of one year, this Website shall have the right to revoke your account. After your account is revoked, this Website shall have the right to offer the member name represented by such account to other applicants for membership.",
    regis_27: "This Website shall ensure the security of your digital assets by strengthening technical input and enhancing security precautions, and is under the obligation to notify you in advance of the foreseeable security risks in your account.",
    regis_28: "This Website shall have the right to delete all kinds of content and information which does not conform to laws and regulations or the rules of this Website at any time, and exercise of this right by this Website is not subject to a prior notice to you.",
    regis_29: "This Website shall have the right to, in accordance with the applicable laws, administrative regulations, rules, orders and other regulatory documents of the sovereign country or region where you are based, request to you for more information or data, and to take reasonable measures to meet the requirements of the local standards, and you have the obligation to provide proper assistance to such measures; this Website shall have the right to suspend or permanently terminate your access to this Website as well as part or all of the services offered by this Website.",
    regis_imde: "Indemnity",
    regis_30: "Under any circumstance, our liability for your direct damage will not exceed the total cost incurred by your three (3) months’ use of services offered by this Website.",
    regis_31: "Shall you breach this Agreement or any applicable law or administrative regulation, you shall pay to us at least US$ Two million in compensation and bear all the expenses in connection with such breach (including attorney's fees, among others). If such compensation cannot cover the actual loss, you shall make up for the difference.",
    terms_bold_7: "The Right to Injunctive Relief",
    sub_34: "Both you and we acknowledge that common law remedies for breach of agreement or possible breach of contract may be insufficient to cover all the losses that we sustain; therefore, in the event of a breach of contract or a possible breach of contract, the non-breaching party shall have the right to seek injunctive relief as well as all other remedies that are permitted under common law or equity.",
    terms_bold_8: "Limitation and Exemption of Liability",
    limitation_1: "You understand and agree that under no circumstance will we be held liable for any of the following events:",
    limitation_1_1: "Loss of income",
    limitation_1_2: "Loss of transaction profits or contractual losses",
    limitation_1_3: "Disruption of the business",
    limitation_1_4: "Loss of expected currency losses",
    limitation_1_5: "Loss of information",
    limitation_1_6: "Loss of opportunity, damage to goodwill or reputation",
    limitation_1_7: "Damage or loss of data",
    limitation_1_8: "Cost of purchasing alternative products or services",
    limitation_1_9: "Any indirect, special or incidental loss or damage arising from any infringement (including negligence), breach of contract or any other cause, regardless of whether or not such loss or damage may reasonably be foreseen by us, and regardless of whether or not we are notified in advance of the possibility of such loss or damage.",
    limitation_1_10: "Items 8.1.1 to 8.1.9 are independent of each other.",
    limitation_2: "You understand and agree that we shall not be held liable for any damages caused by any of the following events:",
    limitation_2_1: "Where we are properly justified in believing that your specific transactions may involve any serious violation or breach of law or agreement",
    limitation_2_2: "Where we are reasonably justified in believing that your conduct on this Website is suspected of being illegal or immoral",
    limitation_2_3: "The expenses and losses arising from the purchase or acquisition of any data, information or transaction, etc. through the services offered by this Website",
    limitation_2_4: "Your misunderstanding of the Services offered by this Website",
    limitation_2_5: "Any other losses related to the services provided by this Website, which cannot be attributed to us",
    limitation_3: "Where we fail to provide the Services or delay in providing such Services due to information network equipment maintenance, information network connectivity failures, errors in computer, communications or other systems, power failures, weather conditions, unexpected accidents, industrial actions, labour disputes, revolts, uprisings, riots, lack of productivity or production materials, fires, floods, storms, explosions, wars, failure on the part of banks or other partners, collapse of the digital asset market, actions by government, judicial or administrative authorities, other acts that are not within our control or beyond our inability to control, or due to causes on the part of third parties, we shall not assume any responsibility for such failure to provide service or delay in providing services, or for the resultant loss you may sustain as a result of such failure or delay.",
    limitation_4: "We cannot guarantee that all the information, programs, texts, etc. contained in this Website are completely safe, free from the interference and destruction by any malicious programs such as viruses, trojans, etc., therefore, your log-into this Website or use of any services offered by this Website, download of any program, information and data from this Website and your use thereof are your personal decisions and therefore you shall bear the any and all risks and losses that may possibly arise.",
    limitation_5: "We do not make any warranties and commitments in connection with any of the information, products and business of any third party websites linked to this Website, as well as any other forms of content that do not belong to us; your use any of the services, information, and products provided by a third party website is your personal decision and therefore you shall assume any and all the responsibilities arising therefrom.",
    limitation_6: "We do not make any explicit or implicit warranties regarding your use of the Services offered by this Website, including but not limited to the applicability, freedom from error or omission, consistency, accuracy, reliability, and applicability to a specific purpose, of the services provided by this Website. Furthermore, we do not make any commitment or guarantee in connection with the validity, accuracy, correctness, reliability, quality, stability, integrity and timeliness of the technology and information covered by the services offered by this Website. Whether to log in this Website or use the services provided by this Website is your personal decision and therefore you shall bear all the risks and possible losses arising from such decision. We do not make any explicit or implicit warranties in connection with the market, value and price of digital assets; you understand and acknowledge that the digital asset market is unstable, that the price and value of assets may fluctuate or collapse at any time, and that the transaction of digital assets is based on your personal free will and decision and therefore you shall assume any and all risks and losses that may possible arise therefrom.",
    limitation_7: "The guarantees and undertakings specified in this Agreement shall be the only guarantee and statements that we make in connection with the Services provided by us under this Agreement and through this Website, and shall supersede any and all the warranties and commitments arising in any other way and manner, whether in writing or in words, express or implied. All these guarantees and statements represent only our own commitments and undertakings and do not guarantee any third party's compliance with the guarantees and commitments contained in this Agreement.",
    limitation_8: "We do not waive any of the rights not mentioned in this Agreement and to the maximum extent permitted by the applicable law, to limit, exempt or offset our liability for damages.",
    limitation_9: "Upon your registration of your account with this Website, it shall be deemed that you approve any and all operations performed by us in accordance with the rules set forth in this Agreement, and any and all risks arising from such operations shall be assumed by you.",
    sub_35: "Termination of Agreement",
    limitation_10: "This Website shall have the right to cancel your account with this Website in accordance with this Agreement, and this Agreement shall be terminated on the date of the cancellation of your account.",
    limitation_11: "This Website shall have the right to terminate all Service offered by this Website to you in accordance with this Agreement, and this Agreement shall terminate on the date of termination of all services offered by this Website to you.",
    limitation_12: "After the termination of this Agreement, you do not have the right to require this Website to continue to provide you with any service or perform any other obligation, including, but not limited to, requesting this Website to keep or disclose to you any information in your former original account, or to forward to you or any third party any information therein that is not read or sent.",
    limitation_13: "The termination of this Agreement shall not prevent the observant party from demanding the breaching party to assume other liabilities.",
    sub_36: "Intellectual Property",
    limitation_14: "All intellectual achievements included in this Website, including, but not limited to, website logos, databases, website design, text and graphics, software, photos, videos, music, sounds and any combinations of the aforementioned files, and the intellectual property rights of software compilation, associated source code and software (including small applications and scripts) shall be owned by this Website. You may not copy, modify, transmit or use any of the foregoing materials or content for commercial purposes.",
    limitation_15: "All rights contained in the name of this Website (including but not limited to business goodwill and trademarks, logos) shall be owned by the Company.",
    limitation_16: "Upon accepting this Agreement, it shall be deemed that you, on the basis of your own free will, have transferred and assigned exclusively and free of charge to this Website all copyright of any form of information that you publish on this Website, including, but not limited to copyrights, distribution rights, lease rights, exhibition rights, performance rights, projection rights, broadcasting rights, information network dissemination rights, shooting rights, adaptation rights, translation rights, compilation rights and other transferable rights that copyright owners are entitled to, and this Website shall have the right to sue for any infringement on such copyright and obtain full compensation for such infringement. This Agreement shall apply to any content that is published by you on this Website and is protected by copyright law, regardless of whether the content is generated before or after the signing of this Agreement.",
    limitation_17: "You shall not illegally use or dispose of the intellectual property rights of this Website or any other person during your use of the services offered by this Website. For any information that you publish on this Website, you may not publish or authorize other websites (or media) to use such information in any manner whatsoever.",
    limitation_18: "Your log into this Website or use of any of the services offered by this Website shall not be deemed as our transfer of any intellectual property to you.",
    terms_bold_9: "Calculation",
    des_calculation: "All the transaction calculations are verified by us, and all the calculation methods have been posted on the Website, but we cannot ensure that your use of this Website will not be disturbed or free from errors.",
    terms_bold_10: "Export Control",
    des_control: "You understand and acknowledge that in accordance with relevant laws, you shall not export, re-export, import or transfer any material (including software) on this Website; therefore, you hereby undertake that you will not voluntarily commit or assist or participate in any of the above export or related transfer or other violations of applicable laws and regulations; if you uncover any of the aforementioned events, you will report to us and assist us in handling them.",
    terms_bold_11: "Transfer",
    des_trasfer: "The rights and obligations agreed in this Agreement shall be equally binding on the assignees, the heirs, executors and administrators of the parties hereto who benefit from the rights and obligations. Without our consent, you may not transfer to any third party any of your rights or obligations hereunder, provided, however, we may, at any time, assign our rights and obligations under this Agreement to any third party with thirty (30) days' notice to you.",
    terms_bold_12: "Severability",
    des_severability: "If any provision of this Agreement is found unenforceable, invalid or illegal by any court of competent jurisdiction, validity of the remaining provisions of this Agreement shall not be affected.",
    terms_bold_13: "No Agency",
    des_agency: "Nothing in this Agreement shall be deemed to have created, implied or otherwise treated us as your agent, trustee or other representative, unless it is provided otherwise in this Agreement.",
    terms_bold_14: "Waiver",
    des_waiver: "Our or your waiver of the right to hold the other party liable for breaches of agreement or any other liability as is agreed upon in this Agreement shall not be construed or deemed as a waiver of the right to hold the other party for other breaches of contract; a failure to exercise any right or remedy shall not be construed in any way as a waiver of such right or remedy.",
    terms_bold_15: "Headings",
    des_headings: "All headings herein are exclusively for the convenience of wording and are not intended to expand or limit the content or scope of the terms and conditions of this Agreement.",
    terms_bold_16: "Entry into Force and Interpretation of the Agreement",
    entry_1: "This Agreement shall enter into force when you click through the registration page of this Website, complete the registration procedures, obtain your account number and password of this Website, and shall be binding on you and this Website.",
    entry_2: "The ultimate power of interpretation of this Agreement shall be vested in this Website.",
    entry_3: "Our assets are 100% sufficient and backed up. We will not use any asset to earn any type of interest.",

  },
  title_balance: "Estimated Balance",
  "validate.format.password_1": "Minimum 8 characters",
  "validate.format.password_2": "At least 1 number",
  "validate.format.password_3": "At least 1 upper case",
  "validate.format.password_4": "At least 1 lower case",
  "validate.format.password_5": "At least 1 special character",
  sidebar_spot_order: "Spot Order",
  sidebar_futures_order: "Futures Order",
  app_google: "Google Play",
  app_apple: "App Store",
  app_android: "Android APK",
  app_api: "API",
  app_mac: "Mac OS",
  app_win: "Windows",
  install_ios: "IOS Application",
  install_android: "Android Application",
  install_text: "Scan to download",
  key_id: "Key ID"
}